var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../node_modules/lodash/lodash.js
var require_lodash = __commonJS({
  "../node_modules/lodash/lodash.js"(exports, module) {
    (function() {
      var undefined2;
      var VERSION = "4.17.21";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        ["ary", WRAP_ARY_FLAG],
        ["bind", WRAP_BIND_FLAG],
        ["bindKey", WRAP_BIND_KEY_FLAG],
        ["curry", WRAP_CURRY_FLAG],
        ["curryRight", WRAP_CURRY_RIGHT_FLAG],
        ["flip", WRAP_FLIP_FLAG],
        ["partial", WRAP_PARTIAL_FLAG],
        ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
        ["rearg", WRAP_REARG_FLAG]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart = /^\s+/;
      var reWhitespace = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "\xC0": "A",
        "\xC1": "A",
        "\xC2": "A",
        "\xC3": "A",
        "\xC4": "A",
        "\xC5": "A",
        "\xE0": "a",
        "\xE1": "a",
        "\xE2": "a",
        "\xE3": "a",
        "\xE4": "a",
        "\xE5": "a",
        "\xC7": "C",
        "\xE7": "c",
        "\xD0": "D",
        "\xF0": "d",
        "\xC8": "E",
        "\xC9": "E",
        "\xCA": "E",
        "\xCB": "E",
        "\xE8": "e",
        "\xE9": "e",
        "\xEA": "e",
        "\xEB": "e",
        "\xCC": "I",
        "\xCD": "I",
        "\xCE": "I",
        "\xCF": "I",
        "\xEC": "i",
        "\xED": "i",
        "\xEE": "i",
        "\xEF": "i",
        "\xD1": "N",
        "\xF1": "n",
        "\xD2": "O",
        "\xD3": "O",
        "\xD4": "O",
        "\xD5": "O",
        "\xD6": "O",
        "\xD8": "O",
        "\xF2": "o",
        "\xF3": "o",
        "\xF4": "o",
        "\xF5": "o",
        "\xF6": "o",
        "\xF8": "o",
        "\xD9": "U",
        "\xDA": "U",
        "\xDB": "U",
        "\xDC": "U",
        "\xF9": "u",
        "\xFA": "u",
        "\xFB": "u",
        "\xFC": "u",
        "\xDD": "Y",
        "\xFD": "y",
        "\xFF": "y",
        "\xC6": "Ae",
        "\xE6": "ae",
        "\xDE": "Th",
        "\xFE": "th",
        "\xDF": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt = parseInt;
      var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = function() {
        try {
          var types = freeModule && freeModule.require && freeModule.require("util").types;
          if (types) {
            return types;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {
        }
      }();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          var value = array[index];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }
      function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (!predicate(array[index], index, array)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result2[resIndex++] = value;
          }
        }
        return result2;
      }
      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }
      function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (comparator(value, array[index])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result2 = Array(length);
        while (++index < length) {
          result2[index] = iteratee(array[index], index, array);
        }
        return result2;
      }
      function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while (++index < length) {
          array[offset + index] = values[index];
        }
        return array;
      }
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[++index];
        }
        while (++index < length) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }
        return accumulator;
      }
      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
      }
      function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (predicate(array[index], index, array)) {
            return true;
          }
        }
        return false;
      }
      var asciiSize = baseProperty("length");
      function asciiToArray(string) {
        return string.split("");
      }
      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }
      function baseFindKey(collection, predicate, eachFunc) {
        var result2;
        eachFunc(collection, function(value, key, collection2) {
          if (predicate(value, key, collection2)) {
            result2 = key;
            return false;
          }
        });
        return result2;
      }
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }
        return -1;
      }
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (comparator(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function baseIsNaN(value) {
        return value !== value;
      }
      function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
      }
      function baseProperty(key) {
        return function(object) {
          return object == null ? undefined2 : object[key];
        };
      }
      function basePropertyOf(object) {
        return function(key) {
          return object == null ? undefined2 : object[key];
        };
      }
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection2);
        });
        return accumulator;
      }
      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
          array[length] = array[length].value;
        }
        return array;
      }
      function baseSum(array, iteratee) {
        var result2, index = -1, length = array.length;
        while (++index < length) {
          var current = iteratee(array[index]);
          if (current !== undefined2) {
            result2 = result2 === undefined2 ? current : result2 + current;
          }
        }
        return result2;
      }
      function baseTimes(n, iteratee) {
        var index = -1, result2 = Array(n);
        while (++index < n) {
          result2[index] = iteratee(index);
        }
        return result2;
      }
      function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
          return [key, object[key]];
        });
      }
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
      }
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      function baseValues(object, props) {
        return arrayMap(props, function(key) {
          return object[key];
        });
      }
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function countHolders(array, placeholder) {
        var length = array.length, result2 = 0;
        while (length--) {
          if (array[length] === placeholder) {
            ++result2;
          }
        }
        return result2;
      }
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      function getValue(object, key) {
        return object == null ? undefined2 : object[key];
      }
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }
      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }
      function iteratorToArray(iterator) {
        var data, result2 = [];
        while (!(data = iterator.next()).done) {
          result2.push(data.value);
        }
        return result2;
      }
      function mapToArray(map) {
        var index = -1, result2 = Array(map.size);
        map.forEach(function(value, key) {
          result2[++index] = [key, value];
        });
        return result2;
      }
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result2 = [];
        while (++index < length) {
          var value = array[index];
          if (value === placeholder || value === PLACEHOLDER) {
            array[index] = PLACEHOLDER;
            result2[resIndex++] = index;
          }
        }
        return result2;
      }
      function setToArray(set) {
        var index = -1, result2 = Array(set.size);
        set.forEach(function(value) {
          result2[++index] = value;
        });
        return result2;
      }
      function setToPairs(set) {
        var index = -1, result2 = Array(set.size);
        set.forEach(function(value) {
          result2[++index] = [value, value];
        });
        return result2;
      }
      function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }
        return -1;
      }
      function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while (index--) {
          if (array[index] === value) {
            return index;
          }
        }
        return index;
      }
      function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
      }
      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }
      function trimmedEndIndex(string) {
        var index = string.length;
        while (index-- && reWhitespace.test(string.charAt(index))) {
        }
        return index;
      }
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string) {
        var result2 = reUnicode.lastIndex = 0;
        while (reUnicode.test(string)) {
          ++result2;
        }
        return result2;
      }
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }
      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }
      var runInContext = function runInContext2(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
        var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
        var coreJsData = context["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty = objectProto.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = function() {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid ? "Symbol(src)_1." + uid : "";
        }();
        var nativeObjectToString = objectProto.toString;
        var objectCtorString = funcToString.call(Object2);
        var oldDash = root._;
        var reIsNative = RegExp2(
          "^" + funcToString.call(hasOwnProperty).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        );
        var Buffer2 = moduleExports ? context.Buffer : undefined2, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined2, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined2, symIterator = Symbol2 ? Symbol2.iterator : undefined2, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined2;
        var defineProperty = function() {
          try {
            var func = getNative(Object2, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e) {
          }
        }();
        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined2, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
        var metaMap = WeakMap && new WeakMap();
        var realNames = {};
        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap);
        var symbolProto = Symbol2 ? Symbol2.prototype : undefined2, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined2, symbolToString = symbolProto ? symbolProto.toString : undefined2;
        function lodash(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty.call(value, "__wrapped__")) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        var baseCreate = function() {
          function object() {
          }
          return function(proto) {
            if (!isObject2(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object.prototype = proto;
            var result3 = new object();
            object.prototype = undefined2;
            return result3;
          };
        }();
        function baseLodash() {
        }
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined2;
        }
        lodash.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "escape": reEscape,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "evaluate": reEvaluate,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "interpolate": reInterpolate,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          "variable": "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          "imports": {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            "_": lodash
          }
        };
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result3 = new LazyWrapper(this.__wrapped__);
          result3.__actions__ = copyArray(this.__actions__);
          result3.__dir__ = this.__dir__;
          result3.__filtered__ = this.__filtered__;
          result3.__iteratees__ = copyArray(this.__iteratees__);
          result3.__takeCount__ = this.__takeCount__;
          result3.__views__ = copyArray(this.__views__);
          return result3;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result3 = new LazyWrapper(this);
            result3.__dir__ = -1;
            result3.__filtered__ = true;
          } else {
            result3 = this.clone();
            result3.__dir__ *= -1;
          }
          return result3;
        }
        function lazyValue() {
          var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result3 = [];
          outer:
            while (length-- && resIndex < takeCount) {
              index += dir;
              var iterIndex = -1, value = array[index];
              while (++iterIndex < iterLength) {
                var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
                if (type == LAZY_MAP_FLAG) {
                  value = computed;
                } else if (!computed) {
                  if (type == LAZY_FILTER_FLAG) {
                    continue outer;
                  } else {
                    break outer;
                  }
                }
              }
              result3[resIndex++] = value;
            }
          return result3;
        }
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        function hashDelete(key) {
          var result3 = this.has(key) && delete this.__data__[key];
          this.size -= result3 ? 1 : 0;
          return result3;
        }
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result3 = data[key];
            return result3 === HASH_UNDEFINED ? undefined2 : result3;
          }
          return hasOwnProperty.call(data, key) ? data[key] : undefined2;
        }
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined2 : hasOwnProperty.call(data, key);
        }
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined2 ? HASH_UNDEFINED : value;
          return this;
        }
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        function listCacheDelete(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index, 1);
          }
          --this.size;
          return true;
        }
        function listCacheGet(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          return index < 0 ? undefined2 : data[index][1];
        }
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        function listCacheSet(key, value) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index][1] = value;
          }
          return this;
        }
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map2 || ListCache)(),
            "string": new Hash()
          };
        }
        function mapCacheDelete(key) {
          var result3 = getMapData(this, key)["delete"](key);
          this.size -= result3 ? 1 : 0;
          return result3;
        }
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        function mapCacheSet(key, value) {
          var data = getMapData(this, key), size2 = data.size;
          data.set(key, value);
          this.size += data.size == size2 ? 0 : 1;
          return this;
        }
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        function SetCache(values2) {
          var index = -1, length = values2 == null ? 0 : values2.length;
          this.__data__ = new MapCache();
          while (++index < length) {
            this.add(values2[index]);
          }
        }
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        function stackDelete(key) {
          var data = this.__data__, result3 = data["delete"](key);
          this.size = data.size;
          return result3;
        }
        function stackGet(key) {
          return this.__data__.get(key);
        }
        function stackHas(key) {
          return this.__data__.has(key);
        }
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result3 = skipIndexes ? baseTimes(value.length, String2) : [], length = result3.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) {
              result3.push(key);
            }
          }
          return result3;
        }
        function arraySample(array) {
          var length = array.length;
          return length ? array[baseRandom(0, length - 1)] : undefined2;
        }
        function arraySampleSize(array, n) {
          return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }
        function assignMergeValue(object, key, value) {
          if (value !== undefined2 && !eq(object[key], value) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assignValue(object, key, value) {
          var objValue = object[key];
          if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        function baseAggregator(collection, setter, iteratee2, accumulator) {
          baseEach(collection, function(value, key, collection2) {
            setter(accumulator, value, iteratee2(value), collection2);
          });
          return accumulator;
        }
        function baseAssign(object, source) {
          return object && copyObject(source, keys(source), object);
        }
        function baseAssignIn(object, source) {
          return object && copyObject(source, keysIn(source), object);
        }
        function baseAssignValue(object, key, value) {
          if (key == "__proto__" && defineProperty) {
            defineProperty(object, key, {
              "configurable": true,
              "enumerable": true,
              "value": value,
              "writable": true
            });
          } else {
            object[key] = value;
          }
        }
        function baseAt(object, paths) {
          var index = -1, length = paths.length, result3 = Array2(length), skip = object == null;
          while (++index < length) {
            result3[index] = skip ? undefined2 : get(object, paths[index]);
          }
          return result3;
        }
        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined2) {
              number = number <= upper ? number : upper;
            }
            if (lower !== undefined2) {
              number = number >= lower ? number : lower;
            }
          }
          return number;
        }
        function baseClone(value, bitmask, customizer, key, object, stack) {
          var result3, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result3 = object ? customizer(value, key, object, stack) : customizer(value);
          }
          if (result3 !== undefined2) {
            return result3;
          }
          if (!isObject2(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result3 = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result3);
            }
          } else {
            var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object) {
              result3 = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result3, value)) : copySymbols(value, baseAssign(result3, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object ? value : {};
              }
              result3 = initCloneByTag(value, tag, isDeep);
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result3);
          if (isSet(value)) {
            value.forEach(function(subValue) {
              result3.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap(value)) {
            value.forEach(function(subValue, key2) {
              result3.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined2 : keysFunc(value);
          arrayEach(props || value, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value[key2];
            }
            assignValue(result3, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
          return result3;
        }
        function baseConforms(source) {
          var props = keys(source);
          return function(object) {
            return baseConformsTo(object, source, props);
          };
        }
        function baseConformsTo(object, source, props) {
          var length = props.length;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (length--) {
            var key = props[length], predicate = source[key], value = object[key];
            if (value === undefined2 && !(key in object) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return setTimeout(function() {
            func.apply(undefined2, args);
          }, wait);
        }
        function baseDifference(array, values2, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result3 = [], valuesLength = values2.length;
          if (!length) {
            return result3;
          }
          if (iteratee2) {
            values2 = arrayMap(values2, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values2.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values2 = new SetCache(values2);
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 == null ? value : iteratee2(value);
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while (valuesIndex--) {
                  if (values2[valuesIndex] === computed) {
                    continue outer;
                  }
                }
                result3.push(value);
              } else if (!includes2(values2, computed, comparator)) {
                result3.push(value);
              }
            }
          return result3;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result3 = true;
          baseEach(collection, function(value, index, collection2) {
            result3 = !!predicate(value, index, collection2);
            return result3;
          });
          return result3;
        }
        function baseExtremum(array, iteratee2, comparator) {
          var index = -1, length = array.length;
          while (++index < length) {
            var value = array[index], current = iteratee2(value);
            if (current != null && (computed === undefined2 ? current === current && !isSymbol(current) : comparator(current, computed))) {
              var computed = current, result3 = value;
            }
          }
          return result3;
        }
        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined2 || end > length ? length : toInteger(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array[start++] = value;
          }
          return array;
        }
        function baseFilter(collection, predicate) {
          var result3 = [];
          baseEach(collection, function(value, index, collection2) {
            if (predicate(value, index, collection2)) {
              result3.push(value);
            }
          });
          return result3;
        }
        function baseFlatten(array, depth, predicate, isStrict, result3) {
          var index = -1, length = array.length;
          predicate || (predicate = isFlattenable);
          result3 || (result3 = []);
          while (++index < length) {
            var value = array[index];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                baseFlatten(value, depth - 1, predicate, isStrict, result3);
              } else {
                arrayPush(result3, value);
              }
            } else if (!isStrict) {
              result3[result3.length] = value;
            }
          }
          return result3;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object, iteratee2) {
          return object && baseFor(object, iteratee2, keys);
        }
        function baseForOwnRight(object, iteratee2) {
          return object && baseForRight(object, iteratee2, keys);
        }
        function baseFunctions(object, props) {
          return arrayFilter(props, function(key) {
            return isFunction(object[key]);
          });
        }
        function baseGet(object, path) {
          path = castPath(path, object);
          var index = 0, length = path.length;
          while (object != null && index < length) {
            object = object[toKey(path[index++])];
          }
          return index && index == length ? object : undefined2;
        }
        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
          var result3 = keysFunc(object);
          return isArray(object) ? result3 : arrayPush(result3, symbolsFunc(object));
        }
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined2 ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString(value);
        }
        function baseGt(value, other) {
          return value > other;
        }
        function baseHas(object, key) {
          return object != null && hasOwnProperty.call(object, key);
        }
        function baseHasIn(object, key) {
          return object != null && key in Object2(object);
        }
        function baseInRange(number, start, end) {
          return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result3 = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee2) {
              array = arrayMap(array, baseUnary(iteratee2));
            }
            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined2;
          }
          array = arrays[0];
          var index = -1, seen = caches[0];
          outer:
            while (++index < length && result3.length < maxLength) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (!(seen ? cacheHas(seen, computed) : includes2(result3, computed, comparator))) {
                othIndex = othLength;
                while (--othIndex) {
                  var cache = caches[othIndex];
                  if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                    continue outer;
                  }
                }
                if (seen) {
                  seen.push(computed);
                }
                result3.push(value);
              }
            }
          return result3;
        }
        function baseInverter(object, setter, iteratee2, accumulator) {
          baseForOwn(object, function(value, key, object2) {
            setter(accumulator, iteratee2(value), key, object2);
          });
          return accumulator;
        }
        function baseInvoke(object, path, args) {
          path = castPath(path, object);
          object = parent(object, path);
          var func = object == null ? object : object[toKey(last(path))];
          return func == null ? undefined2 : apply(func, object, args);
        }
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }
        function baseIsMatch(object, source, matchData, customizer) {
          var index = matchData.length, length = index, noCustomizer = !customizer;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (index--) {
            var data = matchData[index];
            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
              return false;
            }
          }
          while (++index < length) {
            data = matchData[index];
            var key = data[0], objValue = object[key], srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined2 && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result3 = customizer(objValue, srcValue, key, object, source, stack);
              }
              if (!(result3 === undefined2 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result3)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIsNative(value) {
          if (!isObject2(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        function baseIteratee(value) {
          if (typeof value == "function") {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (typeof value == "object") {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }
          var result3 = [];
          for (var key in Object2(object)) {
            if (hasOwnProperty.call(object, key) && key != "constructor") {
              result3.push(key);
            }
          }
          return result3;
        }
        function baseKeysIn(object) {
          if (!isObject2(object)) {
            return nativeKeysIn(object);
          }
          var isProto = isPrototype(object), result3 = [];
          for (var key in object) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty.call(object, key)))) {
              result3.push(key);
            }
          }
          return result3;
        }
        function baseLt(value, other) {
          return value < other;
        }
        function baseMap(collection, iteratee2) {
          var index = -1, result3 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value, key, collection2) {
            result3[++index] = iteratee2(value, key, collection2);
          });
          return result3;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function(object) {
            var objValue = get(object, path);
            return objValue === undefined2 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        function baseMerge(object, source, srcIndex, customizer, stack) {
          if (object === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject2(srcValue)) {
              baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined2;
              if (newValue === undefined2) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          }, keysIn);
        }
        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined2;
          var isCommon = newValue === undefined2;
          if (isCommon) {
            var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject2(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object, key, newValue);
        }
        function baseNth(array, n) {
          var length = array.length;
          if (!length) {
            return;
          }
          n += n < 0 ? length : 0;
          return isIndex(n, length) ? array[n] : undefined2;
        }
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray(iteratee2)) {
                return function(value) {
                  return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [identity];
          }
          var index = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result3 = baseMap(collection, function(value, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value);
            });
            return { "criteria": criteria, "index": ++index, "value": value };
          });
          return baseSortBy(result3, function(object, other) {
            return compareMultiple(object, other, orders);
          });
        }
        function basePick(object, paths) {
          return basePickBy(object, paths, function(value, path) {
            return hasIn(object, path);
          });
        }
        function basePickBy(object, paths, predicate) {
          var index = -1, length = paths.length, result3 = {};
          while (++index < length) {
            var path = paths[index], value = baseGet(object, path);
            if (predicate(value, path)) {
              baseSet(result3, castPath(path, object), value);
            }
          }
          return result3;
        }
        function basePropertyDeep(path) {
          return function(object) {
            return baseGet(object, path);
          };
        }
        function basePullAll(array, values2, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values2.length, seen = array;
          if (array === values2) {
            values2 = copyArray(values2);
          }
          if (iteratee2) {
            seen = arrayMap(array, baseUnary(iteratee2));
          }
          while (++index < length) {
            var fromIndex = 0, value = values2[index], computed = iteratee2 ? iteratee2(value) : value;
            while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }
        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0, lastIndex = length - 1;
          while (length--) {
            var index = indexes[length];
            if (length == lastIndex || index !== previous) {
              var previous = index;
              if (isIndex(index)) {
                splice.call(array, index, 1);
              } else {
                baseUnset(array, index);
              }
            }
          }
          return array;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start, end, step, fromRight) {
          var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result3 = Array2(length);
          while (length--) {
            result3[fromRight ? length : ++index] = start;
            start += step;
          }
          return result3;
        }
        function baseRepeat(string, n) {
          var result3 = "";
          if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
            return result3;
          }
          do {
            if (n % 2) {
              result3 += string;
            }
            n = nativeFloor(n / 2);
            if (n) {
              string += string;
            }
          } while (n);
          return result3;
        }
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + "");
        }
        function baseSample(collection) {
          return arraySample(values(collection));
        }
        function baseSampleSize(collection, n) {
          var array = values(collection);
          return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        function baseSet(object, path, value, customizer) {
          if (!isObject2(object)) {
            return object;
          }
          path = castPath(path, object);
          var index = -1, length = path.length, lastIndex = length - 1, nested = object;
          while (nested != null && ++index < length) {
            var key = toKey(path[index]), newValue = value;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object;
            }
            if (index != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined2;
              if (newValue === undefined2) {
                newValue = isObject2(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object;
        }
        var baseSetData = !metaMap ? identity : function(func, data) {
          metaMap.set(func, data);
          return func;
        };
        var baseSetToString = !defineProperty ? identity : function(func, string) {
          return defineProperty(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        function baseSlice(array, start, end) {
          var index = -1, length = array.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result3 = Array2(length);
          while (++index < length) {
            result3[index] = array[index + start];
          }
          return result3;
        }
        function baseSome(collection, predicate) {
          var result3;
          baseEach(collection, function(value, index, collection2) {
            result3 = predicate(value, index, collection2);
            return !result3;
          });
          return !!result3;
        }
        function baseSortedIndex(array, value, retHighest) {
          var low = 0, high = array == null ? low : array.length;
          if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed = array[mid];
              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value, identity, retHighest);
        }
        function baseSortedIndexBy(array, value, iteratee2, retHighest) {
          var low = 0, high = array == null ? 0 : array.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee2(value);
          var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined2;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined2, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array, iteratee2) {
          var index = -1, length = array.length, resIndex = 0, result3 = [];
          while (++index < length) {
            var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
            if (!index || !eq(computed, seen)) {
              var seen = computed;
              result3[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result3;
        }
        function baseToNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          return +value;
        }
        function baseToString(value) {
          if (typeof value == "string") {
            return value;
          }
          if (isArray(value)) {
            return arrayMap(value, baseToString) + "";
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : "";
          }
          var result3 = value + "";
          return result3 == "0" && 1 / value == -INFINITY ? "-0" : result3;
        }
        function baseUniq(array, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result3 = [], seen = result3;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set2 = iteratee2 ? null : createSet(array);
            if (set2) {
              return setToArray(set2);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result3;
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var seenIndex = seen.length;
                while (seenIndex--) {
                  if (seen[seenIndex] === computed) {
                    continue outer;
                  }
                }
                if (iteratee2) {
                  seen.push(computed);
                }
                result3.push(value);
              } else if (!includes2(seen, computed, comparator)) {
                if (seen !== result3) {
                  seen.push(computed);
                }
                result3.push(value);
              }
            }
          return result3;
        }
        function baseUnset(object, path) {
          path = castPath(path, object);
          object = parent(object, path);
          return object == null || delete object[toKey(last(path))];
        }
        function baseUpdate(object, path, updater, customizer) {
          return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length, index = fromRight ? length : -1;
          while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
          }
          return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        function baseWrapperValue(value, actions) {
          var result3 = value;
          if (result3 instanceof LazyWrapper) {
            result3 = result3.value();
          }
          return arrayReduce(actions, function(result4, action) {
            return action.func.apply(action.thisArg, arrayPush([result4], action.args));
          }, result3);
        }
        function baseXor(arrays, iteratee2, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index = -1, result3 = Array2(length);
          while (++index < length) {
            var array = arrays[index], othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index) {
                result3[index] = baseDifference(result3[index] || array, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result3, 1), iteratee2, comparator);
        }
        function baseZipObject(props, values2, assignFunc) {
          var index = -1, length = props.length, valsLength = values2.length, result3 = {};
          while (++index < length) {
            var value = index < valsLength ? values2[index] : undefined2;
            assignFunc(result3, props[index], value);
          }
          return result3;
        }
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        function castFunction(value) {
          return typeof value == "function" ? value : identity;
        }
        function castPath(value, object) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object) ? [value] : stringToPath(toString(value));
        }
        var castRest = baseRest;
        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined2 ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }
        var clearTimeout = ctxClearTimeout || function(id) {
          return root.clearTimeout(id);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length, result3 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result3);
          return result3;
        }
        function cloneArrayBuffer(arrayBuffer) {
          var result3 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result3).set(new Uint8Array2(arrayBuffer));
          return result3;
        }
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        function cloneRegExp(regexp) {
          var result3 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result3.lastIndex = regexp.lastIndex;
          return result3;
        }
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined2, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined2, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        function compareMultiple(object, other, orders) {
          var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
          while (++index < length) {
            var result3 = compareAscending(objCriteria[index], othCriteria[index]);
            if (result3) {
              if (index >= ordersLength) {
                return result3;
              }
              var order = orders[index];
              return result3 * (order == "desc" ? -1 : 1);
            }
          }
          return object.index - other.index;
        }
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result3 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result3[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result3[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result3[leftIndex++] = args[argsIndex++];
          }
          return result3;
        }
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result3 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result3[argsIndex] = args[argsIndex];
          }
          var offset = argsIndex;
          while (++rightIndex < rightLength) {
            result3[offset + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result3[offset + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result3;
        }
        function copyArray(source, array) {
          var index = -1, length = source.length;
          array || (array = Array2(length));
          while (++index < length) {
            array[index] = source[index];
          }
          return array;
        }
        function copyObject(source, props, object, customizer) {
          var isNew = !object;
          object || (object = {});
          var index = -1, length = props.length;
          while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined2;
            if (newValue === undefined2) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }
          return object;
        }
        function copySymbols(source, object) {
          return copyObject(source, getSymbols(source), object);
        }
        function copySymbolsIn(source, object) {
          return copyObject(source, getSymbolsIn(source), object);
        }
        function createAggregator(setter, initializer) {
          return function(collection, iteratee2) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
          };
        }
        function createAssigner(assigner) {
          return baseRest(function(object, sources) {
            var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined2, guard = length > 2 ? sources[2] : undefined2;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined2;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined2 : customizer;
              length = 1;
            }
            object = Object2(object);
            while (++index < length) {
              var source = sources[index];
              if (source) {
                assigner(object, source, index, customizer);
              }
            }
            return object;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length = collection.length, index = fromRight ? length : -1, iterable = Object2(collection);
            while (fromRight ? index-- : ++index < length) {
              if (iteratee2(iterable[index], index, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function(object, iteratee2, keysFunc) {
            var index = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object;
          };
        }
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper;
        }
        function createCaseFirst(methodName) {
          return function(string) {
            string = toString(string);
            var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined2;
            var chr = strSymbols ? strSymbols[0] : string.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function(string) {
            return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
          };
        }
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result3 = Ctor.apply(thisBinding, args);
            return isObject2(result3) ? result3 : thisBinding;
          };
        }
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length, placeholder = getHolder(wrapper);
            while (index--) {
              args[index] = arguments[index];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            if (length < arity) {
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                undefined2,
                args,
                holders,
                undefined2,
                undefined2,
                arity - length
              );
            }
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return apply(fn, this, args);
          }
          return wrapper;
        }
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object2(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = function(key) {
                return iteratee2(iterable[key], key, iterable);
              };
            }
            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee2 ? collection[index] : index] : undefined2;
          };
        }
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index--) {
              var func = funcs[index];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index = wrapper ? index : length;
            while (++index < length) {
              func = funcs[index];
              var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined2;
              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function() {
              var args = arguments, value = args[0];
              if (wrapper && args.length == 1 && isArray(value)) {
                return wrapper.plant(value).value();
              }
              var index2 = 0, result3 = length ? funcs[index2].apply(this, args) : value;
              while (++index2 < length) {
                result3 = funcs[index2].call(this, result3);
              }
              return result3;
            };
          });
        }
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined2 : createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length;
            while (index--) {
              args[index] = arguments[index];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length -= holdersCount;
            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                thisArg,
                args,
                newHolders,
                argPos,
                ary2,
                arity - length
              );
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length) {
              args.length = ary2;
            }
            if (this && this !== root && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper;
        }
        function createInverter(setter, toIteratee) {
          return function(object, iteratee2) {
            return baseInverter(object, setter, toIteratee(iteratee2), {});
          };
        }
        function createMathOperation(operator, defaultValue) {
          return function(value, other) {
            var result3;
            if (value === undefined2 && other === undefined2) {
              return defaultValue;
            }
            if (value !== undefined2) {
              result3 = value;
            }
            if (other !== undefined2) {
              if (result3 === undefined2) {
                return other;
              }
              if (typeof value == "string" || typeof other == "string") {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result3 = operator(value, other);
            }
            return result3;
          };
        }
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply(iteratee2, thisArg, args);
              });
            });
          });
        }
        function createPadding(length, chars) {
          chars = chars === undefined2 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }
          var result3 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result3), 0, length).join("") : result3.slice(0, length);
        }
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn, isBind ? thisArg : this, args);
          }
          return wrapper;
        }
        function createRange(fromRight) {
          return function(start, end, step) {
            if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
              end = step = undefined2;
            }
            start = toFinite(start);
            if (end === undefined2) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined2 ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }
        function createRelationalOperation(operator) {
          return function(value, other) {
            if (!(typeof value == "string" && typeof other == "string")) {
              value = toNumber(value);
              other = toNumber(other);
            }
            return operator(value, other);
          };
        }
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined2, newHoldersRight = isCurry ? undefined2 : holders, newPartials = isCurry ? partials : undefined2, newPartialsRight = isCurry ? undefined2 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result3 = wrapFunc.apply(undefined2, newData);
          if (isLaziable(func)) {
            setData(result3, newData);
          }
          result3.placeholder = placeholder;
          return setWrapToString(result3, func, bitmask);
        }
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number, precision) {
            number = toNumber(number);
            precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
            if (precision && nativeIsFinite(number)) {
              var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString(value) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number);
          };
        }
        var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop : function(values2) {
          return new Set2(values2);
        };
        function createToPairs(keysFunc) {
          return function(object) {
            var tag = getTag(object);
            if (tag == mapTag) {
              return mapToArray(object);
            }
            if (tag == setTag) {
              return setToPairs(object);
            }
            return baseToPairs(object, keysFunc(object));
          };
        }
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined2;
          }
          ary2 = ary2 === undefined2 ? ary2 : nativeMax(toInteger(ary2), 0);
          arity = arity === undefined2 ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined2;
          }
          var data = isBindKey ? undefined2 : getData(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined2 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result3 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result3 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result3 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result3 = createHybrid.apply(undefined2, newData);
          }
          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result3, newData), func, bitmask);
        }
        function customDefaultsAssignIn(objValue, srcValue, key, object) {
          if (objValue === undefined2 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
            return srcValue;
          }
          return objValue;
        }
        function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
          if (isObject2(objValue) && isObject2(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined2, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        function customOmitClone(value) {
          return isPlainObject(value) ? undefined2 : value;
        }
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }
          var index = -1, result3 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined2;
          stack.set(array, other);
          stack.set(other, array);
          while (++index < arrLength) {
            var arrValue = array[index], othValue = other[index];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            }
            if (compared !== undefined2) {
              if (compared) {
                continue;
              }
              result3 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result3 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result3 = false;
              break;
            }
          }
          stack["delete"](array);
          stack["delete"](other);
          return result3;
        }
        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                return false;
              }
              object = object.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq(+object, +other);
            case errorTag:
              return object.name == other.name && object.message == other.message;
            case regexpTag:
            case stringTag:
              return object == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object, other);
              var result3 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
              stack["delete"](object);
              return result3;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index = objLength;
          while (index--) {
            var key = objProps[index];
            if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object;
          }
          var result3 = true;
          stack.set(object, other);
          stack.set(other, object);
          var skipCtor = isPartial;
          while (++index < objLength) {
            key = objProps[index];
            var objValue = object[key], othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            }
            if (!(compared === undefined2 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result3 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result3 && !skipCtor) {
            var objCtor = object.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result3 = false;
            }
          }
          stack["delete"](object);
          stack["delete"](other);
          return result3;
        }
        function flatRest(func) {
          return setToString(overRest(func, undefined2, flatten), func + "");
        }
        function getAllKeys(object) {
          return baseGetAllKeys(object, keys, getSymbols);
        }
        function getAllKeysIn(object) {
          return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        var getData = !metaMap ? noop : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result3 = func.name + "", array = realNames[result3], length = hasOwnProperty.call(realNames, result3) ? array.length : 0;
          while (length--) {
            var data = array[length], otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result3;
        }
        function getHolder(func) {
          var object = hasOwnProperty.call(lodash, "placeholder") ? lodash : func;
          return object.placeholder;
        }
        function getIteratee() {
          var result3 = lodash.iteratee || iteratee;
          result3 = result3 === iteratee ? baseIteratee : result3;
          return arguments.length ? result3(arguments[0], arguments[1]) : result3;
        }
        function getMapData(map2, key) {
          var data = map2.__data__;
          return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        function getMatchData(object) {
          var result3 = keys(object), length = result3.length;
          while (length--) {
            var key = result3[length], value = object[key];
            result3[length] = [key, value, isStrictComparable(value)];
          }
          return result3;
        }
        function getNative(object, key) {
          var value = getValue(object, key);
          return baseIsNative(value) ? value : undefined2;
        }
        function getRawTag(value) {
          var isOwn = hasOwnProperty.call(value, symToStringTag), tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined2;
            var unmasked = true;
          } catch (e) {
          }
          var result3 = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result3;
        }
        var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
          if (object == null) {
            return [];
          }
          object = Object2(object);
          return arrayFilter(nativeGetSymbols(object), function(symbol) {
            return propertyIsEnumerable.call(object, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
          var result3 = [];
          while (object) {
            arrayPush(result3, getSymbols(object));
            object = getPrototype(object);
          }
          return result3;
        };
        var getTag = baseGetTag;
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
          getTag = function(value) {
            var result3 = baseGetTag(value), Ctor = result3 == objectTag ? value.constructor : undefined2, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result3;
          };
        }
        function getView(start, end, transforms) {
          var index = -1, length = transforms.length;
          while (++index < length) {
            var data = transforms[index], size2 = data.size;
            switch (data.type) {
              case "drop":
                start += size2;
                break;
              case "dropRight":
                end -= size2;
                break;
              case "take":
                end = nativeMin(end, start + size2);
                break;
              case "takeRight":
                start = nativeMax(start, end - size2);
                break;
            }
          }
          return { "start": start, "end": end };
        }
        function getWrapDetails(source) {
          var match = source.match(reWrapDetails);
          return match ? match[1].split(reSplitDetails) : [];
        }
        function hasPath(object, path, hasFunc) {
          path = castPath(path, object);
          var index = -1, length = path.length, result3 = false;
          while (++index < length) {
            var key = toKey(path[index]);
            if (!(result3 = object != null && hasFunc(object, key))) {
              break;
            }
            object = object[key];
          }
          if (result3 || ++index != length) {
            return result3;
          }
          length = object == null ? 0 : object.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        function initCloneArray(array) {
          var length = array.length, result3 = new array.constructor(length);
          if (length && typeof array[0] == "string" && hasOwnProperty.call(array, "index")) {
            result3.index = array.index;
            result3.input = array.input;
          }
          return result3;
        }
        function initCloneObject(object) {
          return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        function initCloneByTag(object, tag, isDeep) {
          var Ctor = object.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object);
            case boolTag:
            case dateTag:
              return new Ctor(+object);
            case dataViewTag:
              return cloneDataView(object, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object);
            case regexpTag:
              return cloneRegExp(object);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object);
          }
        }
        function insertWrapDetails(source, details) {
          var length = details.length;
          if (!length) {
            return source;
          }
          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
        }
        function isIterateeCall(value, index, object) {
          if (!isObject2(object)) {
            return false;
          }
          var type = typeof index;
          if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
            return eq(object[index], value);
          }
          return false;
        }
        function isKey(value, object) {
          if (isArray(value)) {
            return false;
          }
          var type = typeof value;
          if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
        }
        function isKeyable(value) {
          var type = typeof value;
          return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        var isMaskable = coreJsData ? isFunction : stubFalse;
        function isPrototype(value) {
          var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
          return value === proto;
        }
        function isStrictComparable(value) {
          return value === value && !isObject2(value);
        }
        function matchesStrictComparable(key, srcValue) {
          return function(object) {
            if (object == null) {
              return false;
            }
            return object[key] === srcValue && (srcValue !== undefined2 || key in Object2(object));
          };
        }
        function memoizeCapped(func) {
          var result3 = memoize(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result3.cache;
          return result3;
        }
        function mergeData(data, source) {
          var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          }
          value = source[5];
          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          }
          value = source[7];
          if (value) {
            data[7] = value;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          }
          if (data[9] == null) {
            data[9] = source[9];
          }
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        function nativeKeysIn(object) {
          var result3 = [];
          if (object != null) {
            for (var key in Object2(object)) {
              result3.push(key);
            }
          }
          return result3;
        }
        function objectToString(value) {
          return nativeObjectToString.call(value);
        }
        function overRest(func, start, transform2) {
          start = nativeMax(start === undefined2 ? func.length - 1 : start, 0);
          return function() {
            var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
            while (++index < length) {
              array[index] = args[start + index];
            }
            index = -1;
            var otherArgs = Array2(start + 1);
            while (++index < start) {
              otherArgs[index] = args[index];
            }
            otherArgs[start] = transform2(array);
            return apply(func, this, otherArgs);
          };
        }
        function parent(object, path) {
          return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        function reorder(array, indexes) {
          var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
          while (length--) {
            var index = indexes[length];
            array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined2;
          }
          return array;
        }
        function safeGet(object, key) {
          if (key === "constructor" && typeof object[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object[key];
        }
        var setData = shortOut(baseSetData);
        var setTimeout = ctxSetTimeout || function(func, wait) {
          return root.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + "";
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        function shortOut(func) {
          var count = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined2, arguments);
          };
        }
        function shuffleSelf(array, size2) {
          var index = -1, length = array.length, lastIndex = length - 1;
          size2 = size2 === undefined2 ? length : size2;
          while (++index < size2) {
            var rand = baseRandom(index, lastIndex), value = array[rand];
            array[rand] = array[index];
            array[index] = value;
          }
          array.length = size2;
          return array;
        }
        var stringToPath = memoizeCapped(function(string) {
          var result3 = [];
          if (string.charCodeAt(0) === 46) {
            result3.push("");
          }
          string.replace(rePropName, function(match, number, quote, subString) {
            result3.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
          });
          return result3;
        });
        function toKey(value) {
          if (typeof value == "string" || isSymbol(value)) {
            return value;
          }
          var result3 = value + "";
          return result3 == "0" && 1 / value == -INFINITY ? "-0" : result3;
        }
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {
            }
            try {
              return func + "";
            } catch (e) {
            }
          }
          return "";
        }
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result3 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result3.__actions__ = copyArray(wrapper.__actions__);
          result3.__index__ = wrapper.__index__;
          result3.__values__ = wrapper.__values__;
          return result3;
        }
        function chunk(array, size2, guard) {
          if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined2) {
            size2 = 1;
          } else {
            size2 = nativeMax(toInteger(size2), 0);
          }
          var length = array == null ? 0 : array.length;
          if (!length || size2 < 1) {
            return [];
          }
          var index = 0, resIndex = 0, result3 = Array2(nativeCeil(length / size2));
          while (index < length) {
            result3[resIndex++] = baseSlice(array, index, index += size2);
          }
          return result3;
        }
        function compact(array) {
          var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result3 = [];
          while (++index < length) {
            var value = array[index];
            if (value) {
              result3[resIndex++] = value;
            }
          }
          return result3;
        }
        function concat() {
          var length = arguments.length;
          if (!length) {
            return [];
          }
          var args = Array2(length - 1), array = arguments[0], index = length;
          while (index--) {
            args[index - 1] = arguments[index];
          }
          return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
        }
        var difference = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array, values2) {
          var iteratee2 = last(values2);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array, values2) {
          var comparator = last(values2);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined2, comparator) : [];
        });
        function drop(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function dropRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        function fill(array, value, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array, value, start, end);
        }
        function findIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        function findLastIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length - 1;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        function flatten(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, 1) : [];
        }
        function flattenDeep(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, INFINITY) : [];
        }
        function flattenDepth(array, depth) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(array, depth);
        }
        function fromPairs(pairs) {
          var index = -1, length = pairs == null ? 0 : pairs.length, result3 = {};
          while (++index < length) {
            var pair = pairs[index];
            result3[pair[0]] = pair[1];
          }
          return result3;
        }
        function head(array) {
          return array && array.length ? array[0] : undefined2;
        }
        function indexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseIndexOf(array, value, index);
        }
        function initial(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 0, -1) : [];
        }
        var intersection = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined2;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined2, comparator) : [];
        });
        function join(array, separator) {
          return array == null ? "" : nativeJoin.call(array, separator);
        }
        function last(array) {
          var length = array == null ? 0 : array.length;
          return length ? array[length - 1] : undefined2;
        }
        function lastIndexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        function nth(array, n) {
          return array && array.length ? baseNth(array, toInteger(n)) : undefined2;
        }
        var pull = baseRest(pullAll);
        function pullAll(array, values2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
        }
        function pullAllBy(array, values2, iteratee2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
        }
        function pullAllWith(array, values2, comparator) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined2, comparator) : array;
        }
        var pullAt = flatRest(function(array, indexes) {
          var length = array == null ? 0 : array.length, result3 = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function(index) {
            return isIndex(index, length) ? +index : index;
          }).sort(compareAscending));
          return result3;
        });
        function remove(array, predicate) {
          var result3 = [];
          if (!(array && array.length)) {
            return result3;
          }
          var index = -1, indexes = [], length = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index < length) {
            var value = array[index];
            if (predicate(value, index, array)) {
              result3.push(value);
              indexes.push(index);
            }
          }
          basePullAt(array, indexes);
          return result3;
        }
        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }
        function slice(array, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined2 ? length : toInteger(end);
          }
          return baseSlice(array, start, end);
        }
        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }
        function sortedIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
        }
        function sortedIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value);
            if (index < length && eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }
        function sortedLastIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
        }
        function sortedLastIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value, true) - 1;
            if (eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        function sortedUniqBy(array, iteratee2) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function tail(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 1, length) : [];
        }
        function take(array, n, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function takeRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined2, comparator);
        });
        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        function uniqBy(array, iteratee2) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function uniqWith(array, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return array && array.length ? baseUniq(array, undefined2, comparator) : [];
        }
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length = 0;
          array = arrayFilter(array, function(group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function(index) {
            return arrayMap(array, baseProperty(index));
          });
        }
        function unzipWith(array, iteratee2) {
          if (!(array && array.length)) {
            return [];
          }
          var result3 = unzip(array);
          if (iteratee2 == null) {
            return result3;
          }
          return arrayMap(result3, function(group) {
            return apply(iteratee2, undefined2, group);
          });
        }
        var without = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined2, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values2) {
          return baseZipObject(props || [], values2 || [], assignValue);
        }
        function zipObjectDeep(props, values2) {
          return baseZipObject(props || [], values2 || [], baseSet);
        }
        var zipWith = baseRest(function(arrays) {
          var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined2;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined2;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value) {
          var result3 = lodash(value);
          result3.__chain__ = true;
          return result3;
        }
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        function thru(value, interceptor) {
          return interceptor(value);
        }
        var wrapperAt = flatRest(function(paths) {
          var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
            return baseAt(object, paths);
          };
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            "func": thru,
            "args": [interceptor],
            "thisArg": undefined2
          });
          return new LodashWrapper(value, this.__chain__).thru(function(array) {
            if (length && !array.length) {
              array.push(undefined2);
            }
            return array;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperNext() {
          if (this.__values__ === undefined2) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value = done ? undefined2 : this.__values__[this.__index__++];
          return { "done": done, "value": value };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value) {
          var result3, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone2 = wrapperClone(parent2);
            clone2.__index__ = 0;
            clone2.__values__ = undefined2;
            if (result3) {
              previous.__wrapped__ = clone2;
            } else {
              result3 = clone2;
            }
            var previous = clone2;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result3;
        }
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [reverse],
              "thisArg": undefined2
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function(result3, value, key) {
          if (hasOwnProperty.call(result3, key)) {
            ++result3[key];
          } else {
            baseAssignValue(result3, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        var find = createFind(findIndex);
        var findLast = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), 1);
        }
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), INFINITY);
        }
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(map(collection, iteratee2), depth);
        }
        function forEach(collection, iteratee2) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function forEachRight(collection, iteratee2) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        var groupBy = createAggregator(function(result3, value, key) {
          if (hasOwnProperty.call(result3, key)) {
            result3[key].push(value);
          } else {
            baseAssignValue(result3, key, [value]);
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        var invokeMap = baseRest(function(collection, path, args) {
          var index = -1, isFunc = typeof path == "function", result3 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value) {
            result3[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
          });
          return result3;
        });
        var keyBy = createAggregator(function(result3, value, key) {
          baseAssignValue(result3, key, value);
        });
        function map(collection, iteratee2) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined2 : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition2 = createAggregator(function(result3, value, key) {
          result3[key ? 0 : 1].push(value);
        }, function() {
          return [[], []];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }
        function sampleSize(collection, n, guard) {
          if (guard ? isIterateeCall(collection, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n);
        }
        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        function size(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now = ctxNow || function() {
          return root.Date.now();
        };
        function after(n, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n, guard) {
          n = guard ? undefined2 : n;
          n = func && n == null ? func.length : n;
          return createWrap(func, WRAP_ARY_FLAG, undefined2, undefined2, undefined2, undefined2, n);
        }
        function before(n, func) {
          var result3;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n > 0) {
              result3 = func.apply(this, arguments);
            }
            if (n <= 1) {
              func = undefined2;
            }
            return result3;
          };
        }
        var bind = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result3 = createWrap(func, WRAP_CURRY_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result3.placeholder = curry.placeholder;
          return result3;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result3 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result3.placeholder = curryRight.placeholder;
          return result3;
        }
        function debounce(func, wait, options) {
          var lastArgs, lastThis, maxWait, result3, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject2(options)) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined2;
            lastInvokeTime = time;
            result3 = func.apply(thisArg, args);
            return result3;
          }
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout(timerExpired, wait);
            return leading ? invokeFunc(time) : result3;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined2 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined2;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined2;
            return result3;
          }
          function cancel() {
            if (timerId !== undefined2) {
              clearTimeout(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined2;
          }
          function flush() {
            return timerId === undefined2 ? result3 : trailingEdge(now());
          }
          function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined2) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined2) {
              timerId = setTimeout(timerExpired, wait);
            }
            return result3;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        function memoize(func, resolver) {
          if (typeof func != "function" || resolver != null && typeof resolver != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result3 = func.apply(this, args);
            memoized.cache = cache.set(key, result3) || cache;
            return result3;
          };
          memoized.cache = new (memoize.Cache || MapCache)();
          return memoized;
        }
        memoize.Cache = MapCache;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        function once(func) {
          return before(2, func);
        }
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index = -1, length = nativeMin(args.length, funcsLength);
            while (++index < length) {
              args[index] = transforms[index].call(this, args[index]);
            }
            return apply(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined2, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined2, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined2, undefined2, undefined2, indexes);
        });
        function rest(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start === undefined2 ? start : toInteger(start);
          return baseRest(func, start);
        }
        function spread(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start == null ? 0 : nativeMax(toInteger(start), 0);
          return baseRest(function(args) {
            var array = args[start], otherArgs = castSlice(args, 0, start);
            if (array) {
              arrayPush(otherArgs, array);
            }
            return apply(func, this, otherArgs);
          });
        }
        function throttle(func, wait, options) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          if (isObject2(options)) {
            leading = "leading" in options ? !!options.leading : leading;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          return debounce(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray(value) ? value : [value];
        }
        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        function cloneWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        function cloneDeep(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        function conformsTo(object, source) {
          return source == null || baseConformsTo(object, source, keys(source));
        }
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        var gt = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value, other) {
          return value >= other;
        });
        var isArguments = baseIsArguments(function() {
          return arguments;
        }()) ? baseIsArguments : function(value) {
          return isObjectLike(value) && hasOwnProperty.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        var isArray = Array2.isArray;
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
        }
        function isEmpty(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty.call(value, key)) {
              return false;
            }
          }
          return true;
        }
        function isEqual(value, other) {
          return baseIsEqual(value, other);
        }
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          var result3 = customizer ? customizer(value, other) : undefined2;
          return result3 === undefined2 ? baseIsEqual(value, other, undefined2, customizer) : !!result3;
        }
        function isError(value) {
          if (!isObjectLike(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject(value);
        }
        function isFinite(value) {
          return typeof value == "number" && nativeIsFinite(value);
        }
        function isFunction(value) {
          if (!isObject2(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        function isInteger(value) {
          return typeof value == "number" && value == toInteger(value);
        }
        function isLength(value) {
          return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        function isObject2(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }
        var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch(object, source) {
          return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        function isMatchWith(object, source, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        function isNaN2(value) {
          return isNumber(value) && value != +value;
        }
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error2(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }
        function isNull(value) {
          return value === null;
        }
        function isNil(value) {
          return value == null;
        }
        function isNumber(value) {
          return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        function isPlainObject(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
        }
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value) {
          return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString(value) {
          return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        function isSymbol(value) {
          return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined2(value) {
          return value === undefined2;
        }
        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        var lt = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value, other) {
          return value <= other;
        });
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }
        function toInteger(value) {
          var result3 = toFinite(value), remainder = result3 % 1;
          return result3 === result3 ? remainder ? result3 - remainder : result3 : 0;
        }
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          if (isObject2(value)) {
            var other = typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject2(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        function toString(value) {
          return value == null ? "" : baseToString(value);
        }
        var assign = createAssigner(function(object, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty.call(source, key)) {
              assignValue(object, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object, source) {
          copyObject(source, keysIn(source), object);
        });
        var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object, customizer);
        });
        var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keys(source), object, customizer);
        });
        var at = flatRest(baseAt);
        function create(prototype, properties) {
          var result3 = baseCreate(prototype);
          return properties == null ? result3 : baseAssign(result3, properties);
        }
        var defaults = baseRest(function(object, sources) {
          object = Object2(object);
          var index = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined2;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }
          while (++index < length) {
            var source = sources[index];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object[key];
              if (value === undefined2 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
                object[key] = source[key];
              }
            }
          }
          return object;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined2, customDefaultsMerge);
          return apply(mergeWith, undefined2, args);
        });
        function findKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        function findLastKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        function forIn(object, iteratee2) {
          return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forInRight(object, iteratee2) {
          return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forOwn(object, iteratee2) {
          return object && baseForOwn(object, getIteratee(iteratee2, 3));
        }
        function forOwnRight(object, iteratee2) {
          return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
        }
        function functions(object) {
          return object == null ? [] : baseFunctions(object, keys(object));
        }
        function functionsIn(object) {
          return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        function get(object, path, defaultValue) {
          var result3 = object == null ? undefined2 : baseGet(object, path);
          return result3 === undefined2 ? defaultValue : result3;
        }
        function has(object, path) {
          return object != null && hasPath(object, path, baseHas);
        }
        function hasIn(object, path) {
          return object != null && hasPath(object, path, baseHasIn);
        }
        var invert = createInverter(function(result3, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          result3[value] = key;
        }, constant(identity));
        var invertBy = createInverter(function(result3, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          if (hasOwnProperty.call(result3, value)) {
            result3[value].push(key);
          } else {
            result3[value] = [key];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        function keysIn(object) {
          return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        function mapKeys(object, iteratee2) {
          var result3 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result3, iteratee2(value, key, object2), value);
          });
          return result3;
        }
        function mapValues(object, iteratee2) {
          var result3 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result3, key, iteratee2(value, key, object2));
          });
          return result3;
        }
        var merge = createAssigner(function(object, source, srcIndex) {
          baseMerge(object, source, srcIndex);
        });
        var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
          baseMerge(object, source, srcIndex, customizer);
        });
        var omit = flatRest(function(object, paths) {
          var result3 = {};
          if (object == null) {
            return result3;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path) {
            path = castPath(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object, getAllKeysIn(object), result3);
          if (isDeep) {
            result3 = baseClone(result3, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length = paths.length;
          while (length--) {
            baseUnset(result3, paths[length]);
          }
          return result3;
        });
        function omitBy(object, predicate) {
          return pickBy(object, negate(getIteratee(predicate)));
        }
        var pick = flatRest(function(object, paths) {
          return object == null ? {} : basePick(object, paths);
        });
        function pickBy(object, predicate) {
          if (object == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object), function(prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object, props, function(value, path) {
            return predicate(value, path[0]);
          });
        }
        function result2(object, path, defaultValue) {
          path = castPath(path, object);
          var index = -1, length = path.length;
          if (!length) {
            length = 1;
            object = undefined2;
          }
          while (++index < length) {
            var value = object == null ? undefined2 : object[toKey(path[index])];
            if (value === undefined2) {
              index = length;
              value = defaultValue;
            }
            object = isFunction(value) ? value.call(object) : value;
          }
          return object;
        }
        function set(object, path, value) {
          return object == null ? object : baseSet(object, path, value);
        }
        function setWith(object, path, value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseSet(object, path, value, customizer);
        }
        var toPairs = createToPairs(keys);
        var toPairsIn = createToPairs(keysIn);
        function transform(object, iteratee2, accumulator) {
          var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object && object.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject2(object)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object2) {
            return iteratee2(accumulator, value, index, object2);
          });
          return accumulator;
        }
        function unset(object, path) {
          return object == null ? true : baseUnset(object, path);
        }
        function update(object, path, updater) {
          return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        function updateWith(object, path, updater, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        function values(object) {
          return object == null ? [] : baseValues(object, keys(object));
        }
        function valuesIn(object) {
          return object == null ? [] : baseValues(object, keysIn(object));
        }
        function clamp(number, lower, upper) {
          if (upper === undefined2) {
            upper = lower;
            lower = undefined2;
          }
          if (upper !== undefined2) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined2) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number), lower, upper);
        }
        function inRange(number, start, end) {
          start = toFinite(start);
          if (end === undefined2) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          number = toNumber(number);
          return baseInRange(number, start, end);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined2;
          }
          if (floating === undefined2) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined2;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined2;
            }
          }
          if (lower === undefined2 && upper === undefined2) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined2) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase = createCompounder(function(result3, word, index) {
          word = word.toLowerCase();
          return result3 + (index ? capitalize(word) : word);
        });
        function capitalize(string) {
          return upperFirst(toString(string).toLowerCase());
        }
        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        function endsWith(string, target, position) {
          string = toString(string);
          target = baseToString(target);
          var length = string.length;
          position = position === undefined2 ? length : baseClamp(toInteger(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string.slice(position, end) == target;
        }
        function escape(string) {
          string = toString(string);
          return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        var kebabCase = createCompounder(function(result3, word, index) {
          return result3 + (index ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result3, word, index) {
          return result3 + (index ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          if (!length || strLength >= length) {
            return string;
          }
          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        function padEnd(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        function padStart(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        function parseInt2(string, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        function repeat(string, n, guard) {
          if (guard ? isIterateeCall(string, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          return baseRepeat(toString(string), n);
        }
        function replace() {
          var args = arguments, string = toString(args[0]);
          return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function(result3, word, index) {
          return result3 + (index ? "_" : "") + word.toLowerCase();
        });
        function split(string, separator, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
            separator = limit = undefined2;
          }
          limit = limit === undefined2 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string = toString(string);
          if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);
            if (!separator && hasUnicode(string)) {
              return castSlice(stringToArray(string), 0, limit);
            }
          }
          return string.split(separator, limit);
        }
        var startCase = createCompounder(function(result3, word, index) {
          return result3 + (index ? " " : "") + upperFirst(word);
        });
        function startsWith(string, target, position) {
          string = toString(string);
          position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
          target = baseToString(target);
          return string.slice(position, position + target.length) == target;
        }
        function template(string, options, guard) {
          var settings = lodash.templateSettings;
          if (guard && isIterateeCall(string, options, guard)) {
            options = undefined2;
          }
          string = toString(string);
          options = assignInWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
          var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp2(
            (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
            "g"
          );
          var sourceURL = "//# sourceURL=" + (hasOwnProperty.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index = offset + match.length;
            return match;
          });
          source += "';\n";
          var variable = hasOwnProperty.call(options, "variable") && options.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result3 = attempt(function() {
            return Function2(importsKeys, sourceURL + "return " + source).apply(undefined2, importsValues);
          });
          result3.source = source;
          if (isError(result3)) {
            throw result3;
          }
          return result3;
        }
        function toLower(value) {
          return toString(value).toLowerCase();
        }
        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        function trim(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return baseTrim(string);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join("");
        }
        function trimEnd(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.slice(0, trimmedEndIndex(string) + 1);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join("");
        }
        function trimStart(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.replace(reTrimStart, "");
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join("");
        }
        function truncate(string, options) {
          var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject2(options)) {
            var separator = "separator" in options ? options.separator : separator;
            length = "length" in options ? toInteger(options.length) : length;
            omission = "omission" in options ? baseToString(options.omission) : omission;
          }
          string = toString(string);
          var strLength = string.length;
          if (hasUnicode(string)) {
            var strSymbols = stringToArray(string);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result3 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
          if (separator === undefined2) {
            return result3 + omission;
          }
          if (strSymbols) {
            end += result3.length - end;
          }
          if (isRegExp(separator)) {
            if (string.slice(end).search(separator)) {
              var match, substring = result3;
              if (!separator.global) {
                separator = RegExp2(separator.source, toString(reFlags.exec(separator)) + "g");
              }
              separator.lastIndex = 0;
              while (match = separator.exec(substring)) {
                var newEnd = match.index;
              }
              result3 = result3.slice(0, newEnd === undefined2 ? end : newEnd);
            }
          } else if (string.indexOf(baseToString(separator), end) != end) {
            var index = result3.lastIndexOf(separator);
            if (index > -1) {
              result3 = result3.slice(0, index);
            }
          }
          return result3 + omission;
        }
        function unescape(string) {
          string = toString(string);
          return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        var upperCase = createCompounder(function(result3, word, index) {
          return result3 + (index ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined2 : pattern;
          if (pattern === undefined2) {
            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
          }
          return string.match(pattern) || [];
        }
        var attempt = baseRest(function(func, args) {
          try {
            return apply(func, undefined2, args);
          } catch (e) {
            return isError(e) ? e : new Error2(e);
          }
        });
        var bindAll = flatRest(function(object, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey(key);
            baseAssignValue(object, key, bind(object[key], object));
          });
          return object;
        });
        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function(args) {
            var index = -1;
            while (++index < length) {
              var pair = pairs[index];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        function constant(value) {
          return function() {
            return value;
          };
        }
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity(value) {
          return value;
        }
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        var method = baseRest(function(path, args) {
          return function(object) {
            return baseInvoke(object, path, args);
          };
        });
        var methodOf = baseRest(function(object, args) {
          return function(path) {
            return baseInvoke(object, path, args);
          };
        });
        function mixin(object, source, options) {
          var props = keys(source), methodNames = baseFunctions(source, props);
          if (options == null && !(isObject2(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object;
            object = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain2 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object[methodName] = func;
            if (isFunc) {
              object.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result3 = object(this.__wrapped__), actions = result3.__actions__ = copyArray(this.__actions__);
                  actions.push({ "func": func, "args": arguments, "thisArg": object });
                  result3.__chain__ = chainAll;
                  return result3;
                }
                return func.apply(object, arrayPush([this.value()], arguments));
              };
            }
          });
          return object;
        }
        function noConflict() {
          if (root._ === this) {
            root._ = oldDash;
          }
          return this;
        }
        function noop() {
        }
        function nthArg(n) {
          n = toInteger(n);
          return baseRest(function(args) {
            return baseNth(args, n);
          });
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        function propertyOf(object) {
          return function(path) {
            return object == null ? undefined2 : baseGet(object, path);
          };
        }
        var range = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        function stubFalse() {
          return false;
        }
        function stubObject() {
          return {};
        }
        function stubString() {
          return "";
        }
        function stubTrue() {
          return true;
        }
        function times(n, iteratee2) {
          n = toInteger(n);
          if (n < 1 || n > MAX_SAFE_INTEGER) {
            return [];
          }
          var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n -= MAX_ARRAY_LENGTH;
          var result3 = baseTimes(length, iteratee2);
          while (++index < n) {
            iteratee2(index);
          }
          return result3;
        }
        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
        }
        function uniqueId(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }
        var add = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor = createRound("floor");
        function max(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined2;
        }
        function maxBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined2;
        }
        function mean(array) {
          return baseMean(array, identity);
        }
        function meanBy(array, iteratee2) {
          return baseMean(array, getIteratee(iteratee2, 2));
        }
        function min(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined2;
        }
        function minBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined2;
        }
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round = createRound("round");
        var subtract = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }
        function sumBy(array, iteratee2) {
          return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
        }
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition2;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        mixin(lodash, lodash);
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger;
        lodash.isLength = isLength;
        lodash.isMap = isMap;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN2;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject2;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined2;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt2;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result2;
        lodash.round = round;
        lodash.runInContext = runInContext2;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
          var source = {};
          baseForOwn(lodash, function(func, methodName) {
            if (!hasOwnProperty.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), { "chain": false });
        lodash.VERSION = VERSION;
        arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
          lodash[methodName].placeholder = lodash;
        });
        arrayEach(["drop", "take"], function(methodName, index) {
          LazyWrapper.prototype[methodName] = function(n) {
            n = n === undefined2 ? 1 : nativeMax(toInteger(n), 0);
            var result3 = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
            if (result3.__filtered__) {
              result3.__takeCount__ = nativeMin(n, result3.__takeCount__);
            } else {
              result3.__views__.push({
                "size": nativeMin(n, MAX_ARRAY_LENGTH),
                "type": methodName + (result3.__dir__ < 0 ? "Right" : "")
              });
            }
            return result3;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n) {
            return this.reverse()[methodName](n).reverse();
          };
        });
        arrayEach(["filter", "map", "takeWhile"], function(methodName, index) {
          var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result3 = this.clone();
            result3.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type
            });
            result3.__filtered__ = result3.__filtered__ || isFilter;
            return result3;
          };
        });
        arrayEach(["head", "last"], function(methodName, index) {
          var takeName = "take" + (index ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach(["initial", "tail"], function(methodName, index) {
          var dropName = "drop" + (index ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
          if (typeof path == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
          start = toInteger(start);
          var result3 = this;
          if (result3.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result3);
          }
          if (start < 0) {
            result3 = result3.takeRight(-start);
          } else if (start) {
            result3 = result3.drop(start);
          }
          if (end !== undefined2) {
            end = toInteger(end);
            result3 = end < 0 ? result3.dropRight(-end) : result3.take(end - start);
          }
          return result3;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash.prototype[methodName] = function() {
            var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value);
            var interceptor = function(value2) {
              var result4 = lodashFunc.apply(lodash, arrayPush([value2], args));
              return isTaker && chainAll ? result4[0] : result4;
            };
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result3 = func.apply(value, args);
              result3.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined2 });
              return new LodashWrapper(result3, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result3 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result3.value()[0] : result3.value() : result3;
          };
        });
        arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }
            return this[chainName](function(value2) {
              return func.apply(isArray(value2) ? value2 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({ "name": methodName, "func": lodashFunc });
          }
        });
        realNames[createHybrid(undefined2, WRAP_BIND_KEY_FLAG).name] = [{
          "name": "wrapper",
          "func": undefined2
        }];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) {
          lodash.prototype[symIterator] = wrapperToIterator;
        }
        return lodash;
      };
      var _ = runInContext();
      if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        root._ = _;
        define(function() {
          return _;
        });
      } else if (freeModule) {
        (freeModule.exports = _)._ = _;
        freeExports._ = _;
      } else {
        root._ = _;
      }
    }).call(exports);
  }
});

// src/utils/querystring.ts
function buildQueryString(params, parentKey) {
  const queryParts = [];
  for (const key in params) {
    if (Object.prototype.hasOwnProperty.call(params, key)) {
      const value = params[key];
      if (typeof value === "undefined")
        continue;
      if (value === null) {
        queryParts.push(`${key}=`);
        continue;
      }
      const keyName = parentKey ? `${parentKey}${encodeURIComponent(`[${key}]`)}` : encodeURIComponent(key);
      if (Array.isArray(value)) {
        value.forEach((item, index) => {
          queryParts.push(buildQueryString({ [index]: item }, keyName));
        });
      } else if (typeof value === "object") {
        queryParts.push(buildQueryString(value, keyName));
      } else {
        queryParts.push(`${keyName}=${encodeURIComponent(value != null ? value : "")}`);
      }
    }
  }
  return queryParts.join("&");
}

// src/access-control/permission.ts
var PERMISSION = /* @__PURE__ */ ((PERMISSION2) => {
  PERMISSION2["VIEW_EXPERIENCE"] = "experience:read";
  PERMISSION2["MANAGE_EXPERIENCE"] = "experience:manage";
  PERMISSION2["CURATE_EXPERIENCE"] = "experience:curate";
  PERMISSION2["CREATE_BOOKING"] = "booking:create";
  PERMISSION2["VIEW_BOOKING"] = "booking:read";
  PERMISSION2["VOID_BOOKING"] = "booking:void";
  PERMISSION2["REFUND_BOOKING"] = "booking:refund";
  PERMISSION2["CANCEL_BOOKING"] = "booking:cancel";
  PERMISSION2["RESCHEDULE_BOOKING"] = "booking:reschedule";
  PERMISSION2["CHECK_IN_BOOKING"] = "booking:check-in";
  PERMISSION2["VIEW_ALL_BOOKING"] = "booking:viewAll";
  PERMISSION2["VIEW_SESSION"] = "session:read";
  PERMISSION2["EDIT_SESSION"] = "session:edit";
  PERMISSION2["VIEW_HOST"] = "host:read";
  PERMISSION2["VIEW_HOST_FINANCIAL"] = "host:readFinancial";
  PERMISSION2["VIEW_HOST_INFO"] = "host:readInfo";
  PERMISSION2["MANAGE_HOST_IAM"] = "host:manageIAM";
  PERMISSION2["VIEW_ANALYTICS"] = "analytics:read";
  PERMISSION2["VIEW_BRAND_FINANCIAL"] = "brand:readFinancial";
  PERMISSION2["VIEW_FINANCIAL_REPORT"] = "financialReport:read";
  PERMISSION2["VIEW_GUEST_REPORT"] = "guestReport:read";
  PERMISSION2["VIEW_EXPERIENCE_REPORT"] = "experienceReport:read";
  PERMISSION2["MANAGE_BUSINESS_INFO"] = "businessInfo:manage";
  PERMISSION2["MANAGE_BANK_ACCOUNT"] = "bankAccount:manage";
  PERMISSION2["MANAGE_BRAND_IAM"] = "brand:manageIAM";
  PERMISSION2["MANAGE_BRANDING"] = "branding:manage";
  PERMISSION2["MANAGE_CATEGORY_VIBE"] = "category:manage";
  PERMISSION2["MANAGE_EMAIL"] = "email:manage";
  PERMISSION2["MANAGE_ROOM_NUMBER"] = "roomNumber:manage";
  PERMISSION2["MANAGE_LEGAL_DOCUMENT"] = "legalDocument:manage";
  PERMISSION2["MANAGE_CODE"] = "code:manage";
  PERMISSION2["MANAGE_TAX_FEE"] = "taxFee:manage";
  PERMISSION2["MANAGE_DEVELOPER"] = "developer:manage";
  PERMISSION2["MANAGE_INTEGRATION"] = "integration:manage";
  PERMISSION2["VIEW_REVIEW"] = "review:read";
  PERMISSION2["VIEW_MESSAGE"] = "messages:read";
  PERMISSION2["SEND_MESSAGE"] = "messages:send";
  PERMISSION2["VIEW_BUSINESS_INFO"] = "businessInfo:read";
  PERMISSION2["VIEW_CATEGORY_VIBE"] = "category:read";
  PERMISSION2["VIEW_TAX_FEE"] = "tax:read";
  PERMISSION2["MANAGE_MINIMAL_EXPERIENCE"] = "experience:manageMinimal";
  PERMISSION2["MANAGE_BRAND"] = "brand:manage";
  PERMISSION2["VIEW_QUESTIONS_RESPONSE"] = "booking:readCustomQuestionsResponse";
  PERMISSION2["MANAGE_QUESTIONS_RESPONSE"] = "booking:manageCustomQuestionsResponse";
  PERMISSION2["VIEW_BRAND"] = "brand:view";
  PERMISSION2["VIEW_STAFF_USER"] = "staffUser:view";
  PERMISSION2["MANAGE_STAFF_USER"] = "staffUser:manage";
  PERMISSION2["VIEW_USER"] = "user:view";
  PERMISSION2["MANAGE_USER"] = "user:manage";
  PERMISSION2["MANAGE_ORGANIZATION"] = "organization:manage";
  PERMISSION2["MANAGE_GUEST_SURVEY"] = "guestSurvey:manage";
  return PERMISSION2;
})(PERMISSION || {});
var isPermission = (permission) => Object.values(PERMISSION).includes(permission);
var BRAND_MEMBERSHIP_PERMISSIONS = [
  "experience:read" /* VIEW_EXPERIENCE */,
  "experience:manage" /* MANAGE_EXPERIENCE */,
  "booking:create" /* CREATE_BOOKING */,
  "booking:read" /* VIEW_BOOKING */,
  "booking:void" /* VOID_BOOKING */,
  "booking:refund" /* REFUND_BOOKING */,
  "booking:cancel" /* CANCEL_BOOKING */,
  "booking:reschedule" /* RESCHEDULE_BOOKING */,
  "booking:check-in" /* CHECK_IN_BOOKING */,
  "session:read" /* VIEW_SESSION */,
  "session:edit" /* EDIT_SESSION */,
  "host:read" /* VIEW_HOST */,
  "host:readFinancial" /* VIEW_HOST_FINANCIAL */,
  "host:readInfo" /* VIEW_HOST_INFO */,
  "host:manageIAM" /* MANAGE_HOST_IAM */,
  "analytics:read" /* VIEW_ANALYTICS */,
  "brand:readFinancial" /* VIEW_BRAND_FINANCIAL */,
  "financialReport:read" /* VIEW_FINANCIAL_REPORT */,
  "experienceReport:read" /* VIEW_EXPERIENCE_REPORT */,
  "guestReport:read" /* VIEW_GUEST_REPORT */,
  "businessInfo:manage" /* MANAGE_BUSINESS_INFO */,
  "bankAccount:manage" /* MANAGE_BANK_ACCOUNT */,
  "brand:manageIAM" /* MANAGE_BRAND_IAM */,
  "branding:manage" /* MANAGE_BRANDING */,
  "category:manage" /* MANAGE_CATEGORY_VIBE */,
  "email:manage" /* MANAGE_EMAIL */,
  "roomNumber:manage" /* MANAGE_ROOM_NUMBER */,
  "legalDocument:manage" /* MANAGE_LEGAL_DOCUMENT */,
  "code:manage" /* MANAGE_CODE */,
  "taxFee:manage" /* MANAGE_TAX_FEE */,
  "developer:manage" /* MANAGE_DEVELOPER */,
  "integration:manage" /* MANAGE_INTEGRATION */,
  "review:read" /* VIEW_REVIEW */,
  "messages:read" /* VIEW_MESSAGE */,
  "messages:send" /* SEND_MESSAGE */,
  "businessInfo:read" /* VIEW_BUSINESS_INFO */,
  "category:read" /* VIEW_CATEGORY_VIBE */,
  "tax:read" /* VIEW_TAX_FEE */,
  "experience:manageMinimal" /* MANAGE_MINIMAL_EXPERIENCE */,
  "booking:readCustomQuestionsResponse" /* VIEW_QUESTIONS_RESPONSE */,
  "booking:manageCustomQuestionsResponse" /* MANAGE_QUESTIONS_RESPONSE */
];
var isBrandMembershipPermission = (permission) => BRAND_MEMBERSHIP_PERMISSIONS.includes(permission);
var ORGANIZATION_MEMBERSHIP_PERMISSIONS = [...BRAND_MEMBERSHIP_PERMISSIONS, "organization:manage" /* MANAGE_ORGANIZATION */];
var isOrganizationMembershipPermission = (permission) => ORGANIZATION_MEMBERSHIP_PERMISSIONS.includes(permission);
var ADMIN_PERMISSIONS = [
  "experience:read" /* VIEW_EXPERIENCE */,
  "experience:manage" /* MANAGE_EXPERIENCE */,
  "booking:create" /* CREATE_BOOKING */,
  "booking:read" /* VIEW_BOOKING */,
  "booking:void" /* VOID_BOOKING */,
  "booking:refund" /* REFUND_BOOKING */,
  "booking:cancel" /* CANCEL_BOOKING */,
  "booking:reschedule" /* RESCHEDULE_BOOKING */,
  "booking:check-in" /* CHECK_IN_BOOKING */,
  "session:read" /* VIEW_SESSION */,
  "session:edit" /* EDIT_SESSION */,
  "host:read" /* VIEW_HOST */,
  "host:readFinancial" /* VIEW_HOST_FINANCIAL */,
  "host:readInfo" /* VIEW_HOST_INFO */,
  "host:manageIAM" /* MANAGE_HOST_IAM */,
  "analytics:read" /* VIEW_ANALYTICS */,
  "brand:readFinancial" /* VIEW_BRAND_FINANCIAL */,
  "financialReport:read" /* VIEW_FINANCIAL_REPORT */,
  "experienceReport:read" /* VIEW_EXPERIENCE_REPORT */,
  "guestReport:read" /* VIEW_GUEST_REPORT */,
  "businessInfo:manage" /* MANAGE_BUSINESS_INFO */,
  "bankAccount:manage" /* MANAGE_BANK_ACCOUNT */,
  "brand:manageIAM" /* MANAGE_BRAND_IAM */,
  "branding:manage" /* MANAGE_BRANDING */,
  "category:manage" /* MANAGE_CATEGORY_VIBE */,
  "email:manage" /* MANAGE_EMAIL */,
  "roomNumber:manage" /* MANAGE_ROOM_NUMBER */,
  "legalDocument:manage" /* MANAGE_LEGAL_DOCUMENT */,
  "code:manage" /* MANAGE_CODE */,
  "taxFee:manage" /* MANAGE_TAX_FEE */,
  "developer:manage" /* MANAGE_DEVELOPER */,
  "integration:manage" /* MANAGE_INTEGRATION */,
  "review:read" /* VIEW_REVIEW */,
  "experience:manageMinimal" /* MANAGE_MINIMAL_EXPERIENCE */,
  "booking:readCustomQuestionsResponse" /* VIEW_QUESTIONS_RESPONSE */,
  "booking:manageCustomQuestionsResponse" /* MANAGE_QUESTIONS_RESPONSE */,
  "messages:read" /* VIEW_MESSAGE */,
  "messages:send" /* SEND_MESSAGE */,
  "category:read" /* VIEW_CATEGORY_VIBE */
];
var isAdminPermission = (permission) => ADMIN_PERMISSIONS.includes(permission);
var HOST_PERMISSIONS = [
  "booking:read" /* VIEW_BOOKING */,
  "businessInfo:read" /* VIEW_BUSINESS_INFO */,
  "category:read" /* VIEW_CATEGORY_VIBE */,
  "tax:read" /* VIEW_TAX_FEE */,
  "experience:manageMinimal" /* MANAGE_MINIMAL_EXPERIENCE */,
  "host:readFinancial" /* VIEW_HOST_FINANCIAL */,
  "booking:readCustomQuestionsResponse" /* VIEW_QUESTIONS_RESPONSE */,
  "booking:manageCustomQuestionsResponse" /* MANAGE_QUESTIONS_RESPONSE */,
  "messages:read" /* VIEW_MESSAGE */,
  "messages:send" /* SEND_MESSAGE */,
  "booking:check-in" /* CHECK_IN_BOOKING */
];
var isHostPermission = (permission) => HOST_PERMISSIONS.includes(permission);
var INTEGRATION_PERMISSIONS = [
  "booking:refund" /* REFUND_BOOKING */,
  "booking:cancel" /* CANCEL_BOOKING */,
  "booking:void" /* VOID_BOOKING */
];
var isIntegrationPermission = (permission) => INTEGRATION_PERMISSIONS.includes(permission);
var ADDITIONAL_HOST_PERMISSIONS = [
  "booking:cancel" /* CANCEL_BOOKING */,
  "booking:reschedule" /* RESCHEDULE_BOOKING */,
  "booking:void" /* VOID_BOOKING */,
  "booking:refund" /* REFUND_BOOKING */,
  "booking:create" /* CREATE_BOOKING */
];
var isAdditionalHostPermission = (permission) => ADDITIONAL_HOST_PERMISSIONS.includes(permission);
var STAFF_ONLY_PERMISSIONS = [
  "category:read" /* VIEW_CATEGORY_VIBE */,
  "businessInfo:read" /* VIEW_BUSINESS_INFO */,
  "tax:read" /* VIEW_TAX_FEE */,
  "staffUser:view" /* VIEW_STAFF_USER */,
  "staffUser:manage" /* MANAGE_STAFF_USER */,
  "experience:curate" /* CURATE_EXPERIENCE */,
  "brand:view" /* VIEW_BRAND */,
  "brand:manage" /* MANAGE_BRAND */,
  "user:manage" /* MANAGE_USER */,
  "user:view" /* VIEW_USER */,
  "booking:viewAll" /* VIEW_ALL_BOOKING */,
  "organization:manage" /* MANAGE_ORGANIZATION */,
  "guestSurvey:manage" /* MANAGE_GUEST_SURVEY */
];
var ORGANIZATION_ONLY_PERMISSIONS = ["organization:manage" /* MANAGE_ORGANIZATION */];
var ACCOUNT_EXECUTIVE_PERMISSIONS = [
  "experience:read" /* VIEW_EXPERIENCE */,
  "booking:read" /* VIEW_BOOKING */,
  "session:read" /* VIEW_SESSION */,
  "host:read" /* VIEW_HOST */,
  "host:readFinancial" /* VIEW_HOST_FINANCIAL */,
  "host:readInfo" /* VIEW_HOST_INFO */,
  "analytics:read" /* VIEW_ANALYTICS */,
  "brand:readFinancial" /* VIEW_BRAND_FINANCIAL */,
  "financialReport:read" /* VIEW_FINANCIAL_REPORT */,
  "experienceReport:read" /* VIEW_EXPERIENCE_REPORT */,
  "guestReport:read" /* VIEW_GUEST_REPORT */,
  "review:read" /* VIEW_REVIEW */,
  "businessInfo:read" /* VIEW_BUSINESS_INFO */,
  "category:read" /* VIEW_CATEGORY_VIBE */,
  "tax:read" /* VIEW_TAX_FEE */,
  "booking:readCustomQuestionsResponse" /* VIEW_QUESTIONS_RESPONSE */,
  "messages:read" /* VIEW_MESSAGE */,
  "brand:view" /* VIEW_BRAND */
];
var CUSTOMER_SUCCESS_MANAGEMENT_PERMISSIONS = [
  ...ACCOUNT_EXECUTIVE_PERMISSIONS,
  "booking:create" /* CREATE_BOOKING */,
  "booking:void" /* VOID_BOOKING */,
  "booking:refund" /* REFUND_BOOKING */,
  "booking:cancel" /* CANCEL_BOOKING */,
  "booking:reschedule" /* RESCHEDULE_BOOKING */,
  "booking:viewAll" /* VIEW_ALL_BOOKING */,
  "session:edit" /* EDIT_SESSION */,
  "user:view" /* VIEW_USER */,
  "user:manage" /* MANAGE_USER */,
  "host:manageIAM" /* MANAGE_HOST_IAM */,
  "businessInfo:manage" /* MANAGE_BUSINESS_INFO */,
  "bankAccount:manage" /* MANAGE_BANK_ACCOUNT */,
  "brand:manageIAM" /* MANAGE_BRAND_IAM */,
  "category:manage" /* MANAGE_CATEGORY_VIBE */,
  "email:manage" /* MANAGE_EMAIL */,
  "roomNumber:manage" /* MANAGE_ROOM_NUMBER */,
  "legalDocument:manage" /* MANAGE_LEGAL_DOCUMENT */,
  "code:manage" /* MANAGE_CODE */,
  "taxFee:manage" /* MANAGE_TAX_FEE */,
  "developer:manage" /* MANAGE_DEVELOPER */,
  "integration:manage" /* MANAGE_INTEGRATION */,
  "experience:manageMinimal" /* MANAGE_MINIMAL_EXPERIENCE */,
  "experience:curate" /* CURATE_EXPERIENCE */,
  "booking:manageCustomQuestionsResponse" /* MANAGE_QUESTIONS_RESPONSE */,
  "experience:manage" /* MANAGE_EXPERIENCE */,
  "messages:send" /* SEND_MESSAGE */,
  "booking:check-in" /* CHECK_IN_BOOKING */,
  "organization:manage" /* MANAGE_ORGANIZATION */
];
var STAFF_ADMIN_PERMISSIONS = [
  ...CUSTOMER_SUCCESS_MANAGEMENT_PERMISSIONS,
  "brand:manage" /* MANAGE_BRAND */,
  "staffUser:view" /* VIEW_STAFF_USER */,
  "staffUser:manage" /* MANAGE_STAFF_USER */,
  "guestSurvey:manage" /* MANAGE_GUEST_SURVEY */
];
var SYSTEM_PERMISSIONS = [
  "experience:manage" /* MANAGE_EXPERIENCE */,
  "booking:read" /* VIEW_BOOKING */,
  "booking:cancel" /* CANCEL_BOOKING */,
  "booking:refund" /* REFUND_BOOKING */
];

// src/access-control/staff.ts
var StaffRole = /* @__PURE__ */ ((StaffRole2) => {
  StaffRole2["OWNER"] = "owner";
  StaffRole2["ADMIN"] = "admin";
  StaffRole2["CSM"] = "csm";
  StaffRole2["AE"] = "ae";
  return StaffRole2;
})(StaffRole || {});

// src/api/add-on/add-on.ts
import { z as z18 } from "zod";

// src/utils/image-size.ts
import { z } from "zod";
var ImageSizeInUriSchemaBuilder = (imageSizes) => {
  return z.object(
    Object.fromEntries(imageSizes.map((size) => [`${size}w`, z.string()]))
  );
};
var ImageSizeWithOriginalInUriSchemaBuilder = (imageSizes) => {
  return ImageSizeInUriSchemaBuilder(imageSizes).extend({ original: z.string() });
};

// src/api/common.ts
import { z as z3 } from "zod";

// src/api/media/media.ts
import { z as z2 } from "zod";
var IMediaReferenceSchema = z2.object({
  id: z2.string(),
  uri: z2.object({
    original: z2.string()
  })
});
var DocumentCategory = /* @__PURE__ */ ((DocumentCategory2) => {
  DocumentCategory2["CERTIFICATE_OF_INSURANCE"] = "certificate_of_insurance";
  DocumentCategory2["BRAND_HOST_AGREEMENT"] = "brand_host_agreement";
  DocumentCategory2["OTHER"] = "other";
  return DocumentCategory2;
})(DocumentCategory || {});
var DocumentSchema = z2.object({
  id: z2.string().uuid(),
  label: z2.string(),
  uri: z2.string(),
  brandId: z2.string().uuid(),
  userId: z2.string().uuid().nullable(),
  uploadedById: z2.string().uuid(),
  category: z2.nativeEnum(DocumentCategory),
  metadata: z2.record(z2.unknown()).nullable().optional().transform((metadata) => metadata != null ? metadata : null),
  uploadedAt: z2.string().datetime(),
  updatedAt: z2.string().datetime()
});
var GetDocumentsQuerySchema = z2.object({
  userId: z2.string().uuid().optional()
});
var GetDocumentSignedUrlResponseSchema = z2.object({
  name: z2.string(),
  url: z2.string()
});
var UploadDocumentRequestSchema = z2.object({
  userId: z2.string().uuid(),
  category: z2.nativeEnum(DocumentCategory),
  label: z2.string().nullable().optional()
});
var UpdateDocumentRequestSchema = z2.object({
  label: z2.string()
});
var GetDocumentsResponseSchema = z2.array(DocumentSchema);

// ../node_modules/libphonenumber-js/metadata.min.json.js
var metadata_min_json_default = { "version": 4, "country_calling_codes": { "1": ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], "7": ["RU", "KZ"], "20": ["EG"], "27": ["ZA"], "30": ["GR"], "31": ["NL"], "32": ["BE"], "33": ["FR"], "34": ["ES"], "36": ["HU"], "39": ["IT", "VA"], "40": ["RO"], "41": ["CH"], "43": ["AT"], "44": ["GB", "GG", "IM", "JE"], "45": ["DK"], "46": ["SE"], "47": ["NO", "SJ"], "48": ["PL"], "49": ["DE"], "51": ["PE"], "52": ["MX"], "53": ["CU"], "54": ["AR"], "55": ["BR"], "56": ["CL"], "57": ["CO"], "58": ["VE"], "60": ["MY"], "61": ["AU", "CC", "CX"], "62": ["ID"], "63": ["PH"], "64": ["NZ"], "65": ["SG"], "66": ["TH"], "81": ["JP"], "82": ["KR"], "84": ["VN"], "86": ["CN"], "90": ["TR"], "91": ["IN"], "92": ["PK"], "93": ["AF"], "94": ["LK"], "95": ["MM"], "98": ["IR"], "211": ["SS"], "212": ["MA", "EH"], "213": ["DZ"], "216": ["TN"], "218": ["LY"], "220": ["GM"], "221": ["SN"], "222": ["MR"], "223": ["ML"], "224": ["GN"], "225": ["CI"], "226": ["BF"], "227": ["NE"], "228": ["TG"], "229": ["BJ"], "230": ["MU"], "231": ["LR"], "232": ["SL"], "233": ["GH"], "234": ["NG"], "235": ["TD"], "236": ["CF"], "237": ["CM"], "238": ["CV"], "239": ["ST"], "240": ["GQ"], "241": ["GA"], "242": ["CG"], "243": ["CD"], "244": ["AO"], "245": ["GW"], "246": ["IO"], "247": ["AC"], "248": ["SC"], "249": ["SD"], "250": ["RW"], "251": ["ET"], "252": ["SO"], "253": ["DJ"], "254": ["KE"], "255": ["TZ"], "256": ["UG"], "257": ["BI"], "258": ["MZ"], "260": ["ZM"], "261": ["MG"], "262": ["RE", "YT"], "263": ["ZW"], "264": ["NA"], "265": ["MW"], "266": ["LS"], "267": ["BW"], "268": ["SZ"], "269": ["KM"], "290": ["SH", "TA"], "291": ["ER"], "297": ["AW"], "298": ["FO"], "299": ["GL"], "350": ["GI"], "351": ["PT"], "352": ["LU"], "353": ["IE"], "354": ["IS"], "355": ["AL"], "356": ["MT"], "357": ["CY"], "358": ["FI", "AX"], "359": ["BG"], "370": ["LT"], "371": ["LV"], "372": ["EE"], "373": ["MD"], "374": ["AM"], "375": ["BY"], "376": ["AD"], "377": ["MC"], "378": ["SM"], "380": ["UA"], "381": ["RS"], "382": ["ME"], "383": ["XK"], "385": ["HR"], "386": ["SI"], "387": ["BA"], "389": ["MK"], "420": ["CZ"], "421": ["SK"], "423": ["LI"], "500": ["FK"], "501": ["BZ"], "502": ["GT"], "503": ["SV"], "504": ["HN"], "505": ["NI"], "506": ["CR"], "507": ["PA"], "508": ["PM"], "509": ["HT"], "590": ["GP", "BL", "MF"], "591": ["BO"], "592": ["GY"], "593": ["EC"], "594": ["GF"], "595": ["PY"], "596": ["MQ"], "597": ["SR"], "598": ["UY"], "599": ["CW", "BQ"], "670": ["TL"], "672": ["NF"], "673": ["BN"], "674": ["NR"], "675": ["PG"], "676": ["TO"], "677": ["SB"], "678": ["VU"], "679": ["FJ"], "680": ["PW"], "681": ["WF"], "682": ["CK"], "683": ["NU"], "685": ["WS"], "686": ["KI"], "687": ["NC"], "688": ["TV"], "689": ["PF"], "690": ["TK"], "691": ["FM"], "692": ["MH"], "850": ["KP"], "852": ["HK"], "853": ["MO"], "855": ["KH"], "856": ["LA"], "880": ["BD"], "886": ["TW"], "960": ["MV"], "961": ["LB"], "962": ["JO"], "963": ["SY"], "964": ["IQ"], "965": ["KW"], "966": ["SA"], "967": ["YE"], "968": ["OM"], "970": ["PS"], "971": ["AE"], "972": ["IL"], "973": ["BH"], "974": ["QA"], "975": ["BT"], "976": ["MN"], "977": ["NP"], "992": ["TJ"], "993": ["TM"], "994": ["AZ"], "995": ["GE"], "996": ["KG"], "998": ["UZ"] }, "countries": { "AC": ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], "AD": ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], "AE": ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AF": ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], "AG": ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], "AI": ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], "AL": ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], "AM": ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], "AO": ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], "AR": ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], "AS": ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], "AT": ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AU": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "AW": ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], "AX": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], "AZ": ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], "BA": ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], "BB": ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], "BD": ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|22"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], "BE": ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], "BF": ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], "BG": ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], "BH": ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], "BI": ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], "BJ": ["229", "00", "[24-689]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]]]], "BL": ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], "BM": ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], "BN": ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], "BO": ["591", "00(?:1\\d)?", "(?:[2-467]\\d\\d|8001)\\d{5}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[23]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], "BQ": ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], "BR": ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], "BS": ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], "BT": ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], "BW": ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], "BY": ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], "BZ": ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], "CA": ["1", "011", "(?:[2-8]\\d|90)\\d{8}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|73)|90[25])[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|622)[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], "CC": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CD": ["243", "00", "[189]\\d{8}|[1-68]\\d{6}", [7, 9], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], "CF": ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], "CG": ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], "CH": ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], "CI": ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], "CK": ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], "CL": ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], "CM": ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], "CN": ["86", "00|1(?:[12]\\d|79)\\d\\d00", "1[127]\\d{8,9}|2\\d{9}(?:\\d{2})?|[12]\\d{6,7}|86\\d{6}|(?:1[03-689]\\d|6)\\d{7,9}|(?:[3-579]\\d|8[0-57-9])\\d{6,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]", "(?:10|2[0-57-9])(?:10|9[56])", "10(?:10|9[56])|2[0-57-9](?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], "CO": ["57", "00(?:4(?:[14]4|56)|[579])", "(?:60\\d\\d|9101)\\d{6}|(?:1\\d|3)\\d{9}", [10, 11], [["(\\d{3})(\\d{7})", "$1 $2", ["6"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], "CR": ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], "CU": ["53", "119", "[27]\\d{6,7}|[34]\\d{5,7}|63\\d{6}|(?:5|8\\d\\d)\\d{7}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], "CV": ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], "CW": ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], "CX": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:(?:79|94)[01]|83[0-389])\\d{5}|4(?:[0-3]\\d|4[047-9]|5[0-25-9]|6[0-36-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CY": ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], "CZ": ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], "DE": ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], "DJ": ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], "DK": ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], "DM": ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], "DO": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], "DZ": ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], "EC": ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], "EE": ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "EG": ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], "EH": ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], "ER": ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], "ES": ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], "ET": ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], "FI": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:1[3-79]|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], "FJ": ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "FK": ["500", "00", "[2-7]\\d{4}", [5]], "FM": ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], "FO": ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], "FR": ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], "GA": ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], "GB": ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0235])|4(?:[0-5]\\d\\d|69[7-9]|70[0-79])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-2]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], "GD": ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], "GE": ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], "GF": ["594", "00", "[56]94\\d{6}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[56]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], "GG": ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], "GH": ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], "GI": ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], "GL": ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], "GM": ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "GN": ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], "GP": ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], "GQ": ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], "GR": ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], "GT": ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "GU": ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], "GW": ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], "GY": ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "HK": ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "HN": ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], "HR": ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-5]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], "HT": ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], "HU": ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], "ID": ["62", "00[89]", "(?:(?:00[1-9]|8\\d)\\d{4}|[1-36])\\d{6}|00\\d{10}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], "IE": ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "IL": ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], "IM": ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], "IN": ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], "IO": ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], "IQ": ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "IR": ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], "IS": ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "IT": ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}"], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], 0, 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], "JE": ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97[7-9]))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], "JM": ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], "JO": ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "JP": ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], "KE": ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], "KG": ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "KH": ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "KI": ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], "KM": ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], "KN": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], "KP": ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], "KR": ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], "KW": ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], "KY": ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], "KZ": ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], "LA": ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[013-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], "LB": ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], "LC": ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], "LI": ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], "LK": ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], "LR": ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], "LS": ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], "LT": ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(8-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "8 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(8-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(8-$1)", 1]], "8", 0, "[08]"], "LU": ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], "LV": ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], "LY": ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], "MA": ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-489]|3[5-9]|9)|8(?:0[89]|92)", "5(?:2(?:[2-49]|8[235-9])|3[5-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-2]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], "MC": ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], "MD": ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], "ME": ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], "MF": ["590", "00", "590\\d{6}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["69(?:0\\d\\d|1(?:2[2-9]|3[0-5]))\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:395|76[018])\\d|475[0-5])\\d{4}"]]], "MG": ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], "MH": ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], "MK": ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], "ML": ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], "MM": ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["[45]|6(?:0[23]|[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-6]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], "MN": ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], "MO": ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], "MP": ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], "MQ": ["596", "00", "596\\d{6}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[569]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "MR": ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], "MS": ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], "MT": ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], "MU": ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], "MV": ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "MW": ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], "MX": ["52", "0[09]", "1(?:(?:[27]2|44|87|99)[1-9]|65[0-689])\\d{7}|(?:1(?:[01]\\d|2[13-9]|[35][1-9]|4[0-35-9]|6[0-46-9]|7[013-9]|8[1-69]|9[1-8])|[2-9]\\d)\\d{8}", [10, 11], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"], 0, 1], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 $3 $4", ["1(?:33|5[56]|81)"], 0, 1], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 $3 $4", ["1"], 0, 1]], "01", 0, "0(?:[12]|4[45])|1", 0, 0, 0, 0, "00"], "MY": ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], "MZ": ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "NA": ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "NC": ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], "NE": ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[047]"]]]], "NF": ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], "NG": ["234", "009", "2[0-24-9]\\d{8}|[78]\\d{10,13}|[7-9]\\d{9}|[1-9]\\d{7}|[124-7]\\d{6}", [7, 8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["78"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|9(?:0[3-9]|[1-9])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[3-7]|8[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], "NI": ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], "NL": ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], "NO": ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], "NP": ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], "NR": ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], "NU": ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], "NZ": ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], "OM": ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], "PA": ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], "PE": ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], "PF": ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "PG": ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "PH": ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], "PK": ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], "PL": ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], "PM": ["508", "00", "[45]\\d{5}|(?:708|80\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "PR": ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], "PS": ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "PT": ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], "PW": ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "PY": ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], "QA": ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], "RE": ["262", "00", "(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2689]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[27]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], "RO": ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], "RS": ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], "RU": ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], "RW": ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], "SA": ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], "SB": ["677", "0[01]", "(?:[1-6]|[7-9]\\d\\d)\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], "SC": ["248", "010|0[0-2]", "800\\d{4}|(?:[249]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "SD": ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "SE": ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], "SG": ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-8]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "SH": ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], "SI": ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], "SJ": ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], "SK": ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], "SL": ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], "SM": ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], "SN": ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], "SO": ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], "SR": ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], "SS": ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "ST": ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], "SV": ["503", "00", "[267]\\d{7}|[89]00\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], "SX": ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], "SY": ["963", "00", "[1-39]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-5]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1", 1]], "0"], "SZ": ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], "TA": ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], "TC": ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], "TD": ["235", "00|16", "(?:22|[69]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2679]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "TG": ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], "TH": ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "TJ": ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3[1-5]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], "TK": ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], "TL": ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], "TM": ["993", "810", "[1-6]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["6"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], "TN": ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], "TO": ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], "TR": ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], "TT": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], "TV": ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "TW": ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], "TZ": ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], "UA": ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], "UG": ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], "US": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:5056(?:[0-35-9]\\d|4[468])|7302[01]\\d)\\d{4}|(?:472[24]|505[2-57-9]|983[289])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[149]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-57-9]|1[02-9]|2[013569]|3[0-24679]|4[167]|5[0-2]|6[0149]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-7]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"]]], "UY": ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], "UZ": ["998", "810", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], "VA": ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11], 0, 0, 0, 0, 0, 0, "06698"], "VC": ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], "VE": ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], "VG": ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], "VI": ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], "VN": ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], "VU": ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], "WF": ["681", "00", "(?:40|72)\\d{4}|8\\d{5}(?:\\d{3})?", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[478]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "WS": ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "XK": ["383", "00", "[23]\\d{7,8}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[23]"], "0$1"]], "0"], "YE": ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], "YT": ["262", "00", "(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], "ZA": ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "ZM": ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], "ZW": ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, "nonGeographic": { "800": ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], "808": ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], "870": ["870", 0, "7\\d{11}|[35-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[35-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"]]], "878": ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], "881": ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], "882": ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, 0, 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], "883": ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], "888": ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], "979": ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };

// ../node_modules/libphonenumber-js/min/exports/withMetadataArgument.js
function withMetadataArgument(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  args.push(metadata_min_json_default);
  return func.apply(this, args);
}

// ../node_modules/libphonenumber-js/es6/ParseError.js
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result2);
  };
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } });
    return _setPrototypeOf(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a = [null];
      a.push.apply(a, args2);
      var Constructor = Function.bind.apply(Parent2, a);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
var ParseError = /* @__PURE__ */ function(_Error) {
  _inherits(ParseError2, _Error);
  var _super = _createSuper(ParseError2);
  function ParseError2(code) {
    var _this;
    _classCallCheck(this, ParseError2);
    _this = _super.call(this, code);
    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError2.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }
  return _createClass(ParseError2);
}(/* @__PURE__ */ _wrapNativeSuper(Error));

// ../node_modules/libphonenumber-js/es6/constants.js
var MIN_LENGTH_FOR_NSN = 2;
var MAX_LENGTH_FOR_NSN = 17;
var MAX_LENGTH_COUNTRY_CODE = 3;
var VALID_DIGITS = "0-9\uFF10-\uFF19\u0660-\u0669\u06F0-\u06F9";
var DASHES = "-\u2010-\u2015\u2212\u30FC\uFF0D";
var SLASHES = "\uFF0F/";
var DOTS = "\uFF0E.";
var WHITESPACE = " \xA0\xAD\u200B\u2060\u3000";
var BRACKETS = "()\uFF08\uFF09\uFF3B\uFF3D\\[\\]";
var TILDES = "~\u2053\u223C\uFF5E";
var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+\uFF0B";

// ../node_modules/libphonenumber-js/es6/tools/semver-compare.js
function semver_compare_default(a, b) {
  a = a.split("-");
  b = b.split("-");
  var pa = a[0].split(".");
  var pb = b[0].split(".");
  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb)
      return 1;
    if (nb > na)
      return -1;
    if (!isNaN(na) && isNaN(nb))
      return 1;
    if (isNaN(na) && !isNaN(nb))
      return -1;
  }
  if (a[1] && b[1]) {
    return a[1] > b[1] ? 1 : a[1] < b[1] ? -1 : 0;
  }
  return !a[1] && b[1] ? 1 : a[1] && !b[1] ? -1 : 0;
}

// ../node_modules/libphonenumber-js/es6/helpers/isObject.js
var objectConstructor = {}.constructor;
function isObject(object) {
  return object !== void 0 && object !== null && object.constructor === objectConstructor;
}

// ../node_modules/libphonenumber-js/es6/metadata.js
function _typeof2(obj) {
  "@babel/helpers - typeof";
  return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof2(obj);
}
function _classCallCheck2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass2(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties2(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties2(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var V3 = "1.2.0";
var V4 = "1.7.35";
var DEFAULT_EXT_PREFIX = " ext. ";
var CALLING_CODE_REG_EXP = /^\d+$/;
var Metadata = /* @__PURE__ */ function() {
  function Metadata2(metadata) {
    _classCallCheck2(this, Metadata2);
    validateMetadata(metadata);
    this.metadata = metadata;
    setVersion.call(this, metadata);
  }
  _createClass2(Metadata2, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function(_) {
        return _ !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3)
        return;
      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }
      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    }
    // Deprecated.
  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }
      if (countryCode && countryCode !== "001") {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }
        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = void 0;
      }
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];
      if (countryCodes) {
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }
        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);
      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }
      if (this.nonGeographic()) {
        var metadata = this.nonGeographic()[callingCode];
        if (metadata) {
          return metadata;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return this.metadata.countries["001"];
        }
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function type(_type) {
      return this.numberingPlan.type(_type);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1)
        return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== void 0;
    }
  }]);
  return Metadata2;
}();
var NumberingPlan = /* @__PURE__ */ function() {
  function NumberingPlan2(metadata, globalMetadataObject) {
    _classCallCheck2(this, NumberingPlan2);
    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata;
    setVersion.call(this, globalMetadataObject.metadata);
  }
  _createClass2(NumberingPlan2, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2)
        return;
      return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2)
        return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2)
        return this.metadata[1];
      return this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1)
        return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata) {
      return metadata[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function formats() {
      var _this = this;
      var formats2 = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats2.map(function(_) {
        return new Format(_, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata) {
      return metadata[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      if (this.types() && this.types().length === 0) {
        return false;
      }
      return !!this.types();
    }
  }, {
    key: "type",
    value: function type(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2)
        return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);
  return NumberingPlan2;
}();
var Format = /* @__PURE__ */ function() {
  function Format2(format, metadata) {
    _classCallCheck2(this, Format2);
    this._format = format;
    this.metadata = metadata;
  }
  _createClass2(Format2, [{
    key: "pattern",
    value: function pattern() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);
  return Format2;
}();
var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var Type = /* @__PURE__ */ function() {
  function Type2(type, metadata) {
    _classCallCheck2(this, Type2);
    this.type = type;
    this.metadata = metadata;
  }
  _createClass2(Type2, [{
    key: "pattern",
    value: function pattern() {
      if (this.metadata.v1)
        return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1)
        return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
  return Type2;
}();
function getType(types, type) {
  switch (type) {
    case "FIXED_LINE":
      return types[0];
    case "MOBILE":
      return types[1];
    case "TOLL_FREE":
      return types[2];
    case "PREMIUM_RATE":
      return types[3];
    case "PERSONAL_NUMBER":
      return types[4];
    case "VOICEMAIL":
      return types[5];
    case "UAN":
      return types[6];
    case "PAGER":
      return types[7];
    case "VOIP":
      return types[8];
    case "SHARED_COST":
      return types[9];
  }
}
function validateMetadata(metadata) {
  if (!metadata) {
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  }
  if (!isObject(metadata) || !isObject(metadata.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject(metadata) ? "an object of shape: { " + Object.keys(metadata).join(", ") + " }" : "a " + typeOf(metadata) + ": " + metadata, "."));
  }
}
var typeOf = function typeOf2(_) {
  return _typeof2(_);
};
function getCountryCallingCode(country, metadata) {
  metadata = new Metadata(metadata);
  if (metadata.hasCountry(country)) {
    return metadata.country(country).countryCallingCode();
  }
  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata) {
  return metadata.countries.hasOwnProperty(country);
}
function setVersion(metadata) {
  var version = metadata.version;
  if (typeof version === "number") {
    this.v1 = version === 1;
    this.v2 = version === 2;
    this.v3 = version === 3;
    this.v4 = version === 4;
  } else {
    if (!version) {
      this.v1 = true;
    } else if (semver_compare_default(version, V3) === -1) {
      this.v2 = true;
    } else if (semver_compare_default(version, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
}

// ../node_modules/libphonenumber-js/es6/helpers/extension/createExtensionPattern.js
var RFC3966_EXTN_PREFIX = ";ext=";
var getExtensionDigitsPattern = function getExtensionDigitsPattern2(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
function createExtensionPattern(purpose) {
  var extLimitAfterExplicitLabel = "20";
  var extLimitAfterLikelyLabel = "15";
  var extLimitAfterAmbiguousChar = "9";
  var extLimitWhenNotSure = "6";
  var possibleSeparatorsBetweenNumberAndExtLabel = "[ \xA0\\t,]*";
  var possibleCharsAfterExtLabel = "[:\\.\uFF0E]?[ \xA0\\t,-]*";
  var optionalExtnSuffix = "#?";
  var explicitExtLabels = "(?:e?xt(?:ensi(?:o\u0301?|\xF3))?n?|\uFF45?\uFF58\uFF54\uFF4E?|\u0434\u043E\u0431|anexo)";
  var ambiguousExtLabels = "(?:[x\uFF58#\uFF03~\uFF5E]|int|\uFF49\uFF4E\uFF54)";
  var ambiguousSeparator = "[- ]+";
  var possibleSeparatorsNumberExtLabelNoComma = "[ \xA0\\t]*";
  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}

// ../node_modules/libphonenumber-js/es6/helpers/isViablePhoneNumber.js
var MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + VALID_DIGITS + "]{" + MIN_LENGTH_FOR_NSN + "}";
var VALID_PHONE_NUMBER = "[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){3,}[" + VALID_PUNCTUATION + VALID_DIGITS + "]*";
var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){1,2}$", "i");
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
"(?:" + createExtensionPattern() + ")?";
var VALID_PHONE_NUMBER_PATTERN = new RegExp(
  // Either a short two-digit-only phone number
  "^" + MIN_LENGTH_PHONE_NUMBER_PATTERN + "$|^" + VALID_PHONE_NUMBER_WITH_EXTENSION + "$",
  "i"
);
function isViablePhoneNumber(number) {
  return number.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number);
}
function isViablePhoneNumberStart(number) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number);
}

// ../node_modules/libphonenumber-js/es6/helpers/extension/extractExtension.js
var EXTN_PATTERN = new RegExp("(?:" + createExtensionPattern() + ")$", "i");
function extractExtension(number) {
  var start = number.search(EXTN_PATTERN);
  if (start < 0) {
    return {};
  }
  var numberWithoutExtension = number.slice(0, start);
  var matches = number.match(EXTN_PATTERN);
  var i = 1;
  while (i < matches.length) {
    if (matches[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches[i]
      };
    }
    i++;
  }
}

// ../node_modules/libphonenumber-js/es6/helpers/parseDigits.js
var DIGITS = {
  "0": "0",
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "6": "6",
  "7": "7",
  "8": "8",
  "9": "9",
  "\uFF10": "0",
  // Fullwidth digit 0
  "\uFF11": "1",
  // Fullwidth digit 1
  "\uFF12": "2",
  // Fullwidth digit 2
  "\uFF13": "3",
  // Fullwidth digit 3
  "\uFF14": "4",
  // Fullwidth digit 4
  "\uFF15": "5",
  // Fullwidth digit 5
  "\uFF16": "6",
  // Fullwidth digit 6
  "\uFF17": "7",
  // Fullwidth digit 7
  "\uFF18": "8",
  // Fullwidth digit 8
  "\uFF19": "9",
  // Fullwidth digit 9
  "\u0660": "0",
  // Arabic-indic digit 0
  "\u0661": "1",
  // Arabic-indic digit 1
  "\u0662": "2",
  // Arabic-indic digit 2
  "\u0663": "3",
  // Arabic-indic digit 3
  "\u0664": "4",
  // Arabic-indic digit 4
  "\u0665": "5",
  // Arabic-indic digit 5
  "\u0666": "6",
  // Arabic-indic digit 6
  "\u0667": "7",
  // Arabic-indic digit 7
  "\u0668": "8",
  // Arabic-indic digit 8
  "\u0669": "9",
  // Arabic-indic digit 9
  "\u06F0": "0",
  // Eastern-Arabic digit 0
  "\u06F1": "1",
  // Eastern-Arabic digit 1
  "\u06F2": "2",
  // Eastern-Arabic digit 2
  "\u06F3": "3",
  // Eastern-Arabic digit 3
  "\u06F4": "4",
  // Eastern-Arabic digit 4
  "\u06F5": "5",
  // Eastern-Arabic digit 5
  "\u06F6": "6",
  // Eastern-Arabic digit 6
  "\u06F7": "7",
  // Eastern-Arabic digit 7
  "\u06F8": "8",
  // Eastern-Arabic digit 8
  "\u06F9": "9"
  // Eastern-Arabic digit 9
};
function parseDigit(character) {
  return DIGITS[character];
}

// ../node_modules/libphonenumber-js/es6/parseIncompletePhoneNumber.js
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function parseIncompletePhoneNumber(string) {
  var result2 = "";
  for (var _iterator = _createForOfIteratorHelperLoose(string.split("")), _step; !(_step = _iterator()).done; ) {
    var character = _step.value;
    result2 += parsePhoneNumberCharacter(character, result2) || "";
  }
  return result2;
}
function parsePhoneNumberCharacter(character, prevParsedCharacters, emitEvent) {
  if (character === "+") {
    if (prevParsedCharacters) {
      if (typeof emitEvent === "function") {
        emitEvent("end");
      }
      return;
    }
    return "+";
  }
  return parseDigit(character);
}

// ../node_modules/libphonenumber-js/es6/helpers/mergeArrays.js
function _createForOfIteratorHelperLoose2(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray2(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray2(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray2(o, minLen);
}
function _arrayLikeToArray2(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function mergeArrays(a, b) {
  var merged = a.slice();
  for (var _iterator = _createForOfIteratorHelperLoose2(b), _step; !(_step = _iterator()).done; ) {
    var element = _step.value;
    if (a.indexOf(element) < 0) {
      merged.push(element);
    }
  }
  return merged.sort(function(a2, b2) {
    return a2 - b2;
  });
}

// ../node_modules/libphonenumber-js/es6/helpers/checkNumberLength.js
function checkNumberLength(nationalNumber, metadata) {
  return checkNumberLengthForType(nationalNumber, void 0, metadata);
}
function checkNumberLengthForType(nationalNumber, type, metadata) {
  var type_info = metadata.type(type);
  var possible_lengths = type_info && type_info.possibleLengths() || metadata.possibleLengths();
  if (!possible_lengths) {
    return "IS_POSSIBLE";
  }
  if (type === "FIXED_LINE_OR_MOBILE") {
    if (!metadata.type("FIXED_LINE")) {
      return checkNumberLengthForType(nationalNumber, "MOBILE", metadata);
    }
    var mobile_type = metadata.type("MOBILE");
    if (mobile_type) {
      possible_lengths = mergeArrays(possible_lengths, mobile_type.possibleLengths());
    }
  } else if (type && !type_info) {
    return "INVALID_LENGTH";
  }
  var actual_length = nationalNumber.length;
  var minimum_length = possible_lengths[0];
  if (minimum_length === actual_length) {
    return "IS_POSSIBLE";
  }
  if (minimum_length > actual_length) {
    return "TOO_SHORT";
  }
  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return "TOO_LONG";
  }
  return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}

// ../node_modules/libphonenumber-js/es6/isPossible.js
function isPossiblePhoneNumber(input, options, metadata) {
  if (options === void 0) {
    options = {};
  }
  metadata = new Metadata(metadata);
  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error("Invalid phone number object passed");
    }
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }
    if (input.country) {
      if (!metadata.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }
      metadata.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error("Invalid phone number object passed");
      }
      metadata.selectNumberingPlan(input.countryCallingCode);
    }
  }
  if (metadata.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata);
  } else {
    if (input.countryCallingCode && metadata.isNonGeographicCallingCode(input.countryCallingCode)) {
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case "IS_POSSIBLE":
      return true;
    default:
      return false;
  }
}

// ../node_modules/libphonenumber-js/es6/helpers/matchesEntirely.js
function matchesEntirely(text, regular_expression) {
  text = text || "";
  return new RegExp("^(?:" + regular_expression + ")$").test(text);
}

// ../node_modules/libphonenumber-js/es6/helpers/getNumberType.js
function _createForOfIteratorHelperLoose3(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray3(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray3(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray3(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray3(o, minLen);
}
function _arrayLikeToArray3(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var NON_FIXED_LINE_PHONE_TYPES = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function getNumberType(input, options, metadata) {
  options = options || {};
  if (!input.country && !input.countryCallingCode) {
    return;
  }
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern())) {
    return;
  }
  if (isNumberTypeEqualTo(nationalNumber, "FIXED_LINE", metadata)) {
    if (metadata.type("MOBILE") && metadata.type("MOBILE").pattern() === "") {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (!metadata.type("MOBILE")) {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (isNumberTypeEqualTo(nationalNumber, "MOBILE", metadata)) {
      return "FIXED_LINE_OR_MOBILE";
    }
    return "FIXED_LINE";
  }
  for (var _iterator = _createForOfIteratorHelperLoose3(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done; ) {
    var type = _step.value;
    if (isNumberTypeEqualTo(nationalNumber, type, metadata)) {
      return type;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type, metadata) {
  type = metadata.type(type);
  if (!type || !type.pattern()) {
    return false;
  }
  if (type.possibleLengths() && type.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }
  return matchesEntirely(nationalNumber, type.pattern());
}

// ../node_modules/libphonenumber-js/es6/isValid.js
function isValidNumber(input, options, metadata) {
  options = options || {};
  metadata = new Metadata(metadata);
  metadata.selectNumberingPlan(input.country, input.countryCallingCode);
  if (metadata.hasTypes()) {
    return getNumberType(input, options, metadata.metadata) !== void 0;
  }
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata.nationalNumberPattern());
}

// ../node_modules/libphonenumber-js/es6/helpers/getPossibleCountriesForNumber.js
function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata) {
  var _metadata = new Metadata(metadata);
  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return [];
  }
  return possibleCountries.filter(function(country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata);
  });
}
function couldNationalNumberBelongToCountry(nationalNumber, country, metadata) {
  var _metadata = new Metadata(metadata);
  _metadata.selectNumberingPlan(country);
  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }
  return false;
}

// ../node_modules/libphonenumber-js/es6/helpers/applyInternationalSeparatorStyle.js
function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), "g"), " ").trim();
}

// ../node_modules/libphonenumber-js/es6/helpers/formatNationalNumberUsingFormat.js
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number, format, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix, carrierCode = _ref.carrierCode, metadata = _ref.metadata;
  var formattedNumber = number.replace(new RegExp(format.pattern()), useInternationalFormat ? format.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format.nationalPrefixFormattingRule() ? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule()) : format.format()
  ));
  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }
  return formattedNumber;
}

// ../node_modules/libphonenumber-js/es6/helpers/getIddPrefix.js
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(country, callingCode, metadata) {
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }
  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}

// ../node_modules/libphonenumber-js/es6/helpers/RFC3966.js
function formatRFC3966(_ref) {
  var number = _ref.number, ext = _ref.ext;
  if (!number) {
    return "";
  }
  if (number[0] !== "+") {
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  }
  return "tel:".concat(number).concat(ext ? ";ext=" + ext : "");
}

// ../node_modules/libphonenumber-js/es6/format.js
function _createForOfIteratorHelperLoose4(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray4(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray4(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray4(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray4(o, minLen);
}
function _arrayLikeToArray4(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata) {
    return "".concat(formattedNumber).concat(metadata.ext()).concat(extension);
  }
};
function formatNumber(input, format, options, metadata) {
  if (options) {
    options = _objectSpread(_objectSpread({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }
  metadata = new Metadata(metadata);
  if (input.country && input.country !== "001") {
    if (!metadata.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }
    metadata.country(input.country);
  } else if (input.countryCallingCode) {
    metadata.selectNumberingPlan(input.countryCallingCode);
  } else
    return input.phone || "";
  var countryCallingCode = metadata.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  var number;
  switch (format) {
    case "NATIONAL":
      if (!nationalNumber) {
        return "";
      }
      number = formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata, options);
      return addExtension(number, input.ext, metadata, options.formatExtension);
    case "INTERNATIONAL":
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }
      number = formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata, options);
      number = "+".concat(countryCallingCode, " ").concat(number);
      return addExtension(number, input.ext, metadata, options.formatExtension);
    case "E.164":
      return "+".concat(countryCallingCode).concat(nationalNumber);
    case "RFC3966":
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    case "IDD":
      if (!options.fromCountry) {
        return;
      }
      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata);
      return addExtension(formattedNumber, input.ext, metadata, options.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format, '"'));
  }
}
function formatNationalNumber(number, carrierCode, formatAs, metadata, options) {
  var format = chooseFormatForNumber(metadata.formats(), number);
  if (!format) {
    return number;
  }
  return formatNationalNumberUsingFormat(number, format, {
    useInternationalFormat: formatAs === "INTERNATIONAL",
    withNationalPrefix: format.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode,
    metadata
  });
}
function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = _createForOfIteratorHelperLoose4(availableFormats), _step; !(_step = _iterator()).done; ) {
    var format = _step.value;
    if (format.leadingDigitsPatterns().length > 0) {
      var lastLeadingDigitsPattern = format.leadingDigitsPatterns()[format.leadingDigitsPatterns().length - 1];
      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    }
    if (matchesEntirely(nationalNnumber, format.pattern())) {
      return format;
    }
  }
}
function addExtension(formattedNumber, ext, metadata, formatExtension2) {
  return ext ? formatExtension2(formattedNumber, ext, metadata) : formattedNumber;
}
function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata.metadata);
  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata);
    if (countryCallingCode === "1") {
      return countryCallingCode + " " + formattedNumber;
    }
    return formattedNumber;
  }
  var iddPrefix = getIddPrefix(fromCountry, void 0, metadata.metadata);
  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata));
  }
}

// ../node_modules/libphonenumber-js/es6/PhoneNumber.js
function ownKeys2(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys2(Object(source), true).forEach(function(key) {
      _defineProperty2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass3(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties3(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties3(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var USE_NON_GEOGRAPHIC_COUNTRY_CODE = false;
var PhoneNumber = /* @__PURE__ */ function() {
  function PhoneNumber2(countryOrCountryCallingCode, nationalNumber, metadata) {
    _classCallCheck3(this, PhoneNumber2);
    if (!countryOrCountryCallingCode) {
      throw new TypeError("`country` or `countryCallingCode` not passed");
    }
    if (!nationalNumber) {
      throw new TypeError("`nationalNumber` not passed");
    }
    if (!metadata) {
      throw new TypeError("`metadata` not passed");
    }
    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = "+" + this.countryCallingCode + this.nationalNumber;
    this.getMetadata = function() {
      return metadata;
    };
  }
  _createClass3(PhoneNumber2, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }
      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata = new Metadata(this.getMetadata());
      return metadata.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function getType2() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread2(_objectSpread2({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format("NATIONAL", options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format("INTERNATIONAL", options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format("RFC3966", options);
    }
  }]);
  return PhoneNumber2;
}();
var isCountryCode = function isCountryCode2(value) {
  return /^[A-Z]{2}$/.test(value);
};
function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata = new Metadata(metadataJson);
  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata.selectNumberingPlan(country);
    countryCallingCode = metadata.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
    if (USE_NON_GEOGRAPHIC_COUNTRY_CODE) {
      if (metadata.isNonGeographicCallingCode(countryCallingCode)) {
        country = "001";
      }
    }
  }
  return {
    country,
    countryCallingCode
  };
}

// ../node_modules/libphonenumber-js/es6/helpers/stripIddPrefix.js
var CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
function stripIddPrefix(number, country, callingCode, metadata) {
  if (!country) {
    return;
  }
  var countryMetadata = new Metadata(metadata);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
  if (number.search(IDDPrefixPattern) !== 0) {
    return;
  }
  number = number.slice(number.match(IDDPrefixPattern)[0].length);
  var matchedGroups = number.match(CAPTURING_DIGIT_PATTERN);
  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === "0") {
      return;
    }
  }
  return number;
}

// ../node_modules/libphonenumber-js/es6/helpers/extractNationalNumberFromPossiblyIncompleteNumber.js
function extractNationalNumberFromPossiblyIncompleteNumber(number, metadata) {
  if (number && metadata.numberingPlan.nationalPrefixForParsing()) {
    var prefixPattern = new RegExp("^(?:" + metadata.numberingPlan.nationalPrefixForParsing() + ")");
    var prefixMatch = prefixPattern.exec(number);
    if (prefixMatch) {
      var nationalNumber;
      var carrierCode;
      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
      if (metadata.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number.replace(prefixPattern, metadata.nationalPrefixTransformRule());
        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } else {
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number.slice(prefixBeforeNationalNumber.length);
        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      }
      var nationalPrefix;
      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number.slice(0, possiblePositionOfTheFirstCapturedGroup);
        if (possibleNationalPrefix === metadata.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }
      return {
        nationalNumber,
        nationalPrefix,
        carrierCode
      };
    }
  }
  return {
    nationalNumber: number
  };
}

// ../node_modules/libphonenumber-js/es6/helpers/extractNationalNumber.js
function extractNationalNumber(number, metadata) {
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number, metadata), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
  if (nationalNumber !== number) {
    if (!shouldHaveExtractedNationalPrefix(number, nationalNumber, metadata)) {
      return {
        nationalNumber: number
      };
    }
    if (metadata.possibleLengths()) {
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata)) {
        return {
          nationalNumber: number
        };
      }
    }
  }
  return {
    nationalNumber,
    carrierCode
  };
}
function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata) {
  if (matchesEntirely(nationalNumberBefore, metadata.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata.nationalNumberPattern())) {
    return false;
  }
  return true;
}
function isPossibleIncompleteNationalNumber(nationalNumber, metadata) {
  switch (checkNumberLength(nationalNumber, metadata)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return false;
    default:
      return true;
  }
}

// ../node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCodeFromInternationalNumberWithoutPlusSign.js
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata) : callingCode;
  if (number.indexOf(countryCallingCode) === 0) {
    metadata = new Metadata(metadata);
    metadata.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number.slice(countryCallingCode.length);
    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
    var _extractNationalNumbe2 = extractNationalNumber(number, metadata), nationalNumber = _extractNationalNumbe2.nationalNumber;
    if (!matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata) === "TOO_LONG") {
      return {
        countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }
  return {
    number
  };
}

// ../node_modules/libphonenumber-js/es6/helpers/extractCountryCallingCode.js
function extractCountryCallingCode(number, country, callingCode, metadata) {
  if (!number) {
    return {};
  }
  var isNumberWithIddPrefix;
  if (number[0] !== "+") {
    var numberWithoutIDD = stripIddPrefix(number, country, callingCode, metadata);
    if (numberWithoutIDD && numberWithoutIDD !== number) {
      isNumberWithIddPrefix = true;
      number = "+" + numberWithoutIDD;
    } else {
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number, country, callingCode, metadata), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
        if (countryCallingCode) {
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode,
            number: shorterNumber
          };
        }
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number
      };
    }
  }
  if (number[1] === "0") {
    return {};
  }
  metadata = new Metadata(metadata);
  var i = 2;
  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number.length) {
    var _countryCallingCode = number.slice(1, i);
    if (metadata.hasCallingCode(_countryCallingCode)) {
      metadata.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: _countryCallingCode,
        number: number.slice(i)
      };
    }
    i++;
  }
  return {};
}

// ../node_modules/libphonenumber-js/es6/helpers/getCountryByNationalNumber.js
function _createForOfIteratorHelperLoose5(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it)
    return (it = it.call(o)).next.bind(it);
  if (Array.isArray(o) || (it = _unsupportedIterableToArray5(o)) || allowArrayLike && o && typeof o.length === "number") {
    if (it)
      o = it;
    var i = 0;
    return function() {
      if (i >= o.length)
        return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray5(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray5(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray5(o, minLen);
}
function _arrayLikeToArray5(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
  metadata = new Metadata(metadata);
  var matchingCountries = [];
  for (var _iterator = _createForOfIteratorHelperLoose5(countries), _step; !(_step = _iterator()).done; ) {
    var country = _step.value;
    metadata.country(country);
    if (metadata.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata.leadingDigits()) === 0) {
        return country;
      }
    } else if (getNumberType({
      phone: nationalPhoneNumber,
      country
    }, void 0, metadata.metadata)) {
      if (defaultCountry) {
        if (country === defaultCountry) {
          return country;
        }
        matchingCountries.push(country);
      } else {
        return country;
      }
    }
  }
  if (matchingCountries.length > 0) {
    return matchingCountries[0];
  }
}

// ../node_modules/libphonenumber-js/es6/helpers/getCountryByCallingCode.js
var USE_NON_GEOGRAPHIC_COUNTRY_CODE2 = false;
function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata;
  if (USE_NON_GEOGRAPHIC_COUNTRY_CODE2) {
    if (metadata.isNonGeographicCallingCode(callingCode)) {
      return "001";
    }
  }
  var possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return;
  }
  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }
  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    defaultCountry,
    metadata: metadata.metadata
  });
}

// ../node_modules/libphonenumber-js/es6/helpers/extractPhoneContext.js
var PLUS_SIGN = "+";
var RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var RFC3966_PHONE_DIGIT_ = "([" + VALID_DIGITS + "]|" + RFC3966_VISUAL_SEPARATOR_ + ")";
var RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + "*[" + VALID_DIGITS + "]" + RFC3966_PHONE_DIGIT_ + "*$";
var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, "g");
var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = "[" + ALPHANUM_ + "]+((\\-)*[" + ALPHANUM_ + "])*";
var VALID_ALPHA_ = "a-zA-Z";
var RFC3966_TOPLABEL_ = "[" + VALID_ALPHA_ + "]+((\\-)*[" + ALPHANUM_ + "])*";
var RFC3966_DOMAINNAME_ = "^(" + RFC3966_DOMAINLABEL_ + "\\.)*" + RFC3966_TOPLABEL_ + "\\.?$";
var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, "g");
var RFC3966_PREFIX_ = "tel:";
var RFC3966_PHONE_CONTEXT_ = ";phone-context=";
var RFC3966_ISDN_SUBADDRESS_ = ";isub=";
function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_);
  if (indexOfPhoneContext < 0) {
    return null;
  }
  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length;
  if (phoneContextStart >= numberToExtractFrom.length) {
    return "";
  }
  var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart);
  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}
function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }
  if (phoneContext.length === 0) {
    return false;
  }
  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}

// ../node_modules/libphonenumber-js/es6/helpers/extractFormattedPhoneNumberFromPossibleRfc3966NumberUri.js
function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = extractPhoneContext(numberToParse);
  if (!isPhoneContextValid(phoneContext)) {
    throw new ParseError("NOT_A_NUMBER");
  }
  var phoneNumberString;
  if (phoneContext === null) {
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
  } else {
    phoneNumberString = "";
    if (phoneContext.charAt(0) === PLUS_SIGN) {
      phoneNumberString += phoneContext;
    }
    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
    var indexOfNationalNumber;
    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
    } else {
      indexOfNationalNumber = 0;
    }
    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  }
  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);
  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  }
  if (phoneNumberString !== "") {
    return phoneNumberString;
  }
}

// ../node_modules/libphonenumber-js/es6/parse.js
var MAX_INPUT_STRING_LENGTH = 250;
var PHONE_NUMBER_START_PATTERN = new RegExp("[" + PLUS_CHARS + VALID_DIGITS + "]");
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
var USE_NON_GEOGRAPHIC_COUNTRY_CODE3 = false;
function parse(text, options, metadata) {
  options = options || {};
  metadata = new Metadata(metadata);
  if (options.defaultCountry && !metadata.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    throw new Error("Unknown country: ".concat(options.defaultCountry));
  }
  var _parseInput = parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error;
  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === "TOO_SHORT") {
        throw new ParseError("TOO_SHORT");
      }
      throw new ParseError("NOT_A_NUMBER");
    }
    return {};
  }
  var _parsePhoneNumber = parsePhoneNumber(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
  if (!metadata.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    return {};
  }
  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_SHORT");
    }
    return {};
  }
  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_LONG");
    }
    return {};
  }
  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata.metadata);
    if (country) {
      phoneNumber.country = country;
    }
    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }
    if (ext) {
      phoneNumber.ext = ext;
    }
    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  }
  var valid = (options.extended ? metadata.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata.nationalNumberPattern()) : false;
  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  }
  return {
    country,
    countryCallingCode,
    carrierCode,
    valid,
    possible: valid ? true : options.extended === true && metadata.possibleLengths() && isPossibleNumber(nationalNumber, metadata) ? true : false,
    phone: nationalNumber,
    ext
  };
}
function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }
  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError("TOO_LONG");
    }
    return;
  }
  if (extract === false) {
    return text;
  }
  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
  if (startsAt < 0) {
    return;
  }
  return text.slice(startsAt).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
}
function parseInput(text, v2, extract) {
  var number = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text2) {
      return _extractFormattedPhoneNumber(text2, extract, v2);
    }
  });
  if (!number) {
    return {};
  }
  if (!isViablePhoneNumber(number)) {
    if (isViablePhoneNumberStart(number)) {
      return {
        error: "TOO_SHORT"
      };
    }
    return {};
  }
  var withExtensionStripped = extractExtension(number);
  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }
  return {
    number
  };
}
function result(country, nationalNumber, ext) {
  var result2 = {
    country,
    phone: nationalNumber
  };
  if (ext) {
    result2.ext = ext;
  }
  return result2;
}
function parsePhoneNumber(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata) {
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number = _extractCountryCallin.number;
  var country;
  if (countryCallingCode) {
    metadata.selectNumberingPlan(countryCallingCode);
  } else if (number && (defaultCountry || defaultCallingCode)) {
    metadata.selectNumberingPlan(defaultCountry, defaultCallingCode);
    if (defaultCountry) {
      country = defaultCountry;
    } else {
      if (USE_NON_GEOGRAPHIC_COUNTRY_CODE3) {
        if (metadata.isNonGeographicCallingCode(defaultCallingCode)) {
          country = "001";
        }
      }
    }
    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata.metadata);
  } else
    return {};
  if (!number) {
    return {
      countryCallingCodeSource,
      countryCallingCode
    };
  }
  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number), metadata), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
  var exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber,
    defaultCountry,
    metadata
  });
  if (exactCountry) {
    country = exactCountry;
    if (exactCountry === "001") {
    } else {
      metadata.country(country);
    }
  }
  return {
    country,
    countryCallingCode,
    countryCallingCodeSource,
    nationalNumber,
    carrierCode
  };
}

// ../node_modules/libphonenumber-js/es6/parsePhoneNumberWithError_.js
function ownKeys3(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys3(Object(source), true).forEach(function(key) {
      _defineProperty3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys3(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumberWithError(text, options, metadata) {
  return parse(text, _objectSpread3(_objectSpread3({}, options), {}, {
    v2: true
  }), metadata);
}

// ../node_modules/libphonenumber-js/es6/normalizeArguments.js
function ownKeys4(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys4(Object(source), true).forEach(function(key) {
      _defineProperty4(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys4(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray6(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray6(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray6(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray6(o, minLen);
}
function _arrayLikeToArray6(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null)
    return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i)
        break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null)
        _i["return"]();
    } finally {
      if (_d)
        throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
  var text;
  var options;
  var metadata;
  if (typeof arg_1 === "string") {
    text = arg_1;
  } else
    throw new TypeError("A text for parsing must be a string.");
  if (!arg_2 || typeof arg_2 === "string") {
    if (arg_4) {
      options = arg_3;
      metadata = arg_4;
    } else {
      options = void 0;
      metadata = arg_3;
    }
    if (arg_2) {
      options = _objectSpread4({
        defaultCountry: arg_2
      }, options);
    }
  } else if (isObject(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata = arg_3;
    } else {
      metadata = arg_2;
    }
  } else
    throw new Error("Invalid second argument: ".concat(arg_2));
  return {
    text,
    options,
    metadata
  };
}

// ../node_modules/libphonenumber-js/es6/parsePhoneNumber_.js
function ownKeys5(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys5(Object(source), true).forEach(function(key) {
      _defineProperty5(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys5(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumber2(text, options, metadata) {
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata)) {
    options = _objectSpread5(_objectSpread5({}, options), {}, {
      defaultCountry: void 0
    });
  }
  try {
    return parsePhoneNumberWithError(text, options, metadata);
  } catch (error) {
    if (error instanceof ParseError) {
    } else {
      throw error;
    }
  }
}

// ../node_modules/libphonenumber-js/es6/parsePhoneNumber.js
function parsePhoneNumber3() {
  var _normalizeArguments = normalizeArguments(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata = _normalizeArguments.metadata;
  return parsePhoneNumber2(text, options, metadata);
}

// ../node_modules/libphonenumber-js/min/exports/parsePhoneNumber.js
function parsePhoneNumber4() {
  return withMetadataArgument(parsePhoneNumber3, arguments);
}

// src/api/validator/phoneNumber.ts
var import_lodash = __toESM(require_lodash(), 1);

// src/api/config/data/countries.ts
var AllCountries = /* @__PURE__ */ ((AllCountries2) => {
  AllCountries2["AF"] = "Afghanistan";
  AllCountries2["AX"] = "land Islands";
  AllCountries2["AL"] = "Albania";
  AllCountries2["DZ"] = "Algeria";
  AllCountries2["AS"] = "American Samoa";
  AllCountries2["AD"] = "AndorrA";
  AllCountries2["AO"] = "Angola";
  AllCountries2["AI"] = "Anguilla";
  AllCountries2["AQ"] = "Antarctica";
  AllCountries2["AG"] = "Antigua and Barbuda";
  AllCountries2["AR"] = "Argentina";
  AllCountries2["AM"] = "Armenia";
  AllCountries2["AW"] = "Aruba";
  AllCountries2["AU"] = "Australia";
  AllCountries2["AT"] = "Austria";
  AllCountries2["AZ"] = "Azerbaijan";
  AllCountries2["BS"] = "Bahamas";
  AllCountries2["BH"] = "Bahrain";
  AllCountries2["BD"] = "Bangladesh";
  AllCountries2["BB"] = "Barbados";
  AllCountries2["BY"] = "Belarus";
  AllCountries2["BE"] = "Belgium";
  AllCountries2["BZ"] = "Belize";
  AllCountries2["BJ"] = "Benin";
  AllCountries2["BM"] = "Bermuda";
  AllCountries2["BT"] = "Bhutan";
  AllCountries2["BO"] = "Bolivia";
  AllCountries2["BA"] = "Bosnia and Herzegovina";
  AllCountries2["BW"] = "Botswana";
  AllCountries2["BV"] = "Bouvet Island";
  AllCountries2["BR"] = "Brazil";
  AllCountries2["IO"] = "British Indian Ocean Territory";
  AllCountries2["BN"] = "Brunei Darussalam";
  AllCountries2["BG"] = "Bulgaria";
  AllCountries2["BF"] = "Burkina Faso";
  AllCountries2["BI"] = "Burundi";
  AllCountries2["KH"] = "Cambodia";
  AllCountries2["CM"] = "Cameroon";
  AllCountries2["CA"] = "Canada";
  AllCountries2["CV"] = "Cape Verde";
  AllCountries2["KY"] = "Cayman Islands";
  AllCountries2["CF"] = "Central African Republic";
  AllCountries2["TD"] = "Chad";
  AllCountries2["CL"] = "Chile";
  AllCountries2["CN"] = "China";
  AllCountries2["CX"] = "Christmas Island";
  AllCountries2["CC"] = "Cocos (Keeling) Islands";
  AllCountries2["CO"] = "Colombia";
  AllCountries2["KM"] = "Comoros";
  AllCountries2["CG"] = "Congo";
  AllCountries2["CD"] = "Congo, The Democratic Republic of the";
  AllCountries2["CK"] = "Cook Islands";
  AllCountries2["CR"] = "Costa Rica";
  AllCountries2["CI"] = "Cote D'Ivoire";
  AllCountries2["HR"] = "Croatia";
  AllCountries2["CU"] = "Cuba";
  AllCountries2["CY"] = "Cyprus";
  AllCountries2["CZ"] = "Czech Republic";
  AllCountries2["DK"] = "Denmark";
  AllCountries2["DJ"] = "Djibouti";
  AllCountries2["DM"] = "Dominica";
  AllCountries2["DO"] = "Dominican Republic";
  AllCountries2["EC"] = "Ecuador";
  AllCountries2["EG"] = "Egypt";
  AllCountries2["SV"] = "El Salvador";
  AllCountries2["GQ"] = "Equatorial Guinea";
  AllCountries2["ER"] = "Eritrea";
  AllCountries2["EE"] = "Estonia";
  AllCountries2["ET"] = "Ethiopia";
  AllCountries2["FK"] = "Falkland Islands (Malvinas)";
  AllCountries2["FO"] = "Faroe Islands";
  AllCountries2["FJ"] = "Fiji";
  AllCountries2["FI"] = "Finland";
  AllCountries2["FR"] = "France";
  AllCountries2["GF"] = "French Guiana";
  AllCountries2["PF"] = "French Polynesia";
  AllCountries2["TF"] = "French Southern Territories";
  AllCountries2["GA"] = "Gabon";
  AllCountries2["GM"] = "Gambia";
  AllCountries2["GE"] = "Georgia";
  AllCountries2["DE"] = "Germany";
  AllCountries2["GH"] = "Ghana";
  AllCountries2["GI"] = "Gibraltar";
  AllCountries2["GR"] = "Greece";
  AllCountries2["GL"] = "Greenland";
  AllCountries2["GD"] = "Grenada";
  AllCountries2["GP"] = "Guadeloupe";
  AllCountries2["GU"] = "Guam";
  AllCountries2["GT"] = "Guatemala";
  AllCountries2["GG"] = "Guernsey";
  AllCountries2["GN"] = "Guinea";
  AllCountries2["GW"] = "Guinea-Bissau";
  AllCountries2["GY"] = "Guyana";
  AllCountries2["HT"] = "Haiti";
  AllCountries2["HM"] = "Heard Island and Mcdonald Islands";
  AllCountries2["VA"] = "Holy See (Vatican City State)";
  AllCountries2["HN"] = "Honduras";
  AllCountries2["HK"] = "Hong Kong";
  AllCountries2["HU"] = "Hungary";
  AllCountries2["IS"] = "Iceland";
  AllCountries2["IN"] = "India";
  AllCountries2["ID"] = "Indonesia";
  AllCountries2["IR"] = "Iran, Islamic Republic Of";
  AllCountries2["IQ"] = "Iraq";
  AllCountries2["IE"] = "Ireland";
  AllCountries2["IM"] = "Isle of Man";
  AllCountries2["IL"] = "Israel";
  AllCountries2["IT"] = "Italy";
  AllCountries2["JM"] = "Jamaica";
  AllCountries2["JP"] = "Japan";
  AllCountries2["JE"] = "Jersey";
  AllCountries2["JO"] = "Jordan";
  AllCountries2["KZ"] = "Kazakhstan";
  AllCountries2["KE"] = "Kenya";
  AllCountries2["KI"] = "Kiribati";
  AllCountries2["KP"] = "Korea, Democratic People'S Republic of";
  AllCountries2["KR"] = "Korea, Republic of";
  AllCountries2["KW"] = "Kuwait";
  AllCountries2["KG"] = "Kyrgyzstan";
  AllCountries2["LA"] = "Lao People'S Democratic Republic";
  AllCountries2["LV"] = "Latvia";
  AllCountries2["LB"] = "Lebanon";
  AllCountries2["LS"] = "Lesotho";
  AllCountries2["LR"] = "Liberia";
  AllCountries2["LY"] = "Libyan Arab Jamahiriya";
  AllCountries2["LI"] = "Liechtenstein";
  AllCountries2["LT"] = "Lithuania";
  AllCountries2["LU"] = "Luxembourg";
  AllCountries2["MO"] = "Macao";
  AllCountries2["MK"] = "Macedonia, The Former Yugoslav Republic of";
  AllCountries2["MG"] = "Madagascar";
  AllCountries2["MW"] = "Malawi";
  AllCountries2["MY"] = "Malaysia";
  AllCountries2["MV"] = "Maldives";
  AllCountries2["ML"] = "Mali";
  AllCountries2["MT"] = "Malta";
  AllCountries2["MH"] = "Marshall Islands";
  AllCountries2["MQ"] = "Martinique";
  AllCountries2["MR"] = "Mauritania";
  AllCountries2["MU"] = "Mauritius";
  AllCountries2["YT"] = "Mayotte";
  AllCountries2["MX"] = "Mexico";
  AllCountries2["FM"] = "Micronesia, Federated States of";
  AllCountries2["MD"] = "Moldova, Republic of";
  AllCountries2["MC"] = "Monaco";
  AllCountries2["MN"] = "Mongolia";
  AllCountries2["ME"] = "Montenegro";
  AllCountries2["MS"] = "Montserrat";
  AllCountries2["MA"] = "Morocco";
  AllCountries2["MZ"] = "Mozambique";
  AllCountries2["MM"] = "Myanmar";
  AllCountries2["NA"] = "Namibia";
  AllCountries2["NR"] = "Nauru";
  AllCountries2["NP"] = "Nepal";
  AllCountries2["NL"] = "Netherlands";
  AllCountries2["AN"] = "Netherlands Antilles";
  AllCountries2["NC"] = "New Caledonia";
  AllCountries2["NZ"] = "New Zealand";
  AllCountries2["NI"] = "Nicaragua";
  AllCountries2["NE"] = "Niger";
  AllCountries2["NG"] = "Nigeria";
  AllCountries2["NU"] = "Niue";
  AllCountries2["NF"] = "Norfolk Island";
  AllCountries2["MP"] = "Northern Mariana Islands";
  AllCountries2["NO"] = "Norway";
  AllCountries2["OM"] = "Oman";
  AllCountries2["PK"] = "Pakistan";
  AllCountries2["PW"] = "Palau";
  AllCountries2["PS"] = "Palestinian Territory, Occupied";
  AllCountries2["PA"] = "Panama";
  AllCountries2["PG"] = "Papua New Guinea";
  AllCountries2["PY"] = "Paraguay";
  AllCountries2["PE"] = "Peru";
  AllCountries2["PH"] = "Philippines";
  AllCountries2["PN"] = "Pitcairn";
  AllCountries2["PL"] = "Poland";
  AllCountries2["PT"] = "Portugal";
  AllCountries2["PR"] = "Puerto Rico";
  AllCountries2["QA"] = "Qatar";
  AllCountries2["RE"] = "Reunion";
  AllCountries2["RO"] = "Romania";
  AllCountries2["RU"] = "Russian Federation";
  AllCountries2["RW"] = "RWANDA";
  AllCountries2["SH"] = "Saint Helena";
  AllCountries2["KN"] = "Saint Kitts and Nevis";
  AllCountries2["LC"] = "Saint Lucia";
  AllCountries2["PM"] = "Saint Pierre and Miquelon";
  AllCountries2["VC"] = "Saint Vincent and the Grenadines";
  AllCountries2["WS"] = "Samoa";
  AllCountries2["SM"] = "San Marino";
  AllCountries2["ST"] = "Sao Tome and Principe";
  AllCountries2["SA"] = "Saudi Arabia";
  AllCountries2["SN"] = "Senegal";
  AllCountries2["RS"] = "Serbia";
  AllCountries2["SC"] = "Seychelles";
  AllCountries2["SL"] = "Sierra Leone";
  AllCountries2["SG"] = "Singapore";
  AllCountries2["SK"] = "Slovakia";
  AllCountries2["SI"] = "Slovenia";
  AllCountries2["SB"] = "Solomon Islands";
  AllCountries2["SO"] = "Somalia";
  AllCountries2["ZA"] = "South Africa";
  AllCountries2["GS"] = "South Georgia and the South Sandwich Islands";
  AllCountries2["ES"] = "Spain";
  AllCountries2["LK"] = "Sri Lanka";
  AllCountries2["SD"] = "Sudan";
  AllCountries2["SR"] = "Suriname";
  AllCountries2["SJ"] = "Svalbard and Jan Mayen";
  AllCountries2["SZ"] = "Swaziland";
  AllCountries2["SE"] = "Sweden";
  AllCountries2["CH"] = "Switzerland";
  AllCountries2["SY"] = "Syrian Arab Republic";
  AllCountries2["TW"] = "Taiwan, Province of China";
  AllCountries2["TJ"] = "Tajikistan";
  AllCountries2["TZ"] = "Tanzania, United Republic of";
  AllCountries2["TH"] = "Thailand";
  AllCountries2["TL"] = "Timor-Leste";
  AllCountries2["TG"] = "Togo";
  AllCountries2["TK"] = "Tokelau";
  AllCountries2["TO"] = "Tonga";
  AllCountries2["TT"] = "Trinidad and Tobago";
  AllCountries2["TN"] = "Tunisia";
  AllCountries2["TR"] = "Turkey";
  AllCountries2["TM"] = "Turkmenistan";
  AllCountries2["TC"] = "Turks and Caicos Islands";
  AllCountries2["TV"] = "Tuvalu";
  AllCountries2["UG"] = "Uganda";
  AllCountries2["UA"] = "Ukraine";
  AllCountries2["AE"] = "United Arab Emirates";
  AllCountries2["GB"] = "United Kingdom";
  AllCountries2["US"] = "United States";
  AllCountries2["UM"] = "United States Minor Outlying Islands";
  AllCountries2["UY"] = "Uruguay";
  AllCountries2["UZ"] = "Uzbekistan";
  AllCountries2["VU"] = "Vanuatu";
  AllCountries2["VE"] = "Venezuela";
  AllCountries2["VN"] = "Viet Nam";
  AllCountries2["VG"] = "Virgin Islands, British";
  AllCountries2["VI"] = "Virgin Islands, U.S.";
  AllCountries2["WF"] = "Wallis and Futuna";
  AllCountries2["EH"] = "Western Sahara";
  AllCountries2["YE"] = "Yemen";
  AllCountries2["ZM"] = "Zambia";
  AllCountries2["ZW"] = "Zimbabwe";
  return AllCountries2;
})(AllCountries || {});

// src/api/validator/countryCode.ts
var isValidCountryCode = (code) => {
  return code in AllCountries;
};
var castCountryCode = (code) => {
  if (!isValidCountryCode(code)) {
    throw new Error("unsupported country code");
  }
  return code;
};
var getCountryFromCode = (code) => {
  if (isValidCountryCode(code)) {
    return AllCountries[code];
  }
  throw new Error("unsupported country code");
};

// src/api/validator/phoneNumber.ts
var isPhoneNumber = (value, { validateOnlyCountry = false } = {}) => {
  var _a2;
  if (typeof value !== "string") {
    return false;
  }
  const parsed = parsePhoneNumber4(value);
  if ((0, import_lodash.isUndefined)(parsed)) {
    return false;
  }
  const countryCode = (_a2 = parsed.country) == null ? void 0 : _a2.toString();
  return !!countryCode && isValidCountryCode(countryCode) && (validateOnlyCountry || parsed.isValid());
};

// src/api/common.ts
var sortOptions = ["ASC", "DESC"];
var SortOrder = /* @__PURE__ */ ((SortOrder2) => {
  SortOrder2["ASC"] = "ASC";
  SortOrder2["DESC"] = "DESC";
  return SortOrder2;
})(SortOrder || {});
var isSortOption = (value) => value !== void 0 && sortOptions.includes(value);
var PaginationMetaSchema = z3.object({
  totalItems: z3.number().optional(),
  itemCount: z3.number(),
  itemsPerPage: z3.number(),
  totalPages: z3.number().optional(),
  currentPage: z3.number()
});
var PaginationLinkSchema = z3.object({
  first: z3.string(),
  previous: z3.string(),
  next: z3.string(),
  last: z3.string()
}).partial().optional();
var paginateResponseSchema = (schema) => z3.object({
  items: z3.array(schema),
  meta: PaginationMetaSchema,
  links: PaginationLinkSchema
});
var ComparableFilterSchema = z3.object({
  operator: z3.enum(["equals", "greater_than", "less_than"]),
  name: z3.string(),
  value: z3.string()
});
var InFilterSchema = z3.object({
  operator: z3.literal("in"),
  name: z3.string(),
  value: z3.array(z3.string())
});
var RangeFilterSchema = z3.object({
  operator: z3.literal("range"),
  name: z3.string(),
  value: z3.object({ from: z3.string(), to: z3.string() })
});
var FiltersSchema = z3.array(z3.union([ComparableFilterSchema, InFilterSchema, RangeFilterSchema]));
var paginateQuerySchema = ({
  sortBy
} = {}) => {
  return z3.object({
    page: z3.coerce.number().min(1).default(1),
    limit: z3.coerce.number().min(0).default(10),
    sortDir: z3.enum(sortOptions).optional(),
    sortBy: sortBy === void 0 ? z3.never().optional() : z3.enum(sortBy).optional(),
    filters: FiltersSchema.optional(),
    q: z3.string().optional()
  });
};
var LiteralSchema = z3.union([z3.string(), z3.number(), z3.boolean(), z3.null()]);
var JsonSchema = z3.lazy(() => z3.union([LiteralSchema, z3.array(JsonSchema), z3.record(JsonSchema)]));
var makeEndpoint = (endpoint) => endpoint;
var PhoneNumberValidationSchema = z3.string().refine((phoneNumber) => isPhoneNumber(phoneNumber, { validateOnlyCountry: true }), {
  message: "Invalid phone number, please verify proper format."
});
var ENTITY = /* @__PURE__ */ ((ENTITY2) => {
  ENTITY2["ORG"] = "organization";
  ENTITY2["BRAND"] = "brand";
  return ENTITY2;
})(ENTITY || {});
var REST_API_ENTITY = /* @__PURE__ */ ((REST_API_ENTITY3) => {
  REST_API_ENTITY3["ORG"] = "organizations";
  REST_API_ENTITY3["BRAND"] = "brands";
  return REST_API_ENTITY3;
})(REST_API_ENTITY || {});
var MinimalHostSchema = z3.object({
  id: z3.string(),
  fullName: z3.string(),
  profilePicture: IMediaReferenceSchema.nullable()
});
var HostSchema = MinimalHostSchema.extend({
  firstName: z3.string(),
  lastName: z3.string(),
  allowOverlappingBookings: z3.boolean()
});
var Env = /* @__PURE__ */ ((Env2) => {
  Env2["PRODUCTION"] = "production";
  Env2["STAGING"] = "staging";
  Env2["PREVIEW"] = "preview";
  Env2["TEST"] = "test";
  Env2["DEVELOPMENT"] = "development";
  return Env2;
})(Env || {});
var TruthyString = /* @__PURE__ */ ((TruthyString2) => {
  TruthyString2["TRUE"] = "true";
  TruthyString2["ONE"] = "1";
  return TruthyString2;
})(TruthyString || {});
var isHigherEnv = (env) => {
  return ["staging" /* STAGING */, "production" /* PRODUCTION */].includes(env);
};
var isLowerEnv = (env) => {
  return !isHigherEnv(env);
};

// src/api/experience/experiences.ts
import { z as z17 } from "zod";

// src/api/experience/hosts.ts
var HostCommissionType = /* @__PURE__ */ ((HostCommissionType2) => {
  HostCommissionType2["PERCENT"] = "percent";
  HostCommissionType2["FLAT_RATE"] = "flat-rate";
  HostCommissionType2["PER_PARTICIPANT"] = "per-participant";
  HostCommissionType2["NO_COMMISSION"] = "no-commission";
  return HostCommissionType2;
})(HostCommissionType || {});

// src/api/experience/position.ts
import { z as z4 } from "zod";
var PositionSchema = z4.object({ x: z4.number(), y: z4.number() });

// src/api/experience/price-tier-rules.ts
import { z as z6 } from "zod";

// src/common.ts
import { z as z5 } from "zod";
var HexColorSchema = z5.string().regex(/^#[A-F0-9]{6}$/i);
var LocalDateTimeStringSchema = z5.string().refine(
  (str) => z5.string().datetime().safeParse(`${str.padEnd(19, ":00")}Z`).success,
  { message: "Invalid date time" }
);
var DateStringSchema = z5.string().regex(/^\d{4}-(0[1-9]|1[012])-(0[1-9]|[12][0-9]|3[01])$/, { message: "Invalid date" });
var TimeStringSchema = z5.string().regex(/^([0-1]\d|2[0-3])(?::([0-5]\d)){1,2}$/, { message: "Invalid time" });
var EmailStringSchema = z5.string().regex(
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
);
var BooleanStringSchema = z5.enum(["true", "false"]);

// src/api/experience/price-tier-rules.ts
var PriceTierType = /* @__PURE__ */ ((PriceTierType2) => {
  PriceTierType2["DEFAULT"] = "default";
  PriceTierType2["SESSION"] = "session";
  PriceTierType2["RULE"] = "rule";
  return PriceTierType2;
})(PriceTierType || {});
var PriceTierConditionType = /* @__PURE__ */ ((PriceTierConditionType2) => {
  PriceTierConditionType2["DAY_OF_WEEK"] = "day_of_week";
  PriceTierConditionType2["DATE_RANGE"] = "date_range";
  PriceTierConditionType2["MATCH_DATE"] = "match_date";
  PriceTierConditionType2["MATCH_DURATION"] = "match_duration";
  PriceTierConditionType2["DURATION_RANGE"] = "duration_range";
  return PriceTierConditionType2;
})(PriceTierConditionType || {});
var DateRangePriceTierConditionSchema = z6.object({
  type: z6.literal("date_range" /* DATE_RANGE */),
  param: z6.array(
    z6.object({ from: DateStringSchema, to: DateStringSchema }).refine(({ from, to }) => from <= to, {
      message: 'The "from" date must be less than or equal to the "to" date.'
    })
  ).min(1)
});
var DurationRangePriceTierConditionSchema = z6.object({
  type: z6.literal("duration_range" /* DURATION_RANGE */),
  param: z6.array(z6.object({ from: z6.number(), to: z6.number() })).min(1)
});
var MatchDatePriceTierConditionSchema = z6.object({
  type: z6.literal("match_date" /* MATCH_DATE */),
  param: z6.array(LocalDateTimeStringSchema).min(1)
});
var DayOfWeekPriceTierConditionSchema = z6.object({
  type: z6.literal("day_of_week" /* DAY_OF_WEEK */),
  param: z6.array(z6.number().min(
    1
    /* MONDAY */
  ).max(
    7
    /* SUNDAY */
  )).min(1).refine((days) => days.every((day) => day >= 1 && day <= 7), {
    message: "Days of the week must be between 1 (Monday) and 7 (Sunday)."
  })
});
var MatchDurationPriceTierConditionSchema = z6.object({
  type: z6.literal("match_duration" /* MATCH_DURATION */),
  param: z6.array(z6.number().min(1)).min(1, {
    message: "Required"
  })
});
var PriceTierConditionSchema = z6.discriminatedUnion("type", [
  DateRangePriceTierConditionSchema,
  DurationRangePriceTierConditionSchema,
  MatchDatePriceTierConditionSchema,
  DayOfWeekPriceTierConditionSchema,
  MatchDurationPriceTierConditionSchema
]);
var PriceTierSchema = z6.object({
  id: z6.string().uuid(),
  name: z6.string(),
  price: z6.number(),
  maxQuantity: z6.number().min(0).optional()
});
var PostSessionPriceTierRuleRequestSchema = z6.object({
  id: z6.string().uuid(),
  startDateTime: LocalDateTimeStringSchema,
  sessionDuration: z6.number().min(1).optional(),
  priceTiers: z6.array(PriceTierSchema).min(1)
});
var PostSessionPriceTierRuleEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, experienceId }) => `/v1/brands/${brandId}/experiences/${experienceId}/price-tier-rule/session`,
  requestSchema: PostSessionPriceTierRuleRequestSchema,
  responseSchema: z6.void()
});
var PriceTierRulesSchema = z6.object({
  id: z6.string().uuid(),
  name: z6.string().nonempty(),
  order: z6.number(),
  type: z6.literal("rule" /* RULE */),
  isActive: z6.boolean(),
  conditions: z6.array(PriceTierConditionSchema).min(1),
  priceTiers: z6.array(PriceTierSchema).min(1)
});
var PostPriceTierRuleRequestSchema = z6.object({
  id: z6.string().uuid(),
  name: z6.string().nonempty(),
  order: z6.number(),
  isActive: z6.boolean(),
  conditions: z6.array(PriceTierConditionSchema).min(1),
  priceTiers: z6.array(PriceTierSchema).min(1)
});
var PostPriceTrierRuleEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, experienceId }) => `/v1/brands/${brandId}/experiences/${experienceId}/price-tier-rule`,
  requestSchema: PostPriceTierRuleRequestSchema,
  responseSchema: z6.void()
});
var SessionDataSchema = z6.object({
  startDateTime: LocalDateTimeStringSchema,
  sessionDuration: z6.number().min(1).optional()
});
var PostResourceGroupSessionPriceTierRuleRequestSchema = z6.object({
  sessions: z6.array(SessionDataSchema).min(1),
  priceTiers: z6.array(PriceTierSchema).min(1)
});
var PostResourceGroupSessionPriceTierRuleEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, resourceGroupId }) => `/v1/brands/${brandId}/experiences/resource-groups/${resourceGroupId}/price-tier-rule/resource-group-session`,
  requestSchema: PostResourceGroupSessionPriceTierRuleRequestSchema,
  responseSchema: z6.void()
});

// src/api/experience/shape.ts
import { z as z7 } from "zod";
var ShapeType = /* @__PURE__ */ ((ShapeType2) => {
  ShapeType2["CIRCLE"] = "circle";
  ShapeType2["RECTANGLE"] = "rectangle";
  ShapeType2["TABLE"] = "table";
  return ShapeType2;
})(ShapeType || {});
var ShapeSchema = z7.object({
  type: z7.nativeEnum(ShapeType),
  width: z7.number(),
  height: z7.number(),
  color: z7.string()
});
var SHAPE_DEFAULT_WIDTH = 50;
var SHAPE_DEFAULT_HEIGHT = 50;

// src/experience/const.ts
var ExperienceImageSizes = /* @__PURE__ */ ((ExperienceImageSizes2) => {
  ExperienceImageSizes2["W384"] = "384";
  ExperienceImageSizes2["W480"] = "480";
  ExperienceImageSizes2["W640"] = "640";
  ExperienceImageSizes2["W750"] = "750";
  ExperienceImageSizes2["W1080"] = "1080";
  return ExperienceImageSizes2;
})(ExperienceImageSizes || {});
var MediaType = /* @__PURE__ */ ((MediaType2) => {
  MediaType2["IMAGE"] = "image";
  MediaType2["VIDEO"] = "video";
  return MediaType2;
})(MediaType || {});
var MediaLinkResolution = /* @__PURE__ */ ((MediaLinkResolution2) => {
  MediaLinkResolution2["ORIGINAL"] = "original";
  MediaLinkResolution2["ADAPTATIVE"] = "adaptative";
  MediaLinkResolution2["240p"] = "240";
  MediaLinkResolution2["36Op"] = "360";
  MediaLinkResolution2["480p"] = "480";
  MediaLinkResolution2["540p"] = "540";
  MediaLinkResolution2["640p"] = "640";
  MediaLinkResolution2["720p"] = "720";
  MediaLinkResolution2["1080p"] = "1080";
  return MediaLinkResolution2;
})(MediaLinkResolution || {});
var ExperienceImageSizeWithOriginalInUriSchema = ImageSizeWithOriginalInUriSchemaBuilder(
  Object.values(ExperienceImageSizes)
);
var ExperienceKind = /* @__PURE__ */ ((ExperienceKind2) => {
  ExperienceKind2["EXPERIENCE"] = "experience";
  ExperienceKind2["RESOURCE"] = "resource";
  return ExperienceKind2;
})(ExperienceKind || {});
var ExperienceVersion = /* @__PURE__ */ ((ExperienceVersion3) => {
  ExperienceVersion3["LATEST"] = "latest";
  ExperienceVersion3["PUBLISHED"] = "published";
  return ExperienceVersion3;
})(ExperienceVersion || {});
var isExperienceVersion = (experienceVersion) => Object.values(ExperienceVersion).includes(experienceVersion);
var ExperienceStatus = /* @__PURE__ */ ((ExperienceStatus2) => {
  ExperienceStatus2["DRAFT"] = "draft";
  ExperienceStatus2["PENDING"] = "pending";
  ExperienceStatus2["PUBLISHED"] = "published";
  ExperienceStatus2["UNPUBLISHED"] = "unpublished";
  return ExperienceStatus2;
})(ExperienceStatus || {});
var isExperienceStatus = (experienceStatus) => Object.values(ExperienceStatus).includes(experienceStatus);

// src/api/brand/brand.ts
import { z as z14 } from "zod";

// src/api/brand/contact.ts
import { z as z8 } from "zod";
var ContactRole = /* @__PURE__ */ ((ContactRole2) => {
  ContactRole2["DECISION_MAKER"] = "decision_maker";
  ContactRole2["POINT_OF_CONTACT"] = "point_of_contact";
  return ContactRole2;
})(ContactRole || {});
var ContactRoleSchema = z8.nativeEnum(ContactRole, {
  invalid_type_error: "Invalid contact role",
  required_error: "Contact role is required"
});
var ContactSchema = z8.object({
  id: z8.string().uuid(),
  firstName: z8.string().min(2, "First name must be at least 2 characters").max(100, "First name must be less than 100 characters"),
  lastName: z8.string().min(2, "Last name must be at least 2 characters").max(100, "Last name must be less than 100 characters"),
  emailAddress: EmailStringSchema.max(255, "Email Address must be less than 255 characters"),
  role: ContactRoleSchema
});
var ContactResponseSchema = z8.array(ContactSchema);

// src/api/brand/settings.ts
import { z as z9 } from "zod";
var THEME = /* @__PURE__ */ ((THEME2) => {
  THEME2["DEFAULT"] = "default";
  THEME2["DARK"] = "dark";
  return THEME2;
})(THEME || {});
var NOTIFICATION_PLATFORM = /* @__PURE__ */ ((NOTIFICATION_PLATFORM2) => {
  NOTIFICATION_PLATFORM2["EMAIL"] = "email";
  NOTIFICATION_PLATFORM2["SMS"] = "sms";
  return NOTIFICATION_PLATFORM2;
})(NOTIFICATION_PLATFORM || {});
var NOTIFICATION_TYPE = /* @__PURE__ */ ((NOTIFICATION_TYPE2) => {
  NOTIFICATION_TYPE2["BOOKING_CONFIRMATION"] = "booking:confirmation";
  NOTIFICATION_TYPE2["BOOKING_REFUNDED"] = "booking:refunded";
  NOTIFICATION_TYPE2["BOOKING_CANCELLED"] = "booking:cancelled";
  NOTIFICATION_TYPE2["BOOKING_RESCHEDULED"] = "booking:rescheduled";
  NOTIFICATION_TYPE2["REVIEW_REQUEST"] = "review:request";
  NOTIFICATION_TYPE2["REVIEW_REMINDER"] = "review:reminder";
  NOTIFICATION_TYPE2["REVIEW_RECEIVED"] = "review:received";
  NOTIFICATION_TYPE2["EVENT_REMINDER"] = "event:reminder";
  NOTIFICATION_TYPE2["EVENT_SECOND_REMINDER"] = "event:second-reminder";
  NOTIFICATION_TYPE2["EXPERIENCE_APPROVED"] = "experience:approved";
  NOTIFICATION_TYPE2["EXPERIENCE_UNPUBLISHED"] = "experience:unpublished";
  NOTIFICATION_TYPE2["EXPERIENCE_DELETED"] = "experience:deleted";
  NOTIFICATION_TYPE2["EXPERIENCE_ASSIGNED"] = "experience:assigned";
  NOTIFICATION_TYPE2["EXPERIENCE_UNASSIGNED"] = "experience:unassigned";
  NOTIFICATION_TYPE2["AVAILABILITY_REMINDER"] = "experience:availability-reminder";
  NOTIFICATION_TYPE2["AUCTION_CANCELED"] = "auction:canceled";
  NOTIFICATION_TYPE2["AUCTION_CLOSING_SOON"] = "auction:closing-soon";
  NOTIFICATION_TYPE2["AUCTION_CLOSED"] = "auction:closed";
  NOTIFICATION_TYPE2["AUCTION_WON"] = "auction:won";
  NOTIFICATION_TYPE2["AUCTION_OUT_BID"] = "auction:out-bid";
  NOTIFICATION_TYPE2["AUCTION_HIGHEST_BID"] = "auction:highest-bid";
  NOTIFICATION_TYPE2["GUEST_REQUEST_TO_BOOK_CREATED"] = "experience:guest-request-to-book-created";
  return NOTIFICATION_TYPE2;
})(NOTIFICATION_TYPE || {});
var StripePaymentMethods = /* @__PURE__ */ ((StripePaymentMethods2) => {
  StripePaymentMethods2["CARD"] = "card";
  StripePaymentMethods2["APPLE_PAY"] = "apple_pay";
  StripePaymentMethods2["GOOGLE_PAY"] = "google_pay";
  StripePaymentMethods2["AMAZON_PAY"] = "amazon_pay";
  StripePaymentMethods2["CASH_APP_PAY"] = "cashapp";
  StripePaymentMethods2["LINK"] = "link";
  StripePaymentMethods2["ALI_PAY"] = "alipay";
  StripePaymentMethods2["WECHAT_PAY"] = "wechat_pay";
  return StripePaymentMethods2;
})(StripePaymentMethods || {});
var PaymentMethodSettingsSchema = z9.object({
  ["apple_pay" /* APPLE_PAY */]: z9.boolean().optional(),
  ["google_pay" /* GOOGLE_PAY */]: z9.boolean().optional(),
  ["amazon_pay" /* AMAZON_PAY */]: z9.boolean().optional(),
  ["cashapp" /* CASH_APP_PAY */]: z9.boolean().optional(),
  ["link" /* LINK */]: z9.boolean().optional(),
  ["alipay" /* ALI_PAY */]: z9.boolean().optional(),
  ["wechat_pay" /* WECHAT_PAY */]: z9.boolean().optional()
});
var BRAND_EMAIL_ADDRESS_TYPE = /* @__PURE__ */ ((BRAND_EMAIL_ADDRESS_TYPE2) => {
  BRAND_EMAIL_ADDRESS_TYPE2["FROM"] = "from";
  BRAND_EMAIL_ADDRESS_TYPE2["BOOKINGS"] = "bookings";
  BRAND_EMAIL_ADDRESS_TYPE2["HOST_SUBMISSIONS"] = "hostSubmissions";
  return BRAND_EMAIL_ADDRESS_TYPE2;
})(BRAND_EMAIL_ADDRESS_TYPE || {});
var AVAILABLE_BRAND_FEATURES = /* @__PURE__ */ ((AVAILABLE_BRAND_FEATURES2) => {
  AVAILABLE_BRAND_FEATURES2["REVIEWS"] = "reviews";
  AVAILABLE_BRAND_FEATURES2["API_ACCESS"] = "apiAccess";
  AVAILABLE_BRAND_FEATURES2["UNLIMITED_HOST"] = "unlimitedHost";
  AVAILABLE_BRAND_FEATURES2["EXCLUSIVE_EXPERIENCE"] = "exclusiveExperiences";
  AVAILABLE_BRAND_FEATURES2["DATA_PLUS"] = "dataPlus";
  AVAILABLE_BRAND_FEATURES2["EXPERIENCE_COMMENTS"] = "experienceComments";
  AVAILABLE_BRAND_FEATURES2["CUSTOM_BOOKING_EMAIL_MESSAGE"] = "customBookingEmailMessage";
  AVAILABLE_BRAND_FEATURES2["SMS_NOTIFICATION"] = "smsNotifications";
  AVAILABLE_BRAND_FEATURES2["EXPERIENCE_LISTING_TYPE"] = "experienceListingType";
  AVAILABLE_BRAND_FEATURES2["ENHANCED_HOST_COMMISSION"] = "enhancedHostCommission";
  AVAILABLE_BRAND_FEATURES2["PRICE_TIERS"] = "priceTiers";
  AVAILABLE_BRAND_FEATURES2["SHOPPING_CART"] = "shoppingCart";
  AVAILABLE_BRAND_FEATURES2["ENHANCED_NOTIFICATIONS"] = "enhancedNotifications";
  AVAILABLE_BRAND_FEATURES2["EMAIL_CUSTOMIZATION"] = "emailCustomization";
  AVAILABLE_BRAND_FEATURES2["EMAIL_DNS_SETTINGS"] = "emailDnsSettings";
  AVAILABLE_BRAND_FEATURES2["CUSTOM_QUESTIONS"] = "customQuestions";
  AVAILABLE_BRAND_FEATURES2["CONDITIONAL_PRICING"] = "conditionalPricing";
  AVAILABLE_BRAND_FEATURES2["ROOM_MEMBER_CHARGE"] = "roomMemberCharge";
  AVAILABLE_BRAND_FEATURES2["CREDIT_CARD"] = "creditCard";
  AVAILABLE_BRAND_FEATURES2["KICC"] = "kicc";
  AVAILABLE_BRAND_FEATURES2["UNLISTED_EXPERIENCE"] = "unlistedExperience";
  AVAILABLE_BRAND_FEATURES2["IN_APP_MESSAGING"] = "inAppMessaging";
  AVAILABLE_BRAND_FEATURES2["CHECK_IN"] = "check-in";
  AVAILABLE_BRAND_FEATURES2["TICKET_SCANNING"] = "ticketScanning";
  AVAILABLE_BRAND_FEATURES2["OPERA"] = "integrations:opera";
  AVAILABLE_BRAND_FEATURES2["STAYNTOUCH"] = "integrations:stayntouch";
  AVAILABLE_BRAND_FEATURES2["REVINATE"] = "integrations:revinate";
  AVAILABLE_BRAND_FEATURES2["BACKEND_BOOKING"] = "backendBooking";
  AVAILABLE_BRAND_FEATURES2["INFOR"] = "integrations:infor";
  AVAILABLE_BRAND_FEATURES2["AI_CURATION"] = "aiCuration";
  AVAILABLE_BRAND_FEATURES2["ALICE"] = "integrations:alice";
  AVAILABLE_BRAND_FEATURES2["SIMPHONY"] = "integrations:simphony";
  AVAILABLE_BRAND_FEATURES2["BYPASS_CTA_BLOCK"] = "bypassCTABlock";
  AVAILABLE_BRAND_FEATURES2["PAY_UPON_ARRIVAL"] = "payUponArrival";
  AVAILABLE_BRAND_FEATURES2["REMOVE_CASH_PAYMENT"] = "removeCashPayment";
  AVAILABLE_BRAND_FEATURES2["GUEST_MICRO_SURVEY"] = "guestMicroSurvey";
  AVAILABLE_BRAND_FEATURES2["TEALIUM_ANALYTICS"] = "integrations:tealiumAnalytics";
  AVAILABLE_BRAND_FEATURES2["GTM_ANALYTICS"] = "integrations:gtmAnalytics";
  AVAILABLE_BRAND_FEATURES2["GA4_ANALYTICS"] = "integrations:ga4Analytics";
  AVAILABLE_BRAND_FEATURES2["SEAT_CHART"] = "seatChart";
  AVAILABLE_BRAND_FEATURES2["FLEXIBLE_DURATION"] = "flexibleDuration";
  AVAILABLE_BRAND_FEATURES2["PAUSE_AVAILABILITY_REMINDER"] = "pauseAvailabilityReminder";
  AVAILABLE_BRAND_FEATURES2["NEW_SESSION_UI"] = "newSessionUi";
  AVAILABLE_BRAND_FEATURES2["DISABLE_ACTIVATE_SCROLLING_ANIMATION"] = "disableActivateScrollingAnimation";
  AVAILABLE_BRAND_FEATURES2["ENABLE_NEW_LANDING_PAGE"] = "enableNewLandingPage";
  AVAILABLE_BRAND_FEATURES2["ENABLE_WALLETS_PAYMENT"] = "enableWalletsPayment";
  AVAILABLE_BRAND_FEATURES2["ENABLE_HYATT_LMS"] = "enableHyattLms";
  AVAILABLE_BRAND_FEATURES2["ENABLE_ALASKA_LMS"] = "enableAlaskaLms";
  AVAILABLE_BRAND_FEATURES2["ENABLE_PROMOTER"] = "enablePromoter";
  AVAILABLE_BRAND_FEATURES2["ENABLE_VIBES_V2"] = "enableVibesV2";
  AVAILABLE_BRAND_FEATURES2["PREVENT_CATEGORY_MANAGEMENT"] = "preventCategoryManagement";
  AVAILABLE_BRAND_FEATURES2["ENABLE_TRANSLATIONS"] = "enableTranslations";
  AVAILABLE_BRAND_FEATURES2["ENABLE_DURATIONS"] = "enableDurations";
  AVAILABLE_BRAND_FEATURES2["ENABLE_RESCHEDULE_BOOKINGS"] = "enableRescheduleBookings";
  AVAILABLE_BRAND_FEATURES2["ENABLE_REQUEST_BOOKINGS"] = "enableRequestBookings";
  AVAILABLE_BRAND_FEATURES2["ENABLE_AUCTIONS_DEBUG"] = "enableAuctionsDebug";
  AVAILABLE_BRAND_FEATURES2["PREVENT_PMS_LOOKUP"] = "preventPmsLookup";
  AVAILABLE_BRAND_FEATURES2["ENABLE_NEW_PMS_TOTALS_CALCULATION"] = "enableNewPmsTotalsCalculation";
  AVAILABLE_BRAND_FEATURES2["ENABLE_AUCTIONS"] = "enableAuctions";
  AVAILABLE_BRAND_FEATURES2["ENABLE_BOOKING_SURCHARGE"] = "enableBookingSurcharge";
  AVAILABLE_BRAND_FEATURES2["ENABLE_PARTNER_INVITATIONS"] = "enablePartnerInvitations";
  AVAILABLE_BRAND_FEATURES2["ENABLE_LIMITED_TIME_HOST_EXPERIENCES"] = "enableLimitedTimeHostExperiences";
  AVAILABLE_BRAND_FEATURES2["ENABLE_LIMITED_TIME_ACTIVATE_EXPERIENCES"] = "enableLimitedTimeActivateExperiences";
  AVAILABLE_BRAND_FEATURES2["ENABLE_CREDIT_CARD_FEE_ROUTING_TO_HOST"] = "enableCreditCardFeeRoutingToHost";
  return AVAILABLE_BRAND_FEATURES2;
})(AVAILABLE_BRAND_FEATURES || {});
var DesignElementSchema = z9.object({
  logoId: z9.string().uuid().nullable(),
  primaryColor: HexColorSchema.nullable(),
  secondaryColor: HexColorSchema.nullable(),
  buttonColor: HexColorSchema.nullable(),
  primaryFont: z9.string().nullable(),
  secondaryFont: z9.string().nullable(),
  theme: z9.nativeEnum(THEME)
}).partial();
var TemplateElementSchema = z9.object({
  hero: z9.object({
    desktopImageId: z9.string().uuid().nullable(),
    mobileImageId: z9.string().uuid().nullable(),
    intro: z9.string().max(150).nullable(),
    heading: z9.string().max(150).nullable(),
    description: z9.string().nullable()
  }).partial()
});
var EmailSettingSchema = z9.object({
  booking: z9.object({ confirmationMessage: z9.string().nullable() })
});
var TermsAndConditionsSchema = z9.object({
  documents: z9.array(z9.object({ title: z9.string(), mediaId: z9.string().uuid() }))
});
var WhitelistedUrlSchema = z9.string().refine((url) => {
  try {
    const parsedUrl = new URL(url);
    return parsedUrl.protocol === "https:" || parsedUrl.protocol === "http:" && parsedUrl.hostname === "localhost";
  } catch {
    return false;
  }
});
var WhitelistedDomainsSchema = z9.array(WhitelistedUrlSchema);
var SeoSchema = z9.object({
  sitemapBaseUrls: z9.array(z9.string())
});
var FeaturesSchema = z9.record(z9.nativeEnum(AVAILABLE_BRAND_FEATURES), z9.boolean());
var PromotionSchema = z9.object({
  exclusiveTag: z9.string()
});
var DataPlusSettingsSchema = z9.object({
  operatingAccountNumber: z9.string().or(z9.number()),
  propertyId: z9.string().or(z9.number()),
  advanceDepositAccountNumber: z9.string().nullable(),
  emailAddress: z9.string().nullable()
});
var CustomStyleSchema = z9.string();
var HostSignupSchema = z9.object({
  headingText: z9.string(),
  experienceOverview: z9.string(),
  joinCommunityOverview: z9.string(),
  hostFeaturedImageId: z9.string().nullable(),
  experienceFeaturedImageId: z9.string().nullable(),
  signupFeaturedImageId: z9.string().nullable()
});
var ControlCadenceBefore = /* @__PURE__ */ ((ControlCadenceBefore2) => {
  ControlCadenceBefore2["HOUR_BEFORE"] = "hours_before";
  ControlCadenceBefore2["WEEK_BEFORE"] = "week_before";
  return ControlCadenceBefore2;
})(ControlCadenceBefore || {});
var ControlCadenceAfter = /* @__PURE__ */ ((ControlCadenceAfter2) => {
  ControlCadenceAfter2["HOUR_AFTER"] = "hours_after";
  ControlCadenceAfter2["WEEK_AFTER"] = "week_after";
  return ControlCadenceAfter2;
})(ControlCadenceAfter || {});
var PayoutSchedule = /* @__PURE__ */ ((PayoutSchedule2) => {
  PayoutSchedule2["TRANSACTION_DATE"] = "transaction_date";
  PayoutSchedule2["EXPERIENCE_DATE"] = "experience_date";
  return PayoutSchedule2;
})(PayoutSchedule || {});
var PaymentSettingSchema = z9.object({
  payoutSchedule: z9.nativeEnum(PayoutSchedule)
});
var BrandEmailNotificationSettingsSchema = z9.object({
  ["booking:confirmation" /* BOOKING_CONFIRMATION */]: z9.object({ enabled: z9.boolean() }),
  ["booking:refunded" /* BOOKING_REFUNDED */]: z9.object({ enabled: z9.boolean() }),
  ["booking:cancelled" /* BOOKING_CANCELLED */]: z9.object({ enabled: z9.boolean() }),
  ["booking:rescheduled" /* BOOKING_RESCHEDULED */]: z9.object({ enabled: z9.boolean() }),
  ["review:request" /* REVIEW_REQUEST */]: z9.object({
    enabled: z9.boolean(),
    config: z9.object({ value: z9.number(), cadence: z9.nativeEnum(ControlCadenceAfter) }).optional()
  }),
  ["review:reminder" /* REVIEW_REMINDER */]: z9.object({
    enabled: z9.boolean(),
    config: z9.object({ value: z9.number(), cadence: z9.nativeEnum(ControlCadenceAfter) }).optional()
  }),
  ["event:reminder" /* EVENT_REMINDER */]: z9.object({
    enabled: z9.boolean(),
    config: z9.object({ value: z9.number(), cadence: z9.nativeEnum(ControlCadenceBefore) }).optional()
  }),
  ["event:second-reminder" /* EVENT_SECOND_REMINDER */]: z9.object({
    enabled: z9.boolean(),
    config: z9.object({ value: z9.number(), cadence: z9.nativeEnum(ControlCadenceBefore) }).optional()
  })
}).partial();
var BrandSmsNotificationSettingsSchema = BrandEmailNotificationSettingsSchema.omit({
  ["review:reminder" /* REVIEW_REMINDER */]: true,
  ["review:request" /* REVIEW_REQUEST */]: true
});
var BrandNotificationSchema = z9.object({
  ["email" /* EMAIL */]: BrandEmailNotificationSettingsSchema,
  ["sms" /* SMS */]: BrandSmsNotificationSettingsSchema
}).partial();
var BrandEmailAddressesSchema = z9.object({
  ["from" /* FROM */]: EmailStringSchema.or(z9.literal("")),
  ["bookings" /* BOOKINGS */]: EmailStringSchema.or(z9.literal("")),
  ["hostSubmissions" /* HOST_SUBMISSIONS */]: EmailStringSchema.or(z9.literal(""))
}).partial();
var ShouldValidateComplimentaryBookingSchema = z9.object({
  roomCharge: z9.boolean(),
  memberCharge: z9.boolean()
}).partial();
var StripeSchema = z9.record(z9.unknown());
var PutBrandSettingsRequestSchema = z9.object({
  designElement: DesignElementSchema.optional(),
  templateElement: TemplateElementSchema.optional(),
  email: EmailSettingSchema.optional(),
  termsAndConditions: TermsAndConditionsSchema.optional(),
  whitelistedDomains: WhitelistedDomainsSchema.optional(),
  seo: SeoSchema.optional(),
  features: FeaturesSchema.optional(),
  promotion: PromotionSchema.optional(),
  dataPlus: DataPlusSettingsSchema.optional(),
  customStyle: CustomStyleSchema.optional(),
  hostSignup: HostSignupSchema.optional(),
  notifications: BrandNotificationSchema.optional(),
  emailAddresses: BrandEmailAddressesSchema.optional(),
  shouldValidateComplimentaryBooking: ShouldValidateComplimentaryBookingSchema.optional(),
  stripe: StripeSchema.optional(),
  payment: PaymentSettingSchema.optional(),
  paymentMethods: PaymentMethodSettingsSchema.optional(),
  cancellationPolicyId: z9.string().uuid().nullable().optional(),
  reschedulePolicyId: z9.string().uuid().nullable().optional()
});
var DnsSettingsSchema = z9.object({
  valid: z9.boolean(),
  type: z9.string(),
  host: z9.string(),
  data: z9.string()
});
var BrandDnsSettingsResponseSchema = z9.object({
  mx: DnsSettingsSchema,
  spf: DnsSettingsSchema,
  dkim: DnsSettingsSchema
});
var DnsValidationSchema = z9.object({
  valid: z9.boolean(),
  reason: z9.string().nullable()
});
var BrandDnsValidationResponseSchema = z9.object({
  mx: DnsValidationSchema,
  spf: DnsValidationSchema,
  dkim: DnsValidationSchema
});
var UpdateBrandSettingsEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId }) => `v1/brands/${brandId}/settings`,
  responseSchema: z9.void(),
  requestSchema: PutBrandSettingsRequestSchema
});
var UpdateBrandWebsiteUrlsRequestSchema = z9.object({
  urls: WhitelistedDomainsSchema
});
var UpdateBrandWebsiteUrlsEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId }) => `v1/brands/${brandId}/website-urls`,
  responseSchema: z9.void(),
  requestSchema: UpdateBrandWebsiteUrlsRequestSchema
});

// src/api/location/location.ts
import { z as z10 } from "zod";
var LocationSchema = z10.object({
  id: z10.string().uuid(),
  name: z10.string(),
  additionalInfo: z10.string().nullable(),
  city: z10.string().nullable(),
  state: z10.string().nullable(),
  country: z10.string().nullable(),
  longitude: z10.number(),
  latitude: z10.number(),
  timezoneId: z10.string(),
  createdAt: z10.date().optional(),
  updatedAt: z10.date().optional()
});

// src/api/payment-method/const.ts
import { z as z11 } from "zod";
var StripeAccountStatus = /* @__PURE__ */ ((StripeAccountStatus2) => {
  StripeAccountStatus2["ACTIVE"] = "active";
  StripeAccountStatus2["INACTIVE"] = "inactive";
  return StripeAccountStatus2;
})(StripeAccountStatus || {});
var StripeAccountServiceAgreement = /* @__PURE__ */ ((StripeAccountServiceAgreement2) => {
  StripeAccountServiceAgreement2["FULL_AGREEMENT"] = "full_agreement";
  StripeAccountServiceAgreement2["RECIPIENT"] = "recipient";
  return StripeAccountServiceAgreement2;
})(StripeAccountServiceAgreement || {});
var CountryCodesThatRequireFullAgreementStripeAccount = [
  "AT",
  "BE",
  "BG",
  "CH",
  "CY",
  "CZ",
  "DE",
  "DK",
  "EE",
  "ES",
  "FI",
  "FR",
  "GB",
  "GR",
  "HR",
  "HU",
  "IE",
  "IT",
  "LT",
  "LU",
  "LV",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SE",
  "SI",
  "SK",
  "US"
];
var GetServiceAgreementQuerySchema = z11.object({
  brandId: z11.string().uuid()
});
var GetStripeAccountServiceAgreementTypeResponseSchema = z11.object({
  serviceAgreement: z11.nativeEnum(StripeAccountServiceAgreement)
});
var GetStripeAccountServiceAgreementTypeResponseEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/brands/${brandId}/stripe-accounts/service-agreement-type`,
  responseSchema: GetStripeAccountServiceAgreementTypeResponseSchema,
  requestSchema: z11.void()
});

// src/api/translation/types.ts
import { z as z12 } from "zod";
var TranslationEntityTable = /* @__PURE__ */ ((TranslationEntityTable2) => {
  TranslationEntityTable2["AddOn"] = "add_on_i18n";
  TranslationEntityTable2["CancellationPolicy"] = "cancellation_policy_i18n";
  TranslationEntityTable2["ReschedulePolicy"] = "reschedule_policy_i18n";
  TranslationEntityTable2["Category"] = "category_i18n";
  TranslationEntityTable2["CustomQuestion"] = "custom_question_i18n";
  TranslationEntityTable2["Experience"] = "experience_i18n";
  TranslationEntityTable2["Listing"] = "listing_i18n";
  TranslationEntityTable2["ListingAddOn"] = "listing_add_on_i18n";
  TranslationEntityTable2["ListingIncluded"] = "listing_included_i18n";
  TranslationEntityTable2["Location"] = "location_i18n";
  TranslationEntityTable2["ResourceGroup"] = "resource_group_i18n";
  TranslationEntityTable2["ResourceGroupCollection"] = "resource_group_collection_i18n";
  TranslationEntityTable2["Tax"] = "tax_i18n";
  TranslationEntityTable2["User"] = "user_i18n";
  TranslationEntityTable2["Vibe"] = "vibe_i18n";
  TranslationEntityTable2["Duration"] = "duration_i18n";
  return TranslationEntityTable2;
})(TranslationEntityTable || {});
var TranslationSchema = z12.object({
  id: z12.string().nullable().optional(),
  parentId: z12.string(),
  fieldName: z12.string(),
  languageCode: z12.string(),
  isManuallySet: z12.boolean(),
  value: z12.string(),
  createdAt: z12.coerce.date().optional(),
  updatedAt: z12.coerce.date().optional(),
  version: z12.nativeEnum(ExperienceVersion).optional()
});
var TranslationsSchema = z12.array(TranslationSchema);
var TranslationWithIdSchema = TranslationSchema.required({ id: true });
var TranslationsWithIdSchema = z12.array(TranslationWithIdSchema);

// src/api/user/user.ts
import { z as z13 } from "zod";
var BrandMembershipRole = /* @__PURE__ */ ((BrandMembershipRole2) => {
  BrandMembershipRole2["OWNER"] = "owner";
  BrandMembershipRole2["ADMIN"] = "admin";
  BrandMembershipRole2["HOST"] = "host";
  return BrandMembershipRole2;
})(BrandMembershipRole || {});
var BrandMembershipRolesSchema = z13.nativeEnum(BrandMembershipRole);
var UserAddressSchema = z13.object({
  street: z13.string(),
  city: z13.string(),
  state: z13.string(),
  zip: z13.string()
}).partial();
var UserSchema = z13.object({
  firstName: z13.string(),
  lastName: z13.string(),
  emailAddress: EmailStringSchema,
  phoneNumber: z13.string().nullable(),
  role: z13.nativeEnum(BrandMembershipRole).nullable(),
  title: z13.string().nullable(),
  id: z13.string().uuid(),
  lastAccessedAt: z13.string().datetime().nullable(),
  profilePictureId: z13.string().uuid().nullable(),
  countryCode: z13.string().nullable()
});
var UserImageSizes = /* @__PURE__ */ ((UserImageSizes2) => {
  UserImageSizes2["W48"] = "48";
  UserImageSizes2["W256"] = "256";
  return UserImageSizes2;
})(UserImageSizes || {});
var UserImageSizeInUriSchema = z13.object(
  Object.fromEntries(Object.values(UserImageSizes).map((size) => [`${size}w`, z13.string()]))
);
var UserImageSizeWithOriginalInUriSchema = UserImageSizeInUriSchema.extend({ original: z13.string() });
var UserImageSizeMediaSchema = z13.object({ id: z13.string().uuid(), uri: UserImageSizeWithOriginalInUriSchema });
var UserResponseSchema = UserSchema.omit({ profilePictureId: true }).extend({
  profilePicture: UserImageSizeMediaSchema.nullable()
});
var PaginatedUsersResponseSchema = paginateResponseSchema(UserResponseSchema);
var PaymentPlatform = /* @__PURE__ */ ((PaymentPlatform2) => {
  PaymentPlatform2["STRIPE_US"] = "stripe-us";
  PaymentPlatform2["STRIPE_EU"] = "stripe-eu";
  PaymentPlatform2["KICC"] = "kicc";
  return PaymentPlatform2;
})(PaymentPlatform || {});
var Status = /* @__PURE__ */ ((Status2) => {
  Status2["DRAFT"] = "draft";
  Status2["PUBLISHED"] = "published";
  return Status2;
})(Status || {});
var Role = /* @__PURE__ */ ((Role2) => {
  Role2["CUSTOMER"] = "customer";
  Role2["BRAND_USER"] = "brand-user";
  Role2["STAFF_ADMIN"] = "staff-admin";
  Role2["INTEGRATION"] = "integration";
  Role2["SYSTEM"] = "system";
  Role2["ORG_USER"] = "org-user";
  return Role2;
})(Role || {});
var BrandSchema = z13.object({
  id: z13.string(),
  name: z13.string(),
  currency: z13.string(),
  paymentPlatform: z13.nativeEnum(PaymentPlatform)
});
var MembershipSchema = z13.object({
  brand: BrandSchema,
  id: z13.string().uuid(),
  role: z13.nativeEnum(BrandMembershipRole),
  isConfirmed: z13.boolean(),
  permissions: z13.array(z13.string()).nullable(),
  lastAccessedAt: z13.string().datetime().nullable()
});
var UserDetailSchema = z13.object({
  id: z13.string().uuid(),
  firstName: z13.string(),
  lastName: z13.string(),
  emailAddress: EmailStringSchema,
  phoneNumber: z13.string().nullable(),
  address: UserAddressSchema.nullable(),
  role: z13.nativeEnum(Role),
  title: z13.string().nullable(),
  dateOfBirth: z13.string().nullable(),
  description: z13.string().nullable(),
  memberships: z13.array(MembershipSchema),
  confirmedAt: z13.string().datetime().nullable(),
  isResetPassword: z13.boolean().nullable(),
  profilePicture: z13.object({
    id: z13.string(),
    uri: z13.object({ original: z13.string() }).and(z13.record(z13.string()))
  }).nullable(),
  countryCode: z13.string().nullable()
});
var UserSortBy = /* @__PURE__ */ ((UserSortBy2) => {
  UserSortBy2["FIRST_NAME"] = "firstName";
  UserSortBy2["LAST_NAME"] = "lastName";
  UserSortBy2["LAST_ACCESS_AT"] = "lastAccessedAt";
  return UserSortBy2;
})(UserSortBy || {});
var GetUsersQuerySchema = z13.object({
  q: z13.string().optional(),
  sortBy: z13.nativeEnum(UserSortBy).optional(),
  sortDir: z13.enum(sortOptions).optional(),
  page: z13.coerce.number().min(1).default(1),
  limit: z13.coerce.number().min(1).default(10)
}).strict();
var UserRequestSchema = z13.object({
  firstName: z13.string(),
  lastName: z13.string(),
  emailAddress: EmailStringSchema,
  phoneNumber: PhoneNumberValidationSchema.nullable(),
  dateOfBirth: z13.coerce.date(),
  description: z13.string().nullable(),
  profilePictureId: z13.string().uuid().nullable(),
  role: z13.nativeEnum(Role),
  title: z13.string().nullable(),
  countryCode: z13.string().nullable(),
  allowOverlappingBookings: z13.boolean(),
  auth0Id: z13.string().uuid().nullable().optional(),
  acceptedTermsAndConditions: z13.boolean().nullable(),
  address: UserAddressSchema,
  socialMediaHandle: z13.object({
    instagram: z13.string(),
    twitter: z13.string()
  }).partial(),
  verifyBrands: z13.array(
    z13.object({
      brandId: z13.string(),
      verify: z13.boolean()
    })
  )
}).partial();
var ChangePasswordSchema = z13.object({
  currentPassword: z13.string(),
  newPassword: z13.string().min(6)
});
var ResetPasswordSchema = z13.object({
  password: z13.string().min(6)
});
var EmailAddressSchema = z13.object({
  emailAddress: EmailStringSchema,
  skipId: z13.string().uuid()
});
var PhoneNumberSchema = z13.object({
  phoneNumber: PhoneNumberValidationSchema
});
var UpdateUserCountryCodeRequestSchema = z13.object({
  countryCode: z13.string().nullable()
});
var UpdateUserCountryCodeEndpoint = makeEndpoint({
  method: "PATCH",
  url: () => `/v1/users/me/country-code`,
  requestSchema: UpdateUserCountryCodeRequestSchema,
  responseSchema: z13.void()
});
var UserField = /* @__PURE__ */ ((UserField2) => {
  UserField2["DESCRIPTION"] = "description";
  return UserField2;
})(UserField || {});
var GetHostsResponseSchema = z13.array(
  z13.object({
    id: z13.string().uuid(),
    firstName: z13.string(),
    lastName: z13.string(),
    description: z13.string().nullable(),
    profilePicture: z13.object({
      id: z13.string().uuid(),
      uri: UserImageSizeWithOriginalInUriSchema
    }).nullable()
  })
);
var GetHostsQuerySchema = z13.object({
  userIds: z13.array(z13.string().uuid()),
  language: z13.string().optional()
});
var GetHostsEndpoint = makeEndpoint({
  method: "GET",
  url: () => `/v1/users/hosts`,
  requestSchema: z13.void(),
  responseSchema: GetHostsResponseSchema,
  querySchema: GetHostsQuerySchema
});

// src/api/validator/currencyCode.ts
var isValidCurrencyCode = (code) => {
  return code in Currency;
};

// src/api/brand/brand.ts
var Tier = /* @__PURE__ */ ((Tier2) => {
  Tier2["GROWTH"] = "growth";
  Tier2["PRO"] = "pro";
  Tier2["STARTER"] = "starter";
  Tier2["STANDARD"] = "standard";
  Tier2["CUSTOM"] = "custom";
  return Tier2;
})(Tier || {});
var LanguageCode = /* @__PURE__ */ ((LanguageCode2) => {
  LanguageCode2["DE_DE"] = "de-DE";
  LanguageCode2["EN_GB"] = "en-GB";
  LanguageCode2["EN_US"] = "en-US";
  LanguageCode2["ES_ES"] = "es-ES";
  LanguageCode2["FR_FR"] = "fr-FR";
  LanguageCode2["IT_IT"] = "it-IT";
  LanguageCode2["JA_JP"] = "ja-JP";
  LanguageCode2["KO_KR"] = "ko-KR";
  LanguageCode2["PT_BR"] = "pt-BR";
  LanguageCode2["RU_RU"] = "ru-RU";
  LanguageCode2["ZH_HANS"] = "zh-Hans";
  LanguageCode2["ZH_HANT"] = "zh-Hant";
  return LanguageCode2;
})(LanguageCode || {});
var BrandCategory = /* @__PURE__ */ ((BrandCategory2) => {
  BrandCategory2["LUXURY"] = "luxury";
  BrandCategory2["LIFESTYLE"] = "lifestyle";
  BrandCategory2["BOUTIQUE"] = "boutique";
  BrandCategory2["INDEPENDENT"] = "independent";
  BrandCategory2["DESTINATION"] = "destination";
  return BrandCategory2;
})(BrandCategory || {});
var TravelProfile = /* @__PURE__ */ ((TravelProfile2) => {
  TravelProfile2["LUXURY_TRAVELERS"] = "luxury-travelers";
  TravelProfile2["FAMILY_TRAVELERS"] = "family-travelers";
  TravelProfile2["ADVENTURE_SEEKERS"] = "adventure-seekers";
  TravelProfile2["NATURE_LOVERS"] = "nature-lovers";
  TravelProfile2["CULTURE_EXPLORERS"] = "culture-explorers";
  TravelProfile2["DIGITAL_NOMADS"] = "digital-nomads";
  TravelProfile2["RELAXATION_WELLNESS_SEEKERS"] = "relaxation-wellness-seekers";
  return TravelProfile2;
})(TravelProfile || {});
var WayVersion = /* @__PURE__ */ ((WayVersion2) => {
  WayVersion2["V1"] = "V1";
  WayVersion2["V2"] = "V2";
  return WayVersion2;
})(WayVersion || {});
var ProductLine = /* @__PURE__ */ ((ProductLine2) => {
  ProductLine2["ACTIVATE"] = "activate";
  ProductLine2["HOST"] = "host";
  ProductLine2["RESERVE"] = "reserve";
  return ProductLine2;
})(ProductLine || {});
var BrandSchema2 = z14.object({
  id: z14.string().uuid(),
  name: z14.string(),
  tier: z14.nativeEnum(Tier, { invalid_type_error: "Invalid tier supplied" }),
  products: z14.array(z14.nativeEnum(ProductLine)).nullable(),
  countryCode: z14.enum(Object.keys(AllCountries)),
  currency: z14.string().refine((code) => isValidCurrencyCode(code), {
    message: "Currency is invalid"
  }),
  defaultLanguageCode: z14.nativeEnum(LanguageCode),
  manuallyTranslatedLanguages: z14.array(z14.nativeEnum(LanguageCode)).nullable(),
  creditCardFeePercentage: z14.number().min(0).max(100, "Credit card fee % must be less than 100"),
  features: z14.record(z14.string(), z14.boolean()),
  locationId: z14.string().uuid().nullable(),
  location: LocationSchema.omit({
    additionalInfo: true
  }).nullable(),
  category: z14.nativeEnum(BrandCategory).nullable(),
  adr: z14.number().nullable(),
  keys: z14.number().nullable(),
  propertyType: z14.string().nullable().optional(),
  vision: z14.string().nullable(),
  pillars: z14.string().nullable(),
  travelProfile: z14.nativeEnum(TravelProfile).nullable(),
  availableSpacesAndAmenities: z14.string().nullable(),
  contacts: z14.array(ContactSchema).optional(),
  churnedAt: z14.string().datetime().nullable().optional(),
  brandLaunchedAt: z14.string().datetime().nullable(),
  isTestBrand: z14.boolean().nullable().optional(),
  isCuratedBrand: z14.boolean().nullable().optional(),
  csmUserId: z14.string().uuid().nullable().optional(),
  organizationId: z14.string().uuid().nullable().optional(),
  enableAutomaticExperienceSorting: z14.boolean().optional()
});
var CreateBrandRequestSchema = BrandSchema2.pick({
  name: true,
  tier: true,
  countryCode: true,
  currency: true,
  defaultLanguageCode: true,
  creditCardFeePercentage: true,
  features: true,
  contacts: true,
  isTestBrand: true,
  isCuratedBrand: true,
  csmUserId: true,
  products: true
}).extend({
  owner: z14.object({
    firstName: z14.string().min(2, "First name must be at least 2 characters").max(100, "First name must be less than 100 characters"),
    lastName: z14.string().min(2, "Last name must be at least 2 characters").max(100, "Last name must be less than 100 characters"),
    emailAddress: EmailStringSchema.max(255, "Email Address must be less than 255 characters"),
    phoneNumber: PhoneNumberValidationSchema.optional()
  }),
  isBrandLaunched: z14.boolean().optional(),
  csmUserId: z14.string().uuid().optional(),
  organizationId: z14.string().uuid().optional(),
  externalReferenceId: z14.string().optional(),
  wayVersion: z14.nativeEnum(WayVersion).optional()
}).strict();
var UpdateBrandRequestSchema = BrandSchema2.omit({ id: true, churnedAt: true, location: true }).extend({
  emailAddress: EmailStringSchema,
  location: z14.object({
    name: z14.string(),
    longitude: z14.number(),
    latitude: z14.number()
  }).optional(),
  globalCommissionPercentage: z14.number().min(0).max(100),
  creditCardFeePaidByBrand: z14.boolean(),
  isBrandLaunched: z14.boolean().optional(),
  externalReferenceId: z14.string().optional(),
  enableAutomaticExperienceSorting: z14.boolean().optional(),
  wayVersion: z14.nativeEnum(WayVersion).optional()
}).partial().strict();
var BrandDetailResponseSchema = BrandSchema2.omit({
  csmUserId: true,
  location: true
}).extend({
  emailAddress: EmailStringSchema,
  creditCardFeePaidByBrand: z14.boolean(),
  globalCommissionPercentage: z14.number().nullable(),
  paymentPlatform: z14.string(),
  features: z14.object({
    active: z14.array(z14.nativeEnum(AVAILABLE_BRAND_FEATURES)).optional(),
    hostsLimit: z14.number().optional(),
    updatedAt: z14.string().datetime().optional()
  }),
  location: LocationSchema.omit({
    additionalInfo: true,
    createdAt: true,
    updatedAt: true
  }).nullable(),
  csmUser: UserSchema.pick({
    id: true,
    firstName: true,
    lastName: true
  }).nullable(),
  externalReferenceId: z14.string().nullable(),
  enableAutomaticExperienceSorting: z14.boolean(),
  wayVersion: z14.nativeEnum(WayVersion),
  manuallyTranslatedLanguages: z14.array(z14.nativeEnum(LanguageCode)).nullable(),
  wayCode: z14.string().nullable()
}).strict();
var BrandQueryFilter = /* @__PURE__ */ ((BrandQueryFilter2) => {
  BrandQueryFilter2["CHURNED"] = "churned";
  BrandQueryFilter2["DELETED"] = "deleted";
  BrandQueryFilter2["ACTIVE"] = "active";
  return BrandQueryFilter2;
})(BrandQueryFilter || {});
var BrandSortBy = /* @__PURE__ */ ((BrandSortBy2) => {
  BrandSortBy2["NAME"] = "name";
  BrandSortBy2["EMAIL"] = "emailAddress";
  BrandSortBy2["TIER"] = "tier";
  BrandSortBy2["FEE"] = "creditCardFeePercentage";
  return BrandSortBy2;
})(BrandSortBy || {});
var GetBrandsQuerySchema = z14.object({
  q: z14.string().optional(),
  status: z14.nativeEnum(BrandQueryFilter).optional(),
  isTestBrand: z14.boolean().or(BooleanStringSchema.transform((str) => str.toLowerCase() === "true")).optional(),
  isCuratedBrand: z14.boolean().or(BooleanStringSchema.transform((str) => str.toLowerCase() === "true")).optional(),
  organizationId: z14.string().optional(),
  page: z14.coerce.number().min(1).default(1),
  limit: z14.coerce.number().min(1).default(10),
  sortBy: z14.nativeEnum(BrandSortBy).optional(),
  sortDir: z14.enum(sortOptions).optional()
}).strict();
var GetOrganizationBrandsQuerySchema = z14.object({
  page: z14.coerce.number().min(1).default(1),
  limit: z14.coerce.number().min(1).default(10),
  sortBy: z14.nativeEnum(BrandSortBy).optional(),
  sortDir: z14.enum(sortOptions).optional()
}).strict();
var BrandPaginatedResponseSchema = paginateResponseSchema(
  BrandSchema2.pick({
    id: true,
    name: true,
    tier: true,
    countryCode: true,
    currency: true,
    creditCardFeePercentage: true,
    isTestBrand: true,
    isCuratedBrand: true,
    churnedAt: true,
    organizationId: true,
    products: true
  }).extend({
    emailAddress: EmailStringSchema,
    externalReferenceId: z14.string().nullable().optional(),
    csmUser: UserSchema.pick({
      id: true,
      firstName: true,
      lastName: true
    }).nullable(),
    logoUri: z14.string().nullable(),
    deletedAt: z14.string().datetime().nullable()
  }).strict()
);
var BrandPaginatedByUserResponseSchema = paginateResponseSchema(
  BrandSchema2.pick({
    id: true,
    name: true,
    tier: true
    // products: true,
  }).extend({
    emailAddress: EmailStringSchema,
    brandLogo: IMediaReferenceSchema.nullable()
  }).strict()
);
var PaginatedBrandsEndpoint = makeEndpoint({
  method: "GET",
  url: () => `brands`,
  responseSchema: BrandPaginatedResponseSchema,
  requestSchema: GetBrandsQuerySchema
});
var StripeSupportedCountryCodes = /* @__PURE__ */ ((StripeSupportedCountryCodes2) => {
  StripeSupportedCountryCodes2["AE"] = "AE";
  StripeSupportedCountryCodes2["AG"] = "AG";
  StripeSupportedCountryCodes2["AL"] = "AL";
  StripeSupportedCountryCodes2["AM"] = "AM";
  StripeSupportedCountryCodes2["AO"] = "AO";
  StripeSupportedCountryCodes2["AR"] = "AR";
  StripeSupportedCountryCodes2["AT"] = "AT";
  StripeSupportedCountryCodes2["AU"] = "AU";
  StripeSupportedCountryCodes2["AZ"] = "AZ";
  StripeSupportedCountryCodes2["BA"] = "BA";
  StripeSupportedCountryCodes2["BD"] = "BD";
  StripeSupportedCountryCodes2["BE"] = "BE";
  StripeSupportedCountryCodes2["BG"] = "BG";
  StripeSupportedCountryCodes2["BH"] = "BH";
  StripeSupportedCountryCodes2["BJ"] = "BJ";
  StripeSupportedCountryCodes2["BN"] = "BN";
  StripeSupportedCountryCodes2["BO"] = "BO";
  StripeSupportedCountryCodes2["BR"] = "BR";
  StripeSupportedCountryCodes2["BS"] = "BS";
  StripeSupportedCountryCodes2["BT"] = "BT";
  StripeSupportedCountryCodes2["BW"] = "BW";
  StripeSupportedCountryCodes2["CA"] = "CA";
  StripeSupportedCountryCodes2["CH"] = "CH";
  StripeSupportedCountryCodes2["CI"] = "CI";
  StripeSupportedCountryCodes2["CL"] = "CL";
  StripeSupportedCountryCodes2["CO"] = "CO";
  StripeSupportedCountryCodes2["CR"] = "CR";
  StripeSupportedCountryCodes2["CY"] = "CY";
  StripeSupportedCountryCodes2["CZ"] = "CZ";
  StripeSupportedCountryCodes2["DE"] = "DE";
  StripeSupportedCountryCodes2["DK"] = "DK";
  StripeSupportedCountryCodes2["DO"] = "DO";
  StripeSupportedCountryCodes2["DZ"] = "DZ";
  StripeSupportedCountryCodes2["EC"] = "EC";
  StripeSupportedCountryCodes2["EE"] = "EE";
  StripeSupportedCountryCodes2["EG"] = "EG";
  StripeSupportedCountryCodes2["ES"] = "ES";
  StripeSupportedCountryCodes2["ET"] = "ET";
  StripeSupportedCountryCodes2["FI"] = "FI";
  StripeSupportedCountryCodes2["FR"] = "FR";
  StripeSupportedCountryCodes2["GA"] = "GA";
  StripeSupportedCountryCodes2["GB"] = "GB";
  StripeSupportedCountryCodes2["GH"] = "GH";
  StripeSupportedCountryCodes2["GI"] = "GI";
  StripeSupportedCountryCodes2["GM"] = "GM";
  StripeSupportedCountryCodes2["GR"] = "GR";
  StripeSupportedCountryCodes2["GT"] = "GT";
  StripeSupportedCountryCodes2["GY"] = "GY";
  StripeSupportedCountryCodes2["HK"] = "HK";
  StripeSupportedCountryCodes2["HR"] = "HR";
  StripeSupportedCountryCodes2["HU"] = "HU";
  StripeSupportedCountryCodes2["ID"] = "ID";
  StripeSupportedCountryCodes2["IE"] = "IE";
  StripeSupportedCountryCodes2["IL"] = "IL";
  StripeSupportedCountryCodes2["IN"] = "IN";
  StripeSupportedCountryCodes2["IS"] = "IS";
  StripeSupportedCountryCodes2["IT"] = "IT";
  StripeSupportedCountryCodes2["JM"] = "JM";
  StripeSupportedCountryCodes2["JO"] = "JO";
  StripeSupportedCountryCodes2["JP"] = "JP";
  StripeSupportedCountryCodes2["KE"] = "KE";
  StripeSupportedCountryCodes2["KH"] = "KH";
  StripeSupportedCountryCodes2["KR"] = "KR";
  StripeSupportedCountryCodes2["KW"] = "KW";
  StripeSupportedCountryCodes2["KZ"] = "KZ";
  StripeSupportedCountryCodes2["LA"] = "LA";
  StripeSupportedCountryCodes2["LC"] = "LC";
  StripeSupportedCountryCodes2["LI"] = "LI";
  StripeSupportedCountryCodes2["LK"] = "LK";
  StripeSupportedCountryCodes2["LT"] = "LT";
  StripeSupportedCountryCodes2["LU"] = "LU";
  StripeSupportedCountryCodes2["LV"] = "LV";
  StripeSupportedCountryCodes2["MA"] = "MA";
  StripeSupportedCountryCodes2["MC"] = "MC";
  StripeSupportedCountryCodes2["MD"] = "MD";
  StripeSupportedCountryCodes2["MG"] = "MG";
  StripeSupportedCountryCodes2["MK"] = "MK";
  StripeSupportedCountryCodes2["MN"] = "MN";
  StripeSupportedCountryCodes2["MO"] = "MO";
  StripeSupportedCountryCodes2["MT"] = "MT";
  StripeSupportedCountryCodes2["MU"] = "MU";
  StripeSupportedCountryCodes2["MX"] = "MX";
  StripeSupportedCountryCodes2["MY"] = "MY";
  StripeSupportedCountryCodes2["MZ"] = "MZ";
  StripeSupportedCountryCodes2["NA"] = "NA";
  StripeSupportedCountryCodes2["NE"] = "NE";
  StripeSupportedCountryCodes2["NG"] = "NG";
  StripeSupportedCountryCodes2["NL"] = "NL";
  StripeSupportedCountryCodes2["NO"] = "NO";
  StripeSupportedCountryCodes2["NZ"] = "NZ";
  StripeSupportedCountryCodes2["OM"] = "OM";
  StripeSupportedCountryCodes2["PA"] = "PA";
  StripeSupportedCountryCodes2["PE"] = "PE";
  StripeSupportedCountryCodes2["PH"] = "PH";
  StripeSupportedCountryCodes2["PK"] = "PK";
  StripeSupportedCountryCodes2["PL"] = "PL";
  StripeSupportedCountryCodes2["PT"] = "PT";
  StripeSupportedCountryCodes2["PY"] = "PY";
  StripeSupportedCountryCodes2["QA"] = "QA";
  StripeSupportedCountryCodes2["RO"] = "RO";
  StripeSupportedCountryCodes2["RS"] = "RS";
  StripeSupportedCountryCodes2["RW"] = "RW";
  StripeSupportedCountryCodes2["SA"] = "SA";
  StripeSupportedCountryCodes2["SE"] = "SE";
  StripeSupportedCountryCodes2["SG"] = "SG";
  StripeSupportedCountryCodes2["SI"] = "SI";
  StripeSupportedCountryCodes2["SK"] = "SK";
  StripeSupportedCountryCodes2["SM"] = "SM";
  StripeSupportedCountryCodes2["SN"] = "SN";
  StripeSupportedCountryCodes2["SV"] = "SV";
  StripeSupportedCountryCodes2["TH"] = "TH";
  StripeSupportedCountryCodes2["TN"] = "TN";
  StripeSupportedCountryCodes2["TR"] = "TR";
  StripeSupportedCountryCodes2["TT"] = "TT";
  StripeSupportedCountryCodes2["TW"] = "TW";
  StripeSupportedCountryCodes2["TZ"] = "TZ";
  StripeSupportedCountryCodes2["US"] = "US";
  StripeSupportedCountryCodes2["UY"] = "UY";
  StripeSupportedCountryCodes2["UZ"] = "UZ";
  StripeSupportedCountryCodes2["VN"] = "VN";
  StripeSupportedCountryCodes2["ZA"] = "ZA";
  return StripeSupportedCountryCodes2;
})(StripeSupportedCountryCodes || {});
var SupportedCountryCodeForFullAgreement = /* @__PURE__ */ ((SupportedCountryCodeForFullAgreement2) => {
  SupportedCountryCodeForFullAgreement2["AE"] = "AE";
  SupportedCountryCodeForFullAgreement2["AT"] = "AT";
  SupportedCountryCodeForFullAgreement2["AU"] = "AU";
  SupportedCountryCodeForFullAgreement2["BE"] = "BE";
  SupportedCountryCodeForFullAgreement2["CA"] = "CA";
  SupportedCountryCodeForFullAgreement2["CH"] = "CH";
  SupportedCountryCodeForFullAgreement2["CY"] = "CY";
  SupportedCountryCodeForFullAgreement2["CZ"] = "CZ";
  SupportedCountryCodeForFullAgreement2["DE"] = "DE";
  SupportedCountryCodeForFullAgreement2["DK"] = "DK";
  SupportedCountryCodeForFullAgreement2["EE"] = "EE";
  SupportedCountryCodeForFullAgreement2["ES"] = "ES";
  SupportedCountryCodeForFullAgreement2["FI"] = "FI";
  SupportedCountryCodeForFullAgreement2["FR"] = "FR";
  SupportedCountryCodeForFullAgreement2["GB"] = "GB";
  SupportedCountryCodeForFullAgreement2["HR"] = "HR";
  SupportedCountryCodeForFullAgreement2["HU"] = "HU";
  SupportedCountryCodeForFullAgreement2["IE"] = "IE";
  SupportedCountryCodeForFullAgreement2["IT"] = "IT";
  SupportedCountryCodeForFullAgreement2["JP"] = "JP";
  SupportedCountryCodeForFullAgreement2["KR"] = "KR";
  SupportedCountryCodeForFullAgreement2["LT"] = "LT";
  SupportedCountryCodeForFullAgreement2["LU"] = "LU";
  SupportedCountryCodeForFullAgreement2["LV"] = "LV";
  SupportedCountryCodeForFullAgreement2["MT"] = "MT";
  SupportedCountryCodeForFullAgreement2["MX"] = "MX";
  SupportedCountryCodeForFullAgreement2["NL"] = "NL";
  SupportedCountryCodeForFullAgreement2["PL"] = "PL";
  SupportedCountryCodeForFullAgreement2["PT"] = "PT";
  SupportedCountryCodeForFullAgreement2["RO"] = "RO";
  SupportedCountryCodeForFullAgreement2["SE"] = "SE";
  SupportedCountryCodeForFullAgreement2["SI"] = "SI";
  SupportedCountryCodeForFullAgreement2["SK"] = "SK";
  SupportedCountryCodeForFullAgreement2["US"] = "US";
  return SupportedCountryCodeForFullAgreement2;
})(SupportedCountryCodeForFullAgreement || {});
var Currency = /* @__PURE__ */ ((Currency2) => {
  Currency2["AED"] = "AED";
  Currency2["ALL"] = "ALL";
  Currency2["AMD"] = "AMD";
  Currency2["AOA"] = "AOA";
  Currency2["ARS"] = "ARS";
  Currency2["AUD"] = "AUD";
  Currency2["AZN"] = "AZN";
  Currency2["BAM"] = "BAM";
  Currency2["BDT"] = "BDT";
  Currency2["BGN"] = "BGN";
  Currency2["BHD"] = "BHD";
  Currency2["BND"] = "BND";
  Currency2["BOB"] = "BOB";
  Currency2["BRL"] = "BRL";
  Currency2["BSD"] = "BSD";
  Currency2["BTN"] = "BTN";
  Currency2["BWP"] = "BWP";
  Currency2["CAD"] = "CAD";
  Currency2["CHF"] = "CHF";
  Currency2["CLP"] = "CLP";
  Currency2["COP"] = "COP";
  Currency2["CRC"] = "CRC";
  Currency2["CZK"] = "CZK";
  Currency2["DKK"] = "DKK";
  Currency2["DOP"] = "DOP";
  Currency2["DZD"] = "DZD";
  Currency2["EGP"] = "EGP";
  Currency2["ETB"] = "ETB";
  Currency2["EUR"] = "EUR";
  Currency2["GBP"] = "GBP";
  Currency2["GHS"] = "GHS";
  Currency2["GMD"] = "GMD";
  Currency2["GTQ"] = "GTQ";
  Currency2["GYD"] = "GYD";
  Currency2["HKD"] = "HKD";
  Currency2["HUF"] = "HUF";
  Currency2["IDR"] = "IDR";
  Currency2["ILS"] = "ILS";
  Currency2["INR"] = "INR";
  Currency2["JMD"] = "JMD";
  Currency2["JOD"] = "JOD";
  Currency2["JPY"] = "JPY";
  Currency2["KES"] = "KES";
  Currency2["KHR"] = "KHR";
  Currency2["KRW"] = "KRW";
  Currency2["KWD"] = "KWD";
  Currency2["KZT"] = "KZT";
  Currency2["LAK"] = "LAK";
  Currency2["LKR"] = "LKR";
  Currency2["MAD"] = "MAD";
  Currency2["MDL"] = "MDL";
  Currency2["MGA"] = "MGA";
  Currency2["MKD"] = "MKD";
  Currency2["MNT"] = "MNT";
  Currency2["MOP"] = "MOP";
  Currency2["MUR"] = "MUR";
  Currency2["MXN"] = "MXN";
  Currency2["MYR"] = "MYR";
  Currency2["MZN"] = "MZN";
  Currency2["NAD"] = "NAD";
  Currency2["NGN"] = "NGN";
  Currency2["NOK"] = "NOK";
  Currency2["NZD"] = "NZD";
  Currency2["OMR"] = "OMR";
  Currency2["PEN"] = "PEN";
  Currency2["PHP"] = "PHP";
  Currency2["PKR"] = "PKR";
  Currency2["PLN"] = "PLN";
  Currency2["PYG"] = "PYG";
  Currency2["QAR"] = "QAR";
  Currency2["RON"] = "RON";
  Currency2["RSD"] = "RSD";
  Currency2["RWF"] = "RWF";
  Currency2["SAR"] = "SAR";
  Currency2["SEK"] = "SEK";
  Currency2["SGD"] = "SGD";
  Currency2["THB"] = "THB";
  Currency2["TND"] = "TND";
  Currency2["TRY"] = "TRY";
  Currency2["TTD"] = "TTD";
  Currency2["TWD"] = "TWD";
  Currency2["TZS"] = "TZS";
  Currency2["USD"] = "USD";
  Currency2["UYU"] = "UYU";
  Currency2["UZS"] = "UZS";
  Currency2["VND"] = "VND";
  Currency2["XAF"] = "XAF";
  Currency2["XCD"] = "XCD";
  Currency2["XOF"] = "XOF";
  Currency2["ZAR"] = "ZAR";
  return Currency2;
})(Currency || {});
var NON_DECIMAL_CURRENCIES = ["KRW" /* KRW */, "JPY" /* JPY */, "VND" /* VND */, "RWF" /* RWF */, "XOF" /* XOF */, "XAF" /* XAF */];
var CurrencySymbol = /* @__PURE__ */ ((CurrencySymbol2) => {
  CurrencySymbol2["AED"] = "AED";
  CurrencySymbol2["ALL"] = "L";
  CurrencySymbol2["AMD"] = "\u058F";
  CurrencySymbol2["AOA"] = "AOA";
  CurrencySymbol2["ARS"] = "ARS";
  CurrencySymbol2["AUD"] = "AUD";
  CurrencySymbol2["AZN"] = "AZN";
  CurrencySymbol2["BAM"] = "BAM";
  CurrencySymbol2["BDT"] = "BDT";
  CurrencySymbol2["BGN"] = "\u043B\u0432";
  CurrencySymbol2["BHD"] = ".\u062F.\u0628";
  CurrencySymbol2["BND"] = "BND";
  CurrencySymbol2["BOB"] = "BOB";
  CurrencySymbol2["BRL"] = "R$";
  CurrencySymbol2["BSD"] = "BSD";
  CurrencySymbol2["BTN"] = "BTN";
  CurrencySymbol2["BWP"] = "P";
  CurrencySymbol2["CAD"] = "CAD";
  CurrencySymbol2["CHF"] = "CHF";
  CurrencySymbol2["CLP"] = "CLP";
  CurrencySymbol2["COP"] = "COP";
  CurrencySymbol2["CRC"] = "CRC";
  CurrencySymbol2["CZK"] = "K\u010D";
  CurrencySymbol2["DKK"] = "DKK";
  CurrencySymbol2["DOP"] = "RD$";
  CurrencySymbol2["DZD"] = "DZD";
  CurrencySymbol2["EGP"] = "E\xA3";
  CurrencySymbol2["ETB"] = "ETB";
  CurrencySymbol2["EUR"] = "\u20AC";
  CurrencySymbol2["GBP"] = "\xA3";
  CurrencySymbol2["GHS"] = "GHS";
  CurrencySymbol2["GMD"] = "GMD";
  CurrencySymbol2["GTQ"] = "GTQ";
  CurrencySymbol2["GYD"] = "GYD";
  CurrencySymbol2["HKD"] = "HKD";
  CurrencySymbol2["HUF"] = "Ft";
  CurrencySymbol2["IDR"] = "Rp";
  CurrencySymbol2["ILS"] = "\u20AA";
  CurrencySymbol2["INR"] = "\u20B9";
  CurrencySymbol2["JMD"] = "J$";
  CurrencySymbol2["JOD"] = "JOD";
  CurrencySymbol2["JPY"] = "\xA5";
  CurrencySymbol2["KES"] = "KSh";
  CurrencySymbol2["KHR"] = "KHR";
  CurrencySymbol2["KRW"] = "\u20A9";
  CurrencySymbol2["KWD"] = "\u062F.\u0643";
  CurrencySymbol2["KZT"] = "\u20B8";
  CurrencySymbol2["LAK"] = "LAK";
  CurrencySymbol2["LKR"] = "Rs";
  CurrencySymbol2["MAD"] = "\u062F.\u0645.";
  CurrencySymbol2["MDL"] = "MDL";
  CurrencySymbol2["MGA"] = "MGA";
  CurrencySymbol2["MKD"] = "MKD";
  CurrencySymbol2["MNT"] = "MNT";
  CurrencySymbol2["MOP"] = "MOP";
  CurrencySymbol2["MUR"] = "MUR";
  CurrencySymbol2["MXN"] = "M$";
  CurrencySymbol2["MYR"] = "RM";
  CurrencySymbol2["MZN"] = "MZN";
  CurrencySymbol2["NAD"] = "NAD";
  CurrencySymbol2["NGN"] = "NGN";
  CurrencySymbol2["NOK"] = "NOK";
  CurrencySymbol2["NZD"] = "NZD";
  CurrencySymbol2["OMR"] = "\u0631.\u0639.";
  CurrencySymbol2["PEN"] = "PEN";
  CurrencySymbol2["PHP"] = "\u20B1";
  CurrencySymbol2["PKR"] = "\u20A8";
  CurrencySymbol2["PLN"] = "z\u0142";
  CurrencySymbol2["PYG"] = "PYG";
  CurrencySymbol2["QAR"] = "\u0631.\u0642";
  CurrencySymbol2["RON"] = "RON";
  CurrencySymbol2["RSD"] = "RSD";
  CurrencySymbol2["RWF"] = "RWF";
  CurrencySymbol2["SAR"] = "\uFDFC";
  CurrencySymbol2["SEK"] = "SEK";
  CurrencySymbol2["SGD"] = "SGD";
  CurrencySymbol2["THB"] = "\u0E3F";
  CurrencySymbol2["TND"] = "TND";
  CurrencySymbol2["TRY"] = "\u20BA";
  CurrencySymbol2["TTD"] = "TTD";
  CurrencySymbol2["TWD"] = "NT$";
  CurrencySymbol2["TZS"] = "TZS";
  CurrencySymbol2["USD"] = "$";
  CurrencySymbol2["UYU"] = "$U";
  CurrencySymbol2["UZS"] = "UZS";
  CurrencySymbol2["VND"] = "\u20AB";
  CurrencySymbol2["XAF"] = "XAF";
  CurrencySymbol2["XCD"] = "XCD";
  CurrencySymbol2["XOF"] = "XOF";
  CurrencySymbol2["ZAR"] = "R";
  return CurrencySymbol2;
})(CurrencySymbol || {});
var COUNTRY_CURRENCIES = {
  ["AE" /* AE */]: "AED" /* AED */,
  ["AG" /* AG */]: "XCD" /* XCD */,
  ["AL" /* AL */]: "ALL" /* ALL */,
  ["AM" /* AM */]: "AMD" /* AMD */,
  ["AO" /* AO */]: "AOA" /* AOA */,
  ["AR" /* AR */]: "ARS" /* ARS */,
  ["AT" /* AT */]: "EUR" /* EUR */,
  ["AU" /* AU */]: "AUD" /* AUD */,
  ["AZ" /* AZ */]: "AZN" /* AZN */,
  ["BA" /* BA */]: "BAM" /* BAM */,
  ["BD" /* BD */]: "BDT" /* BDT */,
  ["BE" /* BE */]: "EUR" /* EUR */,
  ["BG" /* BG */]: "BGN" /* BGN */,
  ["BH" /* BH */]: "BHD" /* BHD */,
  ["BJ" /* BJ */]: "XOF" /* XOF */,
  ["BN" /* BN */]: "BND" /* BND */,
  ["BO" /* BO */]: "BOB" /* BOB */,
  ["BR" /* BR */]: "BRL" /* BRL */,
  ["BS" /* BS */]: "BSD" /* BSD */,
  ["BT" /* BT */]: "BTN" /* BTN */,
  ["BW" /* BW */]: "BWP" /* BWP */,
  ["CA" /* CA */]: "CAD" /* CAD */,
  ["CH" /* CH */]: "CHF" /* CHF */,
  ["CI" /* CI */]: "XOF" /* XOF */,
  ["CL" /* CL */]: "CLP" /* CLP */,
  ["CO" /* CO */]: "COP" /* COP */,
  ["CR" /* CR */]: "CRC" /* CRC */,
  ["CY" /* CY */]: "EUR" /* EUR */,
  ["CZ" /* CZ */]: "CZK" /* CZK */,
  ["DE" /* DE */]: "EUR" /* EUR */,
  ["DK" /* DK */]: "DKK" /* DKK */,
  ["DO" /* DO */]: "DOP" /* DOP */,
  ["DZ" /* DZ */]: "DZD" /* DZD */,
  ["EC" /* EC */]: "USD" /* USD */,
  ["EE" /* EE */]: "EUR" /* EUR */,
  ["EG" /* EG */]: "EGP" /* EGP */,
  ["ES" /* ES */]: "EUR" /* EUR */,
  ["ET" /* ET */]: "ETB" /* ETB */,
  ["FI" /* FI */]: "EUR" /* EUR */,
  ["FR" /* FR */]: "EUR" /* EUR */,
  ["GA" /* GA */]: "XAF" /* XAF */,
  ["GB" /* GB */]: "GBP" /* GBP */,
  ["GH" /* GH */]: "GHS" /* GHS */,
  ["GI" /* GI */]: "GBP" /* GBP */,
  ["GM" /* GM */]: "GMD" /* GMD */,
  ["GR" /* GR */]: "EUR" /* EUR */,
  ["GT" /* GT */]: "GTQ" /* GTQ */,
  ["GY" /* GY */]: "GYD" /* GYD */,
  ["HK" /* HK */]: "HKD" /* HKD */,
  ["HR" /* HR */]: "EUR" /* EUR */,
  ["HU" /* HU */]: "HUF" /* HUF */,
  ["ID" /* ID */]: "IDR" /* IDR */,
  ["IE" /* IE */]: "EUR" /* EUR */,
  ["IL" /* IL */]: "ILS" /* ILS */,
  ["IN" /* IN */]: "INR" /* INR */,
  ["IS" /* IS */]: "EUR" /* EUR */,
  ["IT" /* IT */]: "EUR" /* EUR */,
  ["JM" /* JM */]: "JMD" /* JMD */,
  ["JO" /* JO */]: "JOD" /* JOD */,
  ["JP" /* JP */]: "JPY" /* JPY */,
  ["KE" /* KE */]: "KES" /* KES */,
  ["KH" /* KH */]: "KHR" /* KHR */,
  ["KR" /* KR */]: "KRW" /* KRW */,
  ["KW" /* KW */]: "KWD" /* KWD */,
  ["KZ" /* KZ */]: "KZT" /* KZT */,
  ["LA" /* LA */]: "LAK" /* LAK */,
  ["LC" /* LC */]: "XCD" /* XCD */,
  ["LI" /* LI */]: "CHF" /* CHF */,
  ["LK" /* LK */]: "LKR" /* LKR */,
  ["LT" /* LT */]: "EUR" /* EUR */,
  ["LU" /* LU */]: "EUR" /* EUR */,
  ["LV" /* LV */]: "EUR" /* EUR */,
  ["MA" /* MA */]: "MAD" /* MAD */,
  ["MC" /* MC */]: "EUR" /* EUR */,
  ["MD" /* MD */]: "MDL" /* MDL */,
  ["MG" /* MG */]: "MGA" /* MGA */,
  ["MK" /* MK */]: "MKD" /* MKD */,
  ["MN" /* MN */]: "MNT" /* MNT */,
  ["MO" /* MO */]: "MOP" /* MOP */,
  ["MT" /* MT */]: "EUR" /* EUR */,
  ["MU" /* MU */]: "MUR" /* MUR */,
  ["MX" /* MX */]: "MXN" /* MXN */,
  ["MY" /* MY */]: "MYR" /* MYR */,
  ["MZ" /* MZ */]: "MZN" /* MZN */,
  ["NA" /* NA */]: "NAD" /* NAD */,
  ["NE" /* NE */]: "XOF" /* XOF */,
  ["NG" /* NG */]: "NGN" /* NGN */,
  ["NL" /* NL */]: "EUR" /* EUR */,
  ["NO" /* NO */]: "NOK" /* NOK */,
  ["NZ" /* NZ */]: "NZD" /* NZD */,
  ["OM" /* OM */]: "OMR" /* OMR */,
  ["PA" /* PA */]: "USD" /* USD */,
  ["PE" /* PE */]: "PEN" /* PEN */,
  ["PH" /* PH */]: "PHP" /* PHP */,
  ["PK" /* PK */]: "PKR" /* PKR */,
  ["PL" /* PL */]: "PLN" /* PLN */,
  ["PT" /* PT */]: "EUR" /* EUR */,
  ["PY" /* PY */]: "PYG" /* PYG */,
  ["QA" /* QA */]: "QAR" /* QAR */,
  ["RO" /* RO */]: "RON" /* RON */,
  ["RS" /* RS */]: "RSD" /* RSD */,
  ["RW" /* RW */]: "RWF" /* RWF */,
  ["SA" /* SA */]: "SAR" /* SAR */,
  ["SE" /* SE */]: "SEK" /* SEK */,
  ["SG" /* SG */]: "SGD" /* SGD */,
  ["SI" /* SI */]: "EUR" /* EUR */,
  ["SK" /* SK */]: "EUR" /* EUR */,
  ["SM" /* SM */]: "EUR" /* EUR */,
  ["SN" /* SN */]: "XOF" /* XOF */,
  ["SV" /* SV */]: "USD" /* USD */,
  ["TH" /* TH */]: "THB" /* THB */,
  ["TN" /* TN */]: "TND" /* TND */,
  ["TR" /* TR */]: "TRY" /* TRY */,
  ["TT" /* TT */]: "TTD" /* TTD */,
  ["TW" /* TW */]: "TWD" /* TWD */,
  ["TZ" /* TZ */]: "TZS" /* TZS */,
  ["US" /* US */]: "USD" /* USD */,
  ["UY" /* UY */]: "UYU" /* UYU */,
  ["UZ" /* UZ */]: "UZS" /* UZS */,
  ["VN" /* VN */]: "VND" /* VND */,
  ["ZA" /* ZA */]: "ZAR" /* ZAR */
};
var getSupportedCountryCode = ({
  agreementType,
  code
}) => {
  if (agreementType === "recipient" /* RECIPIENT */ && Object.values(StripeSupportedCountryCodes).includes(code)) {
    return code;
  }
  if (Object.values(SupportedCountryCodeForFullAgreement).includes(code)) {
    return code;
  }
  throw new Error("unsupported country code");
};
var isStripeSupportedCountryCodes = (code) => {
  return Object.values(StripeSupportedCountryCodes).includes(code);
};
var getCurrencyCode = ({ code }) => {
  if (code && Object.values(Currency).includes(code.toUpperCase())) {
    return code.toUpperCase();
  }
  throw new Error("unsupported currency code");
};
var getCurrencyForCountry = ({ country }) => {
  const countryCode = getSupportedCountryCode({ agreementType: "recipient" /* RECIPIENT */, code: country });
  return COUNTRY_CURRENCIES[countryCode];
};
var HOST_COMMISSIONS_RESTRICTED_COUNTRIES_FOR_FULL_AGREEMENT = [
  "AE" /* AE */,
  "AU" /* AU */,
  "CA" /* CA */,
  "JP" /* JP */,
  "MX" /* MX */
];
var UpdateBrandExperienceSortingRequestSchema = z14.object({
  enableAutomaticExperienceSorting: z14.boolean()
});
var UpdateBrandExperienceSorting = makeEndpoint({
  method: "PATCH",
  url: ({ brandId }) => `v1/brands/${brandId}/experiences-sorting`,
  responseSchema: z14.void(),
  requestSchema: UpdateBrandExperienceSortingRequestSchema
});
var PublicBrandDetailResponseSchema = BrandSchema2.pick({
  id: true,
  name: true,
  countryCode: true,
  currency: true,
  location: true,
  organizationId: true
}).extend({
  externalReferenceId: z14.string().nullable(),
  location: LocationSchema.omit({
    createdAt: true,
    updatedAt: true
  }).nullable()
});
var GetPublicBrandDetails = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/brands/${brandId}`,
  responseSchema: PublicBrandDetailResponseSchema,
  requestSchema: z14.void()
});
var GetBrandCoreTranslationsResponseSchema = z14.object({
  vibes: z14.array(TranslationWithIdSchema.omit({ createdAt: true, updatedAt: true })),
  categories: z14.array(TranslationWithIdSchema.omit({ createdAt: true, updatedAt: true })),
  cancellationPolicies: z14.array(TranslationWithIdSchema.omit({ createdAt: true, updatedAt: true })),
  reschedulePolicies: z14.array(TranslationWithIdSchema.omit({ createdAt: true, updatedAt: true })),
  taxes: z14.array(TranslationWithIdSchema.omit({ createdAt: true, updatedAt: true }))
});
var GetBrandCoreTranslationsQuerySchema = z14.object({
  language: z14.nativeEnum(LanguageCode).optional()
}).default({});
var GetBrandCoreTranslationsEndpoint = makeEndpoint({
  method: "GET",
  url: (params) => {
    var _a2;
    return ((_a2 = params.query) == null ? void 0 : _a2.language) ? `v1/brands/${params["brandId"]}/i18n?${buildQueryString({ language: params.query.language })}` : `v1/brands/${params["brandId"]}/i18n`;
  },
  responseSchema: GetBrandCoreTranslationsResponseSchema,
  requestSchema: z14.void(),
  querySchema: GetBrandCoreTranslationsQuerySchema
});
var PatchBrandCoreTranslationsRequestSchema = z14.object({
  vibes: z14.array(TranslationSchema.omit({ createdAt: true, updatedAt: true })),
  categories: z14.array(TranslationSchema.omit({ createdAt: true, updatedAt: true })),
  cancellationPolicies: z14.array(TranslationSchema.omit({ createdAt: true, updatedAt: true })),
  reschedulePolicies: z14.array(TranslationSchema.omit({ createdAt: true, updatedAt: true })),
  taxes: z14.array(TranslationSchema.omit({ createdAt: true, updatedAt: true }))
});
var PatchBrandCoreTranslationsEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId }) => `v1/brands/${brandId}/i18n`,
  responseSchema: z14.void(),
  requestSchema: PatchBrandCoreTranslationsRequestSchema
});
var GetBrandParentOrganizationsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/brands/${brandId}/parent-organizations`,
  responseSchema: z14.object({
    items: z14.array(
      z14.object({
        id: z14.string().uuid(),
        name: z14.string()
      })
    )
  }).strict(),
  requestSchema: z14.void()
});

// src/api/integration/integration.ts
import { z as z15 } from "zod";
var IntegrationType = /* @__PURE__ */ ((IntegrationType3) => {
  IntegrationType3["SIMPHONY"] = "integrations:simphony";
  IntegrationType3["OPERA"] = "integrations:opera";
  IntegrationType3["STAY_N_TOUCH"] = "integrations:stayntouch";
  IntegrationType3["KICC"] = "integrations:kicc";
  IntegrationType3["REVINATE"] = "integrations:revinate";
  IntegrationType3["ALICE"] = "integrations:alice";
  IntegrationType3["INFOR"] = "integrations:infor";
  IntegrationType3["TEALIUM_ANALYTICS"] = "integrations:tealiumAnalytics";
  IntegrationType3["GTM_ANALYTICS"] = "integrations:gtmAnalytics";
  IntegrationType3["GA4_ANALYTICS"] = "integrations:ga4Analytics";
  return IntegrationType3;
})(IntegrationType || {});
var IntegrationName = /* @__PURE__ */ ((IntegrationName3) => {
  IntegrationName3["OPERA"] = "opera";
  IntegrationName3["STAYNTOUCH"] = "stayntouch";
  IntegrationName3["KICC"] = "kicc";
  IntegrationName3["REVINATE"] = "revinate";
  IntegrationName3["INFOR"] = "infor";
  IntegrationName3["ALICE"] = "alice";
  IntegrationName3["TEALIUM_ANALYTICS"] = "tealiumAnalytics";
  IntegrationName3["GTM_ANALYTICS"] = "gtmAnalytics";
  IntegrationName3["GA4_ANALYTICS"] = "ga4Analytics";
  IntegrationName3["SIMPHONY"] = "simphony";
  return IntegrationName3;
})(IntegrationName || {});
var IntegrationKeys = /* @__PURE__ */ ((IntegrationKeys2) => {
  IntegrationKeys2["TransactionCode"] = "transactionCode";
  IntegrationKeys2["IntegrationAddOn"] = "integrationAddOn";
  IntegrationKeys2["TenderId"] = "tenderId";
  IntegrationKeys2["LocRef"] = "locRef";
  IntegrationKeys2["RvcRef"] = "rvcRef";
  IntegrationKeys2["MenuId"] = "menuId";
  IntegrationKeys2["MenuItemId"] = "menuItemId";
  return IntegrationKeys2;
})(IntegrationKeys || {});
var stripIntegrationPrefix = (str) => (str || "").replace("integrations:", "");
var integrationUrl = ({ brandId, integrationType }) => `v1/brands/${brandId}/integrations/${stripIntegrationPrefix(integrationType)}`;
var IntegrationConfigResponseSchema = z15.record(z15.unknown());
var IntegrationGroup = /* @__PURE__ */ ((IntegrationGroup2) => {
  IntegrationGroup2["PMS"] = "pms";
  IntegrationGroup2["CRM"] = "crm";
  IntegrationGroup2["ANALYTICS"] = "analytics";
  return IntegrationGroup2;
})(IntegrationGroup || {});
var Integrations = {
  ["crm" /* CRM */]: ["alice" /* ALICE */, "revinate" /* REVINATE */],
  ["pms" /* PMS */]: ["infor" /* INFOR */, "opera" /* OPERA */, "stayntouch" /* STAYNTOUCH */],
  ["analytics" /* ANALYTICS */]: [
    "tealiumAnalytics" /* TEALIUM_ANALYTICS */,
    "gtmAnalytics" /* GTM_ANALYTICS */,
    "ga4Analytics" /* GA4_ANALYTICS */
  ]
};

// src/api/payment-method/public.ts
import { z as z16 } from "zod";
var PaymentMethods = /* @__PURE__ */ ((PaymentMethods2) => {
  PaymentMethods2["CREDIT_CARD"] = "credit-card";
  PaymentMethods2["ROOM_CHARGE"] = "room-charge";
  PaymentMethods2["MEMBER_NUMBER"] = "member-number";
  PaymentMethods2["LOYALTY"] = "loyalty";
  PaymentMethods2["KICC"] = "kicc";
  PaymentMethods2["CASH"] = "cash";
  PaymentMethods2["PAY_LATER"] = "pay-later";
  PaymentMethods2["PAY_UPON_ARRIVAL"] = "pay-upon-arrival";
  return PaymentMethods2;
})(PaymentMethods || {});
var PaymentMethodNumberSchema = z16.object({ number: z16.string().trim().nonempty() });
var ImportPaymentMethodsRequestSchema = z16.object({
  data: z16.array(PaymentMethodNumberSchema)
});
var DomainNameSchema = z16.object({
  id: z16.string(),
  domainName: z16.string(),
  hasActiveApplePay: z16.boolean()
});
var _a;
var ValidatePaymentMethodDomainsEndpoint = makeEndpoint({
  url: ({ brandId }) => `v1/brands/${brandId}/validate-payment-method-domains`,
  method: "POST",
  requestSchema: z16.object({
    forceValidation: (_a = z16.boolean()) == null ? void 0 : _a.optional()
  }),
  responseSchema: z16.array(DomainNameSchema)
});

// src/api/experience/experiences.ts
var GetExperienceVersionQuerySchema = z17.object({
  brandId: z17.string().uuid().optional(),
  includeFirstAvailableDate: z17.string().optional()
});
var NotificationPlatform = /* @__PURE__ */ ((NotificationPlatform2) => {
  NotificationPlatform2["EMAIL"] = "email";
  NotificationPlatform2["SMS"] = "sms";
  return NotificationPlatform2;
})(NotificationPlatform || {});
var ExperienceNotificationOverridesSchema = z17.object({
  ["email" /* EMAIL */]: BrandEmailNotificationSettingsSchema.optional(),
  ["sms" /* SMS */]: BrandSmsNotificationSettingsSchema.optional()
});
var BaseTaxSchema = z17.object({
  id: z17.string().uuid(),
  includedInPrice: z17.boolean()
});
var PercentageTaxSchema = BaseTaxSchema.extend({
  percentage: z17.number().min(0)
});
var AmountTaxSchema = BaseTaxSchema.extend({
  amount: z17.number().min(0)
});
var TaxSchema = z17.union([PercentageTaxSchema, AmountTaxSchema]);
var StrictTaxSchema = z17.union([AmountTaxSchema.strict(), PercentageTaxSchema.strict()]);
var StrictTaxWithNameSchema = z17.union([
  AmountTaxSchema.extend({ name: z17.string() }).strict(),
  PercentageTaxSchema.extend({ name: z17.string() }).strict()
]);
var ExternalFieldType = /* @__PURE__ */ ((ExternalFieldType2) => {
  ExternalFieldType2["URL"] = "url";
  ExternalFieldType2["EMAIL"] = "email";
  ExternalFieldType2["PHONE"] = "phone";
  return ExternalFieldType2;
})(ExternalFieldType || {});
var ExternalFieldSchema = z17.object({
  type: z17.nativeEnum(ExternalFieldType),
  value: z17.string().nullable()
});
var ShouldValidateComplimentaryBookingSchema2 = z17.object({
  roomCharge: z17.boolean().optional(),
  memberCharge: z17.boolean().optional()
});
var BookingAvailabilityModeValue = /* @__PURE__ */ ((BookingAvailabilityModeValue2) => {
  BookingAvailabilityModeValue2["PRIVATE_ONLY"] = "private";
  BookingAvailabilityModeValue2["GROUP_ONLY"] = "group";
  BookingAvailabilityModeValue2["NON_RESTRICTED"] = "non-restricted";
  return BookingAvailabilityModeValue2;
})(BookingAvailabilityModeValue || {});
var ExperienceType = /* @__PURE__ */ ((ExperienceType2) => {
  ExperienceType2["RECURRING"] = "recurring";
  ExperienceType2["ONE_TIME"] = "one-time";
  return ExperienceType2;
})(ExperienceType || {});
var IntegrationMetaSchema = z17.object({
  type: z17.nativeEnum(IntegrationName),
  key: z17.nativeEnum(IntegrationKeys),
  value: z17.record(z17.unknown())
});
var UpdateExperienceRequestSchema = z17.object({
  title: z17.string().max(128, { message: "Title must be at most 128 characters long." }),
  headline: z17.string().max(280).optional(),
  description: z17.string().optional(),
  categoryId: z17.string().uuid().optional(),
  vibeIds: z17.array(z17.string().uuid()).max(3, { message: "A maximum of 3 vibes can be selected for an experience" }).refine((vibeIds) => new Set(vibeIds).size === vibeIds.length, { message: "must be unique" }).optional(),
  locationId: z17.string().uuid().optional(),
  location: z17.object({
    latitude: z17.number(),
    name: z17.string(),
    longitude: z17.number(),
    additionalInfo: z17.string().optional()
  }).optional(),
  minAge: z17.number().int().min(1).max(150).optional(),
  maxAge: z17.number().int().min(1).max(150).optional(),
  medias: z17.array(z17.object({ id: z17.string().uuid(), kind: z17.string() })).optional(),
  // TODO: Use MediaInputSchema instead when circular dependency is resolved
  coverPictureId: z17.string().uuid().optional(),
  pictureIds: z17.array(z17.string().uuid()).max(10).refine((pictureIds) => new Set(pictureIds).size === pictureIds.length, { message: "must be unique" }).optional(),
  descriptionPictureId: z17.string().uuid().optional().nullable(),
  bookingAvailabilityMode: z17.nativeEnum(BookingAvailabilityModeValue).optional(),
  maxParticipantsCount: z17.number().int().min(0).optional(),
  sessionDurationMinutes: z17.number().int().min(1).optional(),
  isBookable: z17.boolean(),
  isUnlisted: z17.boolean().optional(),
  type: z17.nativeEnum(ExperienceType).optional(),
  providedItems: z17.array(z17.string()).max(20).optional(),
  healthAndSafety: z17.string().optional(),
  emailMessage: z17.string().optional().nullable(),
  onlineBookingCutoffHours: z17.number().max(1e3).optional(),
  hostedById: z17.string().uuid().optional(),
  hostCommission: z17.number().optional(),
  hostCommissionType: z17.nativeEnum(HostCommissionType).optional(),
  externalField: ExternalFieldSchema.optional(),
  paymentMethods: z17.array(z17.nativeEnum(PaymentMethods)).max(3).optional(),
  priceTiers: z17.array(PriceTierSchema).min(1).optional(),
  taxes: z17.array(TaxSchema).optional(),
  integrationMeta: z17.array(IntegrationMetaSchema).min(1).optional(),
  partySize: z17.number().int().optional().nullable(),
  hidePrice: z17.boolean().optional(),
  isNoHost: z17.boolean().optional(),
  isTicketed: z17.boolean().optional(),
  autoUnpublishAt: LocalDateTimeStringSchema.optional().nullable(),
  notificationEmails: z17.array(EmailStringSchema).max(10).optional().nullable(),
  notificationOverrides: ExperienceNotificationOverridesSchema.optional().nullable(),
  shouldValidateComplimentaryBooking: ShouldValidateComplimentaryBookingSchema2.optional(),
  kind: z17.nativeEnum(ExperienceKind).optional(),
  minimumRequiredToBook: z17.number().int().min(1).optional(),
  maximumAllowedToBook: z17.number().int().min(1).optional(),
  resourceGroupId: z17.string().uuid().optional(),
  number: z17.string().nonempty().optional(),
  displayedCapacity: z17.number().optional(),
  shape: ShapeSchema.optional(),
  position: PositionSchema.optional(),
  cancellationPolicyId: z17.string().uuid().optional().nullable(),
  reschedulePolicyId: z17.string().uuid().optional().nullable(),
  requestToBook: z17.boolean().optional(),
  customCallToAction: z17.string().optional().nullable()
});
var CreateExperienceRequestSchema = UpdateExperienceRequestSchema.required({
  sessionDurationMinutes: true,
  location: true,
  customCallToAction: true
}).extend({
  id: z17.string().uuid().optional(),
  createdByAi: z17.boolean().optional().default(false),
  aiExperienceId: z17.string().uuid().optional(),
  isBookable: UpdateExperienceRequestSchema.shape.isBookable.default(true),
  type: UpdateExperienceRequestSchema.shape.type.default("recurring" /* RECURRING */),
  sessionDurationMinutes: z17.number().int().min(1),
  location: z17.object({
    name: z17.string(),
    latitude: z17.number(),
    longitude: z17.number(),
    additionalInfo: z17.string().optional()
  })
});
var CreateExperienceResponseSchema = z17.void();
var CreateExperienceEndpoint = makeEndpoint({
  url: ({ brandId }) => `/v2/brands/${brandId}/experiences`,
  method: "POST",
  requestSchema: CreateExperienceRequestSchema,
  responseSchema: CreateExperienceResponseSchema
});
var UpdateExperienceEndpoint = makeEndpoint({
  url: ({ experienceId }) => `/v1/experiences/${experienceId}`,
  method: "PATCH",
  requestSchema: UpdateExperienceRequestSchema,
  responseSchema: z17.void()
});
var GetTranslationsForCategoriesQuerySchema = z17.object({
  categoryId: z17.string().uuid().optional(),
  language: z17.nativeEnum(LanguageCode).optional()
});
var GetTranslationsForCategoriesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `/v1/brands/${brandId}/categories/i18n?${buildQueryString(query)}`,
  responseSchema: z17.object({
    translations: z17.array(TranslationSchema)
  }),
  requestSchema: z17.void(),
  querySchema: GetTranslationsForCategoriesQuerySchema
});
var GetTranslationsForExperienceQuerySchema = z17.object({
  language: z17.nativeEnum(LanguageCode).optional()
});
var GetTranslationsForExperienceEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    experienceId,
    version,
    query
  }) => `/v1/experiences/${experienceId}/version/${version}/i18n?${buildQueryString(query)}`,
  responseSchema: z17.object({
    translations: z17.object({
      experience: z17.array(TranslationWithIdSchema),
      listingAddOns: z17.array(TranslationWithIdSchema),
      customQuestions: z17.array(TranslationWithIdSchema),
      cancellationPolicy: z17.array(TranslationWithIdSchema),
      listingIncluded: z17.array(TranslationWithIdSchema),
      location: z17.array(TranslationWithIdSchema)
    })
  }),
  requestSchema: z17.void(),
  querySchema: GetTranslationsForExperienceQuerySchema
});
var PatchTranslationsForExperienceEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ experienceId, version }) => `/v1/experiences/${experienceId}/version/${version}/i18n`,
  responseSchema: z17.void(),
  requestSchema: z17.object({
    translations: z17.array(TranslationSchema)
  })
});
var ExperienceField = /* @__PURE__ */ ((ExperienceField2) => {
  ExperienceField2["TITLE"] = "title";
  ExperienceField2["HEADLINE"] = "headline";
  ExperienceField2["DESCRIPTION"] = "description";
  ExperienceField2["CUSTOM_CALL_TO_ACTION"] = "customCallToAction";
  return ExperienceField2;
})(ExperienceField || {});
var CategoryField = /* @__PURE__ */ ((CategoryField2) => {
  CategoryField2["NAME"] = "name";
  return CategoryField2;
})(CategoryField || {});
var VibeField = /* @__PURE__ */ ((VibeField2) => {
  VibeField2["NAME"] = "name";
  return VibeField2;
})(VibeField || {});
var CustomQuestionField = /* @__PURE__ */ ((CustomQuestionField2) => {
  CustomQuestionField2["PROMPT"] = "prompt";
  return CustomQuestionField2;
})(CustomQuestionField || {});
var TaxField = /* @__PURE__ */ ((TaxField2) => {
  TaxField2["NAME"] = "name";
  return TaxField2;
})(TaxField || {});

// src/api/add-on/add-on.ts
var AddOnStatus = /* @__PURE__ */ ((AddOnStatus2) => {
  AddOnStatus2["AVAILABLE"] = "available";
  AddOnStatus2["UNAVAILABLE"] = "unavailable";
  return AddOnStatus2;
})(AddOnStatus || {});
var AddOnImageSize = /* @__PURE__ */ ((AddOnImageSize2) => {
  AddOnImageSize2["W360"] = "360";
  AddOnImageSize2["W720"] = "720";
  AddOnImageSize2["W1080"] = "1080";
  return AddOnImageSize2;
})(AddOnImageSize || {});
var AddOnImageSizeWithOriginalInUriSchema = ImageSizeWithOriginalInUriSchemaBuilder(Object.values(AddOnImageSize));
var AddOnImageSizeMediaSchema = z18.object({
  id: z18.string().uuid(),
  uri: AddOnImageSizeWithOriginalInUriSchema
});
var BaseAddOnSchema = z18.strictObject({
  id: z18.string().uuid(),
  price: z18.number().finite().nonnegative(),
  label: z18.string().nonempty(),
  description: z18.string(),
  status: z18.nativeEnum(AddOnStatus),
  integrationMeta: z18.array(IntegrationMetaSchema)
});
var RequestAddOnSchema = BaseAddOnSchema.partial({ id: true }).extend({
  pictureId: z18.string().uuid().nullable(),
  taxes: z18.array(StrictTaxSchema)
});
var ResponseAddOnSchema = BaseAddOnSchema.extend({
  picture: AddOnImageSizeMediaSchema.nullable(),
  taxes: z18.array(StrictTaxWithNameSchema)
});
var GetAddOnsQuerySchema = z18.object({
  status: z18.nativeEnum(AddOnStatus),
  language: z18.string().optional().nullable()
}).partial().strict();
var GetAddOnsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `v1/brands/${brandId}/add-ons?${buildQueryString(query)}`,
  responseSchema: z18.object({ items: z18.array(ResponseAddOnSchema) }).strict(),
  requestSchema: z18.void(),
  querySchema: GetAddOnsQuerySchema
});
var PatchAddOnsRequestSchema = BaseAddOnSchema.pick({ label: true }).required({ label: true }).strict();
var DeleteAddOnEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ brandId, addOnId }) => `v1/brands/${brandId}/add-ons/${addOnId}`,
  responseSchema: z18.void(),
  requestSchema: z18.void()
});
var PatchAddOnEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, addOnId }) => `v1/brands/${brandId}/add-ons/${addOnId}`,
  responseSchema: z18.void(),
  requestSchema: PatchAddOnsRequestSchema
});
var AddOnField = /* @__PURE__ */ ((AddOnField2) => {
  AddOnField2["LABEL"] = "label";
  AddOnField2["DESCRIPTION"] = "description";
  return AddOnField2;
})(AddOnField || {});

// src/api/add-on/listing-add-on.ts
import { z as z19 } from "zod";
var ListingAddOnLimitType = /* @__PURE__ */ ((ListingAddOnLimitType2) => {
  ListingAddOnLimitType2["PER_PARTICIPANT"] = "PER_PARTICIPANT";
  ListingAddOnLimitType2["PER_BOOKING"] = "PER_BOOKING";
  return ListingAddOnLimitType2;
})(ListingAddOnLimitType || {});
var ListingAddOnLimitSchema = z19.strictObject({
  type: z19.nativeEnum(ListingAddOnLimitType),
  value: z19.number().nonnegative().finite().int()
});
var PropertiesOnlyForListingAddOnSchema = z19.strictObject({
  limit: ListingAddOnLimitSchema.nullable(),
  hostCommissionType: z19.nativeEnum(HostCommissionType),
  hostCommission: z19.number().nonnegative().finite(),
  experienceId: z19.string().uuid().nullable(),
  resourceGroupId: z19.string().uuid().nullable(),
  resourceGroupCollectionId: z19.string().uuid().nullable(),
  addOnId: z19.string().uuid()
});
var RequestListingAddOnSchema = RequestAddOnSchema.merge(PropertiesOnlyForListingAddOnSchema).partial({
  experienceId: true,
  resourceGroupId: true,
  resourceGroupCollectionId: true,
  addOnId: true
});
var ResponseListingAddOnSchema = ResponseAddOnSchema.merge(PropertiesOnlyForListingAddOnSchema);
var PublicResponseListingAddOnSchema = ResponseListingAddOnSchema.pick({
  id: true,
  label: true,
  description: true,
  status: true,
  price: true,
  picture: true,
  taxes: true,
  limit: true
});
var CreateListingAddOnRequestSchema = z19.union([
  RequestListingAddOnSchema.extend({ addOnId: z19.undefined().optional() }),
  RequestListingAddOnSchema.partial().required({ addOnId: true, hostCommissionType: true, hostCommission: true })
]);
var UpdateListingAddOnRequestSchema = RequestListingAddOnSchema.partial().omit({
  experienceId: true,
  resourceGroupId: true,
  resourceGroupCollectionId: true,
  addOnId: true
});
var CreateListingAddOnEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `v1/brands/${brandId}/listing-add-ons`,
  responseSchema: z19.void(),
  requestSchema: CreateListingAddOnRequestSchema
});
var GetListingAddOnsQuerySchema = z19.object({
  experienceId: z19.string().uuid(),
  resourceGroupCollectionId: z19.string().uuid(),
  resourceGroupId: z19.string().uuid(),
  status: z19.nativeEnum(AddOnStatus),
  language: z19.nativeEnum(LanguageCode).optional().nullable()
}).partial().strict().refine(
  (value) => !!value.experienceId || !!value.resourceGroupCollectionId || !!value.resourceGroupId,
  "At least one of experienceId, resourceGroupCollectionId, or resourceGroupId must be provided."
);
var GetListingAddOnsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `v1/brands/${brandId}/listing-add-ons?${buildQueryString(query)}`,
  responseSchema: z19.object({ items: z19.array(ResponseListingAddOnSchema) }).strict(),
  requestSchema: z19.void(),
  querySchema: GetListingAddOnsQuerySchema
});
var DeleteListingAddOnEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ brandId, listingAddOnId }) => `v1/brands/${brandId}/listing-add-ons/${listingAddOnId}`,
  responseSchema: z19.void(),
  requestSchema: z19.void()
});
var UpdateListingAddOnEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, listingAddOnId }) => `v1/brands/${brandId}/listing-add-ons/${listingAddOnId}`,
  responseSchema: z19.void(),
  requestSchema: UpdateListingAddOnRequestSchema
});
var OrderListingAddOnRequestSchema = z19.object({
  listingAddOns: z19.array(z19.object({ id: z19.string().uuid() }).strict()).min(1)
}).strict();
var OrderListingAddOnEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `v1/brands/${brandId}/order-listing-add-ons`,
  requestSchema: OrderListingAddOnRequestSchema,
  responseSchema: z19.void()
});
var ListingAddOnField = /* @__PURE__ */ ((ListingAddOnField2) => {
  ListingAddOnField2["LABEL"] = "label";
  ListingAddOnField2["DESCRIPTION"] = "description";
  return ListingAddOnField2;
})(ListingAddOnField || {});

// src/api/ai/completion.ts
import { z as z20 } from "zod";
var PromptAuthor = /* @__PURE__ */ ((PromptAuthor2) => {
  PromptAuthor2["USER"] = "user";
  PromptAuthor2["BOT"] = "bot";
  PromptAuthor2["SYSTEM"] = "system";
  return PromptAuthor2;
})(PromptAuthor || {});
var TextPromptSchema = z20.object({ text: z20.string() });
var TextPromptWithIdSchema = TextPromptSchema.extend({ id: z20.string() });
var TextRequestSchema = z20.object({ text: z20.string() });
var TextResponseSchema = z20.object({ data: z20.object({ response: JsonSchema }) });
var ChatPromptSchema = z20.object({ author: z20.nativeEnum(PromptAuthor), text: z20.string() });
var ChatPromptWithIdSchema = ChatPromptSchema.extend({ id: z20.string() });
var ChatRequestSchema = z20.object({ prompt: ChatPromptSchema, context: z20.array(ChatPromptSchema).optional() });
var ChatResponseSchema = z20.object({ data: z20.object({ response: JsonSchema }) });

// src/api/ai/curation-sessions.ts
import { z as z21 } from "zod";
var CurationSessionLocation = /* @__PURE__ */ ((CurationSessionLocation2) => {
  CurationSessionLocation2["ON_PROPERTY"] = "on-property";
  CurationSessionLocation2["OFF_PROPERTY"] = "off-property";
  CurationSessionLocation2["BOTH"] = "both";
  return CurationSessionLocation2;
})(CurationSessionLocation || {});
var BaseAiCurationSessionSchema = z21.object({
  id: z21.string().uuid().optional(),
  count: z21.number().positive(),
  creativity: z21.number().min(0).max(100),
  location: z21.nativeEnum(CurationSessionLocation),
  prompt: z21.string().nullable()
});
var AiCurationSessionSchema = BaseAiCurationSessionSchema.extend({
  id: z21.string().uuid(),
  generatedExperienceCount: z21.number(),
  createdAt: z21.string().datetime(),
  updatedAt: z21.string().datetime()
});
var GetAiCurationSessionsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/ai/brands/${brandId}/curation-sessions`,
  requestSchema: z21.void(),
  responseSchema: z21.array(AiCurationSessionSchema)
});
var PostAiCurationSessionEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `v1/ai/brands/${brandId}/curation-sessions`,
  requestSchema: BaseAiCurationSessionSchema,
  responseSchema: AiCurationSessionSchema
});
var PutAiCurationSessionEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId, curationSessionId }) => `v1/ai/brands/${brandId}/curation-sessions/${curationSessionId}`,
  requestSchema: BaseAiCurationSessionSchema.omit({ id: true }),
  responseSchema: AiCurationSessionSchema
});
var DeleteAiCurationSessionEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ brandId, curationSessionId }) => `v1/ai/brands/${brandId}/curation-sessions/${curationSessionId}`,
  responseSchema: z21.void(),
  requestSchema: z21.void()
});

// src/api/ai/experiences.ts
import { z as z22 } from "zod";
var AiProvider = /* @__PURE__ */ ((AiProvider2) => {
  AiProvider2["OPEN_AI"] = "open-ai";
  return AiProvider2;
})(AiProvider || {});
var IdeatedExperienceSchema = z22.object({
  id: z22.string().uuid(),
  title: z22.string(),
  headline: z22.string(),
  description: z22.string(),
  price: z22.number(),
  vibeIds: z22.array(z22.string().uuid()).max(3),
  categoryId: z22.string().uuid().nullable(),
  duration: z22.number(),
  capacity: z22.number(),
  refinementPrompt: z22.string().nullable(),
  versionsCount: z22.number(),
  updatedAt: z22.date().transform((date) => date.toISOString()).or(z22.string().datetime()),
  aiCurationSessionId: z22.string().uuid(),
  experienceId: z22.string().uuid().nullable()
});
var IdeatedExperienceResponseSchema = IdeatedExperienceSchema;
var IdeatedExperiencesResponseSchema = z22.array(IdeatedExperienceSchema);
var PostIdeatedExperiencesEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, aiCurationSessionId }) => `v1/ai/brands/${brandId}/curation-sessions/${aiCurationSessionId}/ideated-experiences`,
  requestSchema: z22.void(),
  responseSchema: IdeatedExperiencesResponseSchema
});
var GetIdeatedExperiencesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, aiCurationSessionId }) => `v1/ai/brands/${brandId}/curation-sessions/${aiCurationSessionId}/ideated-experiences`,
  requestSchema: z22.void(),
  responseSchema: IdeatedExperiencesResponseSchema
});
var GetIdeatedExperienceEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    aiCurationSessionId,
    experienceId
  }) => `/v1/ai/brands/${brandId}/curation-sessions/${aiCurationSessionId}/ideated-experiences/${experienceId}`,
  requestSchema: z22.void(),
  responseSchema: IdeatedExperienceResponseSchema
});
var DeleteIdeatedExperienceEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({
    brandId,
    aiCurationSessionId,
    experienceId
  }) => `/v1/ai/brands/${brandId}/curation-sessions/${aiCurationSessionId}/ideated-experiences/${experienceId}`,
  requestSchema: z22.void(),
  responseSchema: z22.void()
});
var RestoreIdeatedExperienceEndpoint = makeEndpoint({
  method: "POST",
  url: ({
    brandId,
    aiCurationSessionId,
    experienceId
  }) => `/v1/ai/brands/${brandId}/curation-sessions/${aiCurationSessionId}/ideated-experiences/${experienceId}/restore`,
  requestSchema: z22.void(),
  responseSchema: IdeatedExperienceSchema
});
var FineTuneIdeatedExperienceRequestSchema = z22.object({
  refinementPrompt: z22.string().trim().nonempty()
});
var FineTuneIdeatedExperienceEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({
    brandId,
    aiCurationSessionId,
    experienceId
  }) => `/v1/ai/brands/${brandId}/curation-sessions/${aiCurationSessionId}/ideated-experiences/${experienceId}`,
  requestSchema: FineTuneIdeatedExperienceRequestSchema,
  responseSchema: IdeatedExperienceSchema
});
var IdeateExperienceDescriptionsRequestSchema = z22.object({
  experiences: z22.array(IdeatedExperienceSchema)
});
var IdeateExperienceDescriptionsResponseSchema = z22.object({
  data: z22.array(z22.string())
});
var IdeateNewExperienceImagesRequestSchema = z22.object({
  count: z22.number().positive(),
  prompt: z22.string().trim().nonempty()
});
var IdeateNewExperienceImagesResponseSchema = z22.object({
  data: z22.array(z22.string())
});

// src/api/analytics/analytics.ts
var summaryGroupingOptions = ["brand", "host", "experience"];

// src/api/brand/api-keys.ts
import { z as z23 } from "zod";
var ApiKeyEntityType = /* @__PURE__ */ ((ApiKeyEntityType2) => {
  ApiKeyEntityType2["BRAND"] = "brand";
  ApiKeyEntityType2["ORGANIZATION"] = "organization";
  return ApiKeyEntityType2;
})(ApiKeyEntityType || {});
var ApiKeySchema = z23.object({
  id: z23.string(),
  brandId: z23.string().nullable(),
  organizationId: z23.string().nullable(),
  token: z23.string(),
  name: z23.string().nullable()
});
var GetApiKeysResponseSchema = z23.object({ items: z23.array(ApiKeySchema) });
var PostApiKeysRequestSchema = z23.object({ name: z23.string().nullable().default(null) });
var PostApiKeysResponseSchema = ApiKeySchema;
var GetApiKeysEndpoint = makeEndpoint({
  method: "GET",
  url: ({ entityType, entityId }) => `v1/${entityType}/${entityId}/api-keys`,
  requestSchema: z23.void(),
  responseSchema: GetApiKeysResponseSchema
});
var PostApiKeyEndpoint = makeEndpoint({
  method: "POST",
  url: ({ entityType, entityId }) => `v1/${entityType}/${entityId}/api-keys`,
  requestSchema: PostApiKeysRequestSchema,
  responseSchema: PostApiKeysResponseSchema
});
var DeleteApiKeyEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ entityType, entityId, apiKeyId }) => `v1/${entityType}/${entityId}/api-keys/${apiKeyId}`,
  requestSchema: z23.void(),
  responseSchema: z23.void()
});

// src/api/brand/brand-host.ts
import { z as z26 } from "zod";

// src/api/brand/brand-user.ts
import { z as z25 } from "zod";

// src/api/brand/host.ts
import { z as z24 } from "zod";
var CurateHostSchema = z24.object({
  isCurated: z24.boolean()
});
var HostStatus = /* @__PURE__ */ ((HostStatus2) => {
  HostStatus2["ACTIVE"] = "active";
  HostStatus2["INACTIVE"] = "inactive";
  return HostStatus2;
})(HostStatus || {});

// src/api/brand/brand-user.ts
var UpdateBrandMemberRoleRequestSchema = z25.object({
  role: z25.nativeEnum(BrandMembershipRole),
  permissions: z25.array(z25.enum(BRAND_MEMBERSHIP_PERMISSIONS))
}).strict();
var UpdateBrandMemberRoleEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, memberId }) => `v1/brands/${brandId}/members/${memberId}/role`,
  responseSchema: z25.void(),
  requestSchema: UpdateBrandMemberRoleRequestSchema
});
var InviteBrandMemberRequestSchema = z25.object({
  firstName: z25.string().nonempty(),
  lastName: z25.string().nonempty(),
  emailAddress: EmailStringSchema,
  phoneNumber: PhoneNumberValidationSchema.optional(),
  permissions: z25.array(z25.enum(BRAND_MEMBERSHIP_PERMISSIONS)).optional(),
  products: z25.array(z25.nativeEnum(ProductLine)).nullable().optional()
}).strict();
var InviteBrandMemberEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `v1/brands/${brandId}/members`,
  responseSchema: z25.void(),
  requestSchema: InviteBrandMemberRequestSchema
});
var GetBrandMembersQuerySchema = paginateQuerySchema({
  sortBy: ["name", "email", "phone", "status", "totalEarning"]
}).extend({
  onlyHosts: z25.literal("true").optional(),
  status: z25.nativeEnum(HostStatus).optional()
});
var BrandMemberSchema = z25.object({
  id: z25.string().uuid(),
  firstName: z25.string(),
  lastName: z25.string(),
  emailAddress: EmailStringSchema,
  phoneNumber: PhoneNumberValidationSchema.nullable(),
  dateOfBirth: DateStringSchema.nullable(),
  role: z25.string(),
  // use the enum?
  address: UserAddressSchema.nullable(),
  description: z25.string().nullable(),
  profilePicture: UserImageSizeMediaSchema.nullable(),
  commissionPercentage: z25.number().nullable(),
  ratings: z25.object({ rating: z25.number(), recommendability: z25.number(), total: z25.number().optional() }).optional(),
  membershipRole: z25.nativeEnum(BrandMembershipRole),
  hasFutureConfirmedSession: z25.boolean(),
  isConfirmed: z25.boolean(),
  stripeAccountStatus: z25.nativeEnum(StripeAccountStatus),
  confirmedAt: z25.string().datetime().nullable(),
  createdAt: z25.string().datetime(),
  updatedAt: z25.string().datetime(),
  status: z25.nativeEnum(HostStatus),
  totalEarning: z25.number(),
  permissions: z25.array(z25.enum(BRAND_MEMBERSHIP_PERMISSIONS)),
  settings: z25.object({
    isCurated: z25.boolean().optional(),
    notifications: BrandNotificationSchema.optional()
  }).nullable(),
  products: z25.array(z25.nativeEnum(ProductLine)).nullable()
});
var GetBrandMembersEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `v1/brands/${brandId}/members?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(BrandMemberSchema),
  requestSchema: z25.void(),
  querySchema: GetBrandMembersQuerySchema
});
var UpdateBrandMemberRequestSchema = z25.object({
  permissions: z25.array(z25.enum(BRAND_MEMBERSHIP_PERMISSIONS)),
  products: z25.array(z25.nativeEnum(ProductLine)).optional()
});
var UpdateBrandMemberPermissionsEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, memberId }) => `v1/brands/${brandId}/members/${memberId}/permissions`,
  responseSchema: z25.void(),
  requestSchema: UpdateBrandMemberRequestSchema
});

// src/api/brand/brand-host.ts
var BrandHostSchema = BrandMemberSchema.pick({
  id: true,
  firstName: true,
  lastName: true,
  profilePicture: true,
  emailAddress: true,
  description: true
});
var BrandResponseSchema = z26.object({
  items: z26.array(BrandHostSchema)
});
var PublicBrandHostEndpoint = makeEndpoint({
  url: () => `/v1/hosts`,
  method: "GET",
  responseSchema: BrandResponseSchema,
  requestSchema: z26.void()
});

// src/api/brand/hosts.ts
import { z as z27 } from "zod";
var HostCommissionSortBy = /* @__PURE__ */ ((HostCommissionSortBy2) => {
  HostCommissionSortBy2["START_DATE_TIME"] = "startDateTime";
  HostCommissionSortBy2["AMOUNT"] = "amount";
  HostCommissionSortBy2["INITIATED_ON"] = "scheduledAt";
  HostCommissionSortBy2["PAYOUT_DATE"] = "payoutArrivalDate";
  return HostCommissionSortBy2;
})(HostCommissionSortBy || {});
var PatchBrandHostRequestSchema = z27.object({
  allowOverlappingBookings: z27.boolean()
});
var PatchBrandHostEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, hostId }) => `/brands/${brandId}/hosts/${hostId}`,
  responseSchema: z27.void(),
  requestSchema: PatchBrandHostRequestSchema
});
var AllPaginatedHostsResponse = paginateResponseSchema(
  z27.object({
    id: z27.string(),
    firstName: z27.string(),
    lastName: z27.string(),
    emailAddress: EmailStringSchema,
    profilePicture: z27.object({ id: z27.string(), uri: z27.object({ original: z27.string() }) }).nullable()
  })
);
var GetAllHostsQuerySchema = z27.object({
  q: z27.string().optional(),
  page: z27.coerce.number().min(1).default(1),
  limit: z27.coerce.number().min(1).default(10)
}).strict();
var GetBrandHostsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `v1/brands/${brandId}/hosts?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(BrandMemberSchema),
  requestSchema: z27.void(),
  querySchema: GetBrandMembersQuerySchema
});
var GetBrandsHostCommissionQuerySchema = paginateQuerySchema({}).omit({
  q: true,
  filters: true,
  sortBy: true,
  sortDir: true
}).extend({
  sortBy: z27.nativeEnum(HostCommissionSortBy).optional(),
  sortOrder: z27.enum(sortOptions).optional()
});

// src/api/brand/live-status.ts
import { z as z28 } from "zod";
var LiveStatusSchema = z28.object({
  brandId: z28.string().uuid(),
  live: z28.boolean(),
  enforcedBy: z28.object({
    id: z28.string().uuid(),
    firstName: z28.string(),
    lastName: z28.string(),
    emailAddress: EmailStringSchema
  }).nullable(),
  updatedAt: z28.string().datetime()
});
var LiveStatusWithBreakdownSchema = LiveStatusSchema.extend({
  isScriptEmbedded: z28.boolean().nullable(),
  isBankAccountConnected: z28.boolean().nullable(),
  isBrandInfoSet: z28.boolean().nullable(),
  bookableExperiencesCount: z28.number().nullable()
});
var LiveStatusResponseSchema = LiveStatusSchema;
var GetBrandLiveStatusEndpoint = makeEndpoint({
  method: "GET",
  url: (params) => `/brands/${params.brandId}/live-status`,
  requestSchema: z28.void(),
  responseSchema: LiveStatusResponseSchema
});
var RefreshBrandLiveStatusEndpoint = makeEndpoint({
  method: "POST",
  url: (params) => `v1/brands/${params.brandId}/live-status/refresh?${params.force ? "force=true" : ""}`,
  requestSchema: z28.void(),
  responseSchema: LiveStatusResponseSchema
});
var PutLiveStatusRequestSchema = z28.object({
  live: z28.boolean()
});
var PutBrandLiveStatusEndpoint = makeEndpoint({
  method: "PUT",
  url: (params) => `/brands/${params.brandId}/live-status`,
  requestSchema: PutLiveStatusRequestSchema,
  responseSchema: LiveStatusResponseSchema
});

// src/api/brand/report.ts
import { z as z29 } from "zod";
var BrandStatus = /* @__PURE__ */ ((BrandStatus2) => {
  BrandStatus2["ACTIVE"] = "active";
  BrandStatus2["CHURNED"] = "churned";
  BrandStatus2["DELETED"] = "deleted";
  return BrandStatus2;
})(BrandStatus || {});
var BrandReportQuerySchema = z29.object({
  types: z29.array(z29.nativeEnum(BrandStatus))
});
var BrandReportHeaderSchema = z29.object({
  ID: z29.string(),
  Name: z29.string(),
  "Email Address": EmailStringSchema,
  Version: z29.enum(["1.0", "2.0"]).nullable(),
  Tier: z29.string(),
  Host: z29.boolean().pipe(z29.coerce.string().toUpperCase()).nullable(),
  Activate: z29.boolean().pipe(z29.coerce.string().toUpperCase()).nullable(),
  Reserve: z29.boolean().pipe(z29.coerce.string().toUpperCase()).nullable(),
  "Country Code": z29.string(),
  "Currency Code": z29.string(),
  "Credit Card Fee Percentage": z29.number(),
  "Payment Platform": z29.string(),
  "Created At": z29.string().datetime(),
  Status: z29.string(),
  CSM: z29.string().optional(),
  "Decision Makers": z29.string().optional(),
  "Point of contacts": z29.string().optional(),
  "Test brand": z29.boolean().nullable().optional(),
  Live: z29.boolean().nullable().optional(),
  "Churned At": z29.union([z29.string().trim().length(0), z29.string().datetime()]).optional().nullable(),
  "Launched At": z29.union([z29.string().trim().length(0), z29.string().datetime()]).optional().nullable()
});

// src/api/brand/taxes.ts
import { z as z30 } from "zod";
var BulkUpdateTaxSchema = z30.object({
  id: z30.string().uuid().optional(),
  name: z30.string()
});
var UpdateBrandTaxesSchema = z30.object({
  taxes: z30.array(BulkUpdateTaxSchema)
});
var UpdateBrandTaxesEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId }) => `v1/brands/${brandId}/taxes`,
  responseSchema: z30.void(),
  requestSchema: UpdateBrandTaxesSchema
});
var BrandTaxSchema = z30.object({
  id: z30.string().uuid(),
  name: z30.string()
});

// src/api/brand/financial.ts
import { z as z31 } from "zod";
var BrandsFinancialSummarySchema = z31.object({
  brandId: z31.string(),
  currency: z31.string(),
  host: MinimalHostSchema.optional(),
  experience: z31.object({
    id: z31.string(),
    title: z31.string(),
    coverPicture: IMediaReferenceSchema.nullable()
  }).optional(),
  resourceGroup: z31.object({
    id: z31.string(),
    title: z31.string(),
    coverPicture: IMediaReferenceSchema.nullable(),
    resourceGroupCollectionId: z31.string()
  }).optional(),
  brand: z31.object({
    id: z31.string(),
    name: z31.string(),
    logo: IMediaReferenceSchema.nullable()
  }).optional(),
  grossRevenue: z31.number(),
  netProfit: z31.number(),
  totalHostEarning: z31.number(),
  averageTransactionValue: z31.number(),
  bookingCount: z31.number()
}).strict();
var BrandsFinancialSummaryResponseSchema = paginateResponseSchema(BrandsFinancialSummarySchema).strict();
var financialSummaryGroupingOptions = ["experience", "collection", "listing", "host", "brand"];
var GetBrandsFinancialSummaryQuerySchema = paginateQuerySchema({
  sortBy: ["grossRevenue", "netProfit", "totalHostEarning", "averageTransactionValue"]
}).omit({ sortDir: true, filters: true, q: true }).extend({
  sortDir: z31.enum(sortOptions).optional(),
  experienceId: z31.string().uuid().optional(),
  resourceGroupCollectionId: z31.string().uuid().optional(),
  groupBy: z31.enum(financialSummaryGroupingOptions)
});
var GetBrandsFinancialSummaryEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    entityType,
    entityId,
    query
  }) => `/v1/${entityType}/${entityId}/financial-summary?${buildQueryString(query)}`,
  responseSchema: BrandsFinancialSummaryResponseSchema,
  requestSchema: z31.void(),
  querySchema: GetBrandsFinancialSummaryQuerySchema
});

// src/api/booking/booking.ts
import { z as z39 } from "zod";

// src/api/booking/custom-question-answer.ts
import { z as z33 } from "zod";

// src/api/experience/custom-questions.ts
import { z as z32 } from "zod";
var FieldType = /* @__PURE__ */ ((FieldType2) => {
  FieldType2["INPUT"] = "input";
  FieldType2["TEXTAREA"] = "textarea";
  FieldType2["MULTIPLE_SELECT"] = "multiple_select";
  FieldType2["SINGLE_SELECT"] = "single_select";
  FieldType2["TERMS_AND_CONDITIONS"] = "terms_and_conditions";
  return FieldType2;
})(FieldType || {});
var OptionSchema = z32.object({
  key: z32.string().uuid(),
  value: z32.string()
});
var CustomQuestionScope = /* @__PURE__ */ ((CustomQuestionScope2) => {
  CustomQuestionScope2["PURCHASER"] = "purchaser";
  CustomQuestionScope2["PARTICIPANT"] = "participant";
  return CustomQuestionScope2;
})(CustomQuestionScope || {});
var ConditionMatchType = /* @__PURE__ */ ((ConditionMatchType2) => {
  ConditionMatchType2["ANY"] = "any";
  ConditionMatchType2["ALL"] = "all";
  return ConditionMatchType2;
})(ConditionMatchType || {});
var ConditionRule = /* @__PURE__ */ ((ConditionRule2) => {
  ConditionRule2["VALUE_MATCHES"] = "value_matches";
  return ConditionRule2;
})(ConditionRule || {});
var ConditionSchema = z32.object({
  rule: z32.nativeEnum(ConditionRule),
  conditionKey: z32.string().uuid(),
  conditionValue: z32.string().uuid()
});
var ConfigSchema = z32.object({
  isRequired: z32.boolean(),
  scope: z32.nativeEnum(CustomQuestionScope),
  conditionsMatchType: z32.nativeEnum(ConditionMatchType).nullable(),
  isActive: z32.boolean(),
  conditions: z32.array(ConditionSchema).nullable(),
  order: z32.number(),
  isDefault: z32.boolean().optional(),
  disabled: z32.boolean().optional()
});
var TermAndConditionSchema = z32.object({
  label: z32.string(),
  mediaId: z32.string().uuid(),
  mediaURL: z32.string(),
  isOverrided: z32.boolean()
});
var CustomQuestionSchema = z32.object({
  id: z32.string().uuid(),
  prompt: z32.string(),
  fieldType: z32.nativeEnum(FieldType),
  options: z32.array(OptionSchema).nullable(),
  termsAndConditions: TermAndConditionSchema.nullable(),
  config: ConfigSchema
});

// src/api/booking/custom-question-answer.ts
var AnswerSchema = z33.object({
  value: z33.union([z33.string(), z33.array(z33.string()), z33.boolean()]).nullable(),
  key: z33.string().nullable().optional()
});
var AggregateQuestionSchema = z33.object({
  customQuestionId: z33.string(),
  prompt: z33.string(),
  fieldType: z33.nativeEnum(FieldType),
  options: z33.array(OptionSchema).nullable(),
  termsAndConditions: z33.object({
    label: z33.string(),
    mediaId: z33.string(),
    isOverrided: z33.boolean(),
    mediaUrl: z33.string().optional()
  }).nullable(),
  config: z33.object({
    experienceId: z33.string(),
    experienceQuestionId: z33.string(),
    isRequired: z33.boolean(),
    isActive: z33.boolean(),
    order: z33.number(),
    scope: z33.nativeEnum(CustomQuestionScope),
    conditions: z33.array(ConditionSchema).nullable(),
    conditionsMatchType: z33.nativeEnum(ConditionMatchType).nullable()
  })
});
var CustomQuestionAnswerBookingResponseSchema = z33.object({
  id: z33.string(),
  answer: z33.array(AnswerSchema),
  question: AggregateQuestionSchema
});

// src/api/booking/custom-questions.ts
import { z as z34 } from "zod";
var BookingCustomQuestionSchema = z34.object({
  questionId: z34.string(),
  answer: z34.array(
    z34.object({
      value: z34.union([z34.string(), z34.boolean()]),
      key: z34.string().optional().nullable().transform((key) => key || null)
    })
  )
});
var BookingCustomQuestionWithAnswerSchema = BookingCustomQuestionSchema.extend({
  answerId: z34.string().optional()
});
var BookingCustomQuestionResponseSchema = BookingCustomQuestionWithAnswerSchema;

// src/api/booking/participants.ts
import { z as z35 } from "zod";
var ParticipantType = /* @__PURE__ */ ((ParticipantType2) => {
  ParticipantType2["PARTICIPANT"] = "participant";
  ParticipantType2["PURCHASER"] = "purchaser";
  return ParticipantType2;
})(ParticipantType || {});
var BaseParticipantOrPurchaserSchema = z35.object({
  firstName: z35.string(),
  lastName: z35.string(),
  emailAddress: EmailStringSchema.optional().nullable(),
  phoneNumber: z35.string().optional().nullable(),
  type: z35.nativeEnum(ParticipantType)
});
var BaseParticipantSchema = BaseParticipantOrPurchaserSchema.omit({ type: true }).extend({
  id: z35.string().uuid(),
  priceTierName: z35.string(),
  cancelledAt: z35.string().datetime().nullable()
});
var ParticipantSchema = BaseParticipantOrPurchaserSchema.omit({ type: true }).extend({
  priceTierName: z35.string(),
  customQuestionResponses: z35.array(BookingCustomQuestionSchema).optional()
});
var PurchaserSchema = BaseParticipantOrPurchaserSchema.omit({ type: true }).required({ emailAddress: true }).extend({ id: z35.string().uuid() });
var PurchaserWithCustomQuestionsSchema = PurchaserSchema.extend({
  customQuestionResponses: z35.array(BookingCustomQuestionSchema).optional()
});
var ParticipantUpdateSchema = z35.object({
  experienceId: z35.string().uuid().optional(),
  participant: BaseParticipantOrPurchaserSchema,
  customQuestionResponses: z35.array(BookingCustomQuestionResponseSchema).optional()
});

// src/api/booking/price-tiers.ts
import { z as z36 } from "zod";
var BookingPriceTierSchema = z36.object({
  name: z36.string(),
  participantsCount: z36.number(),
  price: z36.number(),
  amount: z36.number()
});

// src/api/booking/payment-detail.ts
import { z as z37 } from "zod";

// src/api/pms/pms.ts
var PmsType = /* @__PURE__ */ ((PmsType2) => {
  PmsType2["OPERA"] = "opera";
  PmsType2["STAYNTOUCH"] = "stayntouch";
  PmsType2["INFOR"] = "infor";
  return PmsType2;
})(PmsType || {});
var isPmsType = (value) => Object.values(PmsType).includes(value);

// src/api/booking/payment-detail.ts
var PaymentDetailSchema = z37.object({
  lastName: z37.string().optional(),
  methodNumber: z37.string().optional(),
  pmsType: z37.nativeEnum(PmsType).optional(),
  reservationId: z37.union([z37.number().transform((id) => `${id}`), z37.string()]).optional(),
  confirmationId: z37.string().optional(),
  collectionDetail: z37.string().optional()
});

// src/api/experience/experience-settings.ts
import { z as z38 } from "zod";
var BookingFormSchema = z38.object({
  scope: z38.nativeEnum(CustomQuestionScope),
  fields: z38.object({
    emailAddress: z38.object({
      isRequired: z38.boolean(),
      isActive: z38.boolean()
    }),
    phoneNumber: z38.object({
      isRequired: z38.boolean(),
      isActive: z38.boolean()
    })
  })
});
var ExperienceSettingsSchema = z38.object({
  bookingForm: z38.array(BookingFormSchema).optional(),
  isCurated: z38.boolean().optional()
});

// src/api/booking/booking.ts
var BOOKING_SURCHARGE_AMOUNT_USD = 0.3;
var CLAIM_TOKEN_EXPIRATION_MINUTES = 5;
var BookingMode = /* @__PURE__ */ ((BookingMode2) => {
  BookingMode2["PRIVATE"] = "private";
  BookingMode2["SHARED"] = "shared";
  return BookingMode2;
})(BookingMode || {});
var DeviceType = /* @__PURE__ */ ((DeviceType2) => {
  DeviceType2["PC"] = "pc";
  DeviceType2["MOBILE"] = "mobile";
  return DeviceType2;
})(DeviceType || {});
var RefundHistorySchema = z39.object({
  amount: z39.coerce.number(),
  refundedAt: z39.string().datetime(),
  refundedBy: z39.string()
});
var BookingListingAddOnItemSchema = z39.object({
  listingAddOnId: z39.string().uuid(),
  quantity: z39.number().positive()
});
var DetailedBookingAddOnItemSchema = z39.object({
  id: z39.string().uuid(),
  listingAddOnId: z39.string().uuid(),
  label: z39.string(),
  paidAmount: z39.number(),
  price: z39.number(),
  discountedAmount: z39.number(),
  refundedAmount: z39.number(),
  refundHistories: z39.array(RefundHistorySchema),
  cancelledAt: z39.string().datetime().nullable()
});
var MinimalBookingRequestSchema = z39.object({
  sessionTime: LocalDateTimeStringSchema,
  sessionDuration: z39.number().optional(),
  participants: z39.array(ParticipantSchema),
  mode: z39.nativeEnum(BookingMode),
  couponCode: z39.string().nullable().optional().transform((couponCode) => couponCode != null ? couponCode : null),
  discountAmount: z39.number().nullable().optional().transform((discountAmount) => discountAmount != null ? discountAmount : null),
  discountPercentage: z39.number().nullable().optional().transform((discountPercentage) => discountPercentage != null ? discountPercentage : null),
  accessCode: z39.string().nullable().optional().transform((accessCode) => accessCode != null ? accessCode : null),
  notes: z39.string().optional().nullable().transform((notes) => notes != null ? notes : null),
  metadata: z39.record(z39.unknown()).nullable().optional().transform((metadata) => metadata != null ? metadata : null),
  internalNotes: z39.string().optional().nullable().transform((internalNotes) => internalNotes != null ? internalNotes : null),
  listingAddOns: z39.array(BookingListingAddOnItemSchema).default([]),
  appliedCreditCodes: z39.array(
    z39.object({
      code: z39.string(),
      appliedValue: z39.number(),
      sequence: z39.number()
    })
  ).nullable().optional(),
  intendedConfirmationCode: z39.string().optional()
});
var CommonBookingRequestSchema = MinimalBookingRequestSchema.extend({
  waitlistEntryId: z39.string().uuid().optional()
});
var BookingRequestSchema = CommonBookingRequestSchema.extend({
  purchaser: z39.object({
    firstName: z39.string(),
    lastName: z39.string(),
    emailAddress: EmailStringSchema,
    phoneNumber: z39.string().optional(),
    customQuestionResponses: z39.array(BookingCustomQuestionSchema).optional()
  }),
  paymentMethod: z39.nativeEnum(PaymentMethods).optional().transform((paymentMethod) => paymentMethod || null),
  paymentDetail: PaymentDetailSchema.nullable().optional().transform((paymentDetail) => paymentDetail || null),
  bookingScriptUrl: z39.string().url().optional(),
  externalAnalyticsUserId: z39.string().optional(),
  siteLanguage: z39.string().optional(),
  waitlistEntryId: z39.string().uuid().optional(),
  deviceType: z39.nativeEnum(DeviceType).optional(),
  cartId: z39.string().uuid().optional()
});
var BulkBookingExperienceSchema = CommonBookingRequestSchema.extend({
  experienceId: z39.string(),
  additionalCustomQuestionResponses: z39.array(BookingCustomQuestionResponseSchema).optional(),
  externalAnalyticsUserId: z39.string().optional()
});
var BulkBookingRequestSchema = z39.object({
  data: z39.array(
    CommonBookingRequestSchema.extend({
      experienceId: z39.string(),
      resourceGroupId: z39.string().optional(),
      resourceQuantity: z39.number().optional(),
      additionalCustomQuestionResponses: z39.array(BookingCustomQuestionResponseSchema).optional()
    })
  ),
  purchaser: z39.object({
    firstName: z39.string(),
    lastName: z39.string(),
    emailAddress: EmailStringSchema,
    phoneNumber: z39.string().optional(),
    customQuestionResponses: z39.array(BookingCustomQuestionSchema).optional()
  }),
  loyaltyProgramData: z39.object({
    loyaltyProgramId: z39.string(),
    memberId: z39.string()
  }).optional(),
  paymentMethod: z39.nativeEnum(PaymentMethods).optional().transform((paymentMethod) => paymentMethod || null),
  paymentDetail: PaymentDetailSchema.nullable().optional().transform((paymentDetail) => paymentDetail || null),
  bookingScriptUrl: z39.string().url().optional(),
  externalAnalyticsUserId: z39.string().optional(),
  siteLanguage: z39.string().optional(),
  deviceType: z39.nativeEnum(DeviceType).optional(),
  cartId: z39.string().uuid().optional(),
  sendEmail: z39.boolean().optional()
});
var BookingStatus = /* @__PURE__ */ ((BookingStatus2) => {
  BookingStatus2["CONFIRMED"] = "confirmed";
  BookingStatus2["REFUNDED"] = "refunded";
  BookingStatus2["PROCESSING"] = "processing";
  BookingStatus2["FAILED"] = "failed";
  BookingStatus2["CANCELLED"] = "cancelled";
  return BookingStatus2;
})(BookingStatus || {});
var ItemType = /* @__PURE__ */ ((ItemType2) => {
  ItemType2["PRICE_TIER"] = "Price tier";
  ItemType2["ADD_ON"] = "Add-on";
  return ItemType2;
})(ItemType || {});
var BookingStatusesLeadingToOccurringSessions = ["confirmed" /* CONFIRMED */, "processing" /* PROCESSING */];
var PaymentStatusSchema = z39.object({
  code: z39.string(),
  message: z39.string()
});
var PaymentMethodDetailSchema = z39.object({
  fixedChargeId: z39.string().optional(),
  billingChargeId: z39.union([z39.string(), z39.number()]).optional(),
  commentId: z39.string().optional(),
  transactionCode: z39.object({
    code: z39.string(),
    description: z39.string()
  }).optional(),
  pgCno: z39.string().optional(),
  msgAuthValue: z39.string().optional(),
  shopTransactionId: z39.string().optional()
});
var MetaSchema = z39.object({
  paymentStatus: PaymentStatusSchema.optional(),
  paymentDetail: PaymentDetailSchema.nullable(),
  paymentMethodDetail: PaymentMethodDetailSchema.nullable()
}).partial();
var BookingDetailSchema = z39.object({
  id: z39.string(),
  eventId: z39.string(),
  amount: z39.coerce.number(),
  experiencePaidAmount: z39.number(),
  experienceRefundedAmount: z39.number(),
  currency: z39.string(),
  amountRefunded: z39.coerce.number(),
  date: z39.string(),
  confirmationCode: z39.string(),
  status: z39.nativeEnum(BookingStatus),
  sessionDate: z39.string(),
  sessionDuration: z39.number(),
  isCancelled: z39.boolean(),
  isPartiallyCancelled: z39.boolean(),
  createdAt: z39.string().datetime(),
  experience: z39.object({
    id: z39.string(),
    title: z39.string(),
    hostName: z39.string(),
    location: LocationSchema,
    number: z39.string().nullable()
  }),
  customer: z39.object({
    id: z39.string(),
    name: z39.string(),
    emailAddress: z39.string()
  }),
  purchaser: z39.object({
    id: z39.string(),
    firstName: z39.string(),
    lastName: z39.string(),
    emailAddress: z39.string().nullable(),
    phoneNumber: z39.string().nullable(),
    customQuestionAnswers: z39.array(CustomQuestionAnswerBookingResponseSchema).optional()
  }),
  participants: z39.array(
    BaseParticipantSchema.extend({
      customQuestionAnswers: z39.array(CustomQuestionAnswerBookingResponseSchema).optional(),
      cancelledAt: z39.string().datetime().nullable()
    })
  ),
  earning: z39.coerce.number().nullable(),
  hostCommissionType: z39.nativeEnum(HostCommissionType),
  paymentMethod: z39.nativeEnum(PaymentMethods),
  isVoided: z39.boolean(),
  priceTiers: z39.array(BookingPriceTierSchema),
  isFullyRefunded: z39.boolean(),
  isPartiallyRefunded: z39.boolean(),
  refundHistory: z39.array(RefundHistorySchema).nullable(),
  notes: z39.string().nullable(),
  experienceCoverPicture: IMediaReferenceSchema.nullable(),
  chargeId: z39.string().nullable(),
  cancellationPolicyId: z39.string().nullable(),
  reschedulePolicyId: z39.string().nullable(),
  experienceSettings: ExperienceSettingsSchema,
  meta: MetaSchema.nullable(),
  brand: z39.object({
    id: z39.string(),
    name: z39.string()
  }),
  internalNotes: z39.string().nullable(),
  integrations: z39.object({
    alice: z39.object({
      ticketIds: z39.array(z39.coerce.number())
    })
  }),
  isDisputed: z39.boolean(),
  disputedReason: z39.string().nullable(),
  cartId: z39.string().uuid().nullable(),
  cartConfirmationCode: z39.string().nullable(),
  addOns: z39.array(DetailedBookingAddOnItemSchema).nullable(),
  cardBrand: z39.string().nullable().optional(),
  cardLast4: z39.string().nullable().optional()
});
var BookingDetailResponseSchema = paginateResponseSchema(BookingDetailSchema);
var BookingStatusFilterValues = /* @__PURE__ */ ((BookingStatusFilterValues2) => {
  BookingStatusFilterValues2["ACTIVE"] = "active";
  BookingStatusFilterValues2["CANCELLED"] = "cancelled";
  BookingStatusFilterValues2["REFUNDED"] = "refunded";
  BookingStatusFilterValues2["PARTIALLY_REFUNDED"] = "partially_refunded";
  BookingStatusFilterValues2["VOIDED"] = "voided";
  return BookingStatusFilterValues2;
})(BookingStatusFilterValues || {});
var GetPaginatedBookingsQuerySchema = paginateQuerySchema({
  sortBy: ["purchaser", "experience", "dateBooked", "amount", "status", "brand", "sessionDate"]
}).extend({
  organizationId: z39.string().uuid().optional(),
  experienceId: z39.string().uuid().optional(),
  resourceGroupCollectionId: z39.string().uuid().optional(),
  excludeFailed: BooleanStringSchema.optional(),
  excludeCancelled: BooleanStringSchema.optional(),
  cartId: z39.string().uuid().optional(),
  cartConfirmationCode: z39.string().optional(),
  confirmationCode: z39.string().optional(),
  createdFrom: DateStringSchema.optional(),
  createdTo: DateStringSchema.optional(),
  updatedFrom: DateStringSchema.optional(),
  updatedTo: DateStringSchema.optional(),
  bookingIds: z39.array(z39.string().uuid()).min(1).optional(),
  purchaserLastName: z39.string().optional(),
  purchaserEmail: z39.string().optional(),
  methodNumber: z39.string().optional(),
  loyaltyProgramId: z39.string().optional(),
  memberId: z39.string().optional(),
  filters: z39.array(
    z39.union([
      z39.object({
        operator: z39.literal("range"),
        name: z39.literal("transactionDateRange"),
        value: z39.object({ from: DateStringSchema, to: DateStringSchema })
      }),
      z39.object({
        operator: z39.literal("range"),
        name: z39.literal("experienceDateRange"),
        value: z39.object({ from: DateStringSchema, to: DateStringSchema })
      }),
      z39.object({
        operator: z39.enum(["equals", "greater_than", "less_than"]),
        name: z39.literal("amount"),
        value: z39.coerce.number().pipe(z39.coerce.string())
      }),
      z39.object({
        operator: z39.literal("range"),
        name: z39.literal("amount"),
        value: z39.object({
          from: z39.coerce.number().pipe(z39.coerce.string()),
          to: z39.coerce.number().pipe(z39.coerce.string())
        })
      }),
      z39.object({
        operator: z39.literal("in"),
        name: z39.literal("hosts"),
        value: z39.array(z39.string().uuid())
      }),
      z39.object({
        operator: z39.literal("in"),
        name: z39.literal("status"),
        value: z39.array(z39.nativeEnum(BookingStatusFilterValues))
      }),
      z39.object({
        operator: z39.literal("in"),
        name: z39.literal("paymentMethod"),
        value: z39.array(z39.nativeEnum(PaymentMethods))
      }),
      z39.object({
        operator: z39.literal("in"),
        name: z39.literal("products"),
        value: z39.array(z39.nativeEnum(ProductLine))
      }),
      z39.object({
        name: z39.literal("disputed"),
        operator: z39.literal("equals"),
        value: z39.enum(["true", "false"])
      })
    ])
  ).optional()
});
var GetPaginatedBookingsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `v1/bookings?${buildQueryString(query)}`,
  responseSchema: BookingDetailResponseSchema,
  requestSchema: z39.void(),
  querySchema: GetPaginatedBookingsQuerySchema
});
var GetPaginatedBrandBookingsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `v1/brands/${brandId}/bookings?${buildQueryString(query)}`,
  responseSchema: BookingDetailResponseSchema,
  requestSchema: z39.void(),
  querySchema: GetPaginatedBookingsQuerySchema
});
var PaymentResultSchema = z39.object({
  amount: z39.coerce.number(),
  currency: z39.string(),
  confirmationCode: z39.string(),
  subjectId: z39.string(),
  subjectType: z39.string(),
  clientSecret: z39.string().nullable().optional(),
  metadata: z39.record(z39.unknown()).nullable().optional().transform((metadata) => metadata != null ? metadata : null)
});
var PublicBookingResponseSchema = BookingDetailSchema.pick({
  id: true,
  confirmationCode: true,
  cartId: true,
  cartConfirmationCode: true,
  amount: true,
  currency: true,
  amountRefunded: true,
  status: true,
  purchaser: true,
  participants: true,
  paymentMethod: true,
  createdAt: true,
  notes: true,
  internalNotes: true
}).extend({
  event: z39.object({
    timezone: z39.string(),
    startDateTime: LocalDateTimeStringSchema
  }),
  experience: z39.object({
    id: z39.string().uuid(),
    title: z39.string()
  })
});
var PublicCancelBookingRequestItemSchema = z39.object({
  bookingId: z39.string().uuid(),
  cancel: z39.literal(true).optional(),
  participants: z39.array(z39.string().uuid()).min(1).optional(),
  refundAmount: z39.number().optional()
});
var PublicCancelBookingsRequestSchema = z39.object({
  bookings: z39.array(PublicCancelBookingRequestItemSchema)
});
var PublicCancelBookingEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/bookings/cancel`,
  responseSchema: z39.object({ items: z39.array(PublicBookingResponseSchema) }),
  requestSchema: PublicCancelBookingsRequestSchema
});
var RefundBookingRequestSchema = z39.object({
  refundAmount: z39.number().nonnegative(),
  bookingAddOnItems: z39.array(
    z39.object({
      id: z39.string().uuid(),
      refundAmount: z39.number().nonnegative()
    })
  )
});
var RefundBookingEndpoint = makeEndpoint({
  method: "POST",
  url: ({ bookingId }) => `v1/bookings/${bookingId}/refund`,
  responseSchema: z39.void(),
  requestSchema: RefundBookingRequestSchema
});
var CancelBookingRequestSchema = z39.object({
  participantIds: z39.array(z39.object({ id: z39.string().uuid() })),
  bookedAddOnIds: z39.array(z39.object({ id: z39.string().uuid() }))
});
var CancelBookingEndpoint = makeEndpoint({
  method: "POST",
  url: ({ bookingId }) => `v1/bookings/${bookingId}/cancel`,
  responseSchema: z39.void(),
  requestSchema: CancelBookingRequestSchema
});
var GetPromoterBookingIdsResponseSchema = z39.array(z39.string().uuid());
var GetPromoterBookingIdsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/brands/${brandId}/promoted-booking-ids`,
  responseSchema: GetPromoterBookingIdsResponseSchema,
  requestSchema: z39.void()
});
var BookingsByCartIdSchema = z39.object({
  id: z39.string(),
  eventId: z39.string(),
  amount: z39.coerce.number(),
  experiencePaidAmount: z39.number(),
  experienceRefundedAmount: z39.number(),
  currency: z39.string(),
  amountRefunded: z39.coerce.number(),
  date: z39.string(),
  confirmationCode: z39.string(),
  status: z39.nativeEnum(BookingStatus),
  sessionDate: z39.string(),
  sessionDuration: z39.number(),
  isCancelled: z39.boolean(),
  isPartiallyCancelled: z39.boolean(),
  cancellationPolicyId: z39.string().nullable(),
  reschedulePolicyId: z39.string().nullable(),
  createdAt: z39.string().datetime(),
  experience: z39.object({
    id: z39.string(),
    title: z39.string(),
    hostName: z39.string(),
    location: LocationSchema,
    number: z39.string().nullable()
  }),
  customer: z39.object({
    id: z39.string(),
    name: z39.string(),
    emailAddress: z39.string()
  }),
  purchaser: z39.object({
    id: z39.string(),
    firstName: z39.string(),
    lastName: z39.string(),
    emailAddress: z39.string().nullable(),
    phoneNumber: z39.string().nullable(),
    customQuestionAnswers: z39.array(CustomQuestionAnswerBookingResponseSchema).optional()
  }),
  participants: z39.array(
    BaseParticipantSchema.extend({
      customQuestionAnswers: z39.array(CustomQuestionAnswerBookingResponseSchema).optional(),
      cancelledAt: z39.string().datetime().nullable(),
      priceTierPrice: z39.number().nullable().optional(),
      priceTierId: z39.string().nullable().optional()
    })
  ),
  earning: z39.coerce.number().nullable(),
  hostCommissionType: z39.nativeEnum(HostCommissionType),
  paymentMethod: z39.nativeEnum(PaymentMethods),
  isVoided: z39.boolean(),
  priceTiers: z39.array(BookingPriceTierSchema),
  isFullyRefunded: z39.boolean(),
  isPartiallyRefunded: z39.boolean(),
  refundHistory: z39.array(RefundHistorySchema).nullable(),
  notes: z39.string().nullable(),
  experienceCoverPicture: IMediaReferenceSchema.nullable(),
  chargeId: z39.string().nullable(),
  experienceSettings: ExperienceSettingsSchema,
  meta: MetaSchema.nullable(),
  brand: z39.object({
    id: z39.string(),
    name: z39.string()
  }),
  internalNotes: z39.string().nullable(),
  integrations: z39.object({
    alice: z39.object({
      ticketIds: z39.array(z39.coerce.number())
    })
  }),
  isDisputed: z39.boolean(),
  disputedReason: z39.string().nullable(),
  cartId: z39.string().uuid().nullable(),
  cartConfirmationCode: z39.string().nullable(),
  addOns: z39.array(DetailedBookingAddOnItemSchema).nullable(),
  listingId: z39.string().nullable()
});

// src/api/booking/booking-activity.ts
import { z as z42 } from "zod";

// src/api/user/person.ts
import { z as z40 } from "zod";
var PersonSchema = z40.object({
  id: z40.string(),
  firstName: z40.string(),
  lastName: z40.string()
});

// src/api/waitlist/waitlist-entry-activity.ts
import { z as z41 } from "zod";
var WaitlistActivity = /* @__PURE__ */ ((WaitlistActivity2) => {
  WaitlistActivity2["WAITLIST_JOINED"] = "waitlist-joined";
  WaitlistActivity2["WAITLIST_INVITATION_OFFERED"] = "waitlist-invitation-offered";
  return WaitlistActivity2;
})(WaitlistActivity || {});
var BaseWaitlistEntryActivitySchema = z41.object({
  topic: z41.nativeEnum(WaitlistActivity),
  issuer: PersonSchema.extend({
    emailAddress: EmailStringSchema
  }),
  createdAt: z41.string().datetime()
});
var WaitlistJoinedActivitySchema = BaseWaitlistEntryActivitySchema;
var WaitlistInvitationOfferedActivitySchema = BaseWaitlistEntryActivitySchema;
var WaitlistEntryActivitySchema = z41.union([WaitlistJoinedActivitySchema, WaitlistInvitationOfferedActivitySchema]);
var WaitlistEntriesActivitiesResponseSchema = z41.array(WaitlistEntryActivitySchema);
var GetWaitlistEntryActivitiesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, waitlistId, waitlistEntryId }) => `v1/brands/${brandId}/waitlists/${waitlistId}/entries/${waitlistEntryId}/activities`,
  requestSchema: z41.void(),
  responseSchema: WaitlistEntriesActivitiesResponseSchema
});

// src/api/booking/booking-activity.ts
var BookingActivity = /* @__PURE__ */ ((BookingActivity2) => {
  BookingActivity2["BOOKING_CREATED"] = "booking-created";
  BookingActivity2["BOOKING_REFUNDED"] = "booking-refunded";
  BookingActivity2["BOOKING_CANCELLED"] = "booking-cancelled";
  BookingActivity2["BOOKING_VOIDED"] = "booking-voided";
  BookingActivity2["BOOKING_RESCHEDULED"] = "booking-rescheduled";
  return BookingActivity2;
})(BookingActivity || {});
var BaseBookingActivityResponseSchema = z42.object({
  topic: z42.nativeEnum(BookingActivity),
  issuer: PersonSchema,
  createdAt: z42.string()
});
var BookingCreatedActivitySchema = BaseBookingActivityResponseSchema.extend({
  paymentMethod: z42.nativeEnum(PaymentMethods),
  issuer: PersonSchema.nullable(),
  paymentDetail: PaymentDetailSchema.nullable()
});
var BookingRefundedActivitySchema = BaseBookingActivityResponseSchema.extend({
  isGuestCancellation: z42.boolean().default(false),
  refundedAmount: z42.number()
});
var BookingRescheduledActivitySchema = BaseBookingActivityResponseSchema.extend({
  isGuestRescheduled: z42.boolean().default(false),
  previousDate: z42.string(),
  newDate: z42.string(),
  experienceTimezone: z42.string().optional()
});
var BookingCancelledActivitySchema = BaseBookingActivityResponseSchema.extend({
  isGuestCancellation: z42.boolean().default(false),
  participants: z42.array(PersonSchema),
  bookingAddOnItems: z42.array(
    z42.object({
      label: z42.string(),
      quantity: z42.number()
    })
  )
});
var BookingVoidedActivitySchema = BaseBookingActivityResponseSchema.extend({
  voidedAmount: z42.number()
});
var BookingActivitySchema = z42.union([
  BookingCreatedActivitySchema,
  BookingRefundedActivitySchema,
  BookingRescheduledActivitySchema,
  BookingCancelledActivitySchema,
  BookingVoidedActivitySchema
]);
var BookingActivityResponseSchema = z42.array(z42.union([BookingActivitySchema, WaitlistEntryActivitySchema]));
var BookingActivityEndpoint = makeEndpoint({
  method: "GET",
  url: ({ bookingId }) => `v1/bookings/${bookingId}/activities`,
  requestSchema: z42.void(),
  responseSchema: BookingActivityResponseSchema
});

// src/api/booking/booking-participants-for-event.ts
import { z as z44 } from "zod";

// src/api/booking/check-in-history.ts
import { z as z43 } from "zod";
var CheckInHistoryActionEnum = /* @__PURE__ */ ((CheckInHistoryActionEnum2) => {
  CheckInHistoryActionEnum2["CHECK_IN"] = "check-in";
  CheckInHistoryActionEnum2["CHECK_OUT"] = "check-out";
  return CheckInHistoryActionEnum2;
})(CheckInHistoryActionEnum || {});
var CheckInHistorySchema = z43.object({
  id: z43.string(),
  action: z43.nativeEnum(CheckInHistoryActionEnum),
  scanned: z43.boolean(),
  effectiveAt: z43.union([z43.string().datetime(), z43.date().transform((effectiveAt) => effectiveAt.toISOString())]),
  author: z43.object({
    fullName: z43.string()
  })
});

// src/api/booking/booking-participants-for-event.ts
var BookingWithParticipantSchema = z44.object({
  bookingId: z44.string().uuid(),
  experienceId: z44.string().uuid(),
  startDateTime: z44.string(),
  sessionDuration: z44.number(),
  confirmationCode: z44.string(),
  chargeId: z44.string(),
  isCancelled: z44.boolean(),
  isPartiallyCancelled: z44.boolean(),
  mode: z44.nativeEnum(BookingMode),
  eventId: z44.string().uuid(),
  purchaser: z44.object({
    id: z44.string(),
    firstName: z44.string(),
    lastName: z44.string(),
    emailAddress: EmailStringSchema.nullable(),
    phoneNumber: z44.string().optional().nullable(),
    customQuestionAnswers: z44.array(CustomQuestionAnswerBookingResponseSchema).optional()
  }),
  notes: z44.string().nullable(),
  amount: z44.number(),
  participants: z44.array(
    BaseParticipantSchema.extend({
      isCheckedIn: z44.boolean(),
      ticketNumber: z44.string().nullable(),
      checkInHistories: z44.array(CheckInHistorySchema),
      customQuestionAnswers: z44.array(CustomQuestionAnswerBookingResponseSchema).optional()
    })
  ),
  paymentMethod: z44.nativeEnum(PaymentMethods),
  isVoided: z44.boolean(),
  isFullyRefunded: z44.boolean(),
  isPartiallyRefunded: z44.boolean(),
  refundAmount: z44.number().optional(),
  refundHistory: z44.array(RefundHistorySchema).nullable(),
  experienceSettings: ExperienceSettingsSchema,
  internalNotes: z44.string().nullable(),
  brand: z44.object({
    id: z44.string(),
    name: z44.string()
  }),
  isDisputed: z44.boolean(),
  disputedReason: z44.string().nullable(),
  priceTiers: z44.array(BookingPriceTierSchema),
  cardBrand: z44.string().nullable().optional(),
  cardLast4: z44.string().nullable().optional()
});

// src/api/booking/booking-logistic-summary.ts
import { z as z45 } from "zod";
var BrandsLogisticSummarySchema = z45.object({
  brandId: z45.string(),
  host: MinimalHostSchema.optional(),
  brand: BrandSchema.pick({ id: true, name: true }).extend({ logo: IMediaReferenceSchema.nullable() }).optional(),
  experience: z45.object({ id: z45.string(), title: z45.string(), coverPicture: IMediaReferenceSchema.nullable() }).optional(),
  resourceGroup: z45.object({
    id: z45.string(),
    resourceGroupCollectionId: z45.string(),
    title: z45.string(),
    coverPicture: IMediaReferenceSchema.nullable()
  }).optional(),
  totalParticipants: z45.string(),
  averageParticipants: z45.string(),
  averageBookingWindowInMinutes: z45.string(),
  totalBookings: z45.string()
}).strict();
var BrandsLogisticSummaryResponseSchema = paginateResponseSchema(BrandsLogisticSummarySchema).strict();
var GetBrandsLogisticsSummaryQuerySchema = paginateQuerySchema({
  sortBy: ["totalParticipants", "averageBookingWindowInSeconds", "totalBookings"]
}).extend({
  groupBy: z45.enum(financialSummaryGroupingOptions)
});
var GetBrandsLogisticsSummaryEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    entityType,
    entityId,
    query
  }) => `v1/${entityType}/${entityId}/logistics?${buildQueryString(query)}`,
  responseSchema: BrandsLogisticSummaryResponseSchema,
  requestSchema: z45.void(),
  querySchema: GetBrandsLogisticsSummaryQuerySchema
});

// src/api/booking/cart.ts
import { z as z46 } from "zod";
var CreatePaymentIntentRequestSchema = z46.object({
  data: z46.array(
    CommonBookingRequestSchema.extend({
      experienceId: z46.string(),
      resourceGroupId: z46.string().optional(),
      resourceQuantity: z46.number().optional()
    })
  ),
  getOnlyTotalNetAmount: z46.boolean().optional()
});
var CreatePaymentIntentResponseSchema = z46.object({
  totalNetAmount: z46.number(),
  paymentIntentSecret: z46.string().nullable()
});
var CreatePaymentIntentEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, cartId }) => `/v1/brands/${brandId}/carts/${cartId}/payment_intents`,
  requestSchema: CreatePaymentIntentRequestSchema,
  responseSchema: CreatePaymentIntentResponseSchema
});
var DiscardCartEndpoint = makeEndpoint({
  url: ({ brandId, cartId }) => `/v1/brands/${brandId}/carts/${cartId}/discard`,
  method: "POST",
  requestSchema: z46.void(),
  responseSchema: z46.void()
});

// src/api/booking/notes.ts
import { z as z47 } from "zod";
var UpdateNotesSchema = z47.object({
  notes: z47.string().optional(),
  internalNotes: z47.string().optional()
});

// src/api/booking/reschedule.ts
import { z as z48 } from "zod";
var RescheduleBookingEndpoint = makeEndpoint({
  method: "POST",
  url: ({ bookingId }) => `v1/bookings/${bookingId}/reschedule`,
  requestSchema: z48.object({
    sessionTime: LocalDateTimeStringSchema,
    sessionDuration: z48.number().optional(),
    experienceId: z48.string().uuid().optional(),
    sendConfirmationEmail: z48.boolean().optional()
  }),
  responseSchema: z48.void()
});

// src/api/booking/inquiry.ts
import { z as z49 } from "zod";
var BookingInquiryStatus = /* @__PURE__ */ ((BookingInquiryStatus2) => {
  BookingInquiryStatus2["REQUESTED"] = "requested";
  BookingInquiryStatus2["ACCEPTED"] = "accepted";
  BookingInquiryStatus2["DECLINED"] = "declined";
  BookingInquiryStatus2["UNAVAILABLE"] = "unavailable";
  BookingInquiryStatus2["EXPIRED"] = "expired";
  return BookingInquiryStatus2;
})(BookingInquiryStatus || {});
var DateType = /* @__PURE__ */ ((DateType2) => {
  DateType2["HOTEL"] = "hotel";
  DateType2["STANDARD"] = "standard";
  return DateType2;
})(DateType || {});
var InquiryItemType = /* @__PURE__ */ ((InquiryItemType2) => {
  InquiryItemType2["ITEM"] = "item";
  InquiryItemType2["TAX"] = "tax";
  return InquiryItemType2;
})(InquiryItemType || {});
var BookingInquiryItemSchema = z49.object({
  id: z49.string().uuid(),
  label: z49.string(),
  type: z49.nativeEnum(InquiryItemType),
  amount: z49.number()
});
var BookingInquirySchema = z49.object({
  id: z49.string().uuid(),
  status: z49.nativeEnum(BookingInquiryStatus),
  experienceId: z49.string().uuid(),
  experience: z49.object({
    id: z49.string(),
    title: z49.string()
  }),
  customerId: z49.string().uuid(),
  customer: z49.object({
    firstName: z49.string(),
    lastName: z49.string(),
    emailAddress: z49.string(),
    phoneNumber: z49.string().nullable()
  }),
  purchaserId: z49.string().uuid(),
  purchaser: PurchaserWithCustomQuestionsSchema.extend({
    emailAddress: EmailStringSchema,
    customQuestionResponses: z49.array(CustomQuestionAnswerBookingResponseSchema).optional()
  }).omit({
    id: true
  }),
  participants: z49.array(
    BaseParticipantSchema.extend({
      customQuestionResponses: z49.array(CustomQuestionAnswerBookingResponseSchema).optional()
    }).omit({
      priceTierName: true
    })
  ),
  startDate: z49.date().nullable(),
  endDate: z49.date().nullable(),
  dateType: z49.nativeEnum(DateType),
  message: z49.string().nullable(),
  inquiryItems: z49.array(BookingInquiryItemSchema).optional(),
  createdAt: z49.date(),
  updatedAt: z49.date(),
  deletedAt: z49.date().nullable()
});
var BaseBookingInquiryRequestSchema = z49.object({
  customer: z49.object({
    firstName: z49.string(),
    lastName: z49.string(),
    emailAddress: z49.string(),
    phoneNumber: z49.string().nullable()
  }),
  purchaser: PurchaserWithCustomQuestionsSchema.pick({
    firstName: true,
    lastName: true,
    emailAddress: true,
    phoneNumber: true,
    customQuestionResponses: true
  }).required({ emailAddress: true }),
  inquiryItems: z49.array(
    z49.object({
      label: z49.string(),
      type: z49.nativeEnum(InquiryItemType),
      amount: z49.number()
    })
  ).optional(),
  startDate: DateStringSchema.nullable(),
  endDate: DateStringSchema.nullable(),
  dateType: z49.nativeEnum(DateType),
  message: z49.string().nullable().optional()
});
var UpdateBookingInquiryRequestSchema = BaseBookingInquiryRequestSchema.extend({
  status: z49.nativeEnum(BookingInquiryStatus).optional()
});
var CreateBookingInquiryRequestSchema = BaseBookingInquiryRequestSchema.strict();
var PatchBookingInquiryRequestSchema = UpdateBookingInquiryRequestSchema.partial().strict();
var GetBookingInquiriesQuerySchema = z49.object({
  page: z49.number().int().min(1).default(1),
  limit: z49.number().int().min(1).max(100).default(20),
  experienceId: z49.string().uuid().optional(),
  status: z49.nativeEnum(BookingInquiryStatus).optional(),
  searchQuery: z49.string().optional(),
  withDeleted: z49.boolean().optional()
});
var CreateBookingInquiryEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, experienceId }) => `v1/brands/${brandId}/experiences/${experienceId}/inquiry`,
  requestSchema: CreateBookingInquiryRequestSchema,
  responseSchema: BookingInquirySchema
});
var PatchBookingInquiryEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, experienceId, inquiryId }) => `v1/brands/${brandId}/experiences/${experienceId}/inquiry/${inquiryId}`,
  requestSchema: PatchBookingInquiryRequestSchema,
  responseSchema: BookingInquirySchema
});
var DeleteBookingInquiryEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ brandId, experienceId, inquiryId }) => `v1/brands/${brandId}/experiences/${experienceId}/inquiry/${inquiryId}`,
  requestSchema: z49.void(),
  responseSchema: z49.void()
});
var GetBookingInquiriesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/brands/${brandId}/inquiries`,
  requestSchema: GetBookingInquiriesQuerySchema,
  responseSchema: z49.object({
    items: z49.array(BookingInquirySchema),
    meta: z49.object({
      totalItems: z49.number(),
      itemCount: z49.number(),
      itemsPerPage: z49.number(),
      totalPages: z49.number(),
      currentPage: z49.number()
    })
  })
});
var GetBookingInquiryEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, inquiryId }) => `v1/brands/${brandId}/inquiries/${inquiryId}`,
  requestSchema: z49.void(),
  responseSchema: BookingInquirySchema
});

// src/api/category/rearrange-category.ts
import { z as z50 } from "zod";
var RearrangeCategoryRequestSchema = z50.object({
  categoryIds: z50.array(z50.string().uuid())
}).extend({});
var RearrangeCategoryEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId }) => `brands/${brandId}/categories/rearrange`,
  responseSchema: z50.void(),
  requestSchema: RearrangeCategoryRequestSchema
});

// src/api/category/update-categories.ts
import { z as z51 } from "zod";
var BulkUpdateCategorySchema = z51.object({
  id: z51.string().uuid().optional().nullable(),
  name: z51.string(),
  order: z51.number()
});
var UpdateCategoriesDataSchema = z51.object({
  categories: z51.array(BulkUpdateCategorySchema)
});
var UpdateCategoriesEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId }) => `v1/brands/${brandId}/categories`,
  responseSchema: z51.void(),
  requestSchema: UpdateCategoriesDataSchema
});

// src/api/category/patch-translations-for-categories.ts
import { z as z52 } from "zod";
var PatchTranslationsForCategoriesRequestSchema = z52.object({
  translations: z52.array(TranslationSchema.omit({ createdAt: true, updatedAt: true }))
});
var PatchTranslationsForCategoriesEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId }) => `/v1/brands/${brandId}/categories/i18n`,
  responseSchema: z52.void(),
  requestSchema: PatchTranslationsForCategoriesRequestSchema
});

// src/api/cancellation-policy/endpoints.ts
import { z as z54 } from "zod";

// src/api/cancellation-policy/types.ts
var CancellationPolicyCutoffUnit = /* @__PURE__ */ ((CancellationPolicyCutoffUnit2) => {
  CancellationPolicyCutoffUnit2["HOURS"] = "hours";
  CancellationPolicyCutoffUnit2["DAYS"] = "days";
  CancellationPolicyCutoffUnit2["WEEKS"] = "weeks";
  return CancellationPolicyCutoffUnit2;
})(CancellationPolicyCutoffUnit || {});
var GuestCancellationBookingStatus = /* @__PURE__ */ ((GuestCancellationBookingStatus2) => {
  GuestCancellationBookingStatus2["CANCELLABLE"] = "cancellable";
  GuestCancellationBookingStatus2["CANCELLED"] = "cancelled";
  GuestCancellationBookingStatus2["UNCANCELLABLE"] = "uncancellable";
  GuestCancellationBookingStatus2["DEADLINE_PASSED"] = "deadline_passed";
  return GuestCancellationBookingStatus2;
})(GuestCancellationBookingStatus || {});
var CancellationPolicyField = /* @__PURE__ */ ((CancellationPolicyField2) => {
  CancellationPolicyField2["NOTES"] = "notes";
  return CancellationPolicyField2;
})(CancellationPolicyField || {});

// src/api/resource/common.ts
import { z as z53 } from "zod";
var ListingPictureKind = /* @__PURE__ */ ((ListingPictureKind2) => {
  ListingPictureKind2["GALLERY"] = "gallery";
  ListingPictureKind2["COVER"] = "cover";
  ListingPictureKind2["MAP"] = "map";
  ListingPictureKind2["DESCRIPTION"] = "description";
  return ListingPictureKind2;
})(ListingPictureKind || {});
var ExperienceImageSizeMediaSchema = z53.object({
  id: z53.string().uuid(),
  uri: ExperienceImageSizeWithOriginalInUriSchema
});
var MediaLinkSchema = z53.object({
  type: z53.nativeEnum(MediaType),
  url: z53.string().url(),
  resolution: z53.nativeEnum({ ...MediaLinkResolution, ...ExperienceImageSizes })
});
var MediaInputSchema = z53.object({
  id: z53.string().uuid(),
  kind: z53.nativeEnum(ListingPictureKind)
});
var MediaSchema = MediaInputSchema.partial({ kind: true }).extend({
  order: z53.number().int().min(0).optional(),
  type: z53.nativeEnum(MediaType),
  links: z53.array(MediaLinkSchema)
});
var ResourceGroupCollectionEventType = /* @__PURE__ */ ((ResourceGroupCollectionEventType2) => {
  ResourceGroupCollectionEventType2["GENERAL_ADMISSION"] = "general_admission";
  ResourceGroupCollectionEventType2["RESERVED_SEATING"] = "reserved_seating";
  ResourceGroupCollectionEventType2["AUCTION"] = "auction";
  return ResourceGroupCollectionEventType2;
})(ResourceGroupCollectionEventType || {});
var ExperienceSchema = z53.object({
  id: z53.string().uuid(),
  title: z53.string().nonempty(),
  description: z53.string().nonempty().nullable(),
  status: z53.nativeEnum(ExperienceStatus),
  version: z53.nativeEnum(ExperienceVersion),
  coverPicture: IMediaReferenceSchema.nullable(),
  descriptionPicture: IMediaReferenceSchema.nullable(),
  isBookable: z53.boolean(),
  isNoHost: z53.boolean(),
  sessionDurationMinutes: z53.number().min(1).nullable(),
  paymentMethods: z53.array(z53.nativeEnum(PaymentMethods)).nullable(),
  bookingAvailabilityMode: z53.nativeEnum(BookingAvailabilityModeValue).nullable(),
  shouldValidateComplimentaryBooking: z53.object({ memberCharge: z53.boolean(), roomCharge: z53.boolean() }).partial().nullable(),
  onlineBookingCutoffHours: z53.number().nullable(),
  firstAvailableDate: z53.object({
    scheduledDate: z53.string(),
    sessions: z53.array(
      z53.object({
        startTime: z53.string(),
        supportedParticipantsCount: z53.number(),
        priceTiers: z53.array(PriceTierSchema),
        withinOnlineBookingCutoffWindow: z53.boolean().optional(),
        availableQuantityPerTier: z53.record(z53.number()).optional()
      })
    )
  }).nullable(),
  isUnlisted: z53.boolean().nullable(),
  hostedBy: HostSchema,
  category: z53.object({ id: z53.string().uuid(), name: z53.string() }).nullable(),
  hasPublishedVersion: z53.boolean(),
  isArchived: z53.boolean(),
  createdByAi: z53.boolean(),
  settings: ExperienceSettingsSchema.nullable(),
  kind: z53.nativeEnum(ExperienceKind).nullable(),
  minimumRequiredToBook: z53.number().nullable(),
  maximumAllowedToBook: z53.number().nullable(),
  number: z53.string().nullable(),
  displayedCapacity: z53.number().int().nullable(),
  shape: ShapeSchema.nullable(),
  position: PositionSchema.nullable(),
  maxParticipantsCount: z53.number().int().nonnegative().nullable(),
  timezone: z53.string(),
  emailMessage: z53.string().nullable(),
  notificationEmails: z53.array(EmailStringSchema).max(10).nullable(),
  notificationOverrides: ExperienceNotificationOverridesSchema.nullable(),
  integrationMeta: z53.array(IntegrationMetaSchema).nullable(),
  taxes: z53.array(TaxSchema).nullable(),
  type: z53.nativeEnum(ExperienceType),
  isTicketed: z53.boolean().optional(),
  cancellationPolicyId: z53.string().uuid().nullable(),
  reschedulePolicyId: z53.string().uuid().nullable(),
  customCallToAction: z53.string().nullable()
});
var CustomQuestionInResourcesSchema = CustomQuestionSchema.extend({
  id: z53.union([CustomQuestionSchema.shape.id, z53.literal("emailAddress"), z53.literal("phoneNumber")])
});
var ExperienceAsResourceSchema = ExperienceSchema.pick({
  id: true,
  title: true,
  description: true,
  status: true,
  version: true,
  isUnlisted: true,
  displayedCapacity: true,
  position: true,
  onlineBookingCutoffHours: true,
  emailMessage: true,
  notificationOverrides: true,
  notificationEmails: true,
  paymentMethods: true,
  kind: true,
  shouldValidateComplimentaryBooking: true,
  integrationMeta: true,
  sessionDurationMinutes: true,
  taxes: true,
  type: true,
  maximumAllowedToBook: true,
  minimumRequiredToBook: true,
  maxParticipantsCount: true,
  bookingAvailabilityMode: true,
  isTicketed: true,
  cancellationPolicyId: true,
  reschedulePolicyId: true
}).extend({
  shape: ExperienceSchema.shape.shape,
  customQuestions: z53.array(CustomQuestionInResourcesSchema),
  priceTiers: z53.array(PriceTierSchema).optional(),
  priceTierRules: z53.array(PriceTierRulesSchema).optional(),
  number: ExperienceSchema.shape.number.unwrap()
});
var LocationField = /* @__PURE__ */ ((LocationField2) => {
  LocationField2["NAME"] = "name";
  LocationField2["ADDITIONAL_INFO"] = "additionalInfo";
  return LocationField2;
})(LocationField || {});

// src/api/cancellation-policy/endpoints.ts
var CancellationPolicySchema = z54.object({
  active: z54.boolean(),
  cutoffValue: z54.number().min(0),
  cutoffUnit: z54.nativeEnum(CancellationPolicyCutoffUnit),
  refundPercentage: z54.number().min(0).max(100),
  notes: z54.string().nonempty()
});
var PostCancellationPolicyRequestSchema = CancellationPolicySchema;
var PostCancellationPolicyResponseSchema = z54.object({
  id: z54.string().describe("The id of the created cancellation policy")
});
var PostCancellationPolicyEndpoint = makeEndpoint({
  title: "New cancellation policy",
  description: "Create a new cancellation policy for a brand.",
  method: "POST",
  url: ({ brandId }) => `v1/brands/${brandId}/cancellation-policies`,
  requestSchema: PostCancellationPolicyRequestSchema,
  responseSchema: PostCancellationPolicyResponseSchema
});
var GetCancellationPolicyResponseSchema = z54.object({
  id: z54.string().uuid(),
  active: z54.boolean(),
  cutoffValue: z54.number().min(0),
  cutoffUnit: z54.nativeEnum(CancellationPolicyCutoffUnit),
  refundPercentage: z54.number().min(0).max(100),
  notes: z54.string()
}).describe("Get all the cancellation policies.");
var GetCancellationPolicyEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, cancellationPolicyId }) => `v1/brands/${brandId}/cancellation-policies/${cancellationPolicyId}`,
  requestSchema: z54.void(),
  responseSchema: GetCancellationPolicyResponseSchema
});
var GetCancellationPolicyPublicEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, cancellationPolicyId }) => `v1/brands/${brandId}/cancellation-policies/${cancellationPolicyId}`,
  requestSchema: z54.void(),
  responseSchema: GetCancellationPolicyResponseSchema
});
var GetCancellationPoliciesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/brands/${brandId}/cancellation-policies`,
  requestSchema: z54.void(),
  responseSchema: z54.array(GetCancellationPolicyResponseSchema)
});
var GetBookingsForGuestCancellationResponseSchema = z54.array(
  z54.object({
    bookingId: z54.string().uuid(),
    title: z54.string(),
    coverMedia: MediaSchema.omit({ order: true }).required({ kind: true }),
    refundPercentage: z54.number().min(0).max(100).nullable(),
    notes: z54.string().nullable(),
    sessionDateTime: LocalDateTimeStringSchema,
    sessionDurationInMinutes: z54.number(),
    status: z54.nativeEnum(GuestCancellationBookingStatus),
    totalAmount: z54.number(),
    refundAmount: z54.number(),
    previouslyRefundedAmount: z54.number(),
    remainingBalance: z54.number()
  })
).describe("List the bookings associated to a cart id for guest cancellation.");
var GetBookingsForGuestCancellationQuerySchema = z54.object({ token: z54.string().nonempty() });
var GetBookingsForGuestCancellationEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    cartId,
    query
  }) => `v1/brands/${brandId}/carts/${cartId}/guest-cancellation?${buildQueryString(query)}`,
  querySchema: GetBookingsForGuestCancellationQuerySchema,
  requestSchema: z54.void(),
  responseSchema: GetBookingsForGuestCancellationResponseSchema
});
var PostBookingCancellationEndpoint = makeEndpoint({
  method: "POST",
  url: ({ bookingId }) => `v1/bookings/${bookingId}/guest-cancellation`,
  requestSchema: z54.void(),
  responseSchema: z54.void()
});
var PostGuestCancellationRequestSchema = z54.object({
  bookingId: z54.string().uuid(),
  token: z54.string().nonempty()
});
var PostGuestCancellationEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, cartId }) => `v1/brands/${brandId}/carts/${cartId}/guest-cancellation`,
  requestSchema: PostGuestCancellationRequestSchema,
  responseSchema: z54.void()
});

// src/api/reschedule-policy/endpoints.ts
import { z as z61 } from "zod";

// src/api/reschedule-policy/types.ts
var ReschedulePolicyCutoffUnit = /* @__PURE__ */ ((ReschedulePolicyCutoffUnit2) => {
  ReschedulePolicyCutoffUnit2["HOURS"] = "hours";
  ReschedulePolicyCutoffUnit2["DAYS"] = "days";
  ReschedulePolicyCutoffUnit2["WEEKS"] = "weeks";
  return ReschedulePolicyCutoffUnit2;
})(ReschedulePolicyCutoffUnit || {});
var ReschedulePolicyField = /* @__PURE__ */ ((ReschedulePolicyField2) => {
  ReschedulePolicyField2["NOTES"] = "notes";
  return ReschedulePolicyField2;
})(ReschedulePolicyField || {});

// src/api/event/sessions.ts
import { z as z60 } from "zod";

// src/api/resource/resource-group.ts
import { z as z55 } from "zod";
var NumberPattern = /* @__PURE__ */ ((NumberPattern2) => {
  NumberPattern2["numeric"] = "numeric";
  NumberPattern2["alphabetic"] = "alphabetic";
  return NumberPattern2;
})(NumberPattern || {});
var ResourceGroupSchema = z55.object({
  id: z55.string().uuid(),
  order: z55.number().finite(),
  resourceGroupCollectionId: z55.string().uuid(),
  version: z55.nativeEnum(ExperienceVersion),
  pictures: z55.array(ExperienceImageSizeMediaSchema).max(3),
  medias: z55.array(MediaSchema).max(3),
  pictureIds: z55.array(z55.string().uuid()).max(3),
  title: z55.string().trim().nonempty(),
  description: z55.string().trim(),
  included: z55.array(z55.string()),
  experiences: z55.array(ExperienceAsResourceSchema),
  defaultShape: ShapeSchema.nullable(),
  numberPattern: z55.nativeEnum(NumberPattern),
  createdAt: z55.string().datetime(),
  updatedAt: z55.string().datetime()
});
var ResourceGroupResponseSchema = ResourceGroupSchema.omit({ pictureIds: true }).extend({
  defaultPriceTiers: z55.array(PriceTierSchema),
  reminder: z55.string(),
  taxes: z55.array(TaxSchema.and(z55.object({ name: z55.string() }))),
  paymentMethods: z55.array(z55.nativeEnum(PaymentMethods)),
  integrationMeta: z55.array(IntegrationMetaSchema),
  providedItems: z55.array(z55.string()),
  minimumRequiredToBook: z55.number().nonnegative().nullable(),
  maximumAllowedToBook: z55.number().nonnegative().nullable(),
  ratings: z55.object({ rating: z55.number().nullable(), recommendability: z55.number().nullable(), total: z55.number() }),
  isExclusive: z55.boolean()
});
var PostResourceGroupEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, resourceGroupCollectionId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups`,
  requestSchema: ResourceGroupSchema.pick({
    order: true,
    pictureIds: true,
    title: true,
    included: true,
    defaultShape: true,
    numberPattern: true
  }).extend({
    description: ResourceGroupSchema.shape.description.optional(),
    medias: z55.array(MediaSchema.omit({ kind: true })).optional()
  }).strict(),
  responseSchema: ResourceGroupResponseSchema.strict()
});
var GetResourceGroupsQuerySchema = paginateQuerySchema().merge(
  z55.object({
    filters: z55.array(
      z55.object({
        operator: z55.literal("equals"),
        name: z55.literal("status"),
        value: z55.nativeEnum(ExperienceVersion)
      })
    ).optional(),
    language: z55.nativeEnum(LanguageCode).optional()
  })
);
var GetResourceGroupsEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    resourceGroupCollectionId,
    query
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups?${buildQueryString(
    query
  )}`,
  requestSchema: z55.void(),
  responseSchema: paginateResponseSchema(ResourceGroupResponseSchema).strict(),
  querySchema: GetResourceGroupsQuerySchema
});
var GetResourceGroupQuerySchema = z55.object({
  version: z55.nativeEnum(ExperienceVersion).default("latest" /* LATEST */)
});
var GetResourceGroupEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId,
    query
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}?${buildQueryString(
    query
  )}`,
  requestSchema: z55.void(),
  responseSchema: ResourceGroupResponseSchema.strict(),
  querySchema: GetResourceGroupQuerySchema
});
var PatchResourceGroupEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}`,
  requestSchema: PostResourceGroupEndpoint.requestSchema.strict(),
  responseSchema: ResourceGroupResponseSchema.strict()
});
var DeleteResourceGroupEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}`,
  requestSchema: z55.void(),
  responseSchema: z55.object({
    id: z55.string()
  })
});
var GetTranslationsForResourceGroupQuerySchema = z55.object({
  language: z55.nativeEnum(LanguageCode).optional()
});
var GetTranslationsForResourceGroupEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId,
    version,
    query
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}/version/${version}/i18n?${buildQueryString(
    query
  )}`,
  responseSchema: z55.object({
    translations: z55.object({
      resourceGroup: z55.array(TranslationWithIdSchema),
      listingAddOns: z55.array(TranslationWithIdSchema),
      customQuestions: z55.array(TranslationWithIdSchema),
      listingIncluded: z55.array(TranslationWithIdSchema)
    })
  }),
  requestSchema: z55.void(),
  querySchema: GetTranslationsForResourceGroupQuerySchema
});
var PatchTranslationsForResourceGroupEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId,
    version
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}/version/${version}/i18n`,
  responseSchema: z55.void(),
  requestSchema: z55.object({
    translations: z55.array(TranslationSchema.omit({ createdAt: true, updatedAt: true }))
  })
});
var ResourceGroupField = /* @__PURE__ */ ((ResourceGroupField2) => {
  ResourceGroupField2["TITLE"] = "title";
  ResourceGroupField2["DESCRIPTION"] = "description";
  return ResourceGroupField2;
})(ResourceGroupField || {});

// src/api/resource/resource-group-collection.ts
var import_lodash2 = __toESM(require_lodash(), 1);
import { z as z59 } from "zod";

// src/api/auction/auction.ts
import { z as z56 } from "zod";
var AUCTION_MIN_DURATION_MS = 6e4;
var AUCTION_OPEN_SOON_OFFSET_MINUTES = 5;
var AUCTION_CLOSE_SOON_OFFSET_MINUTES = 5;
var AUCTION_CLOSE_VERY_SOON_OFFSET_MINUTES = 2;
var AUCTION_HARD_CLOSE_GRACE_PERIOD_MINUTES = 1;
var AUCTION_OFFER_REMIND_GRACE_PERIOD_HOURS = 24;
var AUCTION_OFFER_LAST_CHANCE_GRACE_PERIOD_HOURS = 48;
var AUCTION_OFFER_CLAIM_GRACE_PERIOD_HOURS = 72;
var AUCTION_OPEN_GRACE_PERIOD_MINUTES = 5;
var AUCTION_LOCKED_PERIOD_MS = 6e4;
var AUCTION_STATUS_TOPIC_NAME = "auction-status";
var AUCTION_DEBUG_INTERVAL_MINUTES = 2;
var AUCTION_DEFAULT_MIN_BID_INCREMENT = 0;
var AUCTION_DEFAULT_START_AMOUNT = 0;
var AuctionMoment = /* @__PURE__ */ ((AuctionMoment2) => {
  AuctionMoment2["PREVIEW"] = "PREVIEW";
  AuctionMoment2["OPEN_SOON"] = "OPEN_SOON";
  AuctionMoment2["OPEN"] = "OPEN";
  AuctionMoment2["OPEN_END"] = "OPEN_END";
  AuctionMoment2["CLOSE_SOON"] = "CLOSE_SOON";
  AuctionMoment2["CLOSE_VERY_SOON"] = "CLOSE_VERY_SOON";
  AuctionMoment2["CLOSE"] = "CLOSE";
  AuctionMoment2["HARD_CLOSE"] = "HARD_CLOSE";
  AuctionMoment2["END"] = "END";
  return AuctionMoment2;
})(AuctionMoment || {});
var OfferMoment = /* @__PURE__ */ ((OfferMoment2) => {
  OfferMoment2["REMIND"] = "REMIND";
  OfferMoment2["LAST_CHANCE"] = "LAST_CHANCE";
  OfferMoment2["EXPIRE"] = "EXPIRE";
  return OfferMoment2;
})(OfferMoment || {});
var AuctionErrorCode = /* @__PURE__ */ ((AuctionErrorCode2) => {
  AuctionErrorCode2["AUCTION_UNAVAILABLE_NOT_OPEN"] = "auction_unavailable.not_open";
  AuctionErrorCode2["AUCTION_UNAVAILABLE_ENDED"] = "auction_unavailable.ended";
  AuctionErrorCode2["AUCTION_UNAVAILABLE_CANCELLED"] = "auction_unavailable.cancelled";
  AuctionErrorCode2["AUCTION_UNAVAILABLE_CLOSED"] = "auction_unavailable.closed";
  AuctionErrorCode2["AUCTION_UPDATE_INVALID"] = "auction_update.invalid";
  AuctionErrorCode2["AUCTION_UPDATE_CLOSE_DATE_BACKWARD"] = "auction_update.close_date_backward";
  AuctionErrorCode2["AUCTION_UPDATE_TIMER_CONFLICT"] = "auction_update.timer_conflict";
  AuctionErrorCode2["BID_INVALID_BELOW_STARTING"] = "bid_invalid.below_starting";
  AuctionErrorCode2["BID_INVALID_BELOW_INCREMENT"] = "bid_invalid.below_increment";
  AuctionErrorCode2["BID_INVALID_AMOUNT_TYPE"] = "bid_invalid.amount_type";
  AuctionErrorCode2["BID_INVALID_NEGATIVE"] = "bid_invalid.negative";
  AuctionErrorCode2["BID_INVALID_MAX_BID_AMOUNT"] = "bid_invalid.max_bid_amount";
  AuctionErrorCode2["BID_INVALID_BELOW_CURRENT"] = "bid_invalid.below_current";
  AuctionErrorCode2["BID_INVALID_MISSING"] = "bid_invalid.missing";
  AuctionErrorCode2["BID_INVALID_FORMAT"] = "bid_invalid.format";
  return AuctionErrorCode2;
})(AuctionErrorCode || {});
var AuctionStatus = /* @__PURE__ */ ((AuctionStatus2) => {
  AuctionStatus2["PREVIEW"] = "preview";
  AuctionStatus2["OPEN"] = "open";
  AuctionStatus2["ENDED"] = "ended";
  AuctionStatus2["CLOSED"] = "closed";
  AuctionStatus2["CANCELED"] = "canceled";
  AuctionStatus2["HARD_CLOSE"] = "hard_close";
  return AuctionStatus2;
})(AuctionStatus || {});
var AUCTION_RETRY_UNTIL_SUCCESS_MOMENTS = ["OPEN_END" /* OPEN_END */, "HARD_CLOSE" /* HARD_CLOSE */, "EXPIRE" /* EXPIRE */];
var AUCTION_SKIPPABLE_MOMENTS = [
  "OPEN_SOON" /* OPEN_SOON */,
  "CLOSE_SOON" /* CLOSE_SOON */,
  "CLOSE_VERY_SOON" /* CLOSE_VERY_SOON */,
  "CLOSE" /* CLOSE */,
  "REMIND" /* REMIND */,
  "LAST_CHANCE" /* LAST_CHANCE */
];
var AUCTION_MUST_SUCCEED_MOMENTS = AUCTION_RETRY_UNTIL_SUCCESS_MOMENTS;
var AuctionAmountType = /* @__PURE__ */ ((AuctionAmountType2) => {
  AuctionAmountType2["POINTS"] = "points";
  AuctionAmountType2["CASH"] = "cash";
  return AuctionAmountType2;
})(AuctionAmountType || {});
var WinningBidStatus = /* @__PURE__ */ ((WinningBidStatus2) => {
  WinningBidStatus2["WINNING"] = "winning";
  WinningBidStatus2["WON"] = "won";
  return WinningBidStatus2;
})(WinningBidStatus || {});
var WinningBidType = /* @__PURE__ */ ((WinningBidType2) => {
  WinningBidType2["STANDARD"] = "standard";
  WinningBidType2["SECOND_CHANCE"] = "secondChance";
  return WinningBidType2;
})(WinningBidType || {});
var BidStatus = /* @__PURE__ */ ((BidStatus2) => {
  BidStatus2["PLACED"] = "placed";
  BidStatus2["OFFERED"] = "offered";
  BidStatus2["OFFER_EXPIRED"] = "offer_expired";
  BidStatus2["CONFIRMED"] = "confirmed";
  BidStatus2["REJECTED"] = "rejected";
  return BidStatus2;
})(BidStatus || {});
var AuctionSchema = z56.object({
  id: z56.string().uuid(),
  brandId: z56.string().uuid(),
  resourceGroupCollectionId: z56.string().uuid(),
  status: z56.nativeEnum(AuctionStatus),
  amountType: z56.nativeEnum(AuctionAmountType).optional(),
  startingAmount: z56.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number with 2 decimal places." }).optional(),
  minBidIncrement: z56.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number with 2 decimal places." }).optional(),
  biddingOpenDateTime: z56.date(),
  biddingCloseDateTime: z56.date(),
  claimTimeMinutes: z56.number().optional(),
  version: z56.string().optional(),
  winningAmount: z56.string().optional().nullable(),
  winningBidderId: z56.string().optional().nullable()
});
var AuctionResponse = z56.object({
  id: z56.string().uuid(),
  brandId: z56.string().uuid(),
  resourceGroupCollectionId: z56.string().uuid(),
  status: z56.nativeEnum(AuctionStatus),
  startingAmount: z56.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number." }).optional(),
  minBidIncrement: z56.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number." }).optional(),
  biddingOpenDateTime: z56.date(),
  biddingCloseDateTime: z56.date(),
  claimTimeMinutes: z56.number()
});
var AuctionApiResponseSchema = AuctionSchema.extend({
  publishedStatus: z56.nativeEnum(AuctionStatus).nullable()
}).transform((auction) => ({
  ...auction,
  claimTimeMinutes: auction.claimTimeMinutes
}));
var BidderInfoSchema = z56.object({
  id: z56.string().uuid(),
  brandId: z56.string().uuid(),
  email: z56.string().email(),
  externalId: z56.string(),
  firstName: z56.string().optional(),
  lastName: z56.string().optional(),
  loyaltyTier: z56.string().optional(),
  loyaltyNumber: z56.string().optional(),
  createdAt: z56.date(),
  updatedAt: z56.date()
});
var BidResponse = z56.object({
  id: z56.string().uuid(),
  amountType: z56.string(),
  amount: z56.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number." }),
  createdAt: z56.date(),
  bidder: BidderInfoSchema
});
var GetBidsResponse = z56.object({
  items: z56.array(BidResponse),
  meta: z56.object({
    totalItems: z56.number(),
    itemCount: z56.number(),
    itemsPerPage: z56.number(),
    totalPages: z56.number(),
    currentPage: z56.number()
  })
});
var UpdateAuctionRequest = z56.object({
  status: z56.nativeEnum(AuctionStatus).optional(),
  startingAmount: z56.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number with 2 decimal places." }).optional(),
  minBidIncrement: z56.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number with 2 decimal places." }).optional(),
  biddingOpenDateTime: z56.string().transform((v) => new Date(v)).optional(),
  biddingCloseDateTime: z56.string().transform((v) => new Date(v)).optional(),
  claimTimeMinutes: z56.number().optional()
});
var UpdateAuctionEndpoint = makeEndpoint({
  method: "PUT",
  url: ({
    brandId,
    resourceGroupCollectionId,
    auctionId
  }) => `v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/auctions/${auctionId}`,
  requestSchema: UpdateAuctionRequest,
  responseSchema: AuctionResponse
});
var CreateAuctionRequest = z56.object({
  startingAmount: z56.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number with 2 decimal places." }),
  minBidIncrement: z56.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number with 2 decimal places." }),
  biddingOpenDateTime: z56.string().transform((v) => new Date(v)),
  biddingCloseDateTime: z56.string().transform((v) => new Date(v)),
  claimTimeMinutes: z56.number()
});
var CreateAuctionEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, resourceGroupCollectionId }) => `v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/auctions`,
  requestSchema: CreateAuctionRequest,
  responseSchema: AuctionResponse
});
var PlaceBidRequestSchema = z56.object({
  brandId: z56.string().uuid(),
  id: z56.string().uuid().optional(),
  amount: z56.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number." }).optional(),
  maxAmount: z56.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number." }).optional(),
  amountType: z56.nativeEnum(AuctionAmountType).optional()
});
var PlaceBidEndpoint = makeEndpoint({
  method: "POST",
  url: ({
    brandId,
    resourceGroupCollectionId,
    auctionId
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/auctions/${auctionId}/bids`,
  requestSchema: PlaceBidRequestSchema,
  responseSchema: z56.void()
});
var BidderSchema = z56.object({
  brandId: z56.string().uuid(),
  id: z56.string().uuid(),
  externalId: z56.string(),
  email: z56.string().email(),
  firstName: z56.string().optional(),
  lastName: z56.string().optional().nullable(),
  pointsBalance: z56.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number." }).optional(),
  phoneNumber: z56.string().optional(),
  loyaltyTier: z56.string().optional(),
  loyaltyNumber: z56.string().optional(),
  maxBids: z56.array(
    z56.object({
      auctionId: z56.string().uuid(),
      amount: z56.string(),
      createdAt: z56.date()
    })
  ).optional(),
  createdAt: z56.date().optional(),
  updatedAt: z56.date().optional()
});
var PartialBidderInfoSchema = z56.object({
  brandId: z56.string().uuid(),
  loyaltyTier: z56.string().optional(),
  externalIdLast4: z56.string().optional()
});
var GetBidsByBidderResponse = z56.object({
  items: z56.array(
    z56.object({
      id: z56.string().uuid(),
      amountType: z56.string(),
      amount: z56.string().regex(/^\d+(\.\d{2})?$/, { message: "Must be a valid decimal number." }).optional(),
      createdAt: z56.date(),
      bidder: BidderSchema
    })
  ),
  meta: z56.object({
    totalItems: z56.number().optional(),
    itemCount: z56.number().optional(),
    itemsPerPage: z56.number().optional(),
    totalPages: z56.number().optional(),
    currentPage: z56.number().optional()
  })
});
var GetBidsByBidderEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    resourceGroupCollectionId,
    auctionId,
    field,
    value,
    page,
    limit
  }) => {
    const queryParams = new URLSearchParams();
    if (page !== void 0)
      queryParams.append("page", page.toString());
    if (limit !== void 0)
      queryParams.append("limit", limit.toString());
    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
    return `v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/auctions/${auctionId}/bids/bidder/${field}/${value}${queryString}`;
  },
  requestSchema: z56.object({
    field: z56.string(),
    value: z56.string(),
    page: z56.number().optional(),
    limit: z56.number().optional()
  }),
  responseSchema: GetBidsByBidderResponse
});
var GetAuctionEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, resourceGroupCollectionId }) => `v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/auctions`,
  requestSchema: z56.object({
    brandId: z56.string().uuid(),
    resourceGroupCollectionId: z56.string().uuid()
  }),
  responseSchema: AuctionResponse
});
var GetBidsEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    resourceGroupCollectionId,
    auctionId,
    page,
    limit
  }) => {
    const queryParams = new URLSearchParams();
    if (page !== void 0)
      queryParams.append("page", page.toString());
    if (limit !== void 0)
      queryParams.append("limit", limit.toString());
    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : "";
    return `v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/auctions/${auctionId}/bids${queryString}`;
  },
  requestSchema: z56.object({
    brandId: z56.string().uuid(),
    resourceGroupCollectionId: z56.string().uuid(),
    auctionId: z56.string().uuid(),
    page: z56.number().optional(),
    limit: z56.number().optional()
  }),
  responseSchema: GetBidsResponse
});

// src/api/listing/listing.ts
import { z as z58 } from "zod";

// src/experience/sessions.ts
import { z as z57 } from "zod";
var SessionSchema = z57.object({
  startTime: z57.string(),
  duration: z57.number(),
  supportedParticipantsCount: z57.number(),
  priceTiers: z57.array(
    z57.object({
      id: z57.string().uuid(),
      name: z57.string(),
      price: z57.number()
    })
  ),
  availableQuantityPerTier: z57.record(z57.number()).optional()
});
var FirstAvailableDateSchema = z57.object({
  scheduledDate: z57.string(),
  sessions: z57.array(SessionSchema)
});

// src/api/promoter/types.ts
var PromoterStatus = /* @__PURE__ */ ((PromoterStatus2) => {
  PromoterStatus2["ACTIVE"] = "active";
  PromoterStatus2["INACTIVE"] = "inactive";
  return PromoterStatus2;
})(PromoterStatus || {});
var PromoterApprovalMode = /* @__PURE__ */ ((PromoterApprovalMode2) => {
  PromoterApprovalMode2["AUTO"] = "auto";
  PromoterApprovalMode2["MANUAL"] = "manual";
  return PromoterApprovalMode2;
})(PromoterApprovalMode || {});
var PromotedListingStatus = /* @__PURE__ */ ((PromotedListingStatus2) => {
  PromotedListingStatus2["NEEDS_APPROVAL"] = "needs-approval";
  PromotedListingStatus2["NEEDS_PROVIDER_APPROVAL"] = "needs-provider-approval";
  PromotedListingStatus2["NEEDS_PROMOTER_APPROVAL"] = "needs-promoter-approval";
  PromotedListingStatus2["APPROVED"] = "approved";
  PromotedListingStatus2["DECLINED"] = "declined";
  return PromotedListingStatus2;
})(PromotedListingStatus || {});
var PromoterAgreementStatus = /* @__PURE__ */ ((PromoterAgreementStatus2) => {
  PromoterAgreementStatus2["NEEDS_APPROVAL"] = "needs-approval";
  PromoterAgreementStatus2["NEEDS_PROVIDER_APPROVAL"] = "needs-provider-approval";
  PromoterAgreementStatus2["NEEDS_PROMOTER_APPROVAL"] = "needs-promoter-approval";
  PromoterAgreementStatus2["APPROVED"] = "approved";
  PromoterAgreementStatus2["NEEDS_ORGANIZATION_APPROVAL"] = "needs-organization-approval";
  return PromoterAgreementStatus2;
})(PromoterAgreementStatus || {});

// src/api/listing/listing.ts
var ListingKind = /* @__PURE__ */ ((ListingKind2) => {
  ListingKind2["EXPERIENCE"] = "experience";
  ListingKind2["RESOURCE"] = "resource";
  ListingKind2["EVENT"] = "event";
  ListingKind2["AUCTION"] = "auction";
  return ListingKind2;
})(ListingKind || {});
var ListingVersion = /* @__PURE__ */ ((ListingVersion2) => {
  ListingVersion2["PUBLISHED"] = "published";
  ListingVersion2["LATEST"] = "latest";
  return ListingVersion2;
})(ListingVersion || {});
var ListingPictureSchema = ExperienceImageSizeMediaSchema.extend({
  kind: z58.nativeEnum(ListingPictureKind)
});
var ResourceGroupSchema2 = ResourceGroupResponseSchema.extend({
  firstAvailableDate: FirstAvailableDateSchema.nullable()
});
var ListingTaxSchema = TaxSchema.and(z58.object({ name: z58.string() }));
var ListingSchema = z58.object({
  id: z58.string().uuid(),
  title: z58.string(),
  type: z58.nativeEnum(ExperienceType).nullable(),
  partySize: z58.number().nullable(),
  headline: z58.string(),
  vibes: z58.array(z58.object({ id: z58.string().uuid(), name: z58.string() })),
  category: z58.object({ id: z58.string().uuid(), name: z58.string() }).nullable(),
  coverPicture: ExperienceImageSizeMediaSchema.nullable(),
  firstAvailableDate: FirstAvailableDateSchema.nullable(),
  kind: z58.nativeEnum(ListingKind),
  eventType: z58.nativeEnum(ResourceGroupCollectionEventType).nullable(),
  productLine: z58.nativeEnum(ProductLine),
  slug: z58.string().nullable(),
  defaultPriceTiers: z58.array(PriceTierSchema),
  conditionalPriceTiers: z58.array(PriceTierSchema).nullable(),
  defaultMaxParticipantCount: z58.number().nullable(),
  description: z58.string(),
  location: LocationSchema.nullable(),
  isBookable: z58.boolean(),
  isUnlisted: z58.boolean(),
  hostedBy: HostSchema.extend({
    profilePicture: UserImageSizeMediaSchema.nullable(),
    description: z58.string().nullable()
  }).nullable(),
  isCurated: z58.boolean(),
  isExclusive: z58.boolean(),
  hidePrice: z58.boolean(),
  bookingAvailabilityMode: z58.nativeEnum(BookingAvailabilityModeValue).nullable(),
  descriptionPicture: ExperienceImageSizeMediaSchema.nullable(),
  paymentMethods: z58.array(z58.nativeEnum(PaymentMethods)).nullable(),
  taxes: z58.array(ListingTaxSchema).nullable(),
  integrationMeta: z58.array(IntegrationMetaSchema).nullable(),
  providedItems: z58.array(z58.string()).nullable(),
  reminder: z58.string().nullable(),
  pictures: z58.array(ListingPictureSchema),
  medias: z58.array(
    MediaSchema.omit({
      kind: true
    }).extend({
      kind: z58.nativeEnum(ListingPictureKind)
    })
  ),
  ratings: z58.object({ rating: z58.number().nullable(), recommendability: z58.number().nullable(), total: z58.number() }),
  minimumRequiredToBook: z58.number().nonnegative().nullable(),
  maximumAllowedToBook: z58.number().nonnegative().nullable(),
  externalField: ExternalFieldSchema.nullable(),
  map: ExperienceImageSizeMediaSchema.nullable(),
  resourceGroups: z58.array(
    ResourceGroupSchema2.pick({
      id: true,
      title: true,
      firstAvailableDate: true,
      coverPicture: true,
      paymentMethods: true
    })
  ).nullable(),
  brandId: z58.string().uuid(),
  listingId: z58.string().uuid().nullable().optional(),
  isFeatured: z58.boolean(),
  cancellationPolicyId: z58.string().uuid().nullable(),
  reschedulePolicyId: z58.string().uuid().nullable(),
  promotedListingId: z58.string().uuid().nullable().optional(),
  promotedListingStatus: z58.nativeEnum(PromotedListingStatus).nullable().optional(),
  providerBrandId: z58.string().uuid().nullable().optional(),
  providerBrandName: z58.string().nullable().optional(),
  auction: AuctionApiResponseSchema.nullable().optional(),
  customCallToAction: z58.string().nullable()
});
var PublicListingSchema = ListingSchema.extend({
  agenda: z58.string().nullable(),
  menu: z58.string().nullable(),
  dates: z58.array(DateStringSchema).nullable(),
  startTimes: z58.array(TimeStringSchema).nullable(),
  supportedCurrencies: z58.array(z58.nativeEnum(Currency))
});
var PublicDetailedListingSchema = PublicListingSchema.extend({
  resourceGroups: z58.array(
    ResourceGroupSchema2.extend({
      ratings: PublicListingSchema.shape.ratings,
      shouldValidateComplimentaryBooking: z58.boolean(),
      addOns: z58.array(PublicResponseListingAddOnSchema)
    })
  ).nullable(),
  auction: AuctionApiResponseSchema.nullable().optional(),
  shouldValidateComplimentaryBooking: z58.boolean().nullable(),
  // Only available for experiences
  waitlistId: z58.string().uuid().nullable(),
  addOns: z58.array(PublicResponseListingAddOnSchema),
  customQuestions: z58.array(CustomQuestionInResourcesSchema).nullable()
});
var PublicGetListingsQuerySchema = paginateQuerySchema({ sortBy: ["title", "kind", "date", "order"] }).omit({ q: true }).extend({
  categoryIds: z58.array(z58.string().uuid()).optional(),
  vibeIds: z58.array(z58.string().uuid()).optional(),
  kinds: z58.array(z58.nativeEnum(ListingKind)).optional(),
  brandIds: z58.array(z58.string().uuid()).optional(),
  search: z58.string().optional(),
  isUnlisted: BooleanStringSchema.default("false"),
  version: z58.nativeEnum(ListingVersion).optional(),
  from: z58.string().optional(),
  to: z58.string().optional(),
  featured: z58.literal("true").optional(),
  bypassFirstAvailableDate: BooleanStringSchema.optional(),
  language: z58.nativeEnum(LanguageCode).optional()
});
var PublicGetListingsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `/v1/listings?${buildQueryString(query)}`,
  requestSchema: z58.void(),
  responseSchema: paginateResponseSchema(PublicListingSchema.strict()),
  querySchema: PublicGetListingsQuerySchema
});
var PublicGetListingQuerySchema = z58.object({
  version: z58.nativeEnum(ListingVersion).optional(),
  language: z58.nativeEnum(LanguageCode).optional()
});
var PublicGetListingEndpoint = makeEndpoint({
  method: "GET",
  url: ({ listingId, query }) => `/v1/listings/${listingId}?${buildQueryString(query)}`,
  requestSchema: z58.void(),
  responseSchema: PublicDetailedListingSchema.strict(),
  querySchema: PublicGetListingQuerySchema
});
var PublicGetListingIdForExperienceOrCollectionEndpoint = makeEndpoint({
  method: "GET",
  url: ({ exchangeId }) => `/v1/listings/exchange-id/${exchangeId}`,
  requestSchema: z58.void(),
  responseSchema: z58.string()
});
var ListingStatus = /* @__PURE__ */ ((ListingStatus2) => {
  ListingStatus2["DRAFT"] = "draft";
  ListingStatus2["PENDING"] = "pending";
  ListingStatus2["PUBLISHED"] = "published";
  ListingStatus2["UNPUBLISHED"] = "unpublished";
  ListingStatus2["ARCHIVED"] = "archived";
  return ListingStatus2;
})(ListingStatus || {});
var InternalListingResourceGroupSchema = ResourceGroupSchema2.pick({
  id: true,
  title: true,
  order: true,
  firstAvailableDate: true,
  paymentMethods: true
}).extend({
  experienceIds: z58.array(z58.string().uuid()),
  coverPicture: ExperienceImageSizeMediaSchema.nullable(),
  pictures: z58.array(ExperienceImageSizeMediaSchema).nullable().optional()
});
var InternalListingSchema = ListingSchema.extend({
  status: z58.nativeEnum(ListingStatus),
  createdByAi: z58.boolean(),
  headline: ListingSchema.shape.headline.nullable(),
  description: ListingSchema.shape.description.nullable(),
  isUnlisted: ListingSchema.shape.isUnlisted.nullable(),
  isExclusive: ListingSchema.shape.isExclusive.nullable(),
  resourceGroups: z58.array(InternalListingResourceGroupSchema).nullable(),
  auction: AuctionApiResponseSchema.nullable().optional()
});
var ListingPromotedStatus = /* @__PURE__ */ ((ListingPromotedStatus2) => {
  ListingPromotedStatus2["ALL"] = "all";
  ListingPromotedStatus2["NEEDS_PROMOTER_APPROVAL"] = "needs-promoter-approval";
  ListingPromotedStatus2["APPROVED"] = "approved";
  ListingPromotedStatus2["DECLINED"] = "declined";
  return ListingPromotedStatus2;
})(ListingPromotedStatus || {});
var InternalGetListingsQuerySchema = paginateQuerySchema({
  sortBy: ["title", "kind", "date", "status", "categoryName", "order"]
}).extend({
  filters: z58.array(
    z58.union([
      z58.object({
        operator: z58.literal("in"),
        name: z58.literal("hostId"),
        value: z58.array(z58.string().uuid())
      }),
      z58.object({
        operator: z58.literal("in"),
        name: z58.literal("categoryId"),
        value: z58.array(z58.string().uuid())
      }),
      z58.object({
        operator: z58.literal("in"),
        name: z58.literal("kind"),
        value: z58.array(z58.nativeEnum(ListingKind))
      }),
      z58.object({
        operator: z58.literal("in"),
        name: z58.literal("productLine"),
        value: z58.array(z58.nativeEnum(ProductLine))
      }),
      z58.object({
        operator: z58.literal("in"),
        name: z58.literal("location"),
        value: z58.array(z58.string())
      }),
      z58.object({
        operator: z58.enum(["equals", "greater_than", "less_than"]),
        name: z58.literal("price"),
        value: z58.coerce.number()
      }),
      z58.object({
        operator: z58.literal("range"),
        name: z58.literal("price"),
        value: z58.object({ from: z58.coerce.number(), to: z58.coerce.number() })
      }),
      z58.object({
        operator: z58.literal("equals"),
        name: z58.literal("isBookable"),
        value: BooleanStringSchema
      }),
      z58.object({
        operator: z58.literal("equals"),
        name: z58.literal("paymentMethod"),
        value: z58.nativeEnum(PaymentMethods)
      }),
      z58.object({
        operator: z58.literal("equals"),
        name: z58.literal("isExclusive"),
        value: BooleanStringSchema
      }),
      z58.object({
        operator: z58.literal("in"),
        name: z58.literal("status"),
        value: z58.array(z58.nativeEnum(ListingStatus))
      }),
      z58.object({
        operator: z58.literal("equals"),
        name: z58.literal("createdByAi"),
        value: BooleanStringSchema
      }),
      z58.object({
        operator: z58.literal("equals"),
        name: z58.literal("isUnlisted"),
        value: BooleanStringSchema
      })
    ])
  ).optional(),
  brandId: z58.string().uuid().optional(),
  organizationId: z58.string().uuid().optional(),
  listingId: z58.string().uuid().optional(),
  from: z58.string().optional(),
  to: z58.string().optional(),
  featured: z58.literal("true").optional(),
  includePromotedListings: z58.literal("true").optional(),
  promotedStatus: z58.nativeEnum(ListingPromotedStatus).optional(),
  language: z58.nativeEnum(LanguageCode).optional(),
  version: z58.nativeEnum(ListingVersion).optional()
});
var InternalGetListingsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `/v1/listings?${buildQueryString(query)}`,
  requestSchema: z58.void(),
  responseSchema: paginateResponseSchema(InternalListingSchema.strict()),
  querySchema: InternalGetListingsQuerySchema
});
var OrderListingsRequestSchema = z58.object({
  listings: z58.array(z58.object({ id: z58.string().uuid(), kind: z58.nativeEnum(ListingKind) }))
});
var OrderListingsEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `/v1/brands/${brandId}/order-listings`,
  requestSchema: OrderListingsRequestSchema,
  responseSchema: z58.void()
});
var InternalGetListingQuerySchema = z58.object({
  version: z58.nativeEnum(ListingVersion).optional(),
  brandId: z58.string().uuid().optional(),
  organizationId: z58.string().uuid().optional(),
  language: z58.nativeEnum(LanguageCode).optional()
});
var InternalGetDetailedListingSchema = InternalListingSchema.omit({
  resourceGroups: true
}).extend({
  resourceGroups: z58.array(
    InternalListingResourceGroupSchema.extend({
      addOns: z58.array(ResponseListingAddOnSchema).optional()
    })
  ).nullable(),
  addOns: z58.array(ResponseListingAddOnSchema).optional(),
  auction: AuctionApiResponseSchema.nullable().optional()
});
var InternalGetListingEndpoint = makeEndpoint({
  method: "GET",
  url: ({ listingId, query }) => `/v1/listings/${listingId}?${buildQueryString(query)}`,
  requestSchema: z58.void(),
  responseSchema: InternalGetDetailedListingSchema.strict(),
  querySchema: InternalGetListingQuerySchema
});
var UpdateFeaturedListings = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `/v1/brands/${brandId}/featured-listings`,
  requestSchema: z58.object({ listings: z58.array(z58.object({ id: z58.string().uuid(), order: z58.number().int().nonnegative() })) }),
  responseSchema: z58.void()
});
var GetOrganizationListingCustomFieldValuesSchema = z58.object({
  customFieldId: z58.string().uuid(),
  organizationId: z58.string().uuid(),
  organizationName: z58.string(),
  isRequired: z58.boolean(),
  isDashboardEditable: z58.boolean(),
  fieldName: z58.string(),
  fieldType: z58.string(),
  enumValues: z58.array(z58.string()),
  isMultiSelect: z58.boolean(),
  defaultValues: z58.array(z58.string()),
  currentValues: z58.array(z58.string())
});
var GetOrganizationListingCustomFieldValuesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, listingId }) => `v1/brands/${brandId}/listings/${listingId}/organization-custom-fields`,
  responseSchema: z58.object({ fields: z58.array(GetOrganizationListingCustomFieldValuesSchema) }).strict(),
  requestSchema: z58.void()
});
var PutOrganizationCustomFieldValuesRequestSchema = z58.object({
  fields: z58.array(
    z58.object({
      customFieldId: z58.string().uuid(),
      fieldType: z58.string(),
      isMultiSelect: z58.boolean(),
      fieldValues: z58.array(z58.string())
    })
  )
});
var PutOrganizationCustomFieldValuesEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId, listingId }) => `/v1/brands/${brandId}/listings/${listingId}/organization-custom-fields`,
  requestSchema: PutOrganizationCustomFieldValuesRequestSchema,
  responseSchema: z58.void()
});
var customField = z58.object({
  externalId: z58.string().nullable().optional(),
  name: z58.string(),
  values: z58.array(z58.string().nullable())
});
var GetListingsV2ItemSchema = z58.object({
  id: z58.string().uuid(),
  title: z58.string(),
  description: z58.string(),
  summary: z58.string().nullable(),
  experienceId: z58.string().uuid().nullable(),
  resourceGroupCollectionId: z58.string().uuid().nullable(),
  kind: z58.nativeEnum(ListingKind),
  productLine: z58.nativeEnum(ProductLine),
  startingPrice: z58.number().nullable(),
  pricePerType: z58.string().nullable(),
  minParticipants: z58.number().nullable(),
  maxParticipants: z58.number().nullable(),
  coverMedia: MediaSchema.omit({ order: true }).required({ kind: true }),
  brandId: z58.string().uuid().nullable(),
  brandCurrency: z58.string().nullable(),
  externalBrandReferenceId: z58.string().nullable().optional(),
  location: z58.object({
    name: z58.string(),
    latitude: z58.number(),
    longitude: z58.number(),
    timezoneId: z58.string(),
    additionalInfo: z58.string().nullable()
  }),
  slug: z58.string().nullable(),
  customFields: z58.array(customField),
  rating: z58.number().nullable(),
  categoryName: z58.string().nullable(),
  dates: z58.array(z58.date()),
  hidePrice: z58.boolean().nullable(),
  isUnlisted: z58.boolean().nullable(),
  category: z58.object({ id: z58.string(), name: z58.string() }).nullable(),
  vibes: z58.array(z58.object({ id: z58.string(), name: z58.string() })),
  bookingAvailabilityMode: z58.nativeEnum(BookingAvailabilityModeValue).nullable(),
  isExclusive: z58.boolean(),
  medias: z58.array(MediaSchema.omit({ order: true }).required({ kind: true })),
  hostedById: z58.string().nullable(),
  featuredOrder: z58.number().nullable(),
  order: z58.number().nullable(),
  createdAt: z58.string().datetime().nullable(),
  publishedAt: z58.string().datetime().nullable(),
  firstAvailableDate: z58.date().nullable(),
  auction: AuctionSchema.nullable().optional(),
  customCallToAction: z58.string().nullable()
});
var GetListingV2ResponseSchema = z58.object({
  id: z58.string().uuid(),
  brandId: z58.string().uuid().nullable(),
  externalBrandReferenceId: z58.string().nullable().optional(),
  categoryId: z58.string().uuid().nullable(),
  locationId: z58.string().uuid().nullable(),
  experienceId: z58.string().uuid().nullable(),
  resourceGroupCollectionId: z58.string().uuid().nullable(),
  kind: z58.nativeEnum(ListingKind),
  productLine: z58.nativeEnum(ProductLine),
  title: z58.string().nullable(),
  description: z58.string().nullable(),
  startingPrice: z58.number().nullable(),
  pricePerType: z58.string().nullable(),
  minParticipants: z58.number().nullable(),
  maxParticipants: z58.number().nullable(),
  status: z58.nativeEnum(ListingStatus).nullable(),
  summary: z58.string().nullable(),
  mediaIds: z58.array(z58.string().uuid()),
  vibeIds: z58.array(z58.string().uuid()),
  startTimes: z58.array(z58.string()).nullable(),
  cancellationPolicyId: z58.string().uuid().nullable(),
  reschedulePolicyId: z58.string().uuid().nullable(),
  createdAt: z58.string().datetime(),
  updatedAt: z58.string().datetime(),
  auction: AuctionSchema.nullable().optional()
});
var listingsV2SortByOptions = [
  "startingPrice",
  "rating",
  "order",
  "featuredOrder",
  "firstAvailableDate",
  "createdAt",
  "publishedAt",
  "timeLeft"
];
var listingsV2Filters = {
  isUnlisted: BooleanStringSchema.default("false"),
  kinds: z58.array(z58.nativeEnum(ListingKind)).optional(),
  productLines: z58.array(z58.nativeEnum(ProductLine)).optional(),
  categories: z58.array(z58.string()).optional(),
  participantCount: z58.coerce.number().optional(),
  customFields: z58.array(z58.object({ externalId: z58.string(), value: z58.string() })).optional(),
  from: z58.string().optional(),
  to: z58.string().optional(),
  excludePromotedListings: z58.literal("true").optional(),
  categoryIds: z58.array(z58.string().uuid()).optional(),
  vibeIds: z58.array(z58.string().uuid()).optional(),
  language: z58.nativeEnum(LanguageCode).optional(),
  featured: z58.literal("true").optional()
};
var GetListingsV2QuerySchema = paginateQuerySchema({
  sortBy: listingsV2SortByOptions
}).omit({ filters: true }).extend(listingsV2Filters);
var GetListingsV2Endpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `v2/listings?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(GetListingsV2ItemSchema),
  requestSchema: z58.void(),
  querySchema: GetListingsV2QuerySchema
});
var GetListingV2Endpoint = makeEndpoint({
  method: "GET",
  url: ({ listingId }) => `v2/listings/${listingId}`,
  responseSchema: GetListingV2ResponseSchema,
  requestSchema: z58.void()
});
var ListingField = /* @__PURE__ */ ((ListingField2) => {
  ListingField2["TITLE"] = "title";
  ListingField2["DESCRIPTION"] = "description";
  ListingField2["SUMMARY"] = "summary";
  ListingField2["HEADLINE"] = "headline";
  return ListingField2;
})(ListingField || {});
var FeaturedListSchema = z58.object({
  listingBrandId: z58.string().uuid(),
  listingId: z58.string().uuid(),
  listingTitle: z58.string(),
  order: z58.number().int().nonnegative()
});
var GetFeaturedListResponseSchema = z58.array(FeaturedListSchema);
var GetFeaturedListEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `/v1/featured-list/brands/${brandId}`,
  responseSchema: GetFeaturedListResponseSchema,
  requestSchema: z58.void()
});
var FavoriteListSchema = z58.object({
  listingUserId: z58.string().uuid(),
  listingId: z58.string().uuid(),
  order: z58.coerce.number().int().nonnegative(),
  title: z58.string().nullable(),
  brandId: z58.string().uuid().nullable(),
  experienceId: z58.string().uuid().nullable(),
  resourceGroupCollectionId: z58.string().uuid().nullable()
});
var GetFavoriteListResponseSchema = z58.array(FavoriteListSchema);
var GetFavoriteListEndpoint = makeEndpoint({
  method: "GET",
  url: ({ userId, brandId }) => `/v1/favorite-list/users/${userId}/${brandId}`,
  responseSchema: GetFavoriteListResponseSchema,
  requestSchema: z58.void()
});
var SetFeaturedListRequestSchema = z58.array(
  z58.object({
    listingId: z58.string().uuid(),
    order: z58.number().int().nonnegative()
  })
);
var AddRemoveFeaturedListResponseSchema = z58.object({
  totalFeaturedCount: z58.number().int().nonnegative()
});
var SetFeaturedListEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `/v1/featured-list/brands/${brandId}`,
  responseSchema: AddRemoveFeaturedListResponseSchema,
  requestSchema: SetFeaturedListRequestSchema
});
var SetFavoriteListRequestSchema = z58.array(
  z58.object({
    listingId: z58.string().uuid(),
    order: z58.number().int().nonnegative()
  })
);
var AddRemoveFavoriteListResponseSchema = z58.object({
  totalFavoriteCount: z58.number().int().nonnegative()
});
var SetFavoriteListEndpoint = makeEndpoint({
  method: "POST",
  url: ({ userId }) => `/v1/favorite-list/users/${userId}`,
  responseSchema: AddRemoveFavoriteListResponseSchema,
  requestSchema: SetFavoriteListRequestSchema
});
var AddToFeaturedListEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, listingId }) => `/v1/featured-list/brands/${brandId}/listings/${listingId}`,
  responseSchema: AddRemoveFeaturedListResponseSchema,
  requestSchema: z58.void()
});
var AddToFavoriteListEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ userId, listingId }) => `/v1/favorite-list/users/${userId}/listings/${listingId}`,
  responseSchema: AddRemoveFavoriteListResponseSchema,
  requestSchema: z58.void()
});
var DeleteFromFeaturedListEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ brandId, listingId }) => `/v1/featured-list/brands/${brandId}/listings/${listingId}`,
  responseSchema: AddRemoveFeaturedListResponseSchema,
  requestSchema: z58.void()
});
var DeleteFromFavoriteListEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ userId, listingId }) => `/v1/favorite-list/users/${userId}/listings/${listingId}`,
  responseSchema: AddRemoveFavoriteListResponseSchema,
  requestSchema: z58.void()
});
var GetListingTranslationsQuerySchema = z58.object({
  language: z58.nativeEnum(LanguageCode).optional()
});
var GetListingTranslationsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ listingId, query }) => `/v1/listings/${listingId}/i18n?${buildQueryString(query)}`,
  responseSchema: z58.object({
    translations: z58.array(TranslationSchema)
  }),
  requestSchema: z58.void(),
  querySchema: GetListingTranslationsQuerySchema
});
var PatchListingTranslationsRequestSchema = z58.object({
  translations: z58.array(TranslationSchema.omit({ createdAt: true, updatedAt: true }))
});
var PatchListingTranslationsEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ listingId }) => `/v1/listings/${listingId}/i18n`,
  responseSchema: z58.void(),
  requestSchema: PatchListingTranslationsRequestSchema
});

// src/api/resource/resource-group-collection.ts
var ResourceGroupCollectionKind = /* @__PURE__ */ ((ResourceGroupCollectionKind2) => {
  ResourceGroupCollectionKind2["EVENT"] = "event";
  ResourceGroupCollectionKind2["RESERVE"] = "reserve";
  return ResourceGroupCollectionKind2;
})(ResourceGroupCollectionKind || {});
var ResourceGroupCollectionStatus = /* @__PURE__ */ ((ResourceGroupCollectionStatus2) => {
  ResourceGroupCollectionStatus2["PUBLISHED"] = "published";
  ResourceGroupCollectionStatus2["UNPUBLISHED"] = "unpublished";
  ResourceGroupCollectionStatus2["ARCHIVED"] = "archived";
  ResourceGroupCollectionStatus2["DRAFT"] = "draft";
  return ResourceGroupCollectionStatus2;
})(ResourceGroupCollectionStatus || {});
var ResourceGroupCollectionAuctionResponse = AuctionResponse.extend({
  publishedStatus: z59.nativeEnum(AuctionStatus).nullable()
});
var ResourceGroupCollectionSchema = z59.object({
  id: z59.string().uuid(),
  order: z59.number().finite().nullable(),
  brandId: z59.string().uuid(),
  status: z59.nativeEnum(ResourceGroupCollectionStatus),
  version: z59.nativeEnum(ExperienceVersion),
  map: ExperienceImageSizeMediaSchema.nullable(),
  locationId: z59.string().uuid(),
  location: LocationSchema,
  category: z59.object({ id: z59.string().uuid(), name: z59.string() }),
  categoryId: z59.string().uuid(),
  vibes: z59.array(z59.object({ id: z59.string().uuid(), name: z59.string(), order: z59.number().nullable() })).min(1).max(3, { message: "A collection can have a maximum of 3 vibes" }),
  vibeIds: z59.array(z59.string().uuid()).min(1).max(3),
  isMapShown: z59.boolean(),
  kind: z59.nativeEnum(ResourceGroupCollectionKind).default("reserve" /* RESERVE */),
  // TODO : remove the default value
  mapId: z59.string().uuid().nullable(),
  pictureIds: z59.array(z59.string().uuid()).max(7),
  pictures: z59.array(ListingPictureSchema),
  name: z59.string().trim().nonempty(),
  summary: z59.string().nullable(),
  details: z59.string().nullable(),
  agenda: z59.string().nullable().optional(),
  reminders: z59.string().nullable().optional(),
  menu: z59.string().nullable().optional(),
  createdAt: z59.string().datetime(),
  updatedAt: z59.string().datetime(),
  publishedAt: z59.string().datetime().nullable(),
  archivedAt: z59.string().datetime().nullable(),
  dates: z59.array(DateStringSchema).nullable().optional(),
  startTimes: z59.array(TimeStringSchema).nullable().optional(),
  waitlistId: z59.string().uuid().nullable(),
  eventType: z59.nativeEnum(ResourceGroupCollectionEventType).nullable(),
  cancellationPolicyId: z59.string().uuid().nullable(),
  auction: ResourceGroupCollectionAuctionResponse.nullable().optional(),
  reschedulePolicyId: z59.string().uuid().nullable(),
  isUnlisted: z59.boolean().default(false),
  customCallToAction: z59.string().nullable()
});
var ResourceGroupCollectionResponseSchema = ResourceGroupCollectionSchema.omit({
  mapId: true,
  pictureIds: true,
  categoryId: true,
  vibeIds: true
}).extend({
  vibes: ResourceGroupCollectionSchema.shape.vibes.min(0),
  medias: z59.array(
    MediaSchema.omit({
      kind: true
    }).extend({
      kind: z59.nativeEnum(ListingPictureKind)
    })
  ).optional()
});
var PostResourceGroupCollectionEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `/v1/brands/${brandId}/resource-group-collections`,
  requestSchema: ResourceGroupCollectionSchema.pick({
    order: true,
    categoryId: true,
    vibeIds: true,
    isMapShown: true,
    pictureIds: true,
    mapId: true,
    name: true,
    kind: true,
    summary: true,
    details: true,
    agenda: true,
    reminders: true,
    menu: true,
    dates: true,
    startTimes: true,
    eventType: true,
    cancellationPolicyId: true,
    reschedulePolicyId: true,
    isUnlisted: true,
    customCallToAction: true
  }).partial({
    eventType: true,
    medias: true,
    pictureIds: true,
    cancellationPolicyId: true,
    reschedulePolicyId: true,
    location: true
  }).extend({
    location: z59.object({
      latitude: z59.number(),
      name: z59.string(),
      longitude: z59.number(),
      additionalInfo: z59.string().optional()
    }),
    medias: z59.array(
      MediaSchema.omit({
        kind: true
      }).extend({
        kind: z59.nativeEnum(ListingPictureKind)
      })
    ).refine(
      (medias) => {
        const [covers, gallery] = (0, import_lodash2.partition)(medias, (picture) => picture.kind === "cover" /* COVER */);
        return covers.length <= 3 && gallery.length <= 8;
      },
      {
        message: "At most 3 cover medias and 8 gallery medias"
      }
    ).optional(),
    pictures: z59.array(
      z59.object({
        id: z59.string().uuid(),
        kind: z59.nativeEnum(ListingPictureKind).optional()
      })
    ).refine(
      (pictures) => {
        const [covers, gallery] = (0, import_lodash2.partition)(pictures, (picture) => picture.kind === "cover" /* COVER */);
        return covers.length <= 3 && gallery.length <= 8;
      },
      {
        message: "At most 3 cover pictures and 8 gallery pictures"
      }
    ).optional()
  }).strict(),
  responseSchema: ResourceGroupCollectionResponseSchema
});
var GetResourceGroupCollectionsQuerySchema = paginateQuerySchema().merge(
  z59.object({
    filters: z59.array(
      z59.object({
        operator: z59.literal("equals"),
        name: z59.literal("status"),
        value: z59.nativeEnum(ExperienceVersion)
      })
    ).optional()
  })
);
var GetResourceGroupCollectionsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, page, limit }) => `/v1/brands/${brandId}/resource-group-collections?page=${page}&limit=${limit}`,
  requestSchema: z59.void(),
  responseSchema: paginateResponseSchema(ResourceGroupCollectionResponseSchema).strict()
});
var GetResourceGroupCollectionQuerySchema = z59.object({
  version: z59.nativeEnum(ExperienceVersion).default("latest" /* LATEST */),
  language: z59.nativeEnum(LanguageCode).optional()
});
var DetailedResourceGroupCollectionSchema = ResourceGroupCollectionResponseSchema.extend({
  status: z59.nativeEnum(ResourceGroupCollectionStatus)
});
var GetResourceGroupCollectionEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    resourceGroupCollectionId,
    query
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}?${buildQueryString(query)}`,
  requestSchema: z59.void(),
  responseSchema: DetailedResourceGroupCollectionSchema,
  querySchema: GetResourceGroupCollectionQuerySchema
});
var PatchResourceGroupCollectionRequestSchema = PostResourceGroupCollectionEndpoint.requestSchema.omit({ eventType: true }).extend({ archived: z59.boolean() }).partial().strict();
var PatchResourceGroupCollectionEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ resourceGroupCollectionId, brandId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}`,
  requestSchema: PatchResourceGroupCollectionRequestSchema,
  responseSchema: ResourceGroupCollectionResponseSchema.strict()
});
var ArchiveResourceGroupCollectionEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ resourceGroupCollectionId, brandId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/archive`,
  requestSchema: z59.void(),
  responseSchema: z59.void()
});
var UnarchiveResourceGroupCollectionEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ resourceGroupCollectionId, brandId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/unarchive`,
  requestSchema: z59.void(),
  responseSchema: z59.void()
});
var DeleteResourceGroupCollectionEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ resourceGroupCollectionId, brandId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}`,
  requestSchema: z59.void(),
  responseSchema: z59.void()
});
var PublishResourceGroupCollectionEndpoint = makeEndpoint({
  method: "POST",
  url: ({ resourceGroupCollectionId, brandId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/publish`,
  requestSchema: z59.void(),
  responseSchema: ResourceGroupCollectionResponseSchema.strict()
});
var UnpublishResourceGroupCollectionEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ resourceGroupCollectionId, brandId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/publish`,
  requestSchema: z59.void(),
  responseSchema: z59.void()
});
var DateQuerySchema = z59.object({
  eventDate: DateStringSchema,
  eventTime: TimeStringSchema.optional()
});
var QRCodeScanPayloadSchema = z59.object({
  qrCodePayload: z59.string()
});
var ParticipantScanResponse = z59.object({
  participantName: z59.string(),
  ticketNumber: z59.string(),
  priceLabel: z59.string(),
  confirmationCode: z59.string(),
  eventDate: DateStringSchema,
  eventTime: TimeStringSchema
});
var CollectionEventParticipantScanEndpoint = makeEndpoint({
  method: "POST",
  url: ({
    brandId,
    resourceGroupCollectionId,
    query
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/participants/scan?${buildQueryString(
    query
  )}`,
  requestSchema: QRCodeScanPayloadSchema,
  responseSchema: ParticipantScanResponse,
  querySchema: DateQuerySchema
});
var CloneResourceGroupCollectionResponseSchema = z59.object({ resourceGroupCollectionId: z59.string().uuid() });
var CloneResourceGroupCollectionEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, resourceGroupCollectionId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/clone`,
  requestSchema: z59.void(),
  responseSchema: CloneResourceGroupCollectionResponseSchema
});
var GetTranslationsForResourceGroupCollectionQuerySchema = z59.object({
  language: z59.nativeEnum(LanguageCode).optional()
});
var GetTranslationsForResourceGroupCollectionEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    resourceGroupCollectionId,
    version,
    query
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/version/${version}/i18n?${buildQueryString(
    query
  )}`,
  responseSchema: z59.object({
    translations: z59.object({
      resourceGroupCollection: z59.array(TranslationWithIdSchema),
      listingAddOns: z59.array(TranslationWithIdSchema),
      cancellationPolicy: z59.array(TranslationWithIdSchema),
      reschedulePolicy: z59.array(TranslationWithIdSchema),
      location: z59.array(TranslationWithIdSchema)
    })
  }),
  requestSchema: z59.void(),
  querySchema: GetTranslationsForResourceGroupCollectionQuerySchema
});
var PatchTranslationsForResourceGroupCollectionEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({
    brandId,
    resourceGroupCollectionId,
    version
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/version/${version}/i18n`,
  responseSchema: z59.void(),
  requestSchema: z59.object({
    translations: z59.array(TranslationSchema.omit({ createdAt: true, updatedAt: true }))
  })
});
var ReorderResourceGroupsEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, resourceGroupCollectionId }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/reorder`,
  requestSchema: z59.object({
    resourceGroups: z59.array(
      z59.object({
        id: z59.string().uuid(),
        version: z59.nativeEnum(ExperienceVersion),
        order: z59.number().int()
      })
    ).min(1)
  }),
  responseSchema: z59.void()
});
var ResourceGroupCollectionField = /* @__PURE__ */ ((ResourceGroupCollectionField2) => {
  ResourceGroupCollectionField2["NAME"] = "name";
  ResourceGroupCollectionField2["SUMMARY"] = "summary";
  ResourceGroupCollectionField2["DETAILS"] = "details";
  ResourceGroupCollectionField2["AGENDA"] = "agenda";
  ResourceGroupCollectionField2["MENU"] = "menu";
  ResourceGroupCollectionField2["REMINDERS"] = "reminders";
  ResourceGroupCollectionField2["CUSTOM_CALL_TO_ACTION"] = "customCallToAction";
  return ResourceGroupCollectionField2;
})(ResourceGroupCollectionField || {});

// src/api/event/sessions.ts
var SessionStatus = /* @__PURE__ */ ((SessionStatus2) => {
  SessionStatus2["OPEN"] = "OPEN";
  SessionStatus2["OVERLAPPED"] = "OVERLAPPED";
  SessionStatus2["CONFIRMED"] = "CONFIRMED";
  SessionStatus2["WAITLISTED"] = "WAITLISTED";
  SessionStatus2["OVERLAPPED_BY_WAITLIST"] = "OVERLAPPED_BY_WAITLIST";
  return SessionStatus2;
})(SessionStatus || {});
var GetSessionsQuerySchema = z60.object({
  experienceId: z60.string().uuid().optional(),
  resourceGroupCollectionId: z60.string().uuid().optional(),
  resourceGroupId: z60.string().uuid().optional(),
  filters: FiltersSchema.optional(),
  mode: z60.nativeEnum(BookingMode).optional(),
  version: z60.nativeEnum(ExperienceVersion).optional(),
  hostId: z60.string().uuid().optional(),
  q: z60.string().optional(),
  includesAllConfirmedEvents: BooleanStringSchema.optional()
});
var SessionBookingParticipantSchema = BaseParticipantSchema.extend({
  id: z60.string(),
  cancelledAt: z60.string().datetime().nullable(),
  ticketNumber: z60.string().nullable(),
  isCheckedIn: z60.boolean(),
  priceTierId: z60.string().optional()
});
var SessionBookingParticipantsSchema = z60.array(SessionBookingParticipantSchema);
var SessionBookingsSchema = z60.array(
  z60.object({
    id: z60.string(),
    mode: z60.nativeEnum(BookingMode),
    purchaser: PurchaserSchema,
    participants: SessionBookingParticipantsSchema
  })
);
var GetSessionsResponseSchema = z60.object({
  sessions: z60.array(
    z60.object({
      sessionId: z60.string().uuid().nullable(),
      scheduleId: z60.string().uuid().nullable(),
      isRepeating: z60.boolean(),
      isPrivateEvent: z60.boolean(),
      priceTiers: z60.array(PriceTierSchema),
      startDateTime: LocalDateTimeStringSchema,
      sessionDuration: z60.number().int().positive(),
      purchaserName: z60.string().optional(),
      participantCount: z60.number().int().nonnegative(),
      isFullyCheckedIn: z60.boolean(),
      capacity: z60.number().nullable(),
      // open experiences do not have a capacity
      experienceId: z60.string().uuid(),
      status: z60.nativeEnum(SessionStatus),
      hostedBy: HostSchema.nullable(),
      isBookableViaNegativeCutOffHours: z60.boolean()
    })
  ),
  experiences: z60.array(ExperienceSchema),
  resourceGroupCollections: z60.array(
    ResourceGroupCollectionResponseSchema.extend({
      resourceGroups: z60.array(ResourceGroupResponseSchema)
    })
  )
});
var GetSessionsEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    from,
    to,
    query
  }) => `/v2/brands/${brandId}/sessions/${from}/${to}?${buildQueryString(query)}`,
  requestSchema: z60.void(),
  responseSchema: GetSessionsResponseSchema,
  querySchema: GetSessionsQuerySchema
});
var GetMineSessionsEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    from,
    to,
    query
  }) => `/v2/brands/${brandId}/sessions/mine/${from}/${to}?${buildQueryString(query)}`,
  requestSchema: z60.void(),
  responseSchema: GetSessionsResponseSchema,
  querySchema: GetSessionsQuerySchema
});
var UpdateSessionRequestSchema = z60.object({
  eventCapacity: z60.array(
    z60.object({
      startDateTime: LocalDateTimeStringSchema,
      // should not be optional once the dashboard has been updated
      sessionDuration: z60.number().int().positive().optional(),
      maxQuantity: z60.number().int().nonnegative()
    })
  ).min(1)
});
var UpdateSessionEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ scheduleId }) => `/v1/schedule/${scheduleId}/update-session`,
  requestSchema: UpdateSessionRequestSchema,
  responseSchema: z60.void()
});
var RemoveManySessionsRequestSchema = z60.object({
  from: DateStringSchema,
  to: DateStringSchema.optional(),
  sessions: z60.array(
    z60.object({
      experienceId: z60.string().uuid(),
      duration: z60.number(),
      startTime: TimeStringSchema
    })
  )
});
var RemoveManySessionsEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `/v1/brands/${brandId}/remove-many-sessions`,
  requestSchema: RemoveManySessionsRequestSchema,
  responseSchema: z60.void()
});
var RemoveSessionRequestSchema = z60.object({
  startTimes: z60.array(LocalDateTimeStringSchema).min(1).max(500),
  scheduleIds: z60.array(z60.string().uuid()).optional(),
  from: DateStringSchema.optional(),
  to: DateStringSchema.optional(),
  sessionDuration: z60.number().optional()
});
var RemoveSessionEndpoint = makeEndpoint({
  method: "POST",
  url: ({ experienceId }) => `/v1/experiences/${experienceId}/remove-sessions`,
  requestSchema: RemoveSessionRequestSchema,
  responseSchema: z60.void()
});
var GetConfirmedSessionsQuerySchema = paginateQuerySchema().omit({ filters: true, sortDir: true, sortBy: true }).extend({
  startDate: DateStringSchema.optional(),
  endDate: DateStringSchema.optional(),
  experienceId: z60.string().uuid().optional(),
  resourceGroupCollectionId: z60.string().uuid().optional(),
  hostId: z60.string().uuid().optional()
});
var ConfirmedSessionsCollectionsSchema = ResourceGroupCollectionSchema.pick({
  id: true,
  name: true,
  kind: true,
  eventType: true
});
var ConfirmedSessionSchema = z60.object({
  eventId: z60.string().uuid(),
  startDateTime: LocalDateTimeStringSchema,
  sessionDuration: z60.number(),
  participantsCount: z60.number(),
  isPrivate: z60.boolean(),
  experience: z60.object({
    id: z60.string().uuid(),
    title: z60.string(),
    hostName: z60.string().nullable(),
    location: LocationSchema,
    maxParticipantsCount: z60.number(),
    isBookable: z60.boolean(),
    resourceGroupId: z60.string().uuid().nullable(),
    kind: z60.nativeEnum(ExperienceKind),
    resourceGroupCollectionId: z60.string().uuid().nullable()
  }),
  collection: ConfirmedSessionsCollectionsSchema.nullable(),
  eventCapacity: z60.object({ maxQuantity: z60.number() }).nullable()
});
var GetConfirmedSessionsResponseSchema = paginateResponseSchema(ConfirmedSessionSchema);
var GetConfirmedSessionsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `/v1/brands/${brandId}/confirmed-sessions?${buildQueryString(query)}`,
  requestSchema: z60.void(),
  responseSchema: GetConfirmedSessionsResponseSchema,
  querySchema: GetConfirmedSessionsQuerySchema
});
var GetMineConfirmedSessionsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `/v1/brands/${brandId}/confirmed-sessions/mine?${buildQueryString(query)}`,
  requestSchema: z60.void(),
  responseSchema: GetConfirmedSessionsResponseSchema,
  querySchema: GetConfirmedSessionsQuerySchema
});

// src/api/reschedule-policy/endpoints.ts
var ReschedulePolicySchema = z61.object({
  id: z61.string().uuid(),
  active: z61.boolean(),
  cutoffValue: z61.number().min(0),
  cutoffUnit: z61.nativeEnum(ReschedulePolicyCutoffUnit),
  notes: z61.string().nonempty()
});
var CreateReschedulePolicyRequestSchema = ReschedulePolicySchema.omit({ id: true });
var CreateReschedulePolicyResponseSchema = ReschedulePolicySchema.pick({ id: true });
var GetReschedulePolicyResponseSchema = ReschedulePolicySchema;
var ReschedulableStatus = /* @__PURE__ */ ((ReschedulableStatus2) => {
  ReschedulableStatus2["ALLOWED"] = "ALLOWED";
  ReschedulableStatus2["NOT_ALLOWED"] = "NOT_ALLOWED";
  return ReschedulableStatus2;
})(ReschedulableStatus || {});
var ReschedulableBookingSchema = z61.object({
  bookingId: z61.string().uuid(),
  coverMedia: z61.any(),
  customerId: z61.string().uuid(),
  experienceTitle: z61.string().nullable(),
  eventStartDateTime: z61.date(),
  eventSessionDuration: z61.any(),
  eventSessionDurationInMinutes: z61.number(),
  experienceTimeZoneId: z61.string().nullable(),
  experienceMediaIds: z61.array(z61.string().uuid()),
  reschedulePolicyId: z61.string().uuid().nullable(),
  reschedulePolicyNotes: z61.string().nullable(),
  reschedulePolicyActive: z61.boolean().nullable(),
  reschedulePolicyCutoffUnit: z61.nativeEnum(ReschedulePolicyCutoffUnit).nullable(),
  reschedulePolicyCutoffValue: z61.number().nullable(),
  status: z61.nativeEnum(ReschedulableStatus)
});
var ReschedulableBookingsSchema = z61.array(ReschedulableBookingSchema).describe("List of reschedulable bookings");
var GetBookingsForGuestRescheduleResponseSchema = z61.array(ReschedulableBookingSchema).describe("List the bookings associated to a cart id for guest cancellation.");
var GetBookingsForGuestRescheduleQuerySchema = z61.object({
  token: z61.string().nonempty(),
  languageCode: z61.string().optional()
});
var GetBookingsForGuestRescheduleEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    cartId,
    query
  }) => `v1/brands/${brandId}/carts/${cartId}/guest-reschedule?${buildQueryString(query)}`,
  querySchema: GetBookingsForGuestRescheduleQuerySchema,
  requestSchema: z61.void(),
  responseSchema: GetBookingsForGuestRescheduleResponseSchema
});
var CreateReschedulePolicyEndpoint = makeEndpoint({
  title: "New reschedule policy",
  description: "Create a new reschedule policy for a brand.",
  method: "POST",
  url: ({ brandId }) => `v1/brands/${brandId}/reschedule-policies`,
  requestSchema: CreateReschedulePolicyRequestSchema,
  responseSchema: CreateReschedulePolicyResponseSchema
});
var GetReschedulePolicyEndpoint = makeEndpoint({
  method: "GET",
  description: "Get a reschedule policy by ID.",
  url: ({ brandId, reschedulePolicyId }) => `v1/brands/${brandId}/reschedule-policies/${reschedulePolicyId}`,
  requestSchema: z61.void(),
  responseSchema: GetReschedulePolicyResponseSchema
});
var GetSessionsToRescheduleQuerySchema = z61.object({
  from: z61.string().optional(),
  to: z61.string().optional(),
  allowOverbooking: z61.string().optional()
});
var SessionsToReschedule = z61.array(
  z61.object({
    sessionId: z61.string().uuid().nullable(),
    scheduleId: z61.string().uuid().nullable(),
    isRepeating: z61.boolean(),
    isPrivateEvent: z61.boolean(),
    priceTiers: z61.array(PriceTierSchema),
    startDateTime: LocalDateTimeStringSchema,
    sessionDuration: z61.number().int().positive(),
    purchaserName: z61.string().optional(),
    participantCount: z61.number().int().nonnegative(),
    isFullyCheckedIn: z61.boolean(),
    capacity: z61.number().nullable(),
    // open experiences do not have a capacity
    experienceId: z61.string().uuid(),
    overlappedEvent: z61.boolean().optional(),
    status: z61.nativeEnum(SessionStatus),
    hostedBy: HostSchema.nullable(),
    isBookableViaNegativeCutOffHours: z61.boolean()
  })
);
var GetSessionsToRescheduleResourceGroupCollection = ResourceGroupCollectionResponseSchema.extend({
  resourceGroups: z61.array(ResourceGroupResponseSchema)
});
var GetSessionsToRescheduleResponseSchema = z61.object({
  sessions: SessionsToReschedule,
  experiences: z61.array(ExperienceSchema),
  experienceId: z61.string().uuid(),
  // The ID of the experience used to query sessions
  resourceGroupCollections: z61.array(GetSessionsToRescheduleResourceGroupCollection)
});
var GetSessionsToRescheduleEndpoint = makeEndpoint({
  title: "All sessions to reschedule a booking",
  description: "It returns all the sessions that are eligible for a rebook scenario.",
  method: "GET",
  url: ({ bookingId, query }) => `v1/bookings/${bookingId}/sessions-to-reschedule?${buildQueryString(query)}`,
  querySchema: GetSessionsToRescheduleQuerySchema,
  requestSchema: z61.void(),
  responseSchema: GetSessionsToRescheduleResponseSchema
});

// src/api/credit-code/endpoints.ts
import { z as z62 } from "zod";
var BaseCreditCodeSchema = z62.object({
  id: z62.string().uuid()
});
var CreateCreditCodeRequestSchema = z62.object({
  code: z62.string(),
  externalTransactionId: z62.string().nullable(),
  description: z62.string().nullable(),
  cardPurchaseTransactionId: z62.string().nullable(),
  redeemableByEmailAddress: z62.string(),
  isRedeemableByAnyUser: z62.boolean().default(false),
  redeemableOnOrganizations: z62.array(z62.string()).nullable(),
  redeemableOnBrands: z62.array(z62.string()).nullable(),
  originalValue: z62.number().default(0),
  expiresAt: z62.string().datetime().nullable()
});
var SearchCreditCodeRequestSchema = z62.object({
  code: z62.string()
});
var CreditCodeHistorySchema = z62.object({
  id: z62.string().uuid(),
  userId: z62.string().uuid(),
  redeemedOn: z62.string().datetime(),
  redeemedAmount: z62.number(),
  beforeValue: z62.number(),
  afterValue: z62.number(),
  cartId: z62.string().uuid()
});
var CreditCodeHistoriesSchema = z62.object({
  histories: z62.array(CreditCodeHistorySchema).nullable()
});
var GetCreditCodeResponseSchema = BaseCreditCodeSchema.merge(CreateCreditCodeRequestSchema);
var CreditCodeRedeemRefundRequestSchema = z62.object({
  code: z62.string(),
  userEmail: z62.string().nullable(),
  transactionAmount: z62.number().positive(),
  cartId: z62.string().uuid()
});
var ValidateListingsRequestSchema = z62.object({
  listingIds: z62.array(z62.string().uuid())
});
var ValidateListingsResponseSchema = z62.object({
  validListingIds: z62.array(z62.string().uuid()).nullable(),
  invalidListingIds: z62.array(z62.string().uuid()).nullable()
});
var CreateCreditCodeEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/credit-codes`,
  responseSchema: GetCreditCodeResponseSchema,
  requestSchema: CreateCreditCodeRequestSchema
});
var GetCreditCodeEndpoint = makeEndpoint({
  method: "GET",
  url: ({ creditCodeId }) => `v1/credit-codes/${creditCodeId}`,
  responseSchema: GetCreditCodeResponseSchema,
  requestSchema: z62.void()
});
var GeneralSearchCreditCodeEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/credit-codes/search`,
  responseSchema: GetCreditCodeResponseSchema,
  requestSchema: SearchCreditCodeRequestSchema
});
var RedeemCreditCodeEndpoint = makeEndpoint({
  method: "POST",
  url: ({ creditCodeId }) => `v1/credit-codes/${creditCodeId}/redeem`,
  responseSchema: z62.object({
    redemptionCode: z62.string().uuid()
    // Id of the credit code history object
  }),
  requestSchema: CreditCodeRedeemRefundRequestSchema
});
var RefundCreditCodeEndpoint = makeEndpoint({
  method: "POST",
  url: ({ creditCodeId }) => `v1/credit-codes/${creditCodeId}/refund`,
  responseSchema: z62.object({
    redemptionCode: z62.string().uuid()
    // Id of the credit code history object
  }),
  requestSchema: CreditCodeRedeemRefundRequestSchema
});
var DeleteCreditCodeEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ creditCodeId }) => `v1/credit-codes/${creditCodeId}`,
  responseSchema: z62.void(),
  requestSchema: z62.void()
});
var GetCreditCodeHistoriesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ creditCodeId }) => `v1/credit-codes/${creditCodeId}/histories`,
  responseSchema: CreditCodeHistoriesSchema,
  requestSchema: z62.void()
});
var ValidateListingsEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/credit-codes/validate-listings`,
  responseSchema: ValidateListingsResponseSchema,
  requestSchema: ValidateListingsRequestSchema
});

// src/api/currency-conversion/types.ts
import { z as z63 } from "zod";
var FromCurrency = /* @__PURE__ */ ((FromCurrency2) => {
  FromCurrency2["AED"] = "AED";
  FromCurrency2["ALL"] = "ALL";
  FromCurrency2["AMD"] = "AMD";
  FromCurrency2["AOA"] = "AOA";
  FromCurrency2["ARS"] = "ARS";
  FromCurrency2["AUD"] = "AUD";
  FromCurrency2["AZN"] = "AZN";
  FromCurrency2["BAM"] = "BAM";
  FromCurrency2["BDT"] = "BDT";
  FromCurrency2["BGN"] = "BGN";
  FromCurrency2["BHD"] = "BHD";
  FromCurrency2["BND"] = "BND";
  FromCurrency2["BOB"] = "BOB";
  FromCurrency2["BRL"] = "BRL";
  FromCurrency2["BSD"] = "BSD";
  FromCurrency2["BTN"] = "BTN";
  FromCurrency2["BWP"] = "BWP";
  FromCurrency2["CAD"] = "CAD";
  FromCurrency2["CHF"] = "CHF";
  FromCurrency2["CLP"] = "CLP";
  FromCurrency2["COP"] = "COP";
  FromCurrency2["CRC"] = "CRC";
  FromCurrency2["CZK"] = "CZK";
  FromCurrency2["DKK"] = "DKK";
  FromCurrency2["DOP"] = "DOP";
  FromCurrency2["DZD"] = "DZD";
  FromCurrency2["EGP"] = "EGP";
  FromCurrency2["ETB"] = "ETB";
  FromCurrency2["EUR"] = "EUR";
  FromCurrency2["GBP"] = "GBP";
  FromCurrency2["GHS"] = "GHS";
  FromCurrency2["GMD"] = "GMD";
  FromCurrency2["GTQ"] = "GTQ";
  FromCurrency2["GYD"] = "GYD";
  FromCurrency2["HKD"] = "HKD";
  FromCurrency2["HUF"] = "HUF";
  FromCurrency2["IDR"] = "IDR";
  FromCurrency2["ILS"] = "ILS";
  FromCurrency2["INR"] = "INR";
  FromCurrency2["JMD"] = "JMD";
  FromCurrency2["JOD"] = "JOD";
  FromCurrency2["JPY"] = "JPY";
  FromCurrency2["KES"] = "KES";
  FromCurrency2["KHR"] = "KHR";
  FromCurrency2["KRW"] = "KRW";
  FromCurrency2["KWD"] = "KWD";
  FromCurrency2["KZT"] = "KZT";
  FromCurrency2["LAK"] = "LAK";
  FromCurrency2["LKR"] = "LKR";
  FromCurrency2["MAD"] = "MAD";
  FromCurrency2["MDL"] = "MDL";
  FromCurrency2["MGA"] = "MGA";
  FromCurrency2["MKD"] = "MKD";
  FromCurrency2["MNT"] = "MNT";
  FromCurrency2["MOP"] = "MOP";
  FromCurrency2["MUR"] = "MUR";
  FromCurrency2["MXN"] = "MXN";
  FromCurrency2["MYR"] = "MYR";
  FromCurrency2["MZN"] = "MZN";
  FromCurrency2["NAD"] = "NAD";
  FromCurrency2["NGN"] = "NGN";
  FromCurrency2["NOK"] = "NOK";
  FromCurrency2["NZD"] = "NZD";
  FromCurrency2["OMR"] = "OMR";
  FromCurrency2["PEN"] = "PEN";
  FromCurrency2["PHP"] = "PHP";
  FromCurrency2["PKR"] = "PKR";
  FromCurrency2["PLN"] = "PLN";
  FromCurrency2["PYG"] = "PYG";
  FromCurrency2["QAR"] = "QAR";
  FromCurrency2["RON"] = "RON";
  FromCurrency2["RSD"] = "RSD";
  FromCurrency2["RWF"] = "RWF";
  FromCurrency2["SAR"] = "SAR";
  FromCurrency2["SEK"] = "SEK";
  FromCurrency2["SGD"] = "SGD";
  FromCurrency2["THB"] = "THB";
  FromCurrency2["TND"] = "TND";
  FromCurrency2["TRY"] = "TRY";
  FromCurrency2["TTD"] = "TTD";
  FromCurrency2["TWD"] = "TWD";
  FromCurrency2["TZS"] = "TZS";
  FromCurrency2["UYU"] = "UYU";
  FromCurrency2["UZS"] = "UZS";
  FromCurrency2["VND"] = "VND";
  FromCurrency2["XAF"] = "XAF";
  FromCurrency2["XCD"] = "XCD";
  FromCurrency2["XOF"] = "XOF";
  FromCurrency2["ZAR"] = "ZAR";
  return FromCurrency2;
})(FromCurrency || {});
var ToCurrency = /* @__PURE__ */ ((ToCurrency2) => {
  ToCurrency2["USD"] = "USD";
  return ToCurrency2;
})(ToCurrency || {});
var PostCurrencyRatesEndpoint = makeEndpoint({
  method: "POST",
  url: () => "/currency-conversion-rates",
  requestSchema: z63.void(),
  responseSchema: z63.void()
});
var GetConvertedCurrencyQuerySchema = z63.object({
  fromCurrency: z63.union([z63.nativeEnum(FromCurrency), z63.nativeEnum(ToCurrency)]),
  toCurrency: z63.union([z63.nativeEnum(FromCurrency), z63.nativeEnum(ToCurrency)]),
  amount: z63.coerce.number()
});
var GetConvertedCurrencyResponseSchema = z63.object({
  convertedAmount: z63.number()
});
var GetConvertedCurrencyEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `/convert-currency?${buildQueryString(query)}`,
  requestSchema: z63.void(),
  querySchema: GetConvertedCurrencyQuerySchema,
  responseSchema: GetConvertedCurrencyResponseSchema
});

// src/api/custom-fields/types.ts
var CustomFieldTypes = /* @__PURE__ */ ((CustomFieldTypes2) => {
  CustomFieldTypes2["NUMBER"] = "number";
  CustomFieldTypes2["STRING"] = "string";
  CustomFieldTypes2["BOOLEAN"] = "boolean";
  CustomFieldTypes2["ENUM"] = "enum";
  CustomFieldTypes2["CURRENCY"] = "currency";
  return CustomFieldTypes2;
})(CustomFieldTypes || {});

// src/api/email/email.ts
var EmailType = /* @__PURE__ */ ((EmailType2) => {
  EmailType2["BookingScriptRemoval"] = "BookingScriptRemoval";
  EmailType2["BrandBookingCancelled"] = "BrandBookingCancelled";
  EmailType2["BrandBookingPartialCancellation"] = "BrandBookingPartialCancellation";
  EmailType2["BrandBookingConfirmation"] = "BrandBookingConfirmation";
  EmailType2["BrandBulkBookingConfirmation"] = "BrandBulkBookingConfirmation";
  EmailType2["BrandResetPassword"] = "BrandResetPassword";
  EmailType2["BrandUserAccountLocked"] = "BrandUserAccountLocked";
  EmailType2["BrandUserInvitation"] = "BrandUserInvitation";
  EmailType2["CustomerBookingCancelled"] = "CustomerBookingCancelled";
  EmailType2["CustomerBookingConfirmation"] = "CustomerBookingConfirmation";
  EmailType2["CustomerBookingRefund"] = "CustomerBookingRefund";
  EmailType2["CustomerBookingReminder"] = "CustomerBookingReminder";
  EmailType2["CustomerBookingReschedule"] = "CustomerBookingReschedule";
  EmailType2["CustomerBulkBookingConfirmation"] = "CustomerBulkBookingConfirmation";
  EmailType2["CustomerExperienceReview"] = "CustomerExperienceReview";
  EmailType2["CustomerInAppMessage"] = "CustomerInAppMessage";
  EmailType2["CustomerPartialCancellation"] = "CustomerPartialCancellation";
  EmailType2["CustomerReminderReview"] = "CustomerReminderReview";
  EmailType2["CustomerWaitlistJoined"] = "CustomerWaitlistJoined";
  EmailType2["CustomerWaitlistOffered"] = "CustomerWaitlistOffered";
  EmailType2["DataPlusReport"] = "DataPlusReport";
  EmailType2["DefaultTemplate"] = "DefaultTemplate";
  EmailType2["ErrorUploadingPaymentNumber"] = "ErrorUploadingPaymentNumber";
  EmailType2["ExperienceApproved"] = "ExperienceApproved";
  EmailType2["ExperienceAvailabilityMissing"] = "ExperienceAvailabilityMissing";
  EmailType2["ExperienceDeleted"] = "ExperienceDeleted";
  EmailType2["ExperienceHostAssigned"] = "ExperienceHostAssigned";
  EmailType2["ExperienceHostUnassigned"] = "ExperienceHostUnassigned";
  EmailType2["ExperienceSubmitted"] = "ExperienceSubmitted";
  EmailType2["ExperienceUnavailabilityList"] = "ExperienceUnavailabilityList";
  EmailType2["ExperienceUnavailabilityReminderForHost"] = "ExperienceUnavailabilityReminderForHost";
  EmailType2["ExperienceUnpublished"] = "ExperienceUnpublished";
  EmailType2["HostBankAccountConnect"] = "HostBankAccountConnect";
  EmailType2["HostBookingCancelled"] = "HostBookingCancelled";
  EmailType2["HostBookingConfirmation"] = "HostBookingConfirmation";
  EmailType2["HostBookingReminder"] = "HostBookingReminder";
  EmailType2["HostBookingRescheduled"] = "HostBookingRescheduled";
  EmailType2["HostNotificationReview"] = "HostNotificationReview";
  EmailType2["HostPartialCancellation"] = "HostPartialCancellation";
  EmailType2["HostSignup"] = "HostSignup";
  EmailType2["OrganizationUserInvitation"] = "OrganizationUserInvitation";
  EmailType2["PaymentNumberUploaded"] = "PaymentNumberUploaded";
  EmailType2["PaymentRestricted"] = "PaymentRestricted";
  EmailType2["PromoterInvitation"] = "PromoterInvitation";
  EmailType2["PromoterRemoved"] = "PromoterRemoved";
  EmailType2["ProviderAccepted"] = "ProviderAccepted";
  EmailType2["ProviderDeclined"] = "ProviderDeclined";
  EmailType2["StaffUserInvitation"] = "StaffUserInvitation";
  EmailType2["RequestToBookCreated"] = "RequestToBookCreated";
  EmailType2["AuctionClosed"] = "AuctionClosed";
  EmailType2["AuctionWon"] = "AuctionWon";
  EmailType2["AuctionOutBid"] = "AuctionOutBid";
  EmailType2["AuctionHighestBid"] = "AuctionHighestBid";
  EmailType2["GuestRequestToBookCreated"] = "GuestRequestToBookCreated";
  return EmailType2;
})(EmailType || {});
var EmailPlaceholder = /* @__PURE__ */ ((EmailPlaceholder2) => {
  EmailPlaceholder2["confirmationCode"] = "confirmationCode";
  EmailPlaceholder2["experienceTitle"] = "experienceTitle";
  EmailPlaceholder2["experienceStartTime"] = "experienceStartTime";
  EmailPlaceholder2["experienceDate"] = "experienceDate";
  EmailPlaceholder2["brandName"] = "brandName";
  EmailPlaceholder2["refundedAmount"] = "refundedAmount";
  EmailPlaceholder2["experienceLocation"] = "experienceLocation";
  EmailPlaceholder2["meetingNotes"] = "meetingNotes";
  EmailPlaceholder2["totalBookedExperiences"] = "totalBookedExperiences";
  EmailPlaceholder2["listOfRemovedParticipants"] = "listOfRemovedParticipants";
  EmailPlaceholder2["claimTime"] = "claimTime";
  EmailPlaceholder2["winningBid"] = "winningBid";
  EmailPlaceholder2["experienceTime"] = "experienceTime";
  EmailPlaceholder2["auctionEndDate"] = "auctionEndDate";
  EmailPlaceholder2["auctionEndTime"] = "auctionEndTime";
  EmailPlaceholder2["leadingBid"] = "leadingBid";
  EmailPlaceholder2["bidderCurrentBid"] = "bidderCurrentBid";
  EmailPlaceholder2["bidderName"] = "bidderName";
  EmailPlaceholder2["bidderEmail"] = "bidderEmail";
  EmailPlaceholder2["purchaserName"] = "purchaserName";
  EmailPlaceholder2["arrivalDate"] = "arrivalDate";
  EmailPlaceholder2["departureDate"] = "departureDate";
  EmailPlaceholder2["currency"] = "currency";
  EmailPlaceholder2["rate"] = "rate";
  EmailPlaceholder2["description"] = "description";
  EmailPlaceholder2["emailMessage"] = "emailMessage";
  EmailPlaceholder2["policies"] = "policies";
  return EmailPlaceholder2;
})(EmailPlaceholder || {});

// src/api/event/participants.ts
import { z as z64 } from "zod";
var EventParticipantsResponse = z64.object({
  items: z64.array(BookingWithParticipantSchema)
});
var GetParticipantsForCollectionWebsocketSchema = z64.object({
  collectionId: z64.string().uuid(),
  eventDate: DateStringSchema,
  brandId: z64.string().uuid()
});
var GetCollectionEventParticipantsQuerySchema = z64.object({
  eventDate: DateStringSchema,
  brandId: z64.string().uuid(),
  q: z64.string().optional()
});
var GetEventParticipantsQuerySchema = z64.object({
  q: z64.string().optional()
});
var GetCollectionEventParticipantsEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    collectionId,
    query
  }) => `/v1/collection/${collectionId}/participants?${buildQueryString(query)}`,
  responseSchema: EventParticipantsResponse,
  requestSchema: z64.void(),
  querySchema: GetCollectionEventParticipantsQuerySchema
});
var GetEventParticipantsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ eventId, ...query }) => {
    const entries = Object.entries(query).filter((keyValue) => keyValue[1] !== void 0);
    return `events/${eventId}/participants?${new URLSearchParams(Object.fromEntries(entries)).toString()}`;
  },
  responseSchema: EventParticipantsResponse,
  requestSchema: z64.void()
});
var ParticipantsCheckInSchema = z64.object({
  items: z64.array(BookingWithParticipantSchema)
});
var PostParticipantsCheckInEndpoint = makeEndpoint({
  method: "POST",
  url: ({ eventId }) => `v1/events/${eventId}/participants/check-in`,
  responseSchema: ParticipantsCheckInSchema,
  requestSchema: z64.object({
    participantIds: z64.array(z64.string())
  })
});
var PostParticipantsCheckOutEndpoint = makeEndpoint({
  method: "POST",
  url: ({ eventId }) => `v1/events/${eventId}/participants/check-out`,
  responseSchema: ParticipantsCheckInSchema,
  requestSchema: z64.object({
    participantIds: z64.array(z64.string())
  })
});

// src/api/event/schedule.ts
import { z as z65 } from "zod";
var CreateSchedulesRequestSchema = z65.object({
  id: z65.string().uuid().optional(),
  startDate: DateStringSchema,
  startTimes: z65.array(TimeStringSchema).min(1),
  recurrencePattern: z65.object({
    weekdays: z65.array(z65.number().min(1).max(7)),
    until: DateStringSchema.nullable()
  }).optional(),
  sessionDuration: z65.number().int().min(1).optional(),
  experienceIds: z65.array(z65.string().uuid()).min(1),
  durations: z65.array(
    z65.object({
      experienceId: z65.string().uuid(),
      sessionDuration: z65.number().int().min(1)
    })
  ).optional()
});
var CreateSchedulesEndpoint = makeEndpoint({
  method: "POST",
  url: () => "/v2/schedules",
  responseSchema: z65.void(),
  requestSchema: CreateSchedulesRequestSchema.strict()
});
var GetSchedulesForExperienceEndpoint = makeEndpoint({
  method: "GET",
  url: () => "/v2/experiences/:experienceId/schedules",
  responseSchema: z65.void(),
  requestSchema: z65.void()
});
var UpdateScheduleEndpoint = makeEndpoint({
  method: "PATCH",
  url: () => "/v2/schedules/:scheduleId",
  responseSchema: z65.void(),
  requestSchema: z65.object({
    status: z65.enum(["scheduled", "cancelled"])
  })
});

// src/api/experience/experience.public.ts
import { z as z66 } from "zod";
var GetExperienceResourceGroupCollectionIdEndpointSchema = z66.object({
  resourceGroupCollectionId: z66.string().uuid()
});
var GetExperienceResourceGroupCollectionIdEndpoint = makeEndpoint({
  method: "GET",
  url: ({ experienceId }) => `/v1/experiences/${experienceId}/resource-group-collection-id`,
  requestSchema: z66.void(),
  responseSchema: GetExperienceResourceGroupCollectionIdEndpointSchema
});

// src/api/integration/add-ons.ts
import { z as z67 } from "zod";
var IntegrationAddOnSchema = z67.object({
  code: z67.string(),
  available: z67.boolean(),
  description: z67.string(),
  name: z67.string().optional()
});
var IntegrationAddOnsResponseSchema = z67.object({
  items: z67.array(IntegrationAddOnSchema)
});

// src/api/integration/alice.ts
import { z as z68 } from "zod";
var integrationPrefix = (brandId) => integrationUrl({ brandId, integrationType: "integrations:alice" /* ALICE */ });
var SendBookingEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `${integrationPrefix(brandId)}/send-booking`,
  requestSchema: z68.object({
    reservationId: z68.string(),
    bookingId: z68.string().uuid()
  }),
  responseSchema: z68.void()
});
var AliceCredentialSchema = z68.object({
  hotelId: z68.string()
});
var getAliceCredentialsEndpoint = makeEndpoint({
  url: ({ brandId }) => `${integrationPrefix(brandId)}/credential`,
  method: "GET",
  responseSchema: AliceCredentialSchema,
  requestSchema: z68.void()
});
var postAliceCredentialsEndpoint = makeEndpoint({
  url: ({ brandId }) => `${integrationPrefix(brandId)}/credential`,
  method: "POST",
  responseSchema: z68.void(),
  requestSchema: AliceCredentialSchema
});

// src/api/integration/analytics.ts
import { z as z69 } from "zod";
var ANALYTICS_EVENT = /* @__PURE__ */ ((ANALYTICS_EVENT2) => {
  ANALYTICS_EVENT2["VIEW_HOME"] = "view_home";
  ANALYTICS_EVENT2["VIEW_COLLECTION"] = "view_collection";
  ANALYTICS_EVENT2["VIEW_HOSTS"] = "view_hosts";
  ANALYTICS_EVENT2["VIEW_EVENTS"] = "view_activates";
  ANALYTICS_EVENT2["VIEW_ACTIVITIES"] = "view_activities";
  ANALYTICS_EVENT2["VIEW_ADDONS"] = "view_addons";
  ANALYTICS_EVENT2["CLICK_EXPERIENCE"] = "click_experience";
  ANALYTICS_EVENT2["VIEW_CALENDAR"] = "view_calendar";
  ANALYTICS_EVENT2["VIEW_EXPERIENCE_DETAIL"] = "view_experience_detail";
  ANALYTICS_EVENT2["RESERVABLE_EXPERIENCE_CLICK_BOOK_BUTTON"] = "reservable_experience_click_book_button";
  ANALYTICS_EVENT2["OPEN_EXPERIENCE_CLICK_BOOK_BUTTON"] = "open_experience_click_book_button";
  ANALYTICS_EVENT2["VIEW_PARTICIPANT_INFO"] = "view_participant_info";
  ANALYTICS_EVENT2["CLICK_ADD_TO_CART_BUTTON"] = "click_add_to_cart_button";
  ANALYTICS_EVENT2["CLICK_PROCEED_TO_CHECKOUT_BUTTON"] = "click_proceed_to_checkout_button";
  ANALYTICS_EVENT2["VIEW_CHECKOUT"] = "view_checkout";
  ANALYTICS_EVENT2["VIEW_BOOKING_CONFIRMATION"] = "view_booking_confirmation";
  ANALYTICS_EVENT2["CLICK_COMPLETE_PAYMENT_BUTTON"] = "click_complete_payment_button";
  return ANALYTICS_EVENT2;
})(ANALYTICS_EVENT || {});
var ANALYTICS_PROPERTY = /* @__PURE__ */ ((ANALYTICS_PROPERTY2) => {
  ANALYTICS_PROPERTY2["BrandName"] = "brandName";
  ANALYTICS_PROPERTY2["ListId"] = "listId";
  ANALYTICS_PROPERTY2["ListName"] = "listName";
  ANALYTICS_PROPERTY2["Products"] = "products";
  ANALYTICS_PROPERTY2["BrandId"] = "brandId";
  ANALYTICS_PROPERTY2["Url"] = "url";
  ANALYTICS_PROPERTY2["TimeStamp"] = "timestamp";
  ANALYTICS_PROPERTY2["UserAgent"] = "userAgent";
  ANALYTICS_PROPERTY2["QueryParams"] = "queryParams";
  ANALYTICS_PROPERTY2["SearchQuery"] = "searchQuery";
  ANALYTICS_PROPERTY2["BrowserLanguage"] = "browserLanguage";
  ANALYTICS_PROPERTY2["AppLanguage"] = "appLanguage";
  ANALYTICS_PROPERTY2["SessionStart"] = "sessionStart";
  ANALYTICS_PROPERTY2["ExperienceTitle"] = "experienceTitle";
  ANALYTICS_PROPERTY2["ExperienceId"] = "experienceId";
  ANALYTICS_PROPERTY2["ExperienceCategory"] = "experienceCategory";
  ANALYTICS_PROPERTY2["ExperienceOrder"] = "experienceOrder";
  ANALYTICS_PROPERTY2["TotalCartAmount"] = "totalCartAmount";
  ANALYTICS_PROPERTY2["CurrentCartAmount"] = "currentCartAmount";
  ANALYTICS_PROPERTY2["DiscountCode"] = "discountCode";
  ANALYTICS_PROPERTY2["PaymentMethod"] = "paymentMethod";
  ANALYTICS_PROPERTY2["CartExperiences"] = "cartExperiences";
  ANALYTICS_PROPERTY2["CartParticipants"] = "cartParticipants";
  ANALYTICS_PROPERTY2["CartConfirmationCode"] = "cartConfirmationCode";
  ANALYTICS_PROPERTY2["CartExperienceCount"] = "cartExperienceCount";
  ANALYTICS_PROPERTY2["IsBookable"] = "isBookable";
  ANALYTICS_PROPERTY2["TotalTaxAmount"] = "totalTaxAmount";
  ANALYTICS_PROPERTY2["CurrencyCode"] = "currencyCode";
  ANALYTICS_PROPERTY2["AllExperiences"] = "allExperiences";
  ANALYTICS_PROPERTY2["AllCategories"] = "allCategories";
  ANALYTICS_PROPERTY2["CartCategories"] = "cartCategories";
  ANALYTICS_PROPERTY2["CartExperienceAmount"] = "cartExperienceAmount";
  ANALYTICS_PROPERTY2["ExperienceAmount"] = "experienceAmount";
  ANALYTICS_PROPERTY2["ExperienceSubtotal"] = "experienceSubtotal";
  ANALYTICS_PROPERTY2["PreviousUrl"] = "previousUrl";
  ANALYTICS_PROPERTY2["CtaUrl"] = "ctaUrl";
  ANALYTICS_PROPERTY2["FilterSelects"] = "filterSelects";
  ANALYTICS_PROPERTY2["AddedAmount"] = "addedAmount";
  ANALYTICS_PROPERTY2["ExperienceCount"] = "experienceCount";
  ANALYTICS_PROPERTY2["SessionId"] = "sessionId";
  ANALYTICS_PROPERTY2["UserId"] = "userId";
  ANALYTICS_PROPERTY2["CartExperienceAvgAmount"] = "cartExperienceAvgAmount";
  ANALYTICS_PROPERTY2["CartExperiencesByPriceTier"] = "cartExperiencesByPriceTiers";
  ANALYTICS_PROPERTY2["CartExperiencesCategoriesByPriceTier"] = "cartExperiencesCategoriesByPriceTier";
  ANALYTICS_PROPERTY2["CartParticipantsCountByPriceTier"] = "cartParticipantsCountByPriceTier";
  ANALYTICS_PROPERTY2["CartExperiencesSubtotalByPriceTier"] = "cartExperiencesSubtotalByPriceTier";
  ANALYTICS_PROPERTY2["CartExperiencesPriceTiersCount"] = "cartExperiencesPriceTiersCount";
  ANALYTICS_PROPERTY2["CartPriceTiers"] = "cartPriceTiers";
  ANALYTICS_PROPERTY2["CurrentExperiencesByPriceTier"] = "currentExperiencesByPriceTiers";
  ANALYTICS_PROPERTY2["CurrentExperiencesCategoriesByPriceTier"] = "currentExperiencesCategoriesByPriceTier";
  ANALYTICS_PROPERTY2["CurrentParticipantsCountByPriceTier"] = "currentParticipantsCountByPriceTier";
  ANALYTICS_PROPERTY2["CurrentExperiencesSubtotalByPriceTier"] = "currentExperiencesSubtotalByPriceTier";
  ANALYTICS_PROPERTY2["CurrentExperiencesPriceTiersCount"] = "currentExperiencesPriceTiersCount";
  ANALYTICS_PROPERTY2["CurrentPriceTiers"] = "currentPriceTiers";
  ANALYTICS_PROPERTY2["MemberLoginType"] = "gp_member_login_type";
  ANALYTICS_PROPERTY2["MemberLoginStatus"] = "gp_login_status";
  ANALYTICS_PROPERTY2["MemberPointsBalance"] = "gp_points_balance";
  ANALYTICS_PROPERTY2["MemberLevel"] = "gp_level";
  ANALYTICS_PROPERTY2["MemberNumber"] = "gp_number";
  ANALYTICS_PROPERTY2["LanguageId"] = "language_id";
  ANALYTICS_PROPERTY2["ExperienceDate"] = "experience_date";
  ANALYTICS_PROPERTY2["ExperienceLocation"] = "experience_location";
  ANALYTICS_PROPERTY2["ExperienceProduct"] = "experience_product";
  ANALYTICS_PROPERTY2["ExperiencePrice"] = "experience_price";
  ANALYTICS_PROPERTY2["PageName"] = "page_name";
  ANALYTICS_PROPERTY2["PageType"] = "page_type";
  ANALYTICS_PROPERTY2["EventName"] = "event_name";
  ANALYTICS_PROPERTY2["ExperienceHotel"] = "experience_hotel";
  ANALYTICS_PROPERTY2["ExperienceSpiritCode"] = "experience_spirit_code";
  ANALYTICS_PROPERTY2["ExperienceVendor"] = "experience_vendor";
  return ANALYTICS_PROPERTY2;
})(ANALYTICS_PROPERTY || {});
var AnalyticsEventConfigurationSchema = z69.object({
  enabled: z69.boolean(),
  property_mapping: z69.record(z69.string())
});
var AnalyticsConfigurationSchema = z69.object({
  defaultTracking: z69.boolean().optional(),
  initializeSdk: z69.boolean().optional(),
  globalVariables: z69.record(z69.unknown()),
  events: z69.record(AnalyticsEventConfigurationSchema)
});
var publicIntegrationConfigUrl = ({ brandId }) => `v1/brands/${brandId}/integrations/analytics`;
var TealiumCredentialSchema = z69.object({
  profile: z69.string(),
  account: z69.string(),
  environment: z69.string()
});
var AnalyticsConfigEndpoint = makeEndpoint({
  method: "GET",
  url: publicIntegrationConfigUrl,
  responseSchema: IntegrationConfigResponseSchema,
  requestSchema: z69.void()
});
var AnalyticsEventRequestSchema = z69.object({
  providers: z69.array(z69.enum(Integrations["analytics" /* ANALYTICS */])).optional(),
  event: z69.nativeEnum(ANALYTICS_EVENT),
  payload: z69.record(z69.string())
});
var AnalyticsEventSchema = AnalyticsEventRequestSchema.extend({
  brandId: z69.string().uuid()
});
var AnalyticsEventEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `v1/brands/${brandId}/analytics/event`,
  responseSchema: z69.void(),
  requestSchema: AnalyticsEventRequestSchema
});
var GetAnalyticsIntegrationConfigEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, integrationType }) => `${integrationUrl({ brandId, integrationType })}/config`,
  responseSchema: AnalyticsConfigurationSchema,
  requestSchema: z69.void()
});
var GetAnalyticsIntegrationCredentialEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, integrationType }) => `${integrationUrl({ brandId, integrationType })}/credential`,
  responseSchema: TealiumCredentialSchema,
  requestSchema: z69.void()
});

// src/api/integration/gtmAnalytics.ts
import { z as z70 } from "zod";
var GtmIntegrationConfigResponse = AnalyticsConfigurationSchema.omit({
  initializeSdk: true
}).extend({
  defaultTracking: z70.boolean()
});
var Ga4IntegrationConfigResponse = AnalyticsConfigurationSchema.omit({
  initializeSdk: true
}).extend({
  enabled: z70.boolean()
});
var GetGtmIntegrationConfigEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `${integrationUrl({ brandId, integrationType: "integrations:gtmAnalytics" /* GTM_ANALYTICS */ })}/config`,
  responseSchema: GtmIntegrationConfigResponse,
  requestSchema: z70.void()
});

// src/api/integration/guests.ts
import { z as z71 } from "zod";
var GetIntegrationGuestRequestQuerySchema = z71.object({
  firstName: z71.string(),
  lastName: z71.string(),
  reservationId: z71.string(),
  emailAddress: z71.string(),
  phoneNumber: z71.string(),
  arrivalDate: z71.string(),
  departureDate: z71.string(),
  roomNumber: z71.string()
}).partial().strict();
var GetIntegrationGuestResponseSchema = z71.object({
  data: z71.array(
    z71.object({
      reservationId: z71.string(),
      confirmationId: z71.string(),
      arrivalDate: z71.string(),
      departureDate: z71.string(),
      status: z71.string(),
      firstName: z71.string().optional(),
      lastName: z71.string().optional(),
      email: z71.string().optional(),
      phoneNumber: z71.string().optional(),
      roomNumber: z71.string().optional()
    })
  )
});

// src/api/integration/opera.ts
import { z as z72 } from "zod";
var OperaAuthMethod = /* @__PURE__ */ ((OperaAuthMethod2) => {
  OperaAuthMethod2["RESOURCE_BASED"] = "resource-based";
  OperaAuthMethod2["CLIENT_CREDENTIALS"] = "client-credentials";
  return OperaAuthMethod2;
})(OperaAuthMethod || {});
var OperaHotelDetailsSchema = z72.object({
  region: z72.string(),
  tenantCode: z72.string(),
  hotelId: z72.string(),
  ssdUrl: z72.string()
});
var OperaResourceBasedCredentialsSchema = OperaHotelDetailsSchema.extend({
  authMethod: z72.literal("resource-based" /* RESOURCE_BASED */).default("resource-based" /* RESOURCE_BASED */),
  appKey: z72.string(),
  host: z72.string(),
  clientId: z72.string(),
  clientSecret: z72.string(),
  extSystemCode: z72.string(),
  username: z72.string(),
  password: z72.string()
});
var OperaClientCredentialsSchema = OperaHotelDetailsSchema.extend({
  authMethod: z72.literal("client-credentials" /* CLIENT_CREDENTIALS */),
  appKey: z72.string(),
  host: z72.string(),
  clientId: z72.string(),
  clientSecret: z72.string(),
  extSystemCode: z72.string(),
  enterpriseId: z72.string()
});
var OperaCredentialsSchema = z72.union([OperaResourceBasedCredentialsSchema, OperaClientCredentialsSchema]);

// src/api/included/included.ts
import { z as z73 } from "zod";
var IncludedField = /* @__PURE__ */ ((IncludedField2) => {
  IncludedField2["INCLUDED_LABEL"] = "includedLabel";
  return IncludedField2;
})(IncludedField || {});
var ResponseListingIncludedSchema = z73.object({
  id: z73.string().uuid(),
  includedLabel: z73.string(),
  order: z73.number().nullable()
});
var GetListingIncludedQuerySchema = z73.object({
  experienceId: z73.string().uuid(),
  resourceGroupCollectionId: z73.string().uuid(),
  resourceGroupId: z73.string().uuid(),
  version: z73.nativeEnum(ExperienceVersion)
}).partial({ experienceId: true, resourceGroupCollectionId: true, resourceGroupId: true }).strict().refine(
  (value) => !!value.experienceId || !!value.resourceGroupCollectionId || !!value.resourceGroupId,
  "At least one of experienceId, resourceGroupCollectionId, or resourceGroupId must be provided."
);
var GetListingIncludedEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `v1/listing-included?${buildQueryString(query)}`,
  responseSchema: z73.object({ included: z73.array(ResponseListingIncludedSchema) }).strict(),
  requestSchema: z73.void(),
  querySchema: GetListingIncludedQuerySchema
});
var PostListingIncludedRequestSchema = z73.object({
  includedLabel: z73.string(),
  experienceId: z73.string().uuid(),
  resourceGroupCollectionId: z73.string().uuid(),
  resourceGroupId: z73.string().uuid(),
  order: z73.number().nullable(),
  version: z73.nativeEnum(ExperienceVersion)
}).partial({ experienceId: true, resourceGroupCollectionId: true, resourceGroupId: true }).strict().refine(
  (value) => !!value.experienceId || !!value.resourceGroupCollectionId || !!value.resourceGroupId,
  "At least one of experienceId, resourceGroupCollectionId, or resourceGroupId must be provided."
);
var PostListingIncludedEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/listing-included`,
  responseSchema: z73.void(),
  requestSchema: PostListingIncludedRequestSchema,
  querySchema: z73.void()
});

// src/api/listing/revenue.ts
import { z as z74 } from "zod";
var GetListingRevenueResponseSchema = z74.object({
  priceTiers: z74.array(
    z74.object({
      priceTierId: z74.string().nullable(),
      priceTierName: z74.string(),
      revenue: z74.number(),
      participantCount: z74.number()
    })
  ),
  totalCapacity: z74.number()
});
var GetListingRevenueQuerySchema = z74.object({
  date: DateStringSchema,
  startTime: TimeStringSchema.optional(),
  sessionDuration: z74.string().pipe(z74.coerce.number().positive()).optional()
  // minutes
});
var GetListingRevenueEndpoint = makeEndpoint({
  method: "GET",
  url: ({ listingId, query }) => `/v1/listings/${listingId}/revenue?${buildQueryString(query)}`,
  requestSchema: z74.void(),
  responseSchema: GetListingRevenueResponseSchema,
  querySchema: GetListingRevenueQuerySchema
});

// src/api/listing/sessions.ts
import { z as z75 } from "zod";
var PublicGetListingSessionsQuerySchema = z75.object({
  from: DateStringSchema,
  to: DateStringSchema,
  resourceGroupId: z75.string().uuid().optional(),
  experienceId: z75.string().uuid().optional(),
  version: z75.nativeEnum(ListingVersion).optional(),
  includeEventsAfterBookingDeadline: z75.literal("true").optional(),
  waitlistEntryId: z75.string().uuid().optional()
});
var PublicGetListingSessionsResponseSchema = z75.object({
  sessions: z75.array(
    z75.object({
      sessionId: z75.string().uuid().nullable(),
      scheduleId: z75.string().uuid().nullable(),
      isRepeating: z75.boolean(),
      isPrivateEvent: z75.boolean(),
      priceTiers: z75.array(PriceTierSchema.required({ maxQuantity: true }).extend({ participantsCount: z75.number().min(0) })),
      startDateTime: LocalDateTimeStringSchema,
      duration: z75.number().int().positive(),
      participantCount: z75.number().int().nonnegative(),
      capacity: z75.number().nullable(),
      // open experiences do not have a capacity
      experienceId: z75.string().uuid(),
      status: z75.nativeEnum(SessionStatus),
      hostedBy: HostSchema.nullable()
    })
  )
});
var PublicGetListingSessionsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ listingId, query }) => `/v1/listings/${listingId}/sessions?${buildQueryString(query)}`,
  responseSchema: PublicGetListingSessionsResponseSchema,
  requestSchema: z75.void(),
  querySchema: PublicGetListingSessionsQuerySchema
});

// src/api/media/endpoints.ts
import { z as z76 } from "zod";
var CreateSignedUrlsEndpoint = makeEndpoint({
  method: "POST",
  url: () => "/v1/media/signed-urls",
  requestSchema: z76.object({
    fileNames: z76.array(z76.string())
  }),
  responseSchema: z76.array(
    z76.object({
      mediaId: z76.string().uuid(),
      signedUrl: z76.string()
    })
  )
});
var ProcessVideosEndpoint = makeEndpoint({
  method: "POST",
  url: () => "/v1/media/videos/process",
  requestSchema: z76.object({
    mediaIds: z76.array(z76.string().uuid())
  }),
  responseSchema: z76.void()
});
var UploadDocumentEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId }) => `v1/brands/${brandId}/documents`,
  responseSchema: DocumentSchema,
  requestSchema: UploadDocumentRequestSchema
});
var GetDocumentsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `v1/brands/${brandId}/documents?${buildQueryString(query)}`,
  responseSchema: GetDocumentsResponseSchema,
  requestSchema: z76.void(),
  querySchema: GetDocumentsQuerySchema
});
var GetDocumentSignedUrlEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, documentId }) => `v1/brands/${brandId}/documents/${documentId}/signed-url`,
  responseSchema: GetDocumentSignedUrlResponseSchema,
  requestSchema: z76.void()
});
var UpdateDocumentEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId, documentId }) => `v1/brands/${brandId}/documents/${documentId}`,
  responseSchema: DocumentSchema,
  requestSchema: UpdateDocumentRequestSchema
});
var DeleteDocumentEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ brandId, documentId }) => `v1/brands/${brandId}/documents/${documentId}`,
  responseSchema: z76.void(),
  requestSchema: z76.void()
});

// src/api/metrics/endpoints.ts
import { z as z77 } from "zod";
var Metric = /* @__PURE__ */ ((Metric2) => {
  Metric2["CART_COUNT"] = "cart_count";
  Metric2["NET_AMOUNT"] = "net_amount";
  Metric2["TOTAL_PAID"] = "total_paid";
  Metric2["NET_REVENUE"] = "net_revenue";
  Metric2["ALL"] = "all";
  return Metric2;
})(Metric || {});
var requestSchema = z77.object({
  start_datetime: z77.string(),
  end_datetime: z77.string(),
  metric: z77.nativeEnum(Metric),
  property_code: z77.string().optional(),
  confirmation_code: z77.string().optional()
}).refine((data) => new Date(data.end_datetime) >= new Date(data.start_datetime), {
  message: "end_datetime must be after or equal to start_datetime",
  path: ["end_datetime"]
});
var sharedResponseSchema = z77.object({
  brandIds: z77.number(),
  propertyCode: z77.string().nullable()
});
var responseSchema = z77.union([
  sharedResponseSchema.merge(
    z77.object({ metric: z77.literal("cart_count" /* CART_COUNT */), results: z77.object({ confirmationCodesCount: z77.number() }) })
  ),
  sharedResponseSchema.merge(
    z77.object({ metric: z77.literal("net_amount" /* NET_AMOUNT */), results: z77.object({ netAmount: z77.number() }) })
  ),
  sharedResponseSchema.merge(
    z77.object({ metric: z77.literal("total_paid" /* TOTAL_PAID */), results: z77.object({ totalPaid: z77.number() }) })
  ),
  sharedResponseSchema.merge(
    z77.object({ metric: z77.literal("net_revenue" /* NET_REVENUE */), results: z77.object({ netRevenue: z77.number() }) })
  ),
  sharedResponseSchema.merge(
    z77.object({
      metric: z77.literal("all" /* ALL */),
      results: z77.object({
        confirmationCodesCount: z77.number(),
        total: z77.number(),
        discountAmount: z77.number(),
        subtotal: z77.number(),
        taxesNotIncludedInPrice: z77.number(),
        taxesIncludedInPrice: z77.number(),
        totalPaid: z77.number(),
        hostPayout: z77.number(),
        creditCardFee: z77.number(),
        netDeposited: z77.number(),
        grossAmount: z77.number(),
        grossRevenue: z77.number(),
        netAmount: z77.number(),
        netRevenue: z77.number()
      })
    })
  )
]);
var GetMetricsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `v1/metrics?${buildQueryString(query)}`,
  responseSchema,
  requestSchema
});

// src/api/organization/organization.ts
import { z as z78 } from "zod";
var OrganizationRole = /* @__PURE__ */ ((OrganizationRole2) => {
  OrganizationRole2["ADMIN"] = "admin";
  return OrganizationRole2;
})(OrganizationRole || {});
var OrganizationSchema = z78.object({
  id: z78.string().uuid(),
  name: z78.string().trim().min(1, "Name is required"),
  segment: z78.string().nullable(),
  parentOrganizationId: z78.string().uuid("Invalid organization id supplied as parent organization").nullable().optional()
});
var OrganizationTreeSchema = OrganizationSchema.extend({
  brandCount: z78.number().optional(),
  userCount: z78.number().optional(),
  userPermissions: z78.array(z78.string()).optional(),
  childOrganizations: z78.lazy(() => OrganizationTreeSchema.array())
});
var OrganizationDetailResponseSchema = OrganizationSchema.pick({
  id: true,
  name: true,
  segment: true,
  parentOrganizationId: true
}).extend({
  products: z78.array(z78.nativeEnum(ProductLine)).nullable(),
  userPermissions: z78.array(z78.string()),
  parentOrganizationName: z78.string().nullable(),
  childrenOrganizations: OrganizationTreeSchema.array().optional(),
  isTopLevel: z78.boolean().optional(),
  createdById: z78.string().uuid().nullable(),
  createdAt: z78.string().datetime(),
  updatedAt: z78.string().datetime(),
  deletedAt: z78.string().datetime().nullable()
});
var CreateOrganizationSchema = OrganizationSchema.pick({
  name: true,
  segment: true,
  parentOrganizationId: true
});
var CreateOrganizationFormSchema = OrganizationSchema.pick({
  name: true,
  parentOrganizationId: true
}).extend({
  segment: z78.array(z78.string().nullable())
});
var UpdateOrganizationSchema = OrganizationSchema.pick({
  name: true,
  segment: true,
  parentOrganizationId: true
}).partial().strict();
var UpdateOrganizationFormSchema = OrganizationSchema.pick({
  name: true,
  parentOrganizationId: true
}).extend({
  segment: z78.array(z78.string().nullable())
}).partial().strict();
var OrganizationPaginatedResponseSchema = paginateResponseSchema(
  OrganizationSchema.pick({
    id: true,
    name: true,
    segment: true,
    parentOrganizationId: true
  }).extend({
    products: z78.array(z78.nativeEnum(ProductLine)).nullable(),
    brandCount: z78.number(),
    userCount: z78.number(),
    userPermissions: z78.array(z78.string()).optional(),
    childOrganizations: OrganizationTreeSchema.array()
  })
).strict();
var OrganizationTreeResponseSchema = OrganizationSchema.pick({
  name: true,
  segment: true,
  parentOrganizationId: true
}).extend({
  childOrganizations: OrganizationTreeSchema.array().optional()
});
var MinimalOrganizationListResponseSchema = z78.array(
  OrganizationSchema.pick({
    id: true,
    name: true,
    segment: true,
    parentOrganizationId: true
  }).extend({
    childOrganizations: OrganizationTreeSchema.array()
  })
);
var OrganizationSortBy = /* @__PURE__ */ ((OrganizationSortBy2) => {
  OrganizationSortBy2["NAME"] = "name";
  OrganizationSortBy2["CREATED_AT"] = "createdAt";
  return OrganizationSortBy2;
})(OrganizationSortBy || {});
var PaginatedOrganizationsRequestQuerySchema = z78.object({
  q: z78.string().optional(),
  parentOrganizationId: z78.string().uuid().optional(),
  subOrganizations: z78.boolean().or(BooleanStringSchema.transform((str) => str.toLowerCase() === "true")).optional(),
  page: z78.coerce.number().min(1).default(1),
  limit: z78.coerce.number().min(1).default(10),
  sortBy: z78.nativeEnum(OrganizationSortBy).optional(),
  sortDir: z78.nativeEnum(SortOrder).optional()
}).strict();
var MinimalOrganizationListRequestQuerySchema = PaginatedOrganizationsRequestQuerySchema.pick({
  q: true,
  parentOrganizationId: true,
  subOrganizations: true
});
var BooleanQuerySchema = BooleanStringSchema.transform((str) => str.toLowerCase() === "true");
var OrganizationsDetailRequestQuerySchema = z78.object({
  showChildren: BooleanQuerySchema.optional(),
  showIsTopLevel: BooleanQuerySchema.optional()
}).strict();
var OrganizationFeatureFlagsResponseSchema = z78.object({
  ["apiAccess" /* API_ACCESS */]: z78.boolean()
});
var AssignBrandToOrganizationSchema = z78.object({
  brandIds: z78.array(z78.string().uuid()).min(1)
}).strict();
var AssignBrandToOrganizationEndpoint = makeEndpoint({
  method: "POST",
  url: ({ organizationId }) => `v1/organizations/${organizationId}/brands`,
  responseSchema: z78.void(),
  requestSchema: AssignBrandToOrganizationSchema
});
var RemoveBrandFromOrganizationEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ organizationId, brandId }) => `v1/organizations/${organizationId}/brands/${brandId}`,
  responseSchema: z78.void(),
  requestSchema: z78.void()
});
var AssignOrganizationToAnotherOrganizationSchema = z78.object({
  organizationId: z78.string().uuid()
}).strict();
var AssignOrganizationToAnotherOrganizationEndpoint = makeEndpoint({
  method: "POST",
  url: ({ organizationId }) => `v1/organizations/${organizationId}/organizations`,
  responseSchema: z78.void(),
  requestSchema: AssignOrganizationToAnotherOrganizationSchema
});
var PaginatedOrganizationsEndpoint = makeEndpoint({
  method: "GET",
  url: () => `v1/organizations`,
  responseSchema: OrganizationPaginatedResponseSchema,
  requestSchema: PaginatedOrganizationsRequestQuerySchema
});
var PaginatedMinimalOrganizationsEndpoint = makeEndpoint({
  method: "GET",
  url: () => `v1/organizations/minimal`,
  responseSchema: MinimalOrganizationListResponseSchema,
  requestSchema: MinimalOrganizationListRequestQuerySchema
});
var GetOrganizationEndpoint = makeEndpoint({
  method: "GET",
  url: ({ organizationId }) => `v1/organizations/${organizationId}`,
  responseSchema: OrganizationDetailResponseSchema,
  requestSchema: OrganizationsDetailRequestQuerySchema
});
var CreateOrganizationEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/organizations`,
  responseSchema: z78.void(),
  requestSchema: CreateOrganizationSchema
});
var UpdateOrganizationEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ organizationId }) => `v1/organizations/${organizationId}`,
  responseSchema: z78.void(),
  requestSchema: UpdateOrganizationSchema
});
var DeleteOrganizationEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ organizationId }) => `v1/organizations/${organizationId}`,
  responseSchema: z78.void(),
  requestSchema: z78.void()
});
var MinimalOrganizationListEndpoint = makeEndpoint({
  method: "GET",
  url: () => `v1/organizations/minimal`,
  responseSchema: MinimalOrganizationListResponseSchema,
  requestSchema: MinimalOrganizationListRequestQuerySchema
});
var BrandsDashboardStatsResponseSchema = z78.object({
  totalBookingAmount: z78.number(),
  averageBookingAmount: z78.number(),
  averageBookingWindowInMinutes: z78.number(),
  totalParticipantCount: z78.number(),
  averageParticipantCount: z78.number(),
  averageRating: z78.number().nullable(),
  netPromoterScore: z78.number().nullable(),
  netProfit: z78.number(),
  totalHostEarning: z78.number(),
  totalEarned: z78.number(),
  futurePayout: z78.number()
});
var BrandsReviewSummaryResponseSchema = paginateResponseSchema(
  z78.object({
    host: MinimalHostSchema.optional(),
    brand: BrandSchema.pick({ id: true, name: true }).extend({ logo: IMediaReferenceSchema.nullable() }).optional(),
    experience: z78.object({ id: z78.string(), title: z78.string(), coverPicture: IMediaReferenceSchema.nullable() }).optional(),
    resourceGroup: z78.object({ id: z78.string(), title: z78.string(), coverPicture: IMediaReferenceSchema.nullable() }).optional(),
    totalReviews: z78.number(),
    averageRating: z78.number(),
    npsScore: z78.number().nullable(),
    reviewPercentage: z78.number()
  })
).strict();
var OrganizationFeatureFlagsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ organizationId }) => `v1/organizations/${organizationId}/features`,
  responseSchema: OrganizationFeatureFlagsResponseSchema,
  requestSchema: z78.void()
});
var NestedOrganizationMembershipsOfUserResponseSchema = z78.object({
  id: z78.string(),
  membershipOrganizationId: z78.string(),
  permissions: z78.array(z78.string())
});
var GetNestedOrganizationMembershipsOfUserResponseSchemaEndpoint = makeEndpoint({
  method: "GET",
  url: () => `v1/organizations/me/memberships`,
  responseSchema: z78.array(NestedOrganizationMembershipsOfUserResponseSchema),
  requestSchema: z78.void()
});
var GetOrganizationPromoterBrandsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ organizationId }) => `v1/organizations/${organizationId}/promoter-brands`,
  responseSchema: z78.array(BrandSchema),
  requestSchema: z78.void()
});
var UpdatePromoterAgreementApprovalResponseSchema = z78.object({
  id: z78.string().uuid()
});
var UpdatePromoterAgreementApprovalSchema = z78.object({
  status: z78.nativeEnum(PromoterAgreementStatus),
  updatedByUserId: z78.string().uuid()
});
var UpdatePromoterAgreementApprovalEndpoint = makeEndpoint({
  method: "POST",
  url: ({ organizationId, agreementId }) => `v1/organizations/${organizationId}/promoter-agreement/${agreementId}/update-approval`,
  responseSchema: UpdatePromoterAgreementApprovalResponseSchema,
  requestSchema: UpdatePromoterAgreementApprovalSchema
});
var GetActiveOrganizationAgreementEndpointResponseSchema = z78.array(
  z78.object({
    id: z78.string().uuid()
  })
);
var GetActiveOrganizationAgreementEndpoint = makeEndpoint({
  method: "GET",
  url: ({ organizationId, promoterId }) => `v1/organizations/${organizationId}/promoters/${promoterId}/promoter-agreement`,
  responseSchema: GetActiveOrganizationAgreementEndpointResponseSchema,
  requestSchema: z78.void()
});

// src/api/organization/user.ts
import { z as z79 } from "zod";
var OrganizationUserStatus = /* @__PURE__ */ ((OrganizationUserStatus2) => {
  OrganizationUserStatus2["ACTIVE"] = "active";
  OrganizationUserStatus2["INVITED"] = "invited";
  return OrganizationUserStatus2;
})(OrganizationUserStatus || {});
var OrganizationUserFilterQuery = /* @__PURE__ */ ((OrganizationUserFilterQuery2) => {
  OrganizationUserFilterQuery2["ORGANIZATION_ADMIN"] = "orgAdmin";
  OrganizationUserFilterQuery2["ALL"] = "all";
  return OrganizationUserFilterQuery2;
})(OrganizationUserFilterQuery || {});
var OrganizationUserStatusesSchema = z79.nativeEnum(OrganizationUserStatus);
var OrganizationUserRolesSchema = z79.nativeEnum(OrganizationRole);
var OrganizationUserSchema = z79.object({
  profilePicture: z79.object({
    id: z79.string(),
    uri: z79.object({ original: z79.string() }).and(z79.record(z79.string()))
  }).nullable(),
  firstName: z79.string(),
  lastName: z79.string(),
  emailAddress: EmailStringSchema,
  phoneNumber: z79.string().nullable(),
  role: OrganizationUserRolesSchema,
  title: z79.string().nullable(),
  status: OrganizationUserStatusesSchema,
  permissions: z79.array(z79.nativeEnum(PERMISSION)),
  products: z79.array(z79.nativeEnum(ProductLine)).nullable(),
  id: z79.string().uuid()
});
var OrganizationPaginatedUserSchema = OrganizationUserSchema.pick({
  profilePicture: true,
  firstName: true,
  lastName: true,
  emailAddress: true,
  phoneNumber: true,
  title: true,
  status: true,
  permissions: true,
  products: true,
  id: true
}).extend({
  role: z79.union([OrganizationUserRolesSchema, BrandMembershipRolesSchema]),
  isOrganizationUser: z79.boolean().optional(),
  lastAccessedAt: z79.string().nullable().optional(),
  associatedOrgIds: z79.array(z79.string()).optional(),
  associatedBrandIds: z79.array(z79.string()).optional()
});
var PaginatedOrganizationUsersResponseSchema = paginateResponseSchema(OrganizationPaginatedUserSchema);
var PaginatedOrganizationUsersRequestQuerySchema = paginateQuerySchema({
  sortBy: ["firstName", "lastName", "role", "status"]
}).extend({ role: z79.nativeEnum(OrganizationUserFilterQuery) });
var CreateOrganizationUserRequestSchema = OrganizationUserSchema.pick({
  emailAddress: true,
  firstName: true,
  lastName: true,
  permissions: true,
  products: true
}).partial({ products: true });
var CreateOrganizationUsersResponseSchema = OrganizationUserSchema;
var UpdateOrganizationUsersRequestSchema = OrganizationUserSchema.pick({
  emailAddress: true,
  firstName: true,
  lastName: true,
  role: true,
  permissions: true,
  products: true
}).partial();
var UpdateOrganizationUsersResponseSchema = OrganizationUserSchema;
var GetOrganizationUsersEndpoint = makeEndpoint({
  method: "GET",
  url: ({ organizationId }) => `v1/organizations/${organizationId}/users`,
  responseSchema: PaginatedOrganizationUsersResponseSchema,
  requestSchema: PaginatedOrganizationUsersRequestQuerySchema
});
var AddOrganizationUserEndpoint = makeEndpoint({
  method: "POST",
  url: ({ organizationId }) => `v1/organizations/${organizationId}/users`,
  responseSchema: z79.void(),
  requestSchema: CreateOrganizationUserRequestSchema
});
var UpdateOrganizationUserEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ organizationId, userId }) => `v1/organizations/${organizationId}/users/${userId}`,
  responseSchema: z79.void(),
  requestSchema: UpdateOrganizationUsersRequestSchema
});
var DeleteOrganizationAdminEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ organizationId, userId }) => `v1/organizations/${organizationId}/users/${userId}`,
  responseSchema: z79.void(),
  requestSchema: z79.void()
});
var ResendOrganizationUserInviteEndpoint = makeEndpoint({
  method: "POST",
  url: ({ organizationId, userId }) => `v1/organizations/${organizationId}/members/${userId}/resend-invitation`,
  responseSchema: z79.void(),
  requestSchema: z79.void()
});

// src/api/promoter/endpoints.ts
import { z as z80 } from "zod";
var FindPromoterResponseSchema = z80.object({
  id: z80.string().uuid(),
  brandId: z80.string().uuid(),
  status: z80.nativeEnum(PromoterStatus),
  name: z80.string(),
  description: z80.string(),
  experienceUrl: z80.string().nullable(),
  approvalMode: z80.nativeEnum(PromoterApprovalMode),
  defaultPercentCommission: z80.number().lte(1).nullable(),
  defaultFlatCommission: z80.number().nullable(),
  updatedByUserId: z80.string().uuid().nullable()
});
var FindPromoterEndpoint = makeEndpoint({
  method: "GET",
  url: ({ promoterId }) => `v1/promoters/${promoterId}`,
  responseSchema: FindPromoterResponseSchema,
  requestSchema: z80.void()
});
var FindApprovedPromotersByBrandResponseSchema = z80.array(
  z80.object({
    id: z80.string().uuid(),
    brandId: z80.string().uuid(),
    status: z80.nativeEnum(PromoterStatus),
    name: z80.string(),
    description: z80.string()
  })
);
var FindApprovedPromotersByBrandEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/promoters/approved-promoters-by-brand/${brandId}`,
  responseSchema: FindApprovedPromotersByBrandResponseSchema,
  requestSchema: z80.void()
});
var UpdateProviderListingStatusSchema = z80.object({
  promoterId: z80.string().uuid(),
  isApproved: z80.boolean(),
  providerUserId: z80.string().uuid()
});
var UpdateProviderListingStatusEndpoint = makeEndpoint({
  method: "POST",
  url: ({ providerBrandId, listingId }) => `v1/providers/${providerBrandId}/listings/${listingId}/update-approval`,
  responseSchema: z80.void(),
  requestSchema: UpdateProviderListingStatusSchema
});
var UpdatePromoterListingStatusSchema = z80.object({
  isApproved: z80.boolean(),
  promoterUserId: z80.string().uuid()
});
var UpdatePromoterListingStatusEndpoint = makeEndpoint({
  method: "POST",
  url: ({ promoterId, promotedListingId }) => `v1/promoters/${promoterId}/promoted-listings/${promotedListingId}/update-approval`,
  responseSchema: z80.void(),
  requestSchema: UpdatePromoterListingStatusSchema
});
var FindApprovedPromotedIdsByBrandSchema = z80.object({
  promoterId: z80.string().uuid().nullable(),
  promoterBrandId: z80.string().nullable(),
  promotedListingId: z80.string().uuid().nullable(),
  listingId: z80.string().uuid().nullable()
});
var FindApprovedPromotedIdsByBrandEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/providers/${brandId}/promoter-ids`,
  responseSchema: z80.array(FindApprovedPromotedIdsByBrandSchema),
  requestSchema: z80.void()
});
var FindActivePromoterAgreementSchema = z80.object({
  id: z80.string().uuid(),
  promoterId: z80.string().uuid(),
  promoterName: z80.string(),
  promoterDescription: z80.string(),
  promoterBrandId: z80.string().uuid(),
  isPublicChannel: z80.boolean(),
  status: z80.nativeEnum(PromoterAgreementStatus),
  providerOrganizationId: z80.string().uuid().nullable(),
  providerBrandId: z80.string().uuid().nullable(),
  providerListingId: z80.string().uuid().nullable(),
  percentCommission: z80.number().nullable(),
  flatCommission: z80.number().nullable(),
  currency: z80.string().nullable(),
  agreementStartDate: z80.date().nullable(),
  agreementEndDate: z80.date().nullable()
});
var FindActivePromoterAgreementEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, promoterId }) => `v1/providers/${brandId}/promoters/${promoterId}/agreement`,
  responseSchema: FindActivePromoterAgreementSchema.nullable(),
  requestSchema: z80.void()
});
var FindActivePromoterAgreementsSchema = z80.array(FindActivePromoterAgreementSchema);
var FindActivePromoterAgreementsEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/providers/${brandId}/promoter-agreements`,
  responseSchema: FindActivePromoterAgreementsSchema,
  requestSchema: z80.void()
});
var GetListingsForPromoterQuerySchema = paginateQuerySchema({
  sortBy: ["startingPrice", "rating", "order", "featuredOrder", "firstAvailableDate", "createdAt", "publishedAt"]
}).omit({ filters: true }).extend({
  kinds: z80.array(z80.nativeEnum(ListingKind)).optional(),
  productLines: z80.array(z80.nativeEnum(ProductLine)).optional(),
  categories: z80.array(z80.string()).optional(),
  isUnlisted: BooleanStringSchema.optional(),
  participantCount: z80.coerce.number().optional(),
  customFields: z80.array(z80.object({ externalId: z80.string(), value: z80.string() })).optional(),
  from: z80.string().optional(),
  to: z80.string().optional(),
  language: z80.nativeEnum(LanguageCode).optional(),
  categoryIds: z80.array(z80.string().uuid()).optional(),
  vibeIds: z80.array(z80.string().uuid()).optional(),
  featured: z80.literal("true").optional()
});
var customField2 = z80.object({
  externalId: z80.string().nullable().optional(),
  name: z80.string(),
  values: z80.array(z80.string().nullable())
});
var GetListingsForPromoterResponseSchema = z80.object({
  id: z80.string().uuid(),
  title: z80.string(),
  description: z80.string(),
  summary: z80.string().nullable(),
  experienceId: z80.string().uuid().nullable(),
  resourceGroupCollectionId: z80.string().uuid().nullable(),
  kind: z80.nativeEnum(ListingKind),
  productLine: z80.nativeEnum(ProductLine),
  startingPrice: z80.number().nullable(),
  pricePerType: z80.string().nullable(),
  minParticipants: z80.number().nullable(),
  maxParticipants: z80.number().nullable(),
  coverMedia: MediaSchema.omit({ order: true }).required({ kind: true }),
  brandId: z80.string().uuid().nullable(),
  brandCurrency: z80.string().nullable(),
  externalBrandReferenceId: z80.string().nullable().optional(),
  location: z80.object({
    longitude: z80.number(),
    latitude: z80.number(),
    name: z80.string(),
    timezoneId: z80.string(),
    additionalInfo: z80.string().nullable()
  }),
  slug: z80.string().nullable(),
  customFields: z80.array(customField2).optional(),
  rating: z80.number().nullable(),
  categoryName: z80.string().nullable(),
  dates: z80.array(z80.date()).nullable(),
  hidePrice: z80.boolean().nullable(),
  isUnlisted: z80.boolean().nullable(),
  bookingAvailabilityMode: z80.nativeEnum(BookingAvailabilityModeValue).nullable(),
  isExclusive: z80.boolean(),
  category: z80.object({ id: z80.string(), name: z80.string() }).nullable(),
  vibes: z80.array(z80.object({ id: z80.string(), name: z80.string() })),
  medias: z80.array(MediaSchema.omit({ order: true }).required({ kind: true })),
  hostedById: z80.string().nullable(),
  featuredOrder: z80.number().nullable(),
  order: z80.number().nullable(),
  createdAt: z80.string().datetime().nullable(),
  publishedAt: z80.string().datetime().nullable(),
  firstAvailableDate: z80.date().nullable()
});
var GetListingsForPromoterEndpoint = makeEndpoint({
  method: "GET",
  url: ({ promoterId, query }) => `v1/promoters/${promoterId}/listings?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(GetListingsForPromoterResponseSchema),
  requestSchema: z80.void(),
  querySchema: GetListingsForPromoterQuerySchema
});
var ProviderListingStatusSchema = z80.array(
  z80.object({
    promoterId: z80.string().uuid(),
    promoterName: z80.string(),
    promoterDescription: z80.string(),
    promoterBrandId: z80.string().uuid(),
    promoterLogoUri: z80.string().nullable(),
    percentCommission: z80.number(),
    promotedListingId: z80.string().uuid().nullable().optional(),
    listingId: z80.string().uuid().nullable().optional(),
    status: z80.nativeEnum(PromotedListingStatus).nullable().optional()
  })
);
var GetProviderListingStatusEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, listingId }) => `v1/providers/${brandId}/listings/${listingId}/status`,
  responseSchema: ProviderListingStatusSchema,
  requestSchema: z80.void()
});
var promoterListingStatusObject = z80.object({
  listingId: z80.string().uuid(),
  providerBrandId: z80.string().uuid(),
  promotedListingId: z80.string().uuid(),
  promotedListingStatus: z80.nativeEnum(PromotedListingStatus)
});
var promoterListingStatusResponse = z80.array(promoterListingStatusObject);
var GetPromoterListingStatusEndpoint = makeEndpoint({
  method: "GET",
  url: ({ promoterId }) => `v1/promoters/${promoterId}/listing-status`,
  responseSchema: promoterListingStatusResponse,
  requestSchema: z80.void()
});
var GetListingCountByPromoterCustomFieldResponseSchema = z80.object({
  items: z80.array(
    z80.object({
      fieldValues: z80.array(z80.string()),
      count: z80.number()
    })
  ),
  totalItems: z80.number()
});
var GetListingCountByPromoterCustomFieldEndpoint = makeEndpoint({
  method: "GET",
  url: ({ promoterId, externalId }) => `/v1/promoters/${promoterId}/promoter-custom-fields/count-by-custom-field/${externalId}`,
  requestSchema: z80.void(),
  responseSchema: GetListingCountByPromoterCustomFieldResponseSchema
});
var GetListingCountByOrganizationCustomFieldResponseSchema = z80.object({
  items: z80.array(
    z80.object({
      value: z80.string(),
      count: z80.number()
    })
  ),
  totalItems: z80.number()
});
var GetListingCountByOrganizationCustomFieldEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, externalId }) => `/v1/promoters/${brandId}/organization-custom-fields/count-by-custom-field/${externalId}`,
  requestSchema: z80.void(),
  responseSchema: GetListingCountByOrganizationCustomFieldResponseSchema
});
var CreatePromoterSchema = z80.object({
  brandId: z80.string().uuid(),
  name: z80.string(),
  description: z80.string(),
  experienceUrl: z80.string().optional(),
  defaultPercentCommission: z80.number(),
  updatedByUserId: z80.string().uuid()
});
var CreatePromoterEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/promoters/`,
  responseSchema: z80.string().uuid(),
  requestSchema: CreatePromoterSchema
});
var CreatePromoterAgreementSchema = z80.object({
  providerOrganizationId: z80.string().uuid().optional(),
  providerBrandId: z80.string().uuid().optional(),
  percentCommission: z80.number().min(0).max(1)
}).refine((data) => data.providerOrganizationId || data.providerBrandId, {
  message: "Either providerOrganizationId or providerBrandId must be provided",
  path: ["providerOrganizationId", "providerBrandId"]
  // path of error
});
var CreatePromoterAgreementResponseSchema = z80.object({
  id: z80.string().uuid()
});
var CreatePromoterAgreementEndpoint = makeEndpoint({
  method: "POST",
  url: ({ promoterId }) => `v1/promoters/${promoterId}/promoter-agreement`,
  responseSchema: CreatePromoterAgreementResponseSchema,
  requestSchema: CreatePromoterAgreementSchema
});
var CreatePromoterAgreementsForAllOrgBrandsResponseSchema = z80.object({
  agreementsCreated: z80.number(),
  promotersCreated: z80.number()
});
var CreatePromoterAgreementForAllOrgBrandsEndpoint = makeEndpoint({
  method: "POST",
  url: ({ organizationId }) => `v1/promoters/organizations/${organizationId}/promoter-agreement-for-all-brands`,
  responseSchema: CreatePromoterAgreementsForAllOrgBrandsResponseSchema,
  requestSchema: z80.void()
});
var UpdatePromoterAgreementApprovalResponseSchema2 = z80.object({
  id: z80.string().uuid()
});
var UpdatePromoterAgreementApprovalSchema2 = z80.object({
  status: z80.nativeEnum(PromoterAgreementStatus),
  updatedByUserId: z80.string().uuid()
});
var UpdateBrandPromoterAgreementApprovalEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, agreementId }) => `v1/promoters/${brandId}/promoter-agreement/${agreementId}/update-approval`,
  responseSchema: UpdatePromoterAgreementApprovalResponseSchema2,
  requestSchema: UpdatePromoterAgreementApprovalSchema2
});
var GetActiveBrandAgreementEndpointResponseSchema = z80.array(
  z80.object({
    id: z80.string().uuid()
  })
);
var GetActiveBrandAgreementEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, promoterId }) => `v1/promoters/${brandId}/promoters/${promoterId}/promoter-agreement`,
  responseSchema: GetActiveBrandAgreementEndpointResponseSchema,
  requestSchema: z80.void()
});

// src/api/report/report.ts
import { z as z86 } from "zod";

// src/api/report/experience-report.ts
import { z as z82 } from "zod";

// src/api/report/common.ts
import { z as z81 } from "zod";
var stringBooleanSchema = z81.union([z81.boolean(), z81.literal("true"), z81.literal("false")]).transform((val) => {
  if (typeof val === "boolean") {
    return val;
  }
  return String(val) === "true";
});
var ReportColumn = /* @__PURE__ */ ((ReportColumn2) => {
  ReportColumn2["EXTERNAL_REFERENCE_ID"] = "externalReferenceId";
  ReportColumn2["CURRENCY"] = "currency";
  ReportColumn2["BRAND_NAME"] = "brandName";
  ReportColumn2["EXPERIENCE_NAME"] = "experienceName";
  ReportColumn2["EXPERIENCE_DATE"] = "experienceDate";
  ReportColumn2["TRANSACTION_DATE"] = "transactionDate";
  ReportColumn2["TRANSACTION_MONTH"] = "transactionMonth";
  ReportColumn2["FIRST_NAME"] = "firstName";
  ReportColumn2["LAST_NAME"] = "lastName";
  ReportColumn2["CONFIRMATION_CODE"] = "confirmationCode";
  ReportColumn2["PAYMENT_TYPE"] = "paymentType";
  ReportColumn2["PAYMENT_METHOD"] = "paymentMethod";
  ReportColumn2["ACCOUNT"] = "accountNumber";
  ReportColumn2["DESCRIPTION"] = "description";
  ReportColumn2["DURATION"] = "duration";
  ReportColumn2["HOST"] = "hostName";
  ReportColumn2["TOTAL"] = "total";
  ReportColumn2["DISCOUNT_AMOUNT"] = "discountAmount";
  ReportColumn2["SUBTOTAL"] = "subtotal";
  ReportColumn2["GROSS_REVENUE"] = "grossRevenue";
  ReportColumn2["NET_REVENUE"] = "netRevenue";
  ReportColumn2["TAXES"] = "taxes";
  ReportColumn2["TOTAL_PAID"] = "totalPaid";
  ReportColumn2["HOST_PAYOUT"] = "hostPayout";
  ReportColumn2["CREDIT_CARD"] = "creditCardFee";
  ReportColumn2["NET_DEPOSITED"] = "netDeposited";
  ReportColumn2["QUANTITY"] = "quantity";
  ReportColumn2["DISCOUNT_CODE"] = "discountCode";
  ReportColumn2["DATE_DEPOSITED"] = "dateDeposited";
  ReportColumn2["NOTES"] = "notes";
  ReportColumn2["INTERNAL_NOTES"] = "internalNotes";
  ReportColumn2["RESERVATION_ID"] = "reservationId";
  ReportColumn2["CART_ID"] = "cartId";
  ReportColumn2["CREATED_BY"] = "createdBy";
  ReportColumn2["PRICING_LABEL"] = "pricingLabel";
  ReportColumn2["EMAIL"] = "email";
  ReportColumn2["PHONE"] = "phone";
  ReportColumn2["START_TIME"] = "startTime";
  ReportColumn2["END_TIME"] = "endTime";
  ReportColumn2["CUSTOM_QUESTION_ANSWERS"] = "customQuestionAnswer";
  ReportColumn2["CATEGORY"] = "category";
  ReportColumn2["LISTING_STATUS"] = "listingStatus";
  ReportColumn2["BOOKING_URL"] = "bookingUrl";
  ReportColumn2["PROMOTER_SOURCE"] = "promoterSource";
  ReportColumn2["APPROVED_PROMOTERS"] = "approvedPromoters";
  ReportColumn2["TOTAL_PARTICIPANTS"] = "totalParticipants";
  ReportColumn2["REFUNDS"] = "refunds";
  ReportColumn2["BOOKING_STATUS"] = "bookingStatus";
  ReportColumn2["CHECK_IN_STATUS"] = "checkInStatus";
  ReportColumn2["GUEST_NOTES"] = "guestNotes";
  ReportColumn2["CUSTOM_QUESTIONS"] = "customQuestions";
  ReportColumn2["PRICE_TIERS"] = "priceTiers";
  ReportColumn2["ADD_ONS"] = "addOns";
  ReportColumn2["ITEM_TYPE"] = "itemType";
  return ReportColumn2;
})(ReportColumn || {});
var ReportSortBy = /* @__PURE__ */ ((ReportSortBy2) => {
  ReportSortBy2["START_DATE_TIME"] = "startDateTime";
  ReportSortBy2["BOOKED_AT"] = "bookedAt";
  ReportSortBy2["TRANSACTION_DATE"] = "transactionDate";
  return ReportSortBy2;
})(ReportSortBy || {});
var TransactionType = /* @__PURE__ */ ((TransactionType2) => {
  TransactionType2["CHARGE"] = "charge";
  TransactionType2["LOYALTY_POINTS"] = "loyaltyPoints";
  TransactionType2["TRANSFER"] = "transfer";
  TransactionType2["REFUND"] = "refund";
  TransactionType2["REVERSE"] = "reverse";
  TransactionType2["DEBIT"] = "debit";
  TransactionType2["VOID"] = "void";
  return TransactionType2;
})(TransactionType || {});

// src/api/report/experience-report.ts
var ExperienceReportStaticColumns01 = [
  "experienceDate" /* EXPERIENCE_DATE */,
  "startTime" /* START_TIME */,
  "endTime" /* END_TIME */,
  "duration" /* DURATION */,
  "transactionDate" /* TRANSACTION_DATE */,
  "firstName" /* FIRST_NAME */,
  "lastName" /* LAST_NAME */,
  "email" /* EMAIL */,
  "confirmationCode" /* CONFIRMATION_CODE */,
  "experienceName" /* EXPERIENCE_NAME */,
  "totalParticipants" /* TOTAL_PARTICIPANTS */
];
var ExperienceReportStaticColumns02 = [
  "total" /* TOTAL */,
  "totalPaid" /* TOTAL_PAID */,
  "discountAmount" /* DISCOUNT_AMOUNT */,
  "refunds" /* REFUNDS */,
  "paymentMethod" /* PAYMENT_METHOD */,
  "bookingStatus" /* BOOKING_STATUS */,
  "checkInStatus" /* CHECK_IN_STATUS */,
  "category" /* CATEGORY */,
  "guestNotes" /* GUEST_NOTES */,
  "internalNotes" /* INTERNAL_NOTES */
];
var ExperienceReportColumn = [
  ...ExperienceReportStaticColumns01,
  "priceTiers" /* PRICE_TIERS */,
  "addOns" /* ADD_ONS */,
  ...ExperienceReportStaticColumns02,
  "customQuestions" /* CUSTOM_QUESTIONS */
];
var experienceColumnsMap = {
  ["experienceDate" /* EXPERIENCE_DATE */]: "Experience Date",
  ["startTime" /* START_TIME */]: "Start Time",
  ["endTime" /* END_TIME */]: "End Time",
  ["duration" /* DURATION */]: "Duration",
  ["transactionDate" /* TRANSACTION_DATE */]: "Transaction Date UTC",
  ["firstName" /* FIRST_NAME */]: "First Name",
  ["lastName" /* LAST_NAME */]: "Last Name",
  ["email" /* EMAIL */]: "Email",
  ["confirmationCode" /* CONFIRMATION_CODE */]: "Confirmation Code",
  ["experienceName" /* EXPERIENCE_NAME */]: "Experience Name",
  ["totalParticipants" /* TOTAL_PARTICIPANTS */]: "Total Participants",
  // PRICE TIERS
  // ADD ONS
  ["total" /* TOTAL */]: "Total Price",
  ["totalPaid" /* TOTAL_PAID */]: "Total Paid",
  ["discountAmount" /* DISCOUNT_AMOUNT */]: "Discount Amount",
  ["refunds" /* REFUNDS */]: "Refunds",
  ["paymentMethod" /* PAYMENT_METHOD */]: "Payment Method",
  ["bookingStatus" /* BOOKING_STATUS */]: "Booking Status",
  ["checkInStatus" /* CHECK_IN_STATUS */]: "Check-In Status",
  ["category" /* CATEGORY */]: "Category",
  ["guestNotes" /* GUEST_NOTES */]: "Guest Notes",
  ["internalNotes" /* INTERNAL_NOTES */]: "Internal Notes"
  // CUSTOM QUESTIONS
};
var ExperienceReportSortBy = [
  "startDateTime" /* START_DATE_TIME */,
  "transactionDate" /* TRANSACTION_DATE */
];
var baseExperienceReportFilters = {
  from: z82.union([DateStringSchema, z82.string().datetime()]).optional(),
  to: z82.union([DateStringSchema, z82.string().datetime()]).optional(),
  showNegativeDiscountValues: stringBooleanSchema.optional(),
  confirmationCode: z82.string().optional(),
  cartId: z82.string().optional(),
  experienceIds: z82.array(z82.string().uuid()).optional(),
  collectionIds: z82.array(z82.string().uuid()).optional(),
  categoryIds: z82.array(z82.string().uuid()).optional(),
  email: z82.string().optional(),
  lastName: z82.string().optional(),
  page: z82.coerce.number().optional(),
  limit: z82.coerce.number().optional(),
  debug: stringBooleanSchema.optional()
};
var experienceReportFiltersSchema = z82.object(baseExperienceReportFilters);
var BaseExperienceReportRequestSchema = z82.object({
  columns: z82.array(z82.enum(ExperienceReportColumn)),
  params: experienceReportFiltersSchema,
  sortBy: z82.enum(ExperienceReportSortBy),
  sortDir: z82.enum(["ASC", "DESC"]).optional(),
  format: z82.enum(["csv" /* CSV */, "pdf" /* PDF */]).optional()
});
var BrandExperienceReportRequestSchema = BaseExperienceReportRequestSchema.extend({
  brandId: z82.string().uuid().optional()
});
var ExperienceReportRequestSchema = BrandExperienceReportRequestSchema;
var ExperienceReportWithHeaderSchema = z82.object({
  "Experience Date": z82.string().optional(),
  "Start Time": z82.string().optional(),
  "End Time": z82.string().optional(),
  Duration: z82.string().optional(),
  "Transaction Date UTC": z82.string().optional(),
  "First Name": z82.string().optional(),
  "Last Name": z82.string().optional(),
  Email: z82.string().optional(),
  "Confirmation Code": z82.string().optional(),
  "Experience Name": z82.string().optional(),
  "Total Participants": z82.string().optional(),
  // PRICE TIERS
  // ADD ONS
  "Total Price": z82.string().optional(),
  "Total Paid": z82.string().optional(),
  "Discount Amount": z82.string().optional(),
  Refunds: z82.string().optional(),
  "Payment Method": z82.string().optional(),
  "Booking Status": z82.string().optional(),
  "Check-In Status": z82.string().optional(),
  Category: z82.string().optional(),
  "Guest Notes": z82.string().optional(),
  "Internal Notes": z82.string().optional()
  // CUSTOM QUESTIONS
});
var PreviewExperienceReportRequestSchema = experienceReportFiltersSchema.extend({
  sortBy: z82.enum(ExperienceReportSortBy)
});
var experienceReportItemSchema = z82.object({
  experienceDate: z82.string(),
  startTime: z82.string(),
  endTime: z82.string(),
  duration: z82.string(),
  transactionDate: z82.string(),
  firstName: z82.string(),
  lastName: z82.string(),
  email: z82.string(),
  confirmationCode: z82.string(),
  experienceName: z82.string(),
  totalParticipants: z82.number(),
  priceTiers: z82.record(z82.number().or(z82.literal(""))),
  addOns: z82.record(z82.number().or(z82.literal(""))),
  total: z82.number(),
  totalPaid: z82.number(),
  discountAmount: z82.number().or(z82.literal("")),
  refunds: z82.number().or(z82.literal("")),
  paymentMethod: z82.string(),
  bookingStatus: z82.string(),
  checkInStatus: z82.string().nullable(),
  category: z82.string().nullable(),
  guestNotes: z82.string().nullable(),
  internalNotes: z82.string().nullable(),
  customQuestions: z82.record(z82.string())
});
var PreviewExperienceReportEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query, brandId }) => `v1/brands/${brandId}/reports/experiences?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(experienceReportItemSchema),
  requestSchema: z82.void(),
  querySchema: PreviewExperienceReportRequestSchema
});

// src/api/report/financial-report-v2.ts
import { z as z83 } from "zod";
var FinancialReportV2Column = [
  "externalReferenceId" /* EXTERNAL_REFERENCE_ID */,
  // ORG ONLY
  "brandName" /* BRAND_NAME */,
  // ORG ONLY
  "currency" /* CURRENCY */,
  "experienceDate" /* EXPERIENCE_DATE */,
  "transactionDate" /* TRANSACTION_DATE */,
  "transactionMonth" /* TRANSACTION_MONTH */,
  // ORG ONLY
  "firstName" /* FIRST_NAME */,
  "lastName" /* LAST_NAME */,
  "email" /* EMAIL */,
  "confirmationCode" /* CONFIRMATION_CODE */,
  "paymentType" /* PAYMENT_TYPE */,
  "paymentMethod" /* PAYMENT_METHOD */,
  "accountNumber" /* ACCOUNT */,
  "experienceName" /* EXPERIENCE_NAME */,
  "pricingLabel" /* PRICING_LABEL */,
  "itemType" /* ITEM_TYPE */,
  "quantity" /* QUANTITY */,
  "startTime" /* START_TIME */,
  "duration" /* DURATION */,
  "hostName" /* HOST */,
  "total" /* TOTAL */,
  "discountAmount" /* DISCOUNT_AMOUNT */,
  "subtotal" /* SUBTOTAL */,
  "grossRevenue" /* GROSS_REVENUE */,
  // ORG ONLY
  "netRevenue" /* NET_REVENUE */,
  // ORG ONLY
  "totalPaid" /* TOTAL_PAID */,
  "hostPayout" /* HOST_PAYOUT */,
  "creditCardFee" /* CREDIT_CARD */,
  "netDeposited" /* NET_DEPOSITED */,
  "discountCode" /* DISCOUNT_CODE */,
  "dateDeposited" /* DATE_DEPOSITED */,
  "notes" /* NOTES */,
  "internalNotes" /* INTERNAL_NOTES */,
  "reservationId" /* RESERVATION_ID */,
  "taxes" /* TAXES */,
  "cartId" /* CART_ID */,
  "createdBy" /* CREATED_BY */,
  "category" /* CATEGORY */,
  "listingStatus" /* LISTING_STATUS */,
  "bookingUrl" /* BOOKING_URL */,
  "promoterSource" /* PROMOTER_SOURCE */,
  "approvedPromoters" /* APPROVED_PROMOTERS */
];
var financialColumnsV2Map = {
  ["externalReferenceId" /* EXTERNAL_REFERENCE_ID */]: "External Reference ID",
  ["brandName" /* BRAND_NAME */]: "Brand Name",
  ["currency" /* CURRENCY */]: "Currency",
  ["experienceDate" /* EXPERIENCE_DATE */]: "Experience Date",
  ["transactionDate" /* TRANSACTION_DATE */]: "Transaction Date UTC",
  ["transactionMonth" /* TRANSACTION_MONTH */]: "Transaction Month UTC",
  ["firstName" /* FIRST_NAME */]: "First Name",
  ["lastName" /* LAST_NAME */]: "Last Name",
  ["email" /* EMAIL */]: "Email",
  ["confirmationCode" /* CONFIRMATION_CODE */]: "Confirmation Code",
  ["paymentType" /* PAYMENT_TYPE */]: "Type",
  ["paymentMethod" /* PAYMENT_METHOD */]: "Payment Method",
  ["accountNumber" /* ACCOUNT */]: "Account",
  ["experienceName" /* EXPERIENCE_NAME */]: "Experience Name",
  ["pricingLabel" /* PRICING_LABEL */]: "Item Label",
  ["itemType" /* ITEM_TYPE */]: "Item Type",
  ["quantity" /* QUANTITY */]: "Quantity",
  ["startTime" /* START_TIME */]: "Start Time",
  ["duration" /* DURATION */]: "Duration",
  ["hostName" /* HOST */]: "Host",
  ["total" /* TOTAL */]: "Total",
  ["discountAmount" /* DISCOUNT_AMOUNT */]: "Discount Amount",
  ["subtotal" /* SUBTOTAL */]: "Subtotal",
  ["grossRevenue" /* GROSS_REVENUE */]: "Gross Revenue",
  ["netRevenue" /* NET_REVENUE */]: "Net Revenue",
  ["totalPaid" /* TOTAL_PAID */]: "Total Paid",
  ["hostPayout" /* HOST_PAYOUT */]: "Host Payout",
  ["creditCardFee" /* CREDIT_CARD */]: "Credit Card",
  ["netDeposited" /* NET_DEPOSITED */]: "Net Deposited",
  ["discountCode" /* DISCOUNT_CODE */]: "Discount Code",
  ["dateDeposited" /* DATE_DEPOSITED */]: "Date Deposited",
  ["notes" /* NOTES */]: "Guest Notes",
  ["internalNotes" /* INTERNAL_NOTES */]: "Internal Notes",
  ["reservationId" /* RESERVATION_ID */]: "Reservation ID",
  ["taxes" /* TAXES */]: "Taxes",
  ["cartId" /* CART_ID */]: "Cart ID",
  ["createdBy" /* CREATED_BY */]: "Created By",
  ["category" /* CATEGORY */]: "Category",
  ["listingStatus" /* LISTING_STATUS */]: "Listing Status",
  ["bookingUrl" /* BOOKING_URL */]: "Booking URL",
  ["promoterSource" /* PROMOTER_SOURCE */]: "Promoter Source",
  ["approvedPromoters" /* APPROVED_PROMOTERS */]: "Approved Promoters"
};
var FinancialReportV2SortBy = [
  "startDateTime" /* START_DATE_TIME */,
  "transactionDate" /* TRANSACTION_DATE */
];
var baseFinancialReportV2Filters = {
  from: z83.union([DateStringSchema, z83.string().datetime()]).optional(),
  to: z83.union([DateStringSchema, z83.string().datetime()]).optional(),
  showNegativeDiscountValues: stringBooleanSchema.optional(),
  transactionType: z83.array(z83.enum(["charge" /* CHARGE */, "refund" /* REFUND */, "debit" /* DEBIT */])).optional(),
  collectionIds: z83.array(z83.string().uuid()).optional(),
  eventId: z83.string().uuid().optional(),
  experienceIds: z83.array(z83.string().uuid()).optional(),
  categoryIds: z83.array(z83.string().uuid()).optional(),
  hostIds: z83.array(z83.string().uuid()).optional(),
  confirmationCode: z83.string().optional(),
  cartId: z83.string().optional(),
  transactionId: z83.string().optional(),
  paymentMethod: z83.array(z83.nativeEnum(PaymentMethods)).optional(),
  itemType: z83.array(z83.nativeEnum(ItemType)).optional(),
  bookingStatus: z83.array(z83.nativeEnum(BookingStatus)).optional(),
  debug: stringBooleanSchema.optional()
};
var financialReportV2FiltersSchema = z83.object(baseFinancialReportV2Filters);
var BaseFinancialReportV2RequestSchema = z83.object({
  params: financialReportV2FiltersSchema,
  sortBy: z83.enum(FinancialReportV2SortBy),
  columns: z83.array(z83.enum(FinancialReportV2Column)),
  format: z83.enum(["csv" /* CSV */, "pdf" /* PDF */]).optional()
});
var BrandFinancialReportV2RequestSchema = BaseFinancialReportV2RequestSchema.extend({ brandId: z83.string().uuid() });
var OrganizationFinancialReportV2RequestSchema = BaseFinancialReportV2RequestSchema.extend({
  organizationId: z83.string().uuid()
});
var FinancialReportV2RequestSchema = z83.union([
  BrandFinancialReportV2RequestSchema,
  OrganizationFinancialReportV2RequestSchema
]);
var PreviewFinancialV2RequestSchema = financialReportV2FiltersSchema.extend({
  limit: z83.coerce.number().optional(),
  page: z83.coerce.number().optional(),
  sortBy: z83.enum(FinancialReportV2SortBy),
  organizationId: z83.string().uuid().optional()
});
var financialReportV2ItemSchema = z83.object({
  ["externalReferenceId" /* EXTERNAL_REFERENCE_ID */]: z83.string().nullable().optional(),
  ["brandName" /* BRAND_NAME */]: z83.string().optional(),
  ["currency" /* CURRENCY */]: z83.string(),
  ["experienceDate" /* EXPERIENCE_DATE */]: z83.string(),
  ["transactionDate" /* TRANSACTION_DATE */]: z83.string(),
  ["transactionMonth" /* TRANSACTION_MONTH */]: z83.string().optional(),
  ["firstName" /* FIRST_NAME */]: z83.string().nullable(),
  ["lastName" /* LAST_NAME */]: z83.string().nullable(),
  ["email" /* EMAIL */]: z83.string().nullable(),
  ["confirmationCode" /* CONFIRMATION_CODE */]: z83.string().nullable(),
  ["paymentType" /* PAYMENT_TYPE */]: z83.string(),
  ["paymentMethod" /* PAYMENT_METHOD */]: z83.string(),
  ["accountNumber" /* ACCOUNT */]: z83.string().nullable(),
  ["experienceName" /* EXPERIENCE_NAME */]: z83.string(),
  ["pricingLabel" /* PRICING_LABEL */]: z83.string().nullable(),
  ["itemType" /* ITEM_TYPE */]: z83.string().nullable(),
  ["quantity" /* QUANTITY */]: z83.number().nullable(),
  ["startTime" /* START_TIME */]: z83.string().nullable(),
  ["duration" /* DURATION */]: z83.string(),
  ["hostName" /* HOST */]: z83.string().nullable(),
  ["total" /* TOTAL */]: z83.number().nullable(),
  ["discountAmount" /* DISCOUNT_AMOUNT */]: z83.number().nullable(),
  ["subtotal" /* SUBTOTAL */]: z83.number().nullable(),
  ["grossRevenue" /* GROSS_REVENUE */]: z83.number().nullable().optional(),
  ["netRevenue" /* NET_REVENUE */]: z83.number().nullable().optional(),
  ["totalPaid" /* TOTAL_PAID */]: z83.number().nullable(),
  ["hostPayout" /* HOST_PAYOUT */]: z83.number().nullable(),
  ["creditCardFee" /* CREDIT_CARD */]: z83.number().nullable(),
  ["netDeposited" /* NET_DEPOSITED */]: z83.number().nullable(),
  ["discountCode" /* DISCOUNT_CODE */]: z83.string().nullable(),
  ["dateDeposited" /* DATE_DEPOSITED */]: z83.string().nullable(),
  ["notes" /* NOTES */]: z83.string().nullable(),
  ["internalNotes" /* INTERNAL_NOTES */]: z83.string().nullable(),
  ["reservationId" /* RESERVATION_ID */]: z83.string().nullable(),
  ["taxes" /* TAXES */]: z83.record(z83.number().nullable()),
  ["cartId" /* CART_ID */]: z83.string().nullable(),
  ["createdBy" /* CREATED_BY */]: z83.string().nullable(),
  ["category" /* CATEGORY */]: z83.string().nullable(),
  ["listingStatus" /* LISTING_STATUS */]: z83.string().nullable(),
  ["bookingUrl" /* BOOKING_URL */]: z83.string().nullable(),
  ["promoterSource" /* PROMOTER_SOURCE */]: z83.string().nullable(),
  ["approvedPromoters" /* APPROVED_PROMOTERS */]: z83.string().nullable()
});
var debugErrorsSchema = z83.object({
  key: z83.string(),
  expectedFromTransactions: z83.number(),
  receivedFromReport: z83.number()
}).or(
  z83.object({
    knownIssue: z83.string()
  })
);
var PreviewFinancialV2Endpoint = makeEndpoint({
  method: "GET",
  url: ({ query, brandId }) => `v1/brands/${brandId}/reports/financials/v2?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(financialReportV2ItemSchema).merge(
    z83.object({
      debugErrors: z83.record(z83.array(debugErrorsSchema)).optional()
    })
  ),
  requestSchema: z83.void(),
  querySchema: PreviewFinancialV2RequestSchema
});
var webhookOnlyDataSchema = z83.object({
  brandId: z83.string(),
  experienceId: z83.string(),
  bookingId: z83.string().nullable(),
  bookingSourceUrl: z83.string().url().nullable(),
  loyaltyPoints: z83.number().nullable(),
  loyaltyMemberId: z83.string().nullable(),
  externalAnalyticsUserId: z83.string().nullable()
});
var webhookFinancialReportV2ItemSchema = financialReportV2ItemSchema.omit({
  ["experienceDate" /* EXPERIENCE_DATE */]: true,
  ["taxes" /* TAXES */]: true
}).extend({
  ["experienceDate" /* EXPERIENCE_DATE */]: DateStringSchema,
  ["taxes" /* TAXES */]: z83.record(z83.number())
}).merge(webhookOnlyDataSchema);
var FinancialReportV2WithHeaderSchema = z83.object({
  "External Reference ID": z83.string().optional(),
  "Brand Name": z83.string().optional(),
  Currency: z83.string().optional(),
  "Experience Date": z83.string().optional(),
  "Transaction Date UTC": z83.string().optional(),
  "Transaction Month UTC": z83.string().optional(),
  "First Name": z83.string().optional(),
  "Last Name": z83.string().optional(),
  Email: z83.string().optional(),
  "Confirmation Code": z83.string().optional(),
  Type: z83.string().optional(),
  "Payment Method": z83.string().optional(),
  Account: z83.string().optional(),
  "Experience Name": z83.string().optional(),
  "Item Label": z83.string().optional(),
  "Item Type": z83.string().optional(),
  Quantity: z83.string().optional(),
  "Start Time": z83.string().optional(),
  Duration: z83.string().optional(),
  Host: z83.string().optional(),
  Total: z83.string().optional(),
  "Discount Amount": z83.string().optional(),
  Subtotal: z83.string().optional(),
  "Gross Revenue": z83.string().optional(),
  "Net Revenue": z83.string().optional(),
  "Total Paid": z83.string().optional(),
  "Host Payout": z83.string().optional(),
  "Credit Card": z83.string().optional(),
  "Net Deposited": z83.string().optional(),
  "Discount Code": z83.string().optional(),
  "Date Deposited": z83.string().optional(),
  "Guest Notes": z83.string().optional(),
  "Internal Notes": z83.string().optional(),
  "Reservation ID": z83.string().optional(),
  "Cart ID": z83.string().optional(),
  "Created By": z83.string().optional(),
  Category: z83.string().optional(),
  "Listing Status": z83.string().optional(),
  "Booking URL": z83.string().optional(),
  "Promoter Source": z83.string().optional(),
  "Approved Promoters": z83.string().optional()
});

// src/api/report/financial-report.ts
import { z as z84 } from "zod";
var FinancialReportColumn = [
  "externalReferenceId" /* EXTERNAL_REFERENCE_ID */,
  "brandName" /* BRAND_NAME */,
  "currency" /* CURRENCY */,
  "experienceDate" /* EXPERIENCE_DATE */,
  "transactionDate" /* TRANSACTION_DATE */,
  "transactionMonth" /* TRANSACTION_MONTH */,
  "firstName" /* FIRST_NAME */,
  "lastName" /* LAST_NAME */,
  "confirmationCode" /* CONFIRMATION_CODE */,
  "paymentType" /* PAYMENT_TYPE */,
  "paymentMethod" /* PAYMENT_METHOD */,
  "accountNumber" /* ACCOUNT */,
  "description" /* DESCRIPTION */,
  "duration" /* DURATION */,
  "hostName" /* HOST */,
  "total" /* TOTAL */,
  "discountAmount" /* DISCOUNT_AMOUNT */,
  "subtotal" /* SUBTOTAL */,
  "grossRevenue" /* GROSS_REVENUE */,
  "netRevenue" /* NET_REVENUE */,
  "taxes" /* TAXES */,
  "totalPaid" /* TOTAL_PAID */,
  "hostPayout" /* HOST_PAYOUT */,
  "creditCardFee" /* CREDIT_CARD */,
  "netDeposited" /* NET_DEPOSITED */,
  "quantity" /* QUANTITY */,
  "discountCode" /* DISCOUNT_CODE */,
  "dateDeposited" /* DATE_DEPOSITED */,
  "notes" /* NOTES */,
  "internalNotes" /* INTERNAL_NOTES */,
  "reservationId" /* RESERVATION_ID */,
  "cartId" /* CART_ID */,
  "createdBy" /* CREATED_BY */,
  "category" /* CATEGORY */,
  "listingStatus" /* LISTING_STATUS */,
  "bookingUrl" /* BOOKING_URL */,
  "promoterSource" /* PROMOTER_SOURCE */,
  "approvedPromoters" /* APPROVED_PROMOTERS */
];
var financialColumnsMap = {
  ["externalReferenceId" /* EXTERNAL_REFERENCE_ID */]: "External Reference ID",
  ["brandName" /* BRAND_NAME */]: "Brand Name",
  ["currency" /* CURRENCY */]: "Currency",
  ["experienceDate" /* EXPERIENCE_DATE */]: "Experience Date",
  ["transactionDate" /* TRANSACTION_DATE */]: "Transaction Date UTC",
  ["transactionMonth" /* TRANSACTION_MONTH */]: "Transaction Month UTC",
  ["firstName" /* FIRST_NAME */]: "First Name",
  ["lastName" /* LAST_NAME */]: "Last Name",
  ["confirmationCode" /* CONFIRMATION_CODE */]: "Confirmation Code",
  ["paymentType" /* PAYMENT_TYPE */]: "Type",
  ["paymentMethod" /* PAYMENT_METHOD */]: "Payment Method",
  ["accountNumber" /* ACCOUNT */]: "Account",
  ["description" /* DESCRIPTION */]: "Description",
  ["duration" /* DURATION */]: "Duration",
  ["hostName" /* HOST */]: "Host",
  ["total" /* TOTAL */]: "Total",
  ["discountAmount" /* DISCOUNT_AMOUNT */]: "Discount Amount",
  ["subtotal" /* SUBTOTAL */]: "Subtotal",
  ["grossRevenue" /* GROSS_REVENUE */]: "Gross Revenue",
  ["netRevenue" /* NET_REVENUE */]: "Net Revenue",
  ["taxes" /* TAXES */]: "Taxes",
  ["totalPaid" /* TOTAL_PAID */]: "Total Paid",
  ["hostPayout" /* HOST_PAYOUT */]: "Host Payout",
  ["creditCardFee" /* CREDIT_CARD */]: "Credit Card",
  ["netDeposited" /* NET_DEPOSITED */]: "Net Deposited",
  ["quantity" /* QUANTITY */]: "Quantity",
  ["discountCode" /* DISCOUNT_CODE */]: "Discount Code",
  ["dateDeposited" /* DATE_DEPOSITED */]: "Date Deposited",
  ["notes" /* NOTES */]: "Guest Notes",
  ["internalNotes" /* INTERNAL_NOTES */]: "Internal Notes",
  ["reservationId" /* RESERVATION_ID */]: "Reservation ID",
  ["cartId" /* CART_ID */]: "Cart ID",
  ["createdBy" /* CREATED_BY */]: "Created By",
  ["category" /* CATEGORY */]: "Category",
  ["listingStatus" /* LISTING_STATUS */]: "Listing Status",
  ["bookingUrl" /* BOOKING_URL */]: "Booking URL",
  ["promoterSource" /* PROMOTER_SOURCE */]: "Promoter Source",
  ["approvedPromoters" /* APPROVED_PROMOTERS */]: "Approved Promoters"
};
var FinancialReportSortBy = [
  "startDateTime" /* START_DATE_TIME */,
  "transactionDate" /* TRANSACTION_DATE */
];
var financialReportInfoSchema = {
  filters: {
    from: "datestring",
    to: "datestring",
    experienceId: "uuid",
    resourceGroupCollectionId: "uuid",
    eventId: "uuid",
    searchParams: "string",
    transactionType: Object.values(TransactionType),
    showNegativeDiscountValues: "boolean"
  },
  sortBy: FinancialReportSortBy,
  columns: Object.entries(financialColumnsMap).map(([key, value]) => ({
    label: value,
    field: key
  }))
};
var BaseFinancialReportRequestSchema = z84.object({
  params: z84.object({
    from: z84.union([DateStringSchema, z84.string().datetime()]).optional(),
    to: z84.union([DateStringSchema, z84.string().datetime()]).optional(),
    experienceId: z84.string().optional().nullable(),
    resourceGroupCollectionId: z84.string().uuid().optional().nullable(),
    eventId: z84.string().optional().nullable(),
    searchParams: z84.string().optional().nullable(),
    transactionType: z84.nativeEnum(TransactionType).optional().nullable(),
    showNegativeDiscountValues: z84.boolean().optional().nullable()
  }),
  sortBy: z84.enum(FinancialReportSortBy),
  columns: z84.array(z84.enum(FinancialReportColumn)),
  format: z84.enum(["csv" /* CSV */, "pdf" /* PDF */]).optional()
});
var BrandFinancialReportRequestSchema = BaseFinancialReportRequestSchema.extend({ brandId: z84.string().uuid() });
var OrganizationFinancialReportRequestSchema = BaseFinancialReportRequestSchema.extend({
  organizationId: z84.string().uuid()
});
var FinancialReportRequestSchema = z84.union([
  BrandFinancialReportRequestSchema,
  OrganizationFinancialReportRequestSchema
]);
var FinancialReportWithHeaderSchema = z84.object({
  "External Reference ID": z84.string().optional(),
  "Brand Name": z84.string().optional(),
  Currency: z84.string().optional(),
  "Experience Date": z84.string().optional(),
  "Transaction Date UTC": z84.string().optional(),
  "Transaction Month UTC": z84.string().optional(),
  "First Name": z84.string().optional(),
  "Last Name": z84.string().optional(),
  "Confirmation Code": z84.string().optional(),
  Type: z84.string().optional(),
  "Payment Method": z84.string().optional(),
  Account: z84.string().optional(),
  Description: z84.string().optional(),
  Duration: z84.string().optional(),
  Host: z84.string().optional(),
  Total: z84.string().optional(),
  "Discount Amount": z84.string().optional(),
  Subtotal: z84.string().optional(),
  "Gross Revenue": z84.string().optional(),
  "Net Revenue": z84.string().optional(),
  "Total Paid": z84.string().optional(),
  "Host Payout": z84.string().optional(),
  "Credit Card": z84.string().optional(),
  "Net Deposited": z84.string().optional(),
  Quantity: z84.string().optional(),
  "Discount Code": z84.string().optional(),
  "Date Deposited": z84.string().optional(),
  "Guest Notes": z84.string().optional(),
  "Internal Notes": z84.string().optional(),
  "Reservation ID": z84.string().optional(),
  "Cart ID": z84.string().optional(),
  "Created By": z84.string().optional(),
  Category: z84.string().optional(),
  "Listing Status": z84.string().optional(),
  "Booking URL": z84.string().optional(),
  "Promoter Source": z84.string().optional(),
  "Approved Promoters": z84.string().optional()
});

// src/api/report/guest-report.ts
import { z as z85 } from "zod";
var GuestReportColumn = [
  "experienceDate" /* EXPERIENCE_DATE */,
  "transactionDate" /* TRANSACTION_DATE */,
  "firstName" /* FIRST_NAME */,
  "lastName" /* LAST_NAME */,
  "email" /* EMAIL */,
  "phone" /* PHONE */,
  "confirmationCode" /* CONFIRMATION_CODE */,
  "experienceName" /* EXPERIENCE_NAME */,
  "startTime" /* START_TIME */,
  "endTime" /* END_TIME */,
  "pricingLabel" /* PRICING_LABEL */,
  "itemType" /* ITEM_TYPE */,
  "total" /* TOTAL */,
  "totalPaid" /* TOTAL_PAID */,
  "refunds" /* REFUNDS */,
  "bookingStatus" /* BOOKING_STATUS */,
  "category" /* CATEGORY */,
  "cartId" /* CART_ID */,
  "checkInStatus" /* CHECK_IN_STATUS */,
  "hostName" /* HOST */,
  "paymentMethod" /* PAYMENT_METHOD */,
  "accountNumber" /* ACCOUNT */,
  "notes" /* NOTES */,
  "internalNotes" /* INTERNAL_NOTES */,
  "customQuestionAnswer" /* CUSTOM_QUESTION_ANSWERS */
];
var guestReportsColumnsMap = {
  ["experienceDate" /* EXPERIENCE_DATE */]: "Experience Date",
  ["transactionDate" /* TRANSACTION_DATE */]: "Transaction Date UTC",
  ["firstName" /* FIRST_NAME */]: "First Name",
  ["lastName" /* LAST_NAME */]: "Last Name",
  ["email" /* EMAIL */]: "Email",
  ["phone" /* PHONE */]: "Phone",
  ["confirmationCode" /* CONFIRMATION_CODE */]: "Confirmation Code",
  ["experienceName" /* EXPERIENCE_NAME */]: "Experience",
  ["startTime" /* START_TIME */]: "Start Time",
  ["endTime" /* END_TIME */]: "End Time",
  ["pricingLabel" /* PRICING_LABEL */]: "Pricing Label",
  ["itemType" /* ITEM_TYPE */]: "Item Type",
  ["total" /* TOTAL */]: "Item Price",
  ["totalPaid" /* TOTAL_PAID */]: "Total Paid",
  ["refunds" /* REFUNDS */]: "Refunds",
  ["bookingStatus" /* BOOKING_STATUS */]: "Booking Status",
  ["category" /* CATEGORY */]: "Category",
  ["cartId" /* CART_ID */]: "Cart ID",
  ["checkInStatus" /* CHECK_IN_STATUS */]: "Check In Status",
  ["hostName" /* HOST */]: "Host",
  ["paymentMethod" /* PAYMENT_METHOD */]: "Payment Method",
  ["accountNumber" /* ACCOUNT */]: "Account",
  ["notes" /* NOTES */]: "Guest Notes",
  ["internalNotes" /* INTERNAL_NOTES */]: "Internal Notes",
  ["customQuestionAnswer" /* CUSTOM_QUESTION_ANSWERS */]: "Custom Question Answers"
};
var GuestReportSortBy = [
  "startDateTime" /* START_DATE_TIME */,
  "bookedAt" /* BOOKED_AT */
];
var baseGuestReportFilters = {
  from: DateStringSchema.optional(),
  to: DateStringSchema.optional(),
  experienceIds: z85.array(z85.string().uuid()).optional(),
  collectionIds: z85.array(z85.string().uuid()).optional(),
  eventId: z85.string().uuid().optional(),
  categoryIds: z85.array(z85.string().uuid()).optional(),
  hostIds: z85.array(z85.string().uuid()).optional(),
  bookingStatus: z85.array(z85.nativeEnum(BookingStatus)).optional(),
  itemType: z85.array(z85.nativeEnum(ItemType)).optional(),
  confirmationCode: z85.string().optional(),
  cartId: z85.string().optional(),
  email: z85.string().optional(),
  lastName: z85.string().optional(),
  showNegativeRefundValues: stringBooleanSchema.optional(),
  transactionType: z85.nativeEnum(TransactionType).optional().nullable(),
  debug: stringBooleanSchema.optional()
};
var guestReportFiltersSchema = z85.object(baseGuestReportFilters);
var GuestReportRequestSchema = z85.object({
  params: guestReportFiltersSchema,
  sortBy: z85.enum(GuestReportSortBy),
  columns: z85.array(z85.enum(GuestReportColumn)),
  brandId: z85.string().uuid().optional(),
  format: z85.enum(["csv" /* CSV */, "pdf" /* PDF */]).optional()
});
var PreviewGuestReportRequestSchema = guestReportFiltersSchema.extend({
  limit: z85.coerce.number().optional(),
  page: z85.coerce.number().optional(),
  sortBy: z85.enum(GuestReportSortBy)
});
var guestReportItemSchema = z85.object({
  experienceDate: z85.string(),
  transactionDate: z85.string(),
  firstName: z85.string(),
  lastName: z85.string(),
  email: z85.string(),
  phone: z85.string(),
  confirmationCode: z85.string(),
  experienceName: z85.string(),
  startTime: z85.string(),
  endTime: z85.string(),
  pricingLabel: z85.string(),
  itemType: z85.string(),
  total: z85.number(),
  totalPaid: z85.number(),
  refunds: z85.number().or(z85.literal("")),
  bookingStatus: z85.string(),
  category: z85.string(),
  cartId: z85.string(),
  checkInStatus: z85.string(),
  hostName: z85.string(),
  paymentMethod: z85.string(),
  accountNumber: z85.string(),
  notes: z85.string(),
  internalNotes: z85.string(),
  customQuestionAnswer: z85.record(z85.unknown())
});
var PreviewGuestReportEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query, brandId }) => `v1/brands/${brandId}/reports/guests?${buildQueryString(query)}`,
  responseSchema: paginateResponseSchema(guestReportItemSchema),
  requestSchema: z85.void(),
  querySchema: PreviewGuestReportRequestSchema
});
var GuestReportWithHeaderSchema = z85.object({
  "Experience Date": z85.string().optional(),
  "Transaction Date UTC": z85.string().optional(),
  "First Name": z85.string().optional(),
  "Last Name": z85.string().optional(),
  Email: EmailStringSchema.optional(),
  Phone: z85.string().optional(),
  "Confirmation Code": z85.string().optional(),
  Experience: z85.string().optional(),
  "Start Time": z85.string().optional(),
  "End Time": z85.string().optional(),
  "Pricing Label": z85.string().optional(),
  "Item Type": z85.string().optional(),
  "Item Price": z85.string().optional(),
  "Total Paid": z85.string().optional(),
  Refunds: z85.string().optional(),
  "Booking Status": z85.string().optional(),
  Category: z85.string().optional(),
  "Cart ID": z85.string().optional(),
  "Check In Status": z85.string().optional(),
  Host: z85.string().optional(),
  "Guest Notes": z85.string().optional(),
  "Internal Notes": z85.string().optional(),
  "Payment Method": z85.string().optional(),
  Account: z85.string().optional()
});

// src/api/report/report.ts
var ReportStatus = /* @__PURE__ */ ((ReportStatus2) => {
  ReportStatus2["PENDING"] = "pending";
  ReportStatus2["SUCCESS"] = "success";
  ReportStatus2["FAILED"] = "failed";
  return ReportStatus2;
})(ReportStatus || {});
var ReportErrorsSchema = z86.object({
  message: z86.string()
});
var ReportFormat = /* @__PURE__ */ ((ReportFormat2) => {
  ReportFormat2["CSV"] = "csv";
  ReportFormat2["PDF"] = "pdf";
  return ReportFormat2;
})(ReportFormat || {});
var ReportType = /* @__PURE__ */ ((ReportType2) => {
  ReportType2["BRANDS"] = "brands";
  ReportType2["FINANCIAL"] = "financial";
  ReportType2["FINANCIAL_V2"] = "financial-v2";
  ReportType2["EXPERIENCE"] = "experience";
  ReportType2["GUEST"] = "guest";
  return ReportType2;
})(ReportType || {});
var brandReportInfoSchema = {
  filters: {
    brandStatuses: Object.values(BrandStatus)
  },
  sortBy: [],
  columns: []
};
var BrandReportRequestSchema = z86.object({
  params: z86.object({
    brandStatuses: z86.array(z86.nativeEnum(BrandStatus))
  }),
  format: z86.enum(["csv" /* CSV */, "pdf" /* PDF */]).optional()
});
var ReportRequestSchema = z86.union([BrandReportRequestSchema, FinancialReportRequestSchema]);
var ReportSchemaByType = {
  ["brands" /* BRANDS */]: BrandReportRequestSchema,
  ["financial" /* FINANCIAL */]: FinancialReportRequestSchema,
  ["financial-v2" /* FINANCIAL_V2 */]: FinancialReportV2RequestSchema,
  ["experience" /* EXPERIENCE */]: ExperienceReportRequestSchema,
  ["guest" /* GUEST */]: GuestReportRequestSchema
};
var FindReportResponseSchema = z86.object({
  id: z86.string(),
  payload: z86.record(z86.string(), z86.unknown()),
  type: z86.nativeEnum(ReportType),
  status: z86.nativeEnum(ReportStatus),
  errors: ReportErrorsSchema.nullable(),
  createdById: z86.string(),
  createdAt: z86.string().datetime(),
  updatedAt: z86.string().datetime(),
  media: z86.object({
    id: z86.string(),
    originalName: z86.string(),
    uri: z86.object({
      original: z86.string()
    })
  }).nullable()
});
var GenerateReportRequestSchema = z86.union([
  BrandReportRequestSchema,
  ExperienceReportRequestSchema,
  FinancialReportRequestSchema,
  GuestReportRequestSchema,
  FinancialReportV2RequestSchema
]);
var ReportDataByTypeSchema = {
  ["brands" /* BRANDS */]: BrandReportHeaderSchema,
  ["financial" /* FINANCIAL */]: z86.union([FinancialReportWithHeaderSchema, z86.record(z86.string(), z86.unknown())]),
  ["financial-v2" /* FINANCIAL_V2 */]: z86.union([FinancialReportV2WithHeaderSchema, z86.record(z86.string(), z86.unknown())]),
  ["experience" /* EXPERIENCE */]: z86.union([ExperienceReportWithHeaderSchema, z86.record(z86.string(), z86.unknown())]),
  ["guest" /* GUEST */]: GuestReportWithHeaderSchema
};
var PostReportEndpoint = makeEndpoint({
  method: "POST",
  url: ({ type }) => `v2/reports/${type}`,
  responseSchema: FindReportResponseSchema,
  requestSchema: GenerateReportRequestSchema
});
var GetReportEndpoint = makeEndpoint({
  method: "GET",
  url: ({ reportId }) => `v2/reports/${reportId}`,
  responseSchema: FindReportResponseSchema,
  requestSchema: z86.void()
});
var infoItemSchema = z86.object({
  fieldType: z86.enum(["text", "single-select", "multi-select", "checkbox", "date"]),
  label: z86.string(),
  key: z86.string(),
  values: z86.array(z86.object({ label: z86.string(), value: z86.string() })).optional()
});
var reportInfoResponseSchema = z86.object({
  filters: z86.array(infoItemSchema),
  experiences: z86.array(
    z86.object({
      label: z86.string(),
      value: z86.string(),
      kind: z86.enum(["experience", "collection"])
    })
  )
});
var GetReportInfoEndpoint = makeEndpoint({
  method: "GET",
  url: ({ reportType }) => `v2/reports/info/${reportType}`,
  responseSchema: reportInfoResponseSchema,
  requestSchema: z86.void()
});
var DownloadReportEndpoint = makeEndpoint({
  method: "GET",
  url: ({ reportId }) => `v2/reports/${reportId}/download`,
  responseSchema: z86.void(),
  requestSchema: z86.void()
});

// src/api/resource/experience.ts
import { z as z87 } from "zod";
var bulkResourcesCommonFields = ExperienceAsResourceSchema.pick({
  customQuestions: true,
  priceTiers: true,
  priceTierRules: true,
  sessionDurationMinutes: true,
  isTicketed: true,
  cancellationPolicyId: true,
  reschedulePolicyId: true
}).partial({ sessionDurationMinutes: true }).extend({
  bookingAvailabilityMode: ExperienceAsResourceSchema.shape.bookingAvailabilityMode.unwrap().optional(),
  displayedCapacity: ExperienceAsResourceSchema.shape.displayedCapacity.unwrap().optional(),
  description: ExperienceAsResourceSchema.shape.description.unwrap().optional(),
  isUnlisted: ExperienceAsResourceSchema.shape.isUnlisted.unwrap().optional(),
  onlineBookingCutoffHours: ExperienceAsResourceSchema.shape.onlineBookingCutoffHours.unwrap().optional(),
  emailMessage: ExperienceAsResourceSchema.shape.emailMessage.unwrap().optional(),
  notificationEmails: ExperienceAsResourceSchema.shape.notificationEmails.unwrap().optional(),
  notificationOverrides: ExperienceAsResourceSchema.shape.notificationOverrides.unwrap().optional(),
  paymentMethods: ExperienceAsResourceSchema.shape.paymentMethods.unwrap().optional(),
  shouldValidateComplimentaryBooking: ExperienceAsResourceSchema.shape.shouldValidateComplimentaryBooking.unwrap().optional(),
  integrationMeta: ExperienceAsResourceSchema.shape.integrationMeta.unwrap().optional(),
  taxes: ExperienceAsResourceSchema.shape.taxes.unwrap().optional()
});
var bulkResourcesUniqueFields = ExperienceAsResourceSchema.extend({
  id: ExperienceAsResourceSchema.shape.id.optional(),
  maxParticipantsCount: ExperienceAsResourceSchema.shape.maxParticipantsCount.optional()
}).pick({
  id: true,
  title: true,
  number: true,
  position: true,
  shape: true,
  maximumAllowedToBook: true,
  minimumRequiredToBook: true,
  maxParticipantsCount: true
});
var BulkCreateExperiencesRequestSchema = z87.object({
  commonFields: bulkResourcesCommonFields,
  experiences: z87.array(bulkResourcesUniqueFields)
});
var BulkCreateExperiencesEndpoint = makeEndpoint({
  method: "POST",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}/experiences`,
  requestSchema: BulkCreateExperiencesRequestSchema.strict(),
  responseSchema: ResourceGroupResponseSchema
});
var BulkUpdateExperiencesRequestSchema = z87.object({
  commonFields: bulkResourcesCommonFields.partial(),
  experiences: z87.array(bulkResourcesUniqueFields.required({ id: true }))
});
var BulkUpdateExperiencesEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}/experiences`,
  requestSchema: BulkUpdateExperiencesRequestSchema.strict(),
  responseSchema: ResourceGroupResponseSchema
});
var DeleteResourceEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ resourceId, status }) => `v1/experiences/${resourceId}?status=${status}`,
  requestSchema: z87.void(),
  responseSchema: z87.void()
});

// src/api/resource/session.ts
import { z as z88 } from "zod";
var BulkCreateSchedulesRequestSchema = z88.object({
  startDate: DateStringSchema,
  startTimes: z88.array(TimeStringSchema),
  recurrencePattern: z88.object({
    weekdays: z88.array(z88.number().min(1).max(7)),
    until: DateStringSchema
  }).optional(),
  sessionDuration: z88.number().min(1).int()
});
var BulkCreateSchedulesEndpoint = makeEndpoint({
  method: "POST",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}/schedules`,
  requestSchema: BulkCreateSchedulesRequestSchema.strict(),
  responseSchema: z88.void()
});
var BulkDeleteSessionsRequestSchema = z88.object({
  sessions: z88.array(z88.object({ startDateTime: LocalDateTimeStringSchema }))
});
var BulkDeleteSessionsEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({
    brandId,
    resourceGroupCollectionId,
    resourceGroupId
  }) => `/v1/brands/${brandId}/resource-group-collections/${resourceGroupCollectionId}/resource-groups/${resourceGroupId}/sessions`,
  requestSchema: BulkDeleteSessionsRequestSchema.strict(),
  responseSchema: z88.void()
});

// src/api/review/review.ts
import { z as z89 } from "zod";
var Rating = /* @__PURE__ */ ((Rating2) => {
  Rating2[Rating2["ONE"] = 1] = "ONE";
  Rating2[Rating2["TWO"] = 2] = "TWO";
  Rating2[Rating2["THREE"] = 3] = "THREE";
  Rating2[Rating2["FOUR"] = 4] = "FOUR";
  Rating2[Rating2["FIVE"] = 5] = "FIVE";
  return Rating2;
})(Rating || {});
var Recommendability = /* @__PURE__ */ ((Recommendability2) => {
  Recommendability2[Recommendability2["ONE"] = 1] = "ONE";
  Recommendability2[Recommendability2["TWO"] = 2] = "TWO";
  Recommendability2[Recommendability2["THREE"] = 3] = "THREE";
  Recommendability2[Recommendability2["FOUR"] = 4] = "FOUR";
  Recommendability2[Recommendability2["FIVE"] = 5] = "FIVE";
  Recommendability2[Recommendability2["SIX"] = 6] = "SIX";
  Recommendability2[Recommendability2["SEVEN"] = 7] = "SEVEN";
  Recommendability2[Recommendability2["EIGHT"] = 8] = "EIGHT";
  Recommendability2[Recommendability2["NINE"] = 9] = "NINE";
  Recommendability2[Recommendability2["TEN"] = 10] = "TEN";
  return Recommendability2;
})(Recommendability || {});
var PostReviewRequestSchema = z89.object({
  rating: z89.coerce.number().transform((n) => {
    const res = z89.nativeEnum(Rating).safeParse(n);
    return res.success ? res.data : 5 /* FIVE */;
  }),
  recommendability: z89.coerce.number().transform((n) => {
    const res = z89.nativeEnum(Recommendability).safeParse(n);
    return res.success ? res.data : 10 /* TEN */;
  }),
  text: z89.string(),
  token: z89.string()
});
var PostReviewEndpoint = makeEndpoint({
  method: "POST",
  url: () => "v1/reviews",
  responseSchema: z89.void(),
  requestSchema: PostReviewRequestSchema
});
var BrandsReviewsSummaryResponseSchema = z89.object({
  brandId: z89.string(),
  host: z89.object({
    id: z89.string(),
    fullName: z89.string(),
    profilePicture: IMediaReferenceSchema.nullable()
  }).optional(),
  brand: z89.object({
    id: z89.string(),
    name: z89.string(),
    logo: IMediaReferenceSchema.nullable()
  }).optional(),
  experience: z89.object({
    id: z89.string(),
    title: z89.string(),
    coverPicture: IMediaReferenceSchema.nullable()
  }).optional(),
  resourceGroup: z89.object({
    id: z89.string(),
    title: z89.string(),
    resourceGroupCollectionId: z89.string(),
    coverPicture: IMediaReferenceSchema.nullable()
  }).optional(),
  totalReviews: z89.string(),
  averageRating: z89.string(),
  npsScore: z89.string().nullable(),
  reviewPercentage: z89.string()
}).strict();
var GetBrandsReviewsSummaryResponseSchema = paginateResponseSchema(BrandsReviewsSummaryResponseSchema);
var GetBrandsReviewsSummaryQuerySchema = paginateQuerySchema({
  sortBy: ["averageRating", "npsScore", "totalReviews", "reviewPercentage"]
}).omit({ filters: true }).extend({
  sortOrder: z89.enum(["ASC", "DESC"]).optional(),
  groupBy: z89.enum(summaryGroupingOptions)
});
var GetBrandsReviewsSummaryEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    entityType,
    entityId,
    query
  }) => `v1/${entityType}/${entityId}/review-summary?${buildQueryString(query)}`,
  responseSchema: GetBrandsReviewsSummaryResponseSchema,
  requestSchema: z89.void(),
  querySchema: GetBrandsReviewsSummaryQuerySchema
});

// src/api/staff-user/staff-users.ts
import { z as z90 } from "zod";
var StaffUserStatus = /* @__PURE__ */ ((StaffUserStatus2) => {
  StaffUserStatus2["ACTIVE"] = "active";
  StaffUserStatus2["DEACTIVATED"] = "deactivated";
  StaffUserStatus2["INVITED"] = "invited";
  return StaffUserStatus2;
})(StaffUserStatus || {});
var StatusesSchema = z90.nativeEnum(StaffUserStatus);
var RolesSchema = z90.nativeEnum(StaffRole);
var StaffUserSchema = z90.object({
  profilePicture: z90.object({
    id: z90.string(),
    uri: z90.object({ original: z90.string() }).and(z90.record(z90.string()))
  }).nullable(),
  firstName: z90.string(),
  lastName: z90.string(),
  email: EmailStringSchema,
  phoneNumber: z90.string().nullable(),
  role: RolesSchema,
  status: StatusesSchema,
  permissions: z90.array(z90.nativeEnum(PERMISSION)),
  id: z90.string().uuid()
});
var GetStaffUsersResponseSchema = paginateResponseSchema(StaffUserSchema);
var GetStaffUsersQuerySchema = paginateQuerySchema({
  sortBy: ["firstName", "lastName", "role", "status"]
});
var CreateStaffUsersRequestSchema = StaffUserSchema.pick({
  email: true,
  firstName: true,
  lastName: true,
  role: true
}).extend({
  permissions: StaffUserSchema.shape.permissions.optional()
});
var CreateStaffUsersResponseSchema = StaffUserSchema;
var UpdateStaffUsersRequestSchema = StaffUserSchema.pick({
  email: true,
  firstName: true,
  lastName: true,
  role: true,
  permissions: true
}).partial();
var UpdateStaffUsersResponseSchema = StaffUserSchema;

// src/api/survey/public.ts
import { z as z94 } from "zod";

// src/api/survey/survey.ts
import { z as z92 } from "zod";

// src/api/survey/survey-questions.ts
import { z as z91 } from "zod";
var SurveyQuestionType = /* @__PURE__ */ ((SurveyQuestionType2) => {
  SurveyQuestionType2["SCALE_3"] = "SCALE_3";
  SurveyQuestionType2["BINARY"] = "BINARY";
  return SurveyQuestionType2;
})(SurveyQuestionType || {});
var SurveyQuestionTypeSchema = z91.nativeEnum(SurveyQuestionType);
var SurveyQuestionsSchema = z91.object({
  surveyQuestionId: z91.string().uuid(),
  surveyQuestionHistoryId: z91.string().uuid(),
  active: z91.boolean(),
  weight: z91.number(),
  type: SurveyQuestionTypeSchema,
  label: z91.string(),
  isAnalyticsActive: z91.boolean().optional().nullable(),
  analyticsTitle: z91.string().optional().nullable(),
  analyticsDescription: z91.string().optional().nullable()
});
var SurveyQuestionWithAggregateAnswerSchema = z91.object({
  surveyQuestionId: z91.string(),
  active: z91.boolean(),
  weight: z91.number(),
  type: SurveyQuestionTypeSchema,
  label: z91.string(),
  isAnalyticsActive: z91.boolean().optional().nullable(),
  analyticsTitle: z91.string().optional().nullable(),
  analyticsDescription: z91.string().optional().nullable(),
  answers: z91.array(
    z91.object({
      answer: z91.string().nullable(),
      count: z91.number()
    })
  )
});
var SurveyQuestionWithAggregateAnswerResponseSchema = z91.array(SurveyQuestionWithAggregateAnswerSchema);
var GetSurveyQuestionsEndpoint = makeEndpoint({
  method: "GET",
  url: () => `v1/survey-questions`,
  requestSchema: z91.void(),
  responseSchema: z91.array(SurveyQuestionsSchema)
});
var PostSurveyQuestionsEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/survey-questions`,
  requestSchema: SurveyQuestionsSchema,
  responseSchema: z91.void()
});
var DeleteSurveyQuestionsEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ surveyQuestionId }) => `v1/survey-questions/${surveyQuestionId}`,
  requestSchema: z91.void(),
  responseSchema: z91.void()
});
var PatchSurveyQuestionsEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ surveyQuestionId }) => `v1/survey-questions/${surveyQuestionId}`,
  requestSchema: SurveyQuestionsSchema.pick({
    active: true,
    isAnalyticsActive: true,
    analyticsTitle: true,
    analyticsDescription: true
  }),
  responseSchema: z91.void()
});
var GetBrandSurveyQuestionsWithAggregateAnswerEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId }) => `v1/brands/${brandId}/survey-questions/aggregate-answers`,
  requestSchema: z91.void(),
  responseSchema: SurveyQuestionWithAggregateAnswerResponseSchema
});
var GetOrganizationSurveyQuestionsWithAggregateAnswerEndpoint = makeEndpoint({
  method: "GET",
  url: ({ organizationId, currency }) => `v1/organizations/${organizationId}/survey-questions/aggregate-answers/${currency}`,
  requestSchema: z91.void(),
  responseSchema: SurveyQuestionWithAggregateAnswerResponseSchema
});
var GetOwnSurveyQuestionsWithAggregateAnswerEndpoint = makeEndpoint({
  method: "GET",
  url: ({ currency }) => `v1/survey-questions/me/aggregate-answers/${currency}`,
  requestSchema: z91.void(),
  responseSchema: SurveyQuestionWithAggregateAnswerResponseSchema
});

// src/api/survey/survey.ts
var SurveySchema = z92.object({
  id: z92.string().uuid(),
  questions: z92.array(
    SurveyQuestionsSchema.pick({ surveyQuestionHistoryId: true, type: true, label: true }).extend({
      answer: z92.string().nullable()
    })
  )
});

// src/api/survey/survey-answers.ts
import { z as z93 } from "zod";
var SurveyQuestionAnswerSchema = z93.object({
  surveyQuestionHistoryId: z93.string().uuid(),
  answer: z93.string()
});
var SurveyAnswersSchema = z93.object({
  answers: z93.array(SurveyQuestionAnswerSchema)
});

// src/api/survey/public.ts
var PostSurveyRequestSchema = z94.object({
  cartId: z94.string().uuid()
});
var PostSurveyResponseSchema = SurveySchema;
var PostSurveyAnswersRequestSchema = SurveyAnswersSchema;
var PostSurveyEndpoint = makeEndpoint({
  method: "POST",
  url: () => `v1/surveys`,
  requestSchema: PostSurveyRequestSchema,
  responseSchema: PostSurveyResponseSchema.optional()
});
var PostAnswersEndpoint = makeEndpoint({
  method: "POST",
  url: ({ surveyId }) => `v1/surveys/${surveyId}/answers`,
  requestSchema: PostSurveyAnswersRequestSchema,
  responseSchema: z94.void()
});

// src/api/user/membership.ts
import { z as z95 } from "zod";
var MembershipCurrenciesOfUserQueryRequestSchema = z95.object({
  organizationId: z95.string().uuid().optional()
});
var GetMembershipCurrenciesOfUserEndpoint = makeEndpoint({
  method: "GET",
  url: () => `v1/users/me/currencies`,
  requestSchema: MembershipCurrenciesOfUserQueryRequestSchema,
  responseSchema: z95.array(z95.string())
});

// src/api/vibe/get-translations-for-vibes.ts
import { z as z96 } from "zod";
var GetTranslationsForVibesQuerySchema = z96.object({
  vibeId: z96.string().uuid().optional(),
  language: z96.nativeEnum(LanguageCode).optional()
});
var GetTranslationsForVibesEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, query }) => `/v1/brands/${brandId}/vibes/i18n?${buildQueryString(query)}`,
  responseSchema: z96.object({
    translations: z96.array(TranslationSchema)
  }),
  requestSchema: z96.void(),
  querySchema: GetTranslationsForVibesQuerySchema
});

// src/api/vibe/rearrange-vibe.ts
import { z as z97 } from "zod";
var RearrangeVibeRequestSchema = z97.object({
  vibeIds: z97.array(z97.string().uuid())
});
var RearrangeVibeEndpoint = makeEndpoint({
  method: "PUT",
  url: (params) => `v1/brands/${params.brandId}/vibes/rearrange`,
  responseSchema: z97.void(),
  requestSchema: RearrangeVibeRequestSchema
});

// src/api/vibe/update-vibes.ts
import { z as z98 } from "zod";
var BulkUpdateVibeSchema = z98.object({
  id: z98.string().uuid().optional().nullable(),
  name: z98.string(),
  order: z98.number()
});
var UpdateVibesDataSchema = z98.object({
  vibes: z98.array(BulkUpdateVibeSchema)
});
var UpdateVibesEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId }) => `v1/brands/${brandId}/vibes`,
  responseSchema: z98.void(),
  requestSchema: UpdateVibesDataSchema
});

// src/api/vibe/update-translation.ts
import { z as z99 } from "zod";
var PatchVibesTranslationsRequestSchema = z99.object({
  translations: z99.array(TranslationSchema.omit({ createdAt: true, updatedAt: true, version: true }))
});
var PatchVibesTranslationsEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId }) => `/v1/${brandId}/vibes/i18n`,
  requestSchema: PatchVibesTranslationsRequestSchema,
  responseSchema: z99.void()
});

// src/api/waitlist/waitlist.ts
import { z as z100 } from "zod";
var WaitlistMode = /* @__PURE__ */ ((WaitlistMode2) => {
  WaitlistMode2["AUTO"] = "auto";
  WaitlistMode2["MANUAL"] = "manual";
  WaitlistMode2["NONE"] = "none";
  return WaitlistMode2;
})(WaitlistMode || {});
var WaitlistSchema = z100.object({
  id: z100.string().uuid(),
  claimTime: z100.number().nullable(),
  mode: z100.nativeEnum(WaitlistMode),
  shouldShowRemovedEntries: z100.boolean()
}).strict();
var UpdateWaitlistRequestSchema = WaitlistSchema.omit({ id: true }).partial();
var UpdateWaitlistEndpoint = makeEndpoint({
  method: "PATCH",
  url: ({ brandId, waitlistId }) => `/v1/brands/${brandId}/waitlists/${waitlistId}`,
  requestSchema: UpdateWaitlistRequestSchema,
  responseSchema: z100.void()
});
var GetWaitlistEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, waitlistId }) => `/v1/brands/${brandId}/waitlists/${waitlistId}`,
  requestSchema: z100.void(),
  responseSchema: WaitlistSchema
});
var PublicWaitlistSchema = WaitlistSchema.omit({ claimTime: true });
var PublicGetWaitlistEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, waitlistId }) => `/v1/brands/${brandId}/waitlists/${waitlistId}`,
  requestSchema: z100.void(),
  responseSchema: PublicWaitlistSchema
});

// src/api/waitlist/waitlist-entry.ts
import { z as z101 } from "zod";
var WaitlistEntryStatus = /* @__PURE__ */ ((WaitlistEntryStatus2) => {
  WaitlistEntryStatus2["REMOVED"] = "removed";
  WaitlistEntryStatus2["WAITING"] = "waiting";
  WaitlistEntryStatus2["OFFERED"] = "offered";
  WaitlistEntryStatus2["ACCEPTED"] = "accepted";
  WaitlistEntryStatus2["DECLINED"] = "declined";
  WaitlistEntryStatus2["EXPIRED"] = "expired";
  WaitlistEntryStatus2["OPENING_AVAILABLE"] = "opening-available";
  return WaitlistEntryStatus2;
})(WaitlistEntryStatus || {});
var JoinWaitlistRequestSchema = z101.object({
  sessionStartDate: DateStringSchema,
  sessionStartTime: TimeStringSchema,
  sessionDuration: z101.number(),
  purchaser: PurchaserWithCustomQuestionsSchema.omit({ id: true }),
  participants: z101.array(ParticipantSchema).min(1)
});
var JoinWaitlistResponseSchema = z101.void({});
var JoinWaitlistEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, waitlistId }) => `/v1/brands/${brandId}/waitlists/${waitlistId}/entries`,
  requestSchema: JoinWaitlistRequestSchema,
  responseSchema: JoinWaitlistResponseSchema
});
var WaitlistParticipantSchema = BaseParticipantOrPurchaserSchema.omit({ type: true }).extend({
  id: z101.string().uuid(),
  priceTierName: z101.string().optional().nullable(),
  cancelledAt: z101.string().datetime().nullable(),
  customQuestionAnswers: z101.array(CustomQuestionAnswerBookingResponseSchema).optional()
});
var WaitlistPurchaserSchema = BaseParticipantOrPurchaserSchema.omit({ type: true }).extend({
  id: z101.string().uuid(),
  customQuestionAnswers: z101.array(CustomQuestionAnswerBookingResponseSchema).optional()
});
var WaitlistEntrySchema = z101.object({
  id: z101.string().uuid(),
  status: z101.nativeEnum(WaitlistEntryStatus),
  resourceGroupCollectionId: z101.string().uuid(),
  startDate: DateStringSchema,
  startTime: TimeStringSchema,
  sessionDuration: z101.number(),
  participants: z101.array(WaitlistParticipantSchema),
  purchaser: WaitlistPurchaserSchema,
  expiresAt: z101.string().datetime().nullable()
});
var GetWaitlistEntriesQuerySchema = paginateQuerySchema().extend({
  sessionDate: DateStringSchema.optional(),
  sessionStartTime: TimeStringSchema.optional(),
  filters: z101.array(
    z101.object({
      operator: z101.literal("in"),
      name: z101.literal("status"),
      value: z101.array(z101.nativeEnum(WaitlistEntryStatus))
    })
  ).optional()
});
var GetWaitlistEntriesResponseSchema = paginateResponseSchema(WaitlistEntrySchema);
var GetWaitlistEntriesEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    brandId,
    waitlistId,
    query
  }) => `/v1/brands/${brandId}/waitlists/${waitlistId}/entries?${buildQueryString(query)}`,
  responseSchema: GetWaitlistEntriesResponseSchema,
  requestSchema: z101.void(),
  querySchema: GetWaitlistEntriesQuerySchema
});
var SendWaitlistInvitationOfferEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, waitlistId, waitlistEntryId }) => `/v1/brands/${brandId}/waitlists/${waitlistId}/entries/${waitlistEntryId}/offer-invitation`,
  requestSchema: z101.void(),
  responseSchema: z101.void()
});
var OrderWaitlistEntriesRequestSchema = z101.object({
  waitlistEntryIds: z101.array(z101.string().uuid()).min(1)
});
var OrderWaitlistEntriesEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, waitlistId }) => `/v1/brands/${brandId}/waitlists/${waitlistId}/order-waitlist-entries`,
  requestSchema: OrderWaitlistEntriesRequestSchema,
  responseSchema: z101.void()
});
var RemoveGuestFromWaitlistEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, waitlistId, waitlistEntryId }) => `/v1/brands/${brandId}/waitlists/${waitlistId}/entries/${waitlistEntryId}/remove`,
  requestSchema: z101.void(),
  responseSchema: z101.void()
});
var WaitlistEntryPublicSchema = WaitlistEntrySchema.omit({});
var GetWaitlistEntryPublicEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, waitlistEntryId }) => `/v1/brands/${brandId}/waitlist-invitation-offered/${waitlistEntryId}`,
  responseSchema: WaitlistEntryPublicSchema,
  requestSchema: z101.void()
});

// src/api/webhook/webhook.ts
import { z as z102 } from "zod";
var WebhookEntityType = /* @__PURE__ */ ((WebhookEntityType2) => {
  WebhookEntityType2["BRAND"] = "brand";
  WebhookEntityType2["ORGANIZATION"] = "organization";
  return WebhookEntityType2;
})(WebhookEntityType || {});
var WebhookEvents = /* @__PURE__ */ ((WebhookEvents2) => {
  WebhookEvents2["BOOKING_CANCELLED"] = "booking.cancelled";
  WebhookEvents2["EXPERIENCE_PUBLISHED"] = "experience.published";
  WebhookEvents2["LISTING_PUBLISHED"] = "listing.published";
  WebhookEvents2["LISTING_UNPUBLISHED"] = "listing.unpublished";
  WebhookEvents2["BOOKING_COMPLETED"] = "booking.completed";
  WebhookEvents2["BOOKING_REFUNDED"] = "booking.refunded";
  WebhookEvents2["BOOKING_RESCHEDULED"] = "booking.rescheduled";
  WebhookEvents2["FINANCIAL_REPORT_UPDATED"] = "financialReport.updated";
  WebhookEvents2["FINANCIAL_REPORT_V2_UPDATED"] = "financialReportV2.updated";
  WebhookEvents2["REVIEW_COMPLETED"] = "review.completed";
  return WebhookEvents2;
})(WebhookEvents || {});
var WebhookResponseSchema = z102.object({
  id: z102.string(),
  url: z102.string().url(),
  events: z102.array(z102.nativeEnum(WebhookEvents)),
  status: z102.boolean(),
  userId: z102.string().uuid(),
  secret: z102.string().nullable().optional(),
  brandId: z102.string().uuid().nullable(),
  organizationId: z102.string().uuid().nullable(),
  createdAt: z102.string().datetime()
});
var PaginatedWebhookResponseSchema = paginateResponseSchema(WebhookResponseSchema);
var WebhookRequestSchema = z102.object({
  url: z102.string().url(),
  events: z102.array(z102.nativeEnum(WebhookEvents)).min(1),
  status: z102.boolean(),
  secret: z102.string().optional()
});
var GetPaginatedWebhooksEndpoint = makeEndpoint({
  method: "GET",
  url: ({ entityType, entityId }) => `v1/${entityType}/${entityId}/webhooks`,
  responseSchema: PaginatedWebhookResponseSchema,
  requestSchema: z102.void()
});
var GetWebhookDetailEndpoint = makeEndpoint({
  method: "GET",
  url: ({ entityType, entityId, webhookId }) => `v1/${entityType}/${entityId}/webhooks/${webhookId}`,
  responseSchema: WebhookResponseSchema,
  requestSchema: z102.void()
});
var CreateWebhookEndpoint = makeEndpoint({
  method: "POST",
  url: ({ entityType, entityId }) => `v1/${entityType}/${entityId}/webhooks`,
  responseSchema: z102.void(),
  requestSchema: WebhookRequestSchema
});
var UpdateWebhookEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ entityType, entityId, webhookId }) => `v1/${entityType}/${entityId}/webhooks/${webhookId}`,
  responseSchema: z102.void(),
  requestSchema: WebhookRequestSchema
});
var DeleteWebhookEndpoint = makeEndpoint({
  method: "DELETE",
  url: ({ entityType, entityId, webhookId }) => `v1/${entityType}/${entityId}/webhooks/${webhookId}`,
  responseSchema: z102.void(),
  requestSchema: z102.void()
});

// src/api/webhook/webhook-event-history.ts
import { z as z103 } from "zod";
var WebhookEventHistoryStatus = /* @__PURE__ */ ((WebhookEventHistoryStatus2) => {
  WebhookEventHistoryStatus2["SUCCESS"] = "success";
  WebhookEventHistoryStatus2["FAILED"] = "failed";
  return WebhookEventHistoryStatus2;
})(WebhookEventHistoryStatus || {});
var WebhookEventStatus = /* @__PURE__ */ ((WebhookEventStatus2) => {
  WebhookEventStatus2["PENDING"] = "pending";
  WebhookEventStatus2["SUCCESS"] = "success";
  WebhookEventStatus2["FAILED"] = "failed";
  return WebhookEventStatus2;
})(WebhookEventStatus || {});
var PaginatedWebhookEventHistoryQueryRequestSchema = z103.object({
  from: z103.string().optional(),
  to: z103.string().optional(),
  status: z103.nativeEnum(WebhookEventHistoryStatus).optional()
});
var PaginatedWebhookEventHistoryResponseSchema = paginateResponseSchema(
  z103.object({
    id: z103.string(),
    event: z103.nativeEnum(WebhookEvents),
    status: z103.nativeEnum(WebhookEventHistoryStatus),
    createdAt: z103.string().datetime()
  })
);
var WebhookEventHistoryDetailResponseSchema = z103.object({
  id: z103.string(),
  url: z103.string().url(),
  status: z103.nativeEnum(WebhookEventHistoryStatus),
  response: z103.record(z103.string(), z103.unknown()),
  webhookEventId: z103.string().uuid(),
  createdAt: z103.string().datetime(),
  updatedAt: z103.string().datetime(),
  webhookEvent: z103.object({
    id: z103.string().uuid(),
    event: z103.nativeEnum(WebhookEvents),
    payload: z103.record(z103.string(), z103.unknown()),
    status: z103.nativeEnum(WebhookEventStatus),
    retryCount: z103.number(),
    webhookId: z103.string().uuid(),
    createdAt: z103.string().datetime(),
    updatedAt: z103.string().datetime()
  })
});
var GetPaginatedWebhookEventHistoryEndpoint = makeEndpoint({
  method: "GET",
  url: ({ entityType, entityId, webhookId }) => `v1/${entityType}/${entityId}/webhooks/${webhookId}/webhook-event-history`,
  responseSchema: PaginatedWebhookEventHistoryResponseSchema,
  requestSchema: PaginatedWebhookEventHistoryQueryRequestSchema
});
var FindWebhookEventHistoryDetailEndpoint = makeEndpoint({
  method: "GET",
  url: ({
    entityType,
    entityId,
    webhookId,
    webhookEventHistoryId
  }) => `v1/${entityType}/${entityId}/webhooks/${webhookId}/webhook-event-history/${webhookEventHistoryId}`,
  responseSchema: WebhookEventHistoryDetailResponseSchema,
  requestSchema: z103.void()
});

// src/api/hyatt/authentication.ts
import { z as z104 } from "zod";
var AuthenticateResponseSchema = z104.object({
  accessToken: z104.string(),
  expiresIn: z104.number(),
  tokenType: z104.string(),
  clientId: z104.string()
});
var AuthenticateRequestSchema = z104.object({
  code: z104.string(),
  redirectUrl: z104.string()
});
var AuthenticateEndpoint = makeEndpoint({
  method: "POST",
  url: () => "hyatt/authenticate",
  responseSchema: AuthenticateResponseSchema,
  requestSchema: AuthenticateRequestSchema
});

// src/api/hyatt/member.ts
import { z as z105 } from "zod";
var MemberProfileEndpoint = makeEndpoint({
  method: "GET",
  url: () => "hyatt/member",
  requestSchema: z105.object({
    accessToken: z105.string().nonempty("Access Token is required")
  }),
  responseSchema: z105.object({
    loyaltyId: z105.string().nonempty(),
    memberSince: z105.string().nonempty(),
    tierCode: z105.string().nonempty(),
    tierExpiration: z105.string().nonempty(),
    firstName: z105.string().nonempty(),
    points: z105.string().nonempty()
  })
});

// src/api/duration/duration.ts
import { z as z106 } from "zod";
var DurationField = /* @__PURE__ */ ((DurationField2) => {
  DurationField2["LABEL"] = "label";
  return DurationField2;
})(DurationField || {});
var DurationSchema = z106.object({
  id: z106.string().uuid().optional(),
  label: z106.string(),
  duration: z106.number()
});
var FindDurationsByDurationSetIdResponseSchema = z106.object({
  durationSetId: z106.string().uuid(),
  durations: z106.array(DurationSchema)
});
var FindDurationsByDurationSetIdEndpoint = makeEndpoint({
  method: "GET",
  url: ({ durationSetId }) => `v1/duration-set/${durationSetId}`,
  responseSchema: FindDurationsByDurationSetIdResponseSchema,
  requestSchema: z106.void()
});
var CreateDurationsForExperienceResponseSchema = z106.object({
  durationSetId: z106.string().uuid(),
  durations: z106.array(DurationSchema)
});
var CreateDurationsForExperienceRequestSchema = z106.object({
  durations: z106.array(
    z106.object({
      label: z106.string(),
      duration: z106.number()
    })
  )
});
var CreateDurationsForExperienceEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, experienceId }) => `v1/brands/${brandId}/experiences/${experienceId}/durations`,
  responseSchema: CreateDurationsForExperienceResponseSchema,
  requestSchema: CreateDurationsForExperienceRequestSchema
});
var CreateDurationsForResourceGroupResponseSchema = z106.object({
  durationSetId: z106.string().uuid(),
  durations: z106.array(DurationSchema)
});
var CreateDurationsForResourceGroupRequestSchema = z106.object({
  durations: z106.array(DurationSchema)
});
var CreateDurationsForResourceGroupEndpoint = makeEndpoint({
  method: "POST",
  url: ({ brandId, resourceGroupId }) => `v1/brands/${brandId}/resource-groups/${resourceGroupId}/durations`,
  responseSchema: CreateDurationsForResourceGroupResponseSchema,
  requestSchema: CreateDurationsForResourceGroupRequestSchema
});
var UpdateDurationRequestSchema = z106.object({
  label: z106.string()
});
var UpdateDurationEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ durationId }) => `v1/durations/${durationId}`,
  responseSchema: z106.void(),
  requestSchema: UpdateDurationRequestSchema
});
var UpdateDurationsByExperienceIdRequestSchema = z106.object({
  durations: z106.array(
    z106.object({
      id: z106.string().uuid().optional(),
      label: z106.string(),
      duration: z106.number()
    })
  )
});
var UpdateDurationsByExperienceIdEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId, experienceId }) => `v1/brands/${brandId}/experiences/${experienceId}/durations`,
  responseSchema: z106.void(),
  requestSchema: UpdateDurationsByExperienceIdRequestSchema
});
var UpdateDurationsByResourceGroupIdRequestSchema = z106.object({
  durations: z106.array(DurationSchema)
});
var UpdateDurationsByResourceGroupIdEndpoint = makeEndpoint({
  method: "PUT",
  url: ({ brandId, resourceGroupId }) => `v1/brands/${brandId}/resource-groups/${resourceGroupId}/durations`,
  responseSchema: z106.void(),
  requestSchema: UpdateDurationsByResourceGroupIdRequestSchema
});
var FindDurationsByExperienceIdResponseSchema = z106.object({
  durationSetId: z106.string().uuid(),
  version: z106.string(),
  durations: z106.array(DurationSchema)
});
var FindDurationsByExperienceIdEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, experienceId, version }) => `v1/brands/${brandId}/experiences/${experienceId}/durations/${version}`,
  responseSchema: FindDurationsByExperienceIdResponseSchema,
  requestSchema: z106.void()
});
var FindDurationsByResourceGroupIdResponseSchema = z106.object({
  durationSetId: z106.string().uuid(),
  version: z106.string(),
  durations: z106.array(DurationSchema)
});
var FindDurationsByResourceGroupIdEndpoint = makeEndpoint({
  method: "GET",
  url: ({ brandId, resourceGroupId, version }) => `v1/brands/${brandId}/resource-groups/${resourceGroupId}/durations/${version}`,
  responseSchema: FindDurationsByResourceGroupIdResponseSchema,
  requestSchema: z106.void()
});

// src/api/simphony/schemas.ts
import { z as z107 } from "zod";
var SuggestedTipSchema = z107.object({
  isDefault: z107.boolean(),
  percentage: z107.number()
});
var OrderTypeSchema = z107.object({
  orderTypeRef: z107.number(),
  name: z107.string(),
  serviceLevelTime: z107.number().optional(),
  suggestedTips: z107.array(SuggestedTipSchema).optional()
});
var OrderChannelSchema = z107.object({
  orderChannelId: z107.number(),
  name: z107.record(z107.string()),
  // e.g. { "en-US": "Default" }
  isDefault: z107.boolean(),
  serviceLevelTime: z107.number().optional()
});
var PostalAddressSchema = z107.object({
  addressLine1: z107.string(),
  addressLine2: z107.string().optional(),
  floor: z107.string().optional(),
  locality: z107.string(),
  region: z107.string(),
  postalCode: z107.string(),
  country: z107.string(),
  notes: z107.string().optional()
});
var GeoLocationSchema = z107.object({
  latitude: z107.number(),
  longitude: z107.number()
});
var ExtensionDataSchema = z107.unknown();
var PhoneNumberSchema2 = z107.string();
var SimphonyRevenueCenterSchema = z107.object({
  orgShortName: z107.string(),
  locRef: z107.string(),
  rvcRef: z107.number(),
  name: z107.string(),
  orderTypes: z107.array(OrderTypeSchema).optional(),
  orderChannels: z107.array(OrderChannelSchema).optional(),
  tables: z107.array(z107.string()).optional(),
  consumerName: z107.string().optional(),
  address: PostalAddressSchema.optional(),
  geoLocation: GeoLocationSchema.optional(),
  extensions: ExtensionDataSchema.optional(),
  phoneNumber: PhoneNumberSchema2.optional()
});
var SimphonyMenuItemSchema = z107.object({
  menuItemId: z107.number(),
  definitionSequence: z107.number(),
  name: z107.object({
    "en-US": z107.string()
  }),
  quantity: z107.number(),
  unitPrice: z107.number(),
  priceSequence: z107.number(),
  total: z107.number(),
  seat: z107.number(),
  referenceText: z107.string(),
  surcharge: z107.number(),
  itemDiscounts: z107.array(z107.any()),
  condiments: z107.array(z107.any()),
  extensions: z107.array(z107.any())
});
var SimphonyMenuCategorySchema = z107.object({
  id: z107.number(),
  name: z107.string(),
  items: z107.array(SimphonyMenuItemSchema)
});
var MenuPriceSchema = z107.object({
  price: z107.number(),
  priceSequence: z107.number()
});
var CondimentGroupRuleSchema = z107.object({
  condimentGroupRef: z107.number(),
  minimumCount: z107.number(),
  maximumCount: z107.number()
});
var SimphonyMenuDefinitionSchema = z107.object({
  name: z107.record(z107.string()),
  prices: z107.array(MenuPriceSchema),
  condimentGroupRules: z107.array(CondimentGroupRuleSchema).optional(),
  allergens: z107.array(z107.string()).optional()
});
var SimphonyMenuItemDetailSchema = SimphonyMenuItemSchema.extend({
  familyGroupRef: z107.number(),
  definitions: z107.array(SimphonyMenuDefinitionSchema)
});
var condimentItemSchema = z107.object({
  condimentId: z107.number(),
  name: z107.record(z107.string())
});
var SimphonyMenuDetailSchema = z107.object({
  menuId: z107.string(),
  menuItems: z107.array(SimphonyMenuItemDetailSchema),
  condimentItems: z107.array(condimentItemSchema)
});
var SimphonyMenuSummarySchema = z107.object({
  categories: z107.array(SimphonyMenuCategorySchema),
  items: z107.array(SimphonyMenuItemSchema),
  status: z107.string(),
  message: z107.string().optional()
});
var SimphonyTenderItemSchema = z107.object({
  tenderId: z107.number(),
  name: z107.string(),
  tenderMediaId: z107.number(),
  tenderMediaRef: z107.number(),
  tenderMediaObjectNumber: z107.number()
});
var SimphonyTenderCollectionSchema = z107.object({
  items: z107.array(SimphonyTenderItemSchema),
  status: z107.string(),
  message: z107.string().optional()
});

// src/api/simphony/endpoints.ts
import { z as z108 } from "zod";
var GetBrandRevenueCentersResponseSchema = z108.object({
  count: z108.number(),
  limit: z108.number(),
  offset: z108.number(),
  items: z108.array(SimphonyRevenueCenterSchema)
});
var GetBrandRevenueCentersEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `v1/simphony/revenue-centers?${buildQueryString(query)}`,
  requestSchema: z108.void(),
  querySchema: z108.object({
    brandId: z108.string()
  }),
  responseSchema: GetBrandRevenueCentersResponseSchema
});
var QuerySchema = z108.object({
  rvcRef: z108.string(),
  brandId: z108.string()
});
var GetBrandMenuSummaryEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `v1/simphony/menu/summary?${buildQueryString(query)}`,
  requestSchema: z108.void(),
  querySchema: QuerySchema,
  responseSchema: SimphonyMenuSummarySchema
});
var GetBrandMenuEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `v1/simphony/menu?${buildQueryString(query)}`,
  requestSchema: z108.void(),
  querySchema: QuerySchema,
  responseSchema: SimphonyMenuDetailSchema
});
var GetBrandTendersCollectionEndpoint = makeEndpoint({
  method: "GET",
  url: ({ query }) => `v1/simphony/tenders/collection?${buildQueryString(query)}`,
  requestSchema: z108.void(),
  querySchema: QuerySchema,
  responseSchema: SimphonyTenderCollectionSchema
});

// src/api/alaska/member.ts
import { z as z109 } from "zod";
var AlaskaGetMemberResponseSchema = z109.object({
  data: z109.object({
    TopRankedBankCardDesignatorCode: z109.string(),
    TopRankedBankCardDesignator: z109.string(),
    LoyaltyDetails: z109.object({
      LoyaltyNumber: z109.string(),
      StatusPoints: z109.number(),
      PreviousYearStatusPoints: z109.number(),
      MemberBalance: z109.number(),
      Tier: z109.object({
        Code: z109.string(),
        Description: z109.string(),
        TierEndDate: z109.string(),
        TierStartDate: z109.string()
      })
    }),
    MemberProfile: z109.object({
      DateOfBirth: z109.string(),
      LastProcessedTransactionDateTime: z109.string(),
      ZipCode: z109.string(),
      CountryCode: z109.string(),
      RegionCode: z109.string(),
      AccountCreationDate: z109.string(),
      ContactEmail: z109.string(),
      FirstName: z109.string(),
      LastName: z109.string(),
      MemberType: z109.string(),
      MemberStatus: z109.string(),
      FraudAlertFlag: z109.boolean(),
      IsValid: z109.boolean(),
      StatusMessage: z109.string()
    })
  })
});
var AlaskaGetMemberSchema = z109.object({
  loyaltyNumber: z109.string(),
  lastName: z109.string()
});
var AlaskaGetMemberEndpoint = makeEndpoint({
  method: "GET",
  url: () => "alaska/member/profile",
  requestSchema: AlaskaGetMemberSchema,
  responseSchema: AlaskaGetMemberResponseSchema
});
export {
  ACCOUNT_EXECUTIVE_PERMISSIONS,
  ADDITIONAL_HOST_PERMISSIONS,
  ADMIN_PERMISSIONS,
  ANALYTICS_EVENT,
  ANALYTICS_PROPERTY,
  AUCTION_CLOSE_SOON_OFFSET_MINUTES,
  AUCTION_CLOSE_VERY_SOON_OFFSET_MINUTES,
  AUCTION_DEBUG_INTERVAL_MINUTES,
  AUCTION_DEFAULT_MIN_BID_INCREMENT,
  AUCTION_DEFAULT_START_AMOUNT,
  AUCTION_HARD_CLOSE_GRACE_PERIOD_MINUTES,
  AUCTION_LOCKED_PERIOD_MS,
  AUCTION_MIN_DURATION_MS,
  AUCTION_MUST_SUCCEED_MOMENTS,
  AUCTION_OFFER_CLAIM_GRACE_PERIOD_HOURS,
  AUCTION_OFFER_LAST_CHANCE_GRACE_PERIOD_HOURS,
  AUCTION_OFFER_REMIND_GRACE_PERIOD_HOURS,
  AUCTION_OPEN_GRACE_PERIOD_MINUTES,
  AUCTION_OPEN_SOON_OFFSET_MINUTES,
  AUCTION_RETRY_UNTIL_SUCCESS_MOMENTS,
  AUCTION_SKIPPABLE_MOMENTS,
  AUCTION_STATUS_TOPIC_NAME,
  AVAILABLE_BRAND_FEATURES,
  AddOnField,
  AddOnImageSize,
  AddOnImageSizeMediaSchema,
  AddOnImageSizeWithOriginalInUriSchema,
  AddOnStatus,
  AddOrganizationUserEndpoint,
  AddToFavoriteListEndpoint,
  AddToFeaturedListEndpoint,
  AggregateQuestionSchema,
  AiCurationSessionSchema,
  AiProvider,
  AlaskaGetMemberEndpoint,
  AlaskaGetMemberResponseSchema,
  AlaskaGetMemberSchema,
  AliceCredentialSchema,
  AllCountries,
  AllPaginatedHostsResponse,
  AmountTaxSchema,
  AnalyticsConfigEndpoint,
  AnalyticsConfigurationSchema,
  AnalyticsEventConfigurationSchema,
  AnalyticsEventEndpoint,
  AnalyticsEventRequestSchema,
  AnalyticsEventSchema,
  AnswerSchema,
  ApiKeyEntityType,
  ApiKeySchema,
  ArchiveResourceGroupCollectionEndpoint,
  AssignBrandToOrganizationEndpoint,
  AssignBrandToOrganizationSchema,
  AssignOrganizationToAnotherOrganizationEndpoint,
  AssignOrganizationToAnotherOrganizationSchema,
  AuctionAmountType,
  AuctionApiResponseSchema,
  AuctionErrorCode,
  AuctionMoment,
  AuctionResponse,
  AuctionSchema,
  AuctionStatus,
  AuthenticateEndpoint,
  BOOKING_SURCHARGE_AMOUNT_USD,
  BRAND_EMAIL_ADDRESS_TYPE,
  BRAND_MEMBERSHIP_PERMISSIONS,
  BaseAddOnSchema,
  BaseAiCurationSessionSchema,
  BaseParticipantOrPurchaserSchema,
  BaseParticipantSchema,
  BidResponse,
  BidStatus,
  BidderInfoSchema,
  BidderSchema,
  BookingActivity,
  BookingActivityEndpoint,
  BookingActivitySchema,
  BookingAvailabilityModeValue,
  BookingCancelledActivitySchema,
  BookingCreatedActivitySchema,
  BookingCustomQuestionResponseSchema,
  BookingCustomQuestionSchema,
  BookingCustomQuestionWithAnswerSchema,
  BookingDetailResponseSchema,
  BookingDetailSchema,
  BookingFormSchema,
  BookingInquiryItemSchema,
  BookingInquirySchema,
  BookingInquiryStatus,
  BookingMode,
  BookingPriceTierSchema,
  BookingRefundedActivitySchema,
  BookingRequestSchema,
  BookingRescheduledActivitySchema,
  BookingStatus,
  BookingStatusFilterValues,
  BookingStatusesLeadingToOccurringSessions,
  BookingVoidedActivitySchema,
  BookingWithParticipantSchema,
  BookingsByCartIdSchema,
  BooleanStringSchema,
  BrandCategory,
  BrandDetailResponseSchema,
  BrandDnsSettingsResponseSchema,
  BrandDnsValidationResponseSchema,
  BrandEmailNotificationSettingsSchema,
  BrandExperienceReportRequestSchema,
  BrandFinancialReportRequestSchema,
  BrandFinancialReportV2RequestSchema,
  BrandHostSchema,
  BrandMemberSchema,
  BrandMembershipRole,
  BrandMembershipRolesSchema,
  BrandNotificationSchema,
  BrandPaginatedByUserResponseSchema,
  BrandPaginatedResponseSchema,
  BrandQueryFilter,
  BrandReportHeaderSchema,
  BrandReportQuerySchema,
  BrandReportRequestSchema,
  BrandSchema,
  BrandSmsNotificationSettingsSchema,
  BrandSortBy,
  BrandStatus,
  BrandsDashboardStatsResponseSchema,
  BrandsFinancialSummaryResponseSchema,
  BrandsFinancialSummarySchema,
  BrandsLogisticSummarySchema,
  BrandsReviewSummaryResponseSchema,
  BrandsReviewsSummaryResponseSchema,
  BulkBookingExperienceSchema,
  BulkBookingRequestSchema,
  BulkCreateExperiencesEndpoint,
  BulkCreateExperiencesRequestSchema,
  BulkCreateSchedulesEndpoint,
  BulkCreateSchedulesRequestSchema,
  BulkDeleteSessionsEndpoint,
  BulkDeleteSessionsRequestSchema,
  BulkUpdateExperiencesEndpoint,
  BulkUpdateExperiencesRequestSchema,
  CLAIM_TOKEN_EXPIRATION_MINUTES,
  COUNTRY_CURRENCIES,
  CUSTOMER_SUCCESS_MANAGEMENT_PERMISSIONS,
  CancelBookingEndpoint,
  CancellationPolicyCutoffUnit,
  CancellationPolicyField,
  CancellationPolicySchema,
  CategoryField,
  ChangePasswordSchema,
  ChatPromptSchema,
  ChatPromptWithIdSchema,
  ChatRequestSchema,
  ChatResponseSchema,
  CheckInHistoryActionEnum,
  CheckInHistorySchema,
  CloneResourceGroupCollectionEndpoint,
  CollectionEventParticipantScanEndpoint,
  CommonBookingRequestSchema,
  ComparableFilterSchema,
  CondimentGroupRuleSchema,
  ConditionMatchType,
  ConditionRule,
  ConditionSchema,
  ConfigSchema,
  ConfirmedSessionSchema,
  ConfirmedSessionsCollectionsSchema,
  ContactResponseSchema,
  ContactRole,
  ContactRoleSchema,
  ContactSchema,
  ControlCadenceAfter,
  ControlCadenceBefore,
  CountryCodesThatRequireFullAgreementStripeAccount,
  CreateAuctionEndpoint,
  CreateAuctionRequest,
  CreateBookingInquiryEndpoint,
  CreateBookingInquiryRequestSchema,
  CreateBrandRequestSchema,
  CreateCreditCodeEndpoint,
  CreateDurationsForExperienceEndpoint,
  CreateDurationsForResourceGroupEndpoint,
  CreateExperienceEndpoint,
  CreateExperienceRequestSchema,
  CreateExperienceResponseSchema,
  CreateListingAddOnEndpoint,
  CreateOrganizationEndpoint,
  CreateOrganizationFormSchema,
  CreateOrganizationSchema,
  CreateOrganizationUserRequestSchema,
  CreateOrganizationUsersResponseSchema,
  CreatePaymentIntentEndpoint,
  CreatePaymentIntentRequestSchema,
  CreatePromoterAgreementEndpoint,
  CreatePromoterAgreementForAllOrgBrandsEndpoint,
  CreatePromoterEndpoint,
  CreateReschedulePolicyEndpoint,
  CreateSchedulesEndpoint,
  CreateSchedulesRequestSchema,
  CreateSignedUrlsEndpoint,
  CreateStaffUsersRequestSchema,
  CreateStaffUsersResponseSchema,
  CreateWebhookEndpoint,
  CurateHostSchema,
  CurationSessionLocation,
  Currency,
  CurrencySymbol,
  CustomFieldTypes,
  CustomQuestionAnswerBookingResponseSchema,
  CustomQuestionField,
  CustomQuestionInResourcesSchema,
  CustomQuestionSchema,
  CustomQuestionScope,
  DateRangePriceTierConditionSchema,
  DateStringSchema,
  DateType,
  DayOfWeekPriceTierConditionSchema,
  DeleteAddOnEndpoint,
  DeleteAiCurationSessionEndpoint,
  DeleteApiKeyEndpoint,
  DeleteBookingInquiryEndpoint,
  DeleteCreditCodeEndpoint,
  DeleteDocumentEndpoint,
  DeleteFromFavoriteListEndpoint,
  DeleteFromFeaturedListEndpoint,
  DeleteIdeatedExperienceEndpoint,
  DeleteListingAddOnEndpoint,
  DeleteOrganizationAdminEndpoint,
  DeleteOrganizationEndpoint,
  DeleteResourceEndpoint,
  DeleteResourceGroupCollectionEndpoint,
  DeleteResourceGroupEndpoint,
  DeleteSurveyQuestionsEndpoint,
  DeleteWebhookEndpoint,
  DetailedBookingAddOnItemSchema,
  DetailedResourceGroupCollectionSchema,
  DeviceType,
  DiscardCartEndpoint,
  DocumentCategory,
  DocumentSchema,
  DomainNameSchema,
  DownloadReportEndpoint,
  DurationField,
  DurationRangePriceTierConditionSchema,
  ENTITY,
  EmailAddressSchema,
  EmailPlaceholder,
  EmailStringSchema,
  EmailType,
  Env,
  EventParticipantsResponse,
  ExperienceAsResourceSchema,
  ExperienceField,
  ExperienceImageSizeMediaSchema,
  ExperienceImageSizeWithOriginalInUriSchema,
  ExperienceImageSizes,
  ExperienceKind,
  ExperienceNotificationOverridesSchema,
  ExperienceReportColumn,
  ExperienceReportRequestSchema,
  ExperienceReportSortBy,
  ExperienceReportStaticColumns01,
  ExperienceReportStaticColumns02,
  ExperienceReportWithHeaderSchema,
  ExperienceSchema,
  ExperienceSettingsSchema,
  ExperienceStatus,
  ExperienceType,
  ExperienceVersion,
  ExternalFieldSchema,
  ExternalFieldType,
  FieldType,
  FiltersSchema,
  FinancialReportColumn,
  FinancialReportRequestSchema,
  FinancialReportSortBy,
  FinancialReportV2Column,
  FinancialReportV2RequestSchema,
  FinancialReportV2SortBy,
  FinancialReportV2WithHeaderSchema,
  FinancialReportWithHeaderSchema,
  FindActivePromoterAgreementEndpoint,
  FindActivePromoterAgreementsEndpoint,
  FindApprovedPromotedIdsByBrandEndpoint,
  FindApprovedPromotersByBrandEndpoint,
  FindApprovedPromotersByBrandResponseSchema,
  FindDurationsByDurationSetIdEndpoint,
  FindDurationsByExperienceIdEndpoint,
  FindDurationsByResourceGroupIdEndpoint,
  FindPromoterEndpoint,
  FindReportResponseSchema,
  FindWebhookEventHistoryDetailEndpoint,
  FineTuneIdeatedExperienceEndpoint,
  FineTuneIdeatedExperienceRequestSchema,
  FirstAvailableDateSchema,
  FromCurrency,
  Ga4IntegrationConfigResponse,
  GeneralSearchCreditCodeEndpoint,
  GenerateReportRequestSchema,
  GetActiveBrandAgreementEndpoint,
  GetActiveOrganizationAgreementEndpoint,
  GetAddOnsEndpoint,
  GetAiCurationSessionsEndpoint,
  GetAllHostsQuerySchema,
  GetAnalyticsIntegrationConfigEndpoint,
  GetAnalyticsIntegrationCredentialEndpoint,
  GetApiKeysEndpoint,
  GetApiKeysResponseSchema,
  GetAuctionEndpoint,
  GetBidsByBidderEndpoint,
  GetBidsByBidderResponse,
  GetBidsEndpoint,
  GetBidsResponse,
  GetBookingInquiriesEndpoint,
  GetBookingInquiriesQuerySchema,
  GetBookingInquiryEndpoint,
  GetBookingsForGuestCancellationEndpoint,
  GetBookingsForGuestRescheduleEndpoint,
  GetBrandCoreTranslationsEndpoint,
  GetBrandHostsEndpoint,
  GetBrandLiveStatusEndpoint,
  GetBrandMembersEndpoint,
  GetBrandMembersQuerySchema,
  GetBrandMenuEndpoint,
  GetBrandMenuSummaryEndpoint,
  GetBrandParentOrganizationsEndpoint,
  GetBrandRevenueCentersEndpoint,
  GetBrandSurveyQuestionsWithAggregateAnswerEndpoint,
  GetBrandTendersCollectionEndpoint,
  GetBrandsFinancialSummaryEndpoint,
  GetBrandsFinancialSummaryQuerySchema,
  GetBrandsHostCommissionQuerySchema,
  GetBrandsLogisticsSummaryEndpoint,
  GetBrandsQuerySchema,
  GetBrandsReviewsSummaryEndpoint,
  GetCancellationPoliciesEndpoint,
  GetCancellationPolicyEndpoint,
  GetCancellationPolicyPublicEndpoint,
  GetCollectionEventParticipantsEndpoint,
  GetCollectionEventParticipantsQuerySchema,
  GetConfirmedSessionsEndpoint,
  GetConfirmedSessionsQuerySchema,
  GetConvertedCurrencyEndpoint,
  GetConvertedCurrencyQuerySchema,
  GetConvertedCurrencyResponseSchema,
  GetCreditCodeEndpoint,
  GetCreditCodeHistoriesEndpoint,
  GetDocumentSignedUrlEndpoint,
  GetDocumentSignedUrlResponseSchema,
  GetDocumentsEndpoint,
  GetDocumentsQuerySchema,
  GetDocumentsResponseSchema,
  GetEventParticipantsEndpoint,
  GetEventParticipantsQuerySchema,
  GetExperienceResourceGroupCollectionIdEndpoint,
  GetExperienceVersionQuerySchema,
  GetFavoriteListEndpoint,
  GetFeaturedListEndpoint,
  GetGtmIntegrationConfigEndpoint,
  GetHostsEndpoint,
  GetIdeatedExperienceEndpoint,
  GetIdeatedExperiencesEndpoint,
  GetIntegrationGuestRequestQuerySchema,
  GetIntegrationGuestResponseSchema,
  GetListingAddOnsEndpoint,
  GetListingCountByOrganizationCustomFieldEndpoint,
  GetListingCountByOrganizationCustomFieldResponseSchema,
  GetListingCountByPromoterCustomFieldEndpoint,
  GetListingCountByPromoterCustomFieldResponseSchema,
  GetListingIncludedEndpoint,
  GetListingRevenueEndpoint,
  GetListingTranslationsEndpoint,
  GetListingTranslationsQuerySchema,
  GetListingV2Endpoint,
  GetListingV2ResponseSchema,
  GetListingsForPromoterEndpoint,
  GetListingsV2Endpoint,
  GetListingsV2ItemSchema,
  GetMembershipCurrenciesOfUserEndpoint,
  GetMetricsEndpoint,
  GetMineConfirmedSessionsEndpoint,
  GetMineSessionsEndpoint,
  GetNestedOrganizationMembershipsOfUserResponseSchemaEndpoint,
  GetOrganizationBrandsQuerySchema,
  GetOrganizationEndpoint,
  GetOrganizationListingCustomFieldValuesEndpoint,
  GetOrganizationListingCustomFieldValuesSchema,
  GetOrganizationPromoterBrandsEndpoint,
  GetOrganizationSurveyQuestionsWithAggregateAnswerEndpoint,
  GetOrganizationUsersEndpoint,
  GetOwnSurveyQuestionsWithAggregateAnswerEndpoint,
  GetPaginatedBookingsEndpoint,
  GetPaginatedBookingsQuerySchema,
  GetPaginatedBrandBookingsEndpoint,
  GetPaginatedWebhookEventHistoryEndpoint,
  GetPaginatedWebhooksEndpoint,
  GetParticipantsForCollectionWebsocketSchema,
  GetPromoterBookingIdsEndpoint,
  GetPromoterListingStatusEndpoint,
  GetProviderListingStatusEndpoint,
  GetPublicBrandDetails,
  GetReportEndpoint,
  GetReportInfoEndpoint,
  GetReschedulePolicyEndpoint,
  GetResourceGroupCollectionEndpoint,
  GetResourceGroupCollectionsEndpoint,
  GetResourceGroupCollectionsQuerySchema,
  GetResourceGroupEndpoint,
  GetResourceGroupsEndpoint,
  GetResourceGroupsQuerySchema,
  GetSchedulesForExperienceEndpoint,
  GetServiceAgreementQuerySchema,
  GetSessionsEndpoint,
  GetSessionsQuerySchema,
  GetSessionsResponseSchema,
  GetSessionsToRescheduleEndpoint,
  GetSessionsToRescheduleResourceGroupCollection,
  GetSessionsToRescheduleResponseSchema,
  GetStaffUsersQuerySchema,
  GetStaffUsersResponseSchema,
  GetStripeAccountServiceAgreementTypeResponseEndpoint,
  GetStripeAccountServiceAgreementTypeResponseSchema,
  GetSurveyQuestionsEndpoint,
  GetTranslationsForCategoriesEndpoint,
  GetTranslationsForCategoriesQuerySchema,
  GetTranslationsForExperienceEndpoint,
  GetTranslationsForExperienceQuerySchema,
  GetTranslationsForResourceGroupCollectionEndpoint,
  GetTranslationsForResourceGroupCollectionQuerySchema,
  GetTranslationsForResourceGroupEndpoint,
  GetTranslationsForResourceGroupQuerySchema,
  GetTranslationsForVibesEndpoint,
  GetTranslationsForVibesQuerySchema,
  GetUsersQuerySchema,
  GetWaitlistEndpoint,
  GetWaitlistEntriesEndpoint,
  GetWaitlistEntryActivitiesEndpoint,
  GetWaitlistEntryPublicEndpoint,
  GetWebhookDetailEndpoint,
  GtmIntegrationConfigResponse,
  GuestCancellationBookingStatus,
  GuestReportColumn,
  GuestReportRequestSchema,
  GuestReportSortBy,
  GuestReportWithHeaderSchema,
  HOST_COMMISSIONS_RESTRICTED_COUNTRIES_FOR_FULL_AGREEMENT,
  HOST_PERMISSIONS,
  HexColorSchema,
  HostCommissionSortBy,
  HostCommissionType,
  HostSchema,
  HostStatus,
  IMediaReferenceSchema,
  INTEGRATION_PERMISSIONS,
  IdeateExperienceDescriptionsRequestSchema,
  IdeateExperienceDescriptionsResponseSchema,
  IdeateNewExperienceImagesRequestSchema,
  IdeateNewExperienceImagesResponseSchema,
  IdeatedExperienceResponseSchema,
  IdeatedExperienceSchema,
  IdeatedExperiencesResponseSchema,
  ImportPaymentMethodsRequestSchema,
  InFilterSchema,
  IncludedField,
  InquiryItemType,
  IntegrationAddOnSchema,
  IntegrationAddOnsResponseSchema,
  IntegrationConfigResponseSchema,
  IntegrationGroup,
  IntegrationKeys,
  IntegrationMetaSchema,
  IntegrationName,
  IntegrationType,
  Integrations,
  InternalGetDetailedListingSchema,
  InternalGetListingEndpoint,
  InternalGetListingsEndpoint,
  InternalGetListingsQuerySchema,
  InternalListingResourceGroupSchema,
  InternalListingSchema,
  InviteBrandMemberEndpoint,
  InviteBrandMemberRequestSchema,
  ItemType,
  JoinWaitlistEndpoint,
  JsonSchema,
  LanguageCode,
  ListingAddOnField,
  ListingAddOnLimitType,
  ListingField,
  ListingKind,
  ListingPictureKind,
  ListingPictureSchema,
  ListingPromotedStatus,
  ListingStatus,
  ListingTaxSchema,
  ListingVersion,
  LiveStatusResponseSchema,
  LiveStatusSchema,
  LiveStatusWithBreakdownSchema,
  LocalDateTimeStringSchema,
  LocationField,
  LocationSchema,
  MatchDatePriceTierConditionSchema,
  MatchDurationPriceTierConditionSchema,
  MediaInputSchema,
  MediaLinkResolution,
  MediaLinkSchema,
  MediaSchema,
  MediaType,
  MemberProfileEndpoint,
  MembershipCurrenciesOfUserQueryRequestSchema,
  MembershipSchema,
  MenuPriceSchema,
  MetaSchema,
  Metric,
  MinimalBookingRequestSchema,
  MinimalHostSchema,
  MinimalOrganizationListEndpoint,
  MinimalOrganizationListRequestQuerySchema,
  MinimalOrganizationListResponseSchema,
  NON_DECIMAL_CURRENCIES,
  NOTIFICATION_PLATFORM,
  NOTIFICATION_TYPE,
  NestedOrganizationMembershipsOfUserResponseSchema,
  NotificationPlatform,
  NumberPattern,
  ORGANIZATION_MEMBERSHIP_PERMISSIONS,
  ORGANIZATION_ONLY_PERMISSIONS,
  OfferMoment,
  OperaAuthMethod,
  OperaCredentialsSchema,
  OperaHotelDetailsSchema,
  OptionSchema,
  OrderListingAddOnEndpoint,
  OrderListingAddOnRequestSchema,
  OrderListingsEndpoint,
  OrderWaitlistEntriesEndpoint,
  OrganizationDetailResponseSchema,
  OrganizationFeatureFlagsEndpoint,
  OrganizationFeatureFlagsResponseSchema,
  OrganizationFinancialReportRequestSchema,
  OrganizationFinancialReportV2RequestSchema,
  OrganizationPaginatedResponseSchema,
  OrganizationPaginatedUserSchema,
  OrganizationRole,
  OrganizationSchema,
  OrganizationSortBy,
  OrganizationTreeResponseSchema,
  OrganizationTreeSchema,
  OrganizationUserFilterQuery,
  OrganizationUserRolesSchema,
  OrganizationUserSchema,
  OrganizationUserStatus,
  OrganizationUserStatusesSchema,
  OrganizationsDetailRequestQuerySchema,
  PERMISSION,
  PaginatedBrandsEndpoint,
  PaginatedMinimalOrganizationsEndpoint,
  PaginatedOrganizationUsersRequestQuerySchema,
  PaginatedOrganizationUsersResponseSchema,
  PaginatedOrganizationsEndpoint,
  PaginatedOrganizationsRequestQuerySchema,
  PaginatedUsersResponseSchema,
  PaginatedWebhookEventHistoryQueryRequestSchema,
  PaginatedWebhookEventHistoryResponseSchema,
  PaginatedWebhookResponseSchema,
  PaginationLinkSchema,
  PaginationMetaSchema,
  PartialBidderInfoSchema,
  ParticipantSchema,
  ParticipantType,
  ParticipantUpdateSchema,
  PatchAddOnEndpoint,
  PatchBookingInquiryEndpoint,
  PatchBookingInquiryRequestSchema,
  PatchBrandCoreTranslationsEndpoint,
  PatchBrandHostEndpoint,
  PatchBrandHostRequestSchema,
  PatchListingTranslationsEndpoint,
  PatchListingTranslationsRequestSchema,
  PatchResourceGroupCollectionEndpoint,
  PatchResourceGroupEndpoint,
  PatchSurveyQuestionsEndpoint,
  PatchTranslationsForCategoriesEndpoint,
  PatchTranslationsForCategoriesRequestSchema,
  PatchTranslationsForExperienceEndpoint,
  PatchTranslationsForResourceGroupCollectionEndpoint,
  PatchTranslationsForResourceGroupEndpoint,
  PatchVibesTranslationsEndpoint,
  PatchVibesTranslationsRequestSchema,
  PaymentDetailSchema,
  PaymentMethodDetailSchema,
  PaymentMethodNumberSchema,
  PaymentMethodSettingsSchema,
  PaymentMethods,
  PaymentPlatform,
  PaymentResultSchema,
  PaymentSettingSchema,
  PaymentStatusSchema,
  PayoutSchedule,
  PercentageTaxSchema,
  PersonSchema,
  PhoneNumberSchema,
  PhoneNumberValidationSchema,
  PlaceBidEndpoint,
  PlaceBidRequestSchema,
  PmsType,
  PositionSchema,
  PostAiCurationSessionEndpoint,
  PostAnswersEndpoint,
  PostApiKeyEndpoint,
  PostApiKeysRequestSchema,
  PostApiKeysResponseSchema,
  PostBookingCancellationEndpoint,
  PostCancellationPolicyEndpoint,
  PostCurrencyRatesEndpoint,
  PostGuestCancellationEndpoint,
  PostIdeatedExperiencesEndpoint,
  PostListingIncludedEndpoint,
  PostParticipantsCheckInEndpoint,
  PostParticipantsCheckOutEndpoint,
  PostPriceTierRuleRequestSchema,
  PostPriceTrierRuleEndpoint,
  PostReportEndpoint,
  PostResourceGroupCollectionEndpoint,
  PostResourceGroupEndpoint,
  PostResourceGroupSessionPriceTierRuleEndpoint,
  PostResourceGroupSessionPriceTierRuleRequestSchema,
  PostReviewEndpoint,
  PostReviewRequestSchema,
  PostSessionPriceTierRuleEndpoint,
  PostSessionPriceTierRuleRequestSchema,
  PostSurveyAnswersRequestSchema,
  PostSurveyEndpoint,
  PostSurveyQuestionsEndpoint,
  PostSurveyRequestSchema,
  PostSurveyResponseSchema,
  PreviewExperienceReportEndpoint,
  PreviewFinancialV2Endpoint,
  PreviewGuestReportEndpoint,
  PriceTierConditionSchema,
  PriceTierConditionType,
  PriceTierRulesSchema,
  PriceTierSchema,
  PriceTierType,
  ProcessVideosEndpoint,
  ProductLine,
  PromotedListingStatus,
  PromoterAgreementStatus,
  PromoterApprovalMode,
  PromoterStatus,
  PromptAuthor,
  PublicBookingResponseSchema,
  PublicBrandHostEndpoint,
  PublicCancelBookingEndpoint,
  PublicCancelBookingsRequestSchema,
  PublicDetailedListingSchema,
  PublicGetListingEndpoint,
  PublicGetListingIdForExperienceOrCollectionEndpoint,
  PublicGetListingSessionsEndpoint,
  PublicGetListingSessionsQuerySchema,
  PublicGetListingSessionsResponseSchema,
  PublicGetListingsEndpoint,
  PublicGetListingsQuerySchema,
  PublicGetWaitlistEndpoint,
  PublicListingSchema,
  PublicResponseListingAddOnSchema,
  PublicWaitlistSchema,
  PublishResourceGroupCollectionEndpoint,
  PurchaserSchema,
  PurchaserWithCustomQuestionsSchema,
  PutAiCurationSessionEndpoint,
  PutBrandLiveStatusEndpoint,
  PutBrandSettingsRequestSchema,
  PutLiveStatusRequestSchema,
  PutOrganizationCustomFieldValuesEndpoint,
  REST_API_ENTITY,
  RangeFilterSchema,
  Rating,
  RearrangeCategoryEndpoint,
  RearrangeCategoryRequestSchema,
  RearrangeVibeEndpoint,
  RearrangeVibeRequestSchema,
  Recommendability,
  RedeemCreditCodeEndpoint,
  RefreshBrandLiveStatusEndpoint,
  RefundBookingEndpoint,
  RefundCreditCodeEndpoint,
  RefundHistorySchema,
  RemoveBrandFromOrganizationEndpoint,
  RemoveGuestFromWaitlistEndpoint,
  RemoveManySessionsEndpoint,
  RemoveManySessionsRequestSchema,
  RemoveSessionEndpoint,
  RemoveSessionRequestSchema,
  ReorderResourceGroupsEndpoint,
  ReportColumn,
  ReportDataByTypeSchema,
  ReportErrorsSchema,
  ReportFormat,
  ReportRequestSchema,
  ReportSchemaByType,
  ReportSortBy,
  ReportStatus,
  ReportType,
  RequestAddOnSchema,
  ReschedulableBookingSchema,
  ReschedulableBookingsSchema,
  ReschedulableStatus,
  RescheduleBookingEndpoint,
  ReschedulePolicyCutoffUnit,
  ReschedulePolicyField,
  ReschedulePolicySchema,
  ResendOrganizationUserInviteEndpoint,
  ResetPasswordSchema,
  ResourceGroupCollectionAuctionResponse,
  ResourceGroupCollectionEventType,
  ResourceGroupCollectionField,
  ResourceGroupCollectionKind,
  ResourceGroupCollectionResponseSchema,
  ResourceGroupCollectionSchema,
  ResourceGroupCollectionStatus,
  ResourceGroupField,
  ResourceGroupResponseSchema,
  ResourceGroupSchema,
  ResponseAddOnSchema,
  ResponseListingAddOnSchema,
  ResponseListingIncludedSchema,
  RestoreIdeatedExperienceEndpoint,
  Role,
  RolesSchema,
  SHAPE_DEFAULT_HEIGHT,
  SHAPE_DEFAULT_WIDTH,
  STAFF_ADMIN_PERMISSIONS,
  STAFF_ONLY_PERMISSIONS,
  SYSTEM_PERMISSIONS,
  SendBookingEndpoint,
  SendWaitlistInvitationOfferEndpoint,
  SessionBookingParticipantSchema,
  SessionBookingParticipantsSchema,
  SessionBookingsSchema,
  SessionSchema,
  SessionStatus,
  SessionsToReschedule,
  SetFavoriteListEndpoint,
  SetFeaturedListEndpoint,
  ShapeSchema,
  ShapeType,
  ShouldValidateComplimentaryBookingSchema2 as ShouldValidateComplimentaryBookingSchema,
  SimphonyMenuCategorySchema,
  SimphonyMenuDefinitionSchema,
  SimphonyMenuDetailSchema,
  SimphonyMenuItemDetailSchema,
  SimphonyMenuItemSchema,
  SimphonyMenuSummarySchema,
  SimphonyRevenueCenterSchema,
  SimphonyTenderCollectionSchema,
  SimphonyTenderItemSchema,
  SortOrder,
  StaffRole,
  StaffUserSchema,
  StaffUserStatus,
  Status,
  StatusesSchema,
  StrictTaxSchema,
  StrictTaxWithNameSchema,
  StripeAccountServiceAgreement,
  StripeAccountStatus,
  StripePaymentMethods,
  StripeSupportedCountryCodes,
  SupportedCountryCodeForFullAgreement,
  SurveyAnswersSchema,
  SurveyQuestionAnswerSchema,
  SurveyQuestionType,
  SurveyQuestionTypeSchema,
  SurveyQuestionWithAggregateAnswerResponseSchema,
  SurveyQuestionWithAggregateAnswerSchema,
  SurveyQuestionsSchema,
  SurveySchema,
  THEME,
  TaxField,
  TaxSchema,
  TealiumCredentialSchema,
  TermAndConditionSchema,
  TextPromptSchema,
  TextPromptWithIdSchema,
  TextRequestSchema,
  TextResponseSchema,
  Tier,
  TimeStringSchema,
  ToCurrency,
  TransactionType,
  TranslationEntityTable,
  TranslationSchema,
  TranslationWithIdSchema,
  TranslationsSchema,
  TranslationsWithIdSchema,
  TravelProfile,
  TruthyString,
  UnarchiveResourceGroupCollectionEndpoint,
  UnpublishResourceGroupCollectionEndpoint,
  UpdateAuctionEndpoint,
  UpdateAuctionRequest,
  UpdateBrandExperienceSorting,
  UpdateBrandExperienceSortingRequestSchema,
  UpdateBrandMemberPermissionsEndpoint,
  UpdateBrandMemberRoleEndpoint,
  UpdateBrandMemberRoleRequestSchema,
  UpdateBrandPromoterAgreementApprovalEndpoint,
  UpdateBrandRequestSchema,
  UpdateBrandSettingsEndpoint,
  UpdateBrandTaxesEndpoint,
  UpdateBrandTaxesSchema,
  UpdateBrandWebsiteUrlsEndpoint,
  UpdateCategoriesDataSchema,
  UpdateCategoriesEndpoint,
  UpdateDocumentEndpoint,
  UpdateDocumentRequestSchema,
  UpdateDurationEndpoint,
  UpdateDurationsByExperienceIdEndpoint,
  UpdateDurationsByResourceGroupIdEndpoint,
  UpdateExperienceEndpoint,
  UpdateExperienceRequestSchema,
  UpdateFeaturedListings,
  UpdateListingAddOnEndpoint,
  UpdateNotesSchema,
  UpdateOrganizationEndpoint,
  UpdateOrganizationFormSchema,
  UpdateOrganizationSchema,
  UpdateOrganizationUserEndpoint,
  UpdateOrganizationUsersRequestSchema,
  UpdateOrganizationUsersResponseSchema,
  UpdatePromoterAgreementApprovalEndpoint,
  UpdatePromoterListingStatusEndpoint,
  UpdateProviderListingStatusEndpoint,
  UpdateScheduleEndpoint,
  UpdateSessionEndpoint,
  UpdateStaffUsersRequestSchema,
  UpdateStaffUsersResponseSchema,
  UpdateUserCountryCodeEndpoint,
  UpdateUserCountryCodeRequestSchema,
  UpdateVibesDataSchema,
  UpdateVibesEndpoint,
  UpdateWaitlistEndpoint,
  UpdateWebhookEndpoint,
  UploadDocumentEndpoint,
  UploadDocumentRequestSchema,
  UserAddressSchema,
  UserDetailSchema,
  UserField,
  UserImageSizeInUriSchema,
  UserImageSizeMediaSchema,
  UserImageSizeWithOriginalInUriSchema,
  UserImageSizes,
  UserRequestSchema,
  UserResponseSchema,
  UserSchema,
  UserSortBy,
  ValidateListingsEndpoint,
  ValidatePaymentMethodDomainsEndpoint,
  VibeField,
  WaitlistActivity,
  WaitlistEntryActivitySchema,
  WaitlistEntryPublicSchema,
  WaitlistEntrySchema,
  WaitlistEntryStatus,
  WaitlistInvitationOfferedActivitySchema,
  WaitlistJoinedActivitySchema,
  WaitlistMode,
  WaitlistSchema,
  WayVersion,
  WebhookEntityType,
  WebhookEventHistoryDetailResponseSchema,
  WebhookEventHistoryStatus,
  WebhookEventStatus,
  WebhookEvents,
  WebhookRequestSchema,
  WebhookResponseSchema,
  WinningBidStatus,
  WinningBidType,
  brandReportInfoSchema,
  buildQueryString,
  bulkResourcesCommonFields,
  castCountryCode,
  condimentItemSchema,
  experienceColumnsMap,
  financialColumnsMap,
  financialColumnsV2Map,
  financialReportInfoSchema,
  financialReportV2ItemSchema,
  financialSummaryGroupingOptions,
  getAliceCredentialsEndpoint,
  getCountryFromCode,
  getCurrencyCode,
  getCurrencyForCountry,
  getSupportedCountryCode,
  guestReportsColumnsMap,
  integrationUrl,
  isAdditionalHostPermission,
  isAdminPermission,
  isBrandMembershipPermission,
  isExperienceStatus,
  isExperienceVersion,
  isHigherEnv,
  isHostPermission,
  isIntegrationPermission,
  isLowerEnv,
  isOrganizationMembershipPermission,
  isPermission,
  isPhoneNumber,
  isPmsType,
  isSortOption,
  isStripeSupportedCountryCodes,
  isValidCountryCode,
  isValidCurrencyCode,
  listingsV2Filters,
  listingsV2SortByOptions,
  makeEndpoint,
  paginateQuerySchema,
  paginateResponseSchema,
  postAliceCredentialsEndpoint,
  publicIntegrationConfigUrl,
  sortOptions,
  stringBooleanSchema,
  summaryGroupingOptions,
  webhookFinancialReportV2ItemSchema,
  webhookOnlyDataSchema
};
/*! Bundled license information:

lodash/lodash.js:
  (**
   * @license
   * Lodash <https://lodash.com/>
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)
*/
//# sourceMappingURL=index.js.map